
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired0b2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired0b2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cm03h", function(module, exports) {

$parcel$export(module.exports, "Toast", () => $8fe7946a28c22cbf$export$8d8dc7d5f743331b);
/**
 * Clase para manejo de notificaciones toast
 * @class AppToast
 */ class $8fe7946a28c22cbf$export$6301969f65979a3a {
    /**
     * Constructor del AppToast
     */ constructor(){
        this.effectIn = 'animate__flipInX';
        this.effectOut = 'animate__flipOutX';
    }
    /**
     * Quita toasts que coinciden con selector (animación igual que al cerrar con click).
     * @private
     * @param {string} selector - selector CSS dentro de `.app-toaster`
     */ _dismissMatching(selector) {
        const toaster = document.querySelector('.app-toaster');
        if (!toaster) return;
        toaster.querySelectorAll(selector).forEach((toast)=>{
            toast.classList.remove(this.effectIn);
            toast.classList.add(this.effectOut);
            toast.addEventListener('animationend', (e)=>{
                e.target.remove();
            }, {
                once: true
            });
        });
    }
    /**
     * Oculta todos los toasts visibles.
     */ dismissAll() {
        this._dismissMatching('.app-toast');
    }
    /**
     * Muestra un toast
     * @param {string} html - Contenido HTML del toast
     * @param {string} type - Tipo de toast (success, warning, danger, info)
     * @param {boolean|number} permanent - Si es true, permanente; si es número, delay en ms
     * @param {string|Function} click - 'exit' para cerrar al click, o función callback
     * @param {string} classes - Clases CSS adicionales
     * @returns {HTMLElement|null} Elemento del toast o null si hay error
     */ show(html = '', type = 'success', permanent = false, click = 'exit', classes = false) {
        if (typeof html !== 'string') html = String(html || '');
        const validTypes = [
            'success',
            'warning',
            'danger',
            'info'
        ];
        if (!validTypes.includes(type)) type = 'success';
        const toaster = document.querySelector('.app-toaster');
        if (!toaster) return null;
        this._dismissMatching('.app-toast:not(.uploading):not(.toast-offline)');
        const toast = document.createElement('div');
        toast.className = `animate__animated ${this.effectIn} app-toast p-3 rounded ${type} text-bg-${type}`;
        toast.innerHTML = html;
        let words = html.split(' ').length * 250;
        if (words < 4000) words = 4000;
        let time = Number.isInteger(permanent) ? permanent : words;
        if (classes) classes.split(' ').forEach((className)=>{
            toast.classList.add(className);
        });
        if (click) {
            toast.classList.add('cursor-pointer');
            if (click === 'exit') toast.addEventListener('click', function(e) {
                e.stopPropagation();
                this.classList.remove('animate__flipInX');
                this.classList.add('animate__flipOutX');
                this.addEventListener('animationend', (e)=>{
                    e.target.remove();
                });
            });
            else toast.addEventListener('click', function(e) {
                e.stopPropagation();
                click();
            });
        }
        if (permanent === false || Number.isInteger(permanent)) setTimeout(()=>{
            toast.classList.remove(this.effectIn);
            toast.classList.add(this.effectOut);
            toast.addEventListener('animationend', (e)=>e.target.remove());
        }, time);
        toaster.append(toast);
        return toast;
    }
}
const $8fe7946a28c22cbf$export$8d8dc7d5f743331b = new $8fe7946a28c22cbf$export$6301969f65979a3a();

});

parcelRegister("hLcer", function(module, exports) {

$parcel$export(module.exports, "apiCall", () => $cee05077a475c94f$export$7f9256869ac7089d);
$parcel$export(module.exports, "apiGet", () => $cee05077a475c94f$export$b216272c8be3751a);
$parcel$export(module.exports, "apiPost", () => $cee05077a475c94f$export$bd1dc54ad3b0ef79);
/**
 * Utilidades para llamadas a la API
 * @module utils/api
 */ /**
 * Realiza una llamada a la API con autenticación
 * @async
 * @param {string} endpoint - Endpoint de la API (sin base URL)
 * @param {Object} options - Opciones de fetch
 * @param {string} options.method - Método HTTP (default: 'GET')
 * @param {Object} options.body - Body de la petición
 * @param {Object} options.headers - Headers adicionales
 * @param {boolean} options.requireAuth - Requiere autenticación (default: true)
 * @param {boolean} options.requireType - Incluir header X-WETAG-Type (default: true)
 * @returns {Promise<Object>} Respuesta parseada como JSON
 * @throws {Error} Si la respuesta no es OK o hay error de red
 */ async function $cee05077a475c94f$export$7f9256869ac7089d(endpoint, options = {}) {
    if (!window.App || !window.App.settings || !window.App.settings.restUrl) throw new Error('App settings not available');
    const { method: method = 'GET', body: body = null, headers: headers = {}, requireAuth: requireAuth = true, requireType: requireType = true } = options;
    let url = endpoint.startsWith('http') ? endpoint : `${window.App.settings.restUrl}${endpoint}`;
    const requestHeaders = {
        ...headers
    };
    if (requireType) requestHeaders['X-WETAG-Type'] = 'members';
    if (requireAuth) {
        if (!window.App.auth || !window.App.auth.token) throw new Error('Authentication token not available');
        requestHeaders['X-WETAG-Token'] = window.App.auth.token;
    }
    try {
        const fetchOptions = {
            method: method,
            headers: requestHeaders,
            cache: 'no-cache'
        };
        if (body) {
            if (body instanceof FormData) fetchOptions.body = body;
            else if (body instanceof URLSearchParams) fetchOptions.body = body;
            else {
                fetchOptions.body = JSON.stringify(body);
                requestHeaders['Content-Type'] = 'application/json';
            }
        }
        const urlObj = new URL(url);
        if (urlObj.searchParams.has('reload')) {
            urlObj.searchParams.set('reload', Date.now().toString());
            url = urlObj.toString();
        }
        const response = await fetch(url, fetchOptions);
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const responseText = await response.text();
        if (!responseText || responseText.trim() === '') return {
            class: 'success',
            html: ''
        };
        try {
            const data = JSON.parse(responseText);
            return data;
        } catch (parseError) {
            return {
                class: 'success',
                html: responseText,
                raw: responseText
            };
        }
    } catch (error) {
        throw error;
    }
}
async function $cee05077a475c94f$export$b216272c8be3751a(endpoint, options = {}) {
    return $cee05077a475c94f$export$7f9256869ac7089d(endpoint, {
        ...options,
        method: 'GET'
    });
}
async function $cee05077a475c94f$export$bd1dc54ad3b0ef79(endpoint, body, options = {}) {
    return $cee05077a475c94f$export$7f9256869ac7089d(endpoint, {
        ...options,
        method: 'POST',
        body: body
    });
}
async function $cee05077a475c94f$export$bb2abc1fe2f1c239(endpoint, options = {}) {
    return $cee05077a475c94f$export$7f9256869ac7089d(endpoint, {
        ...options,
        method: 'DELETE'
    });
}

});

parcelRegister("3kyGY", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("fdK23", function(module, exports) {
//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})(module.exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'), monthsParse = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function(m, format) {
            if (!m) return monthsShortDot;
            else if (/-MMM-/.test(format)) return monthsShort[m.month()];
            else return monthsShortDot[m.month()];
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    });
    return es;
});

});

parcelRegister("iL6vn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("jDt91")),
    import("8wY6c"),
    import("6NyUp")
]).then(()=>parcelRequire('bdft7'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6NLMO", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("73Xu0")),
    import("761tV"),
    import("9INgC"),
    import("8wY6c"),
    import("dOa5u")
]).then(()=>parcelRequire('emKyz'));

});

parcelRegister("1fxu9", function(module, exports) {
module.exports = import("5PCVs").then(()=>parcelRequire('2kafm'));

});

parcelRegister("dmeRL", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("g7Xc0")),
    import("9INgC"),
    import("8wY6c"),
    import("afswr")
]).then(()=>parcelRequire('672eI'));

});

parcelRegister("dJzqN", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("esQ8p")),
    import("8wY6c"),
    import("2kIVP")
]).then(()=>parcelRequire('l1RXY'));

});

parcelRegister("ir0N9", function(module, exports) {
module.exports = Promise.all([
    import("9INgC"),
    import("8dQDl")
]).then(()=>parcelRequire('jo5pG'));

});

parcelRegister("lg8ne", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("kTI5Y")),
    import("8wY6c"),
    import("hN3xF")
]).then(()=>parcelRequire('cy3RT'));

});

parcelRegister("dwLw8", function(module, exports) {
module.exports = import("9BKbj").then(()=>parcelRequire('1lGAm'));

});

parcelRegister("akgT4", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("fC82Y")),
    import("9INgC"),
    import("8wY6c"),
    import("5QlJo")
]).then(()=>parcelRequire('3d0bf'));

});

parcelRegister("lGJNv", function(module, exports) {
module.exports = import("hNWYo").then(()=>parcelRequire('69nhU'));

});

parcelRegister("46YEJ", function(module, exports) {
module.exports = import("aiBka").then(()=>parcelRequire('0ShiX'));

});

parcelRegister("8Q0Vh", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("6Fyz9")),
    import("761tV"),
    import("fcwMh")
]).then(()=>parcelRequire('83R5I'));

});

parcelRegister("i8rwJ", function(module, exports) {
module.exports = import("83cs0").then(()=>parcelRequire('4IfzK'));

});

parcelRegister("4KWEf", function(module, exports) {

$parcel$export(module.exports, "SERVICE_WORKER_CACHE_VERSION", () => $3768f395e7c62bb1$export$333f86f167b75e0e);
const $3768f395e7c62bb1$export$333f86f167b75e0e = 'WETAGAPP-03112026-1';

});

parcelRegister("bUw5l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.install = module.exports.initDataLayer = module.exports.gtag = module.exports["default"] = void 0;
var $8abdd02230d1c140$var$initDataLayer = module.exports.initDataLayer = function initDataLayer() {
    window.dataLayer = window.dataLayer || [];
};
var $8abdd02230d1c140$var$install = module.exports.install = function install(trackingId) {
    var additionalConfigInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var scriptId = "ga-gtag";
    if (document.getElementById(scriptId)) return;
    var _document = document, head = _document.head;
    var script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(trackingId);
    head.insertBefore(script, head.firstChild);
    $8abdd02230d1c140$var$initDataLayer();
    $8abdd02230d1c140$var$gtag("js", new Date);
    $8abdd02230d1c140$var$gtag("config", trackingId, additionalConfigInfo);
};
var $8abdd02230d1c140$var$gtag = module.exports.gtag = function gtag() {
    window.dataLayer.push(arguments);
};
var $8abdd02230d1c140$var$_default = module.exports["default"] = $8abdd02230d1c140$var$gtag;

});

parcelRegister("1Fbaj", function(module, exports) {

$parcel$export(module.exports, "pageTouch", () => $136247f7c0ddb204$export$86191402834189de);
$parcel$export(module.exports, "setupExampleImage", () => $136247f7c0ddb204$export$46728135b5497bd1);
$parcel$export(module.exports, "setupVideoPlayer", () => $136247f7c0ddb204$export$8fa7b5398a4c219c);
$parcel$export(module.exports, "celebratePreset", () => (parcelRequire("e9hcU")).celebratePreset);
/**
 * Utilidades para la interfaz de usuario
 * @module utils/Ui
 */ 
var $73YaN = parcelRequire("73YaN");


var $e9hcU = parcelRequire("e9hcU");
let $136247f7c0ddb204$var$overlayTimeoutId = null;
let $136247f7c0ddb204$var$releaseTimeoutId = null;
const $136247f7c0ddb204$var$DEFAULT_OVERLAY_ICON = 'rocket_launch';
function $136247f7c0ddb204$var$cancelScheduledRelease() {
    if ($136247f7c0ddb204$var$releaseTimeoutId) {
        clearTimeout($136247f7c0ddb204$var$releaseTimeoutId);
        $136247f7c0ddb204$var$releaseTimeoutId = null;
    }
}
function $136247f7c0ddb204$export$86191402834189de(block, showOverlay = false, opts = {}) {
    const { overlayIcon: overlayIcon = $136247f7c0ddb204$var$DEFAULT_OVERLAY_ICON, overlayText: overlayText, releaseAfterMs: releaseAfterMs } = opts;
    if (block) {
        $136247f7c0ddb204$var$cancelScheduledRelease();
        document.body.classList.add('app-block-touch');
        if (typeof releaseAfterMs === 'number' && releaseAfterMs > 0) $136247f7c0ddb204$var$releaseTimeoutId = setTimeout(()=>{
            $136247f7c0ddb204$var$releaseTimeoutId = null;
            $136247f7c0ddb204$export$86191402834189de(false);
        }, releaseAfterMs);
        if (showOverlay) {
            if ($136247f7c0ddb204$var$overlayTimeoutId) clearTimeout($136247f7c0ddb204$var$overlayTimeoutId);
            $136247f7c0ddb204$var$overlayTimeoutId = setTimeout(()=>{
                let overlay = document.getElementById('app-loading-overlay');
                if (!overlay) {
                    overlay = document.createElement('div');
                    overlay.id = 'app-loading-overlay';
                    overlay.className = 'app-block-overlay';
                    document.body.appendChild(overlay);
                }
                overlay.style.display = 'flex';
                overlay.replaceChildren();
                const text = typeof overlayText === 'string' && overlayText.trim() ? overlayText.trim() : '';
                if (text) {
                    const heading = document.createElement('h1');
                    heading.className = 'title h1 text-yellow text-center mb-0';
                    heading.innerHTML = text;
                    overlay.appendChild(heading);
                } else {
                    const icon = document.createElement('i');
                    icon.className = 'material-symbols-outlined animate__animated animate__pulse animate__infinite';
                    icon.textContent = overlayIcon;
                    overlay.appendChild(icon);
                }
                $136247f7c0ddb204$var$overlayTimeoutId = null;
            }, 10);
        }
    } else {
        $136247f7c0ddb204$var$cancelScheduledRelease();
        if ($136247f7c0ddb204$var$overlayTimeoutId) {
            clearTimeout($136247f7c0ddb204$var$overlayTimeoutId);
            $136247f7c0ddb204$var$overlayTimeoutId = null;
        }
        document.body.classList.remove('app-block-touch');
        const overlay = document.getElementById('app-loading-overlay');
        if (overlay) overlay.remove();
    }
}
function $136247f7c0ddb204$export$46728135b5497bd1(page, examplePath, selector = '.upload-example') {
    const photoWrap = page.querySelector(selector);
    if (!photoWrap) return;
    if (examplePath && window.App?.settings?.contentUrl) photoWrap.innerHTML = `<img src='${window.App.settings.contentUrl}/others/actions/${examplePath}' class='img-fluid rounded'>`;
    else photoWrap.remove();
}
function $136247f7c0ddb204$export$8fa7b5398a4c219c(page, videoId, playerSelector = '#video-player', containerSelector = '.upload-player') {
    if (!videoId) {
        const container = page.querySelector(containerSelector);
        if (container) container.remove();
        return null;
    }
    const container = page.querySelector(containerSelector);
    const videoElement = page.querySelector(playerSelector);
    if (!container || !videoElement) return null;
    videoElement.setAttribute('data-plyr-embed-id', videoId);
    const player = new (0, (/*@__PURE__*/$parcel$interopDefault($73YaN)))(videoElement, {
        autoplay: false,
        controls: [
            'play-large',
            'play',
            'fullscreen',
            'progress',
            'pip',
            'airplay',
            'mute',
            'volume'
        ],
        youtube: {
            noCookie: true
        }
    });
    const navElement = page.querySelector('.app-page-nav');
    if (navElement) {
        player.on('enterfullscreen', ()=>navElement.classList.add('d-none'));
        player.on('exitfullscreen', ()=>navElement.classList.remove('d-none'));
    }
    return player;
}

});
parcelRegister("73YaN", function(module, exports) {
typeof navigator === "object" && function(global, factory) {
    module.exports = factory();
}(module.exports, function() {
    'use strict';
    function _defineProperty$1(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[r] = t, e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || false, r.configurable = true, "value" in r && (r.writable = true), Object.defineProperty(e, r.key, r);
        }
    }
    function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }
    function _defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[t] = n, e;
    }
    function ownKeys(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function _objectSpread2(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(n), true).forEach(function(t) {
                _defineProperty(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var defaults$1 = {
        addCSS: true,
        thumbWidth: 15,
        watch: true
    };
    function matches$1(e, t) {
        return (function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function trigger(e, t) {
        if (e && t) {
            var n = new Event(t, {
                bubbles: true
            });
            e.dispatchEvent(n);
        }
    }
    var getConstructor$1 = function(e) {
        return null != e ? e.constructor : null;
    }, instanceOf$1 = function(e, t) {
        return !!(e && t && e instanceof t);
    }, isNullOrUndefined$1 = function(e) {
        return null == e;
    }, isObject$1 = function(e) {
        return getConstructor$1(e) === Object;
    }, isNumber$1 = function(e) {
        return getConstructor$1(e) === Number && !Number.isNaN(e);
    }, isString$1 = function(e) {
        return getConstructor$1(e) === String;
    }, isBoolean$1 = function(e) {
        return getConstructor$1(e) === Boolean;
    }, isFunction$1 = function(e) {
        return getConstructor$1(e) === Function;
    }, isArray$1 = function(e) {
        return Array.isArray(e);
    }, isNodeList$1 = function(e) {
        return instanceOf$1(e, NodeList);
    }, isElement$1 = function(e) {
        return instanceOf$1(e, Element);
    }, isEvent$1 = function(e) {
        return instanceOf$1(e, Event);
    }, isEmpty$1 = function(e) {
        return isNullOrUndefined$1(e) || (isString$1(e) || isArray$1(e) || isNodeList$1(e)) && !e.length || isObject$1(e) && !Object.keys(e).length;
    }, is$1 = {
        nullOrUndefined: isNullOrUndefined$1,
        object: isObject$1,
        number: isNumber$1,
        string: isString$1,
        boolean: isBoolean$1,
        function: isFunction$1,
        array: isArray$1,
        nodeList: isNodeList$1,
        element: isElement$1,
        event: isEvent$1,
        empty: isEmpty$1
    };
    function getDecimalPlaces(e) {
        var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
    }
    function round(e, t) {
        if (1 > t) {
            var n = getDecimalPlaces(t);
            return parseFloat(e.toFixed(n));
        }
        return Math.round(e / t) * t;
    }
    var RangeTouch = function() {
        function e(t, n) {
            _classCallCheck(this, e), is$1.element(t) ? this.element = t : is$1.string(t) && (this.element = document.querySelector(t)), is$1.element(this.element) && is$1.empty(this.element.rangeTouch) && (this.config = _objectSpread2({}, defaults$1, {}, n), this.init());
        }
        return _createClass(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(true), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(false), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, n = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[n](e, function(e) {
                            return t.set(e);
                        }, false);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !is$1.event(t)) return null;
                    var n, r = t.target, i = t.changedTouches[0], o = parseFloat(r.getAttribute("min")) || 0, s = parseFloat(r.getAttribute("max")) || 100, u = parseFloat(r.getAttribute("step")) || 1, c = r.getBoundingClientRect(), a = 100 / c.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (n = 100 / c.width * (i.clientX - c.left)) ? n = 0 : 100 < n && (n = 100), 50 > n ? n -= (100 - 2 * n) * a : 50 < n && (n += 2 * (n - 50) * a), o + round(n / 100 * (s - o), u);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && is$1.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), trigger(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, r = null;
                    if (is$1.empty(t) || is$1.string(t) ? r = Array.from(document.querySelectorAll(is$1.string(t) ? t : 'input[type="range"]')) : is$1.element(t) ? r = [
                        t
                    ] : is$1.nodeList(t) ? r = Array.from(t) : is$1.array(t) && (r = t.filter(is$1.element)), is$1.empty(r)) return null;
                    var i = _objectSpread2({}, defaults$1, {}, n);
                    if (is$1.string(t) && i.watch) {
                        var o = new MutationObserver(function(n) {
                            Array.from(n).forEach(function(n) {
                                Array.from(n.addedNodes).forEach(function(n) {
                                    is$1.element(n) && matches$1(n, t) && new e(n, i);
                                });
                            });
                        });
                        o.observe(document.body, {
                            childList: true,
                            subtree: true
                        });
                    }
                    return r.map(function(t) {
                        return new e(t, n);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    // ==========================================================================
    // Type checking utils
    // ==========================================================================
    const getConstructor = (input)=>input !== null && typeof input !== 'undefined' ? input.constructor : null;
    const instanceOf = (input, constructor)=>Boolean(input && constructor && input instanceof constructor);
    const isNullOrUndefined = (input)=>input === null || typeof input === 'undefined';
    const isObject = (input)=>getConstructor(input) === Object;
    const isNumber = (input)=>getConstructor(input) === Number && !Number.isNaN(input);
    const isString = (input)=>getConstructor(input) === String;
    const isBoolean = (input)=>getConstructor(input) === Boolean;
    const isFunction = (input)=>typeof input === 'function';
    const isArray = (input)=>Array.isArray(input);
    const isWeakMap = (input)=>instanceOf(input, WeakMap);
    const isNodeList = (input)=>instanceOf(input, NodeList);
    const isTextNode = (input)=>getConstructor(input) === Text;
    const isEvent = (input)=>instanceOf(input, Event);
    const isKeyboardEvent = (input)=>instanceOf(input, KeyboardEvent);
    const isCue = (input)=>instanceOf(input, window.TextTrackCue) || instanceOf(input, window.VTTCue);
    const isTrack = (input)=>instanceOf(input, TextTrack) || !isNullOrUndefined(input) && isString(input.kind);
    const isPromise = (input)=>instanceOf(input, Promise) && isFunction(input.then);
    function isElement(input) {
        return input !== null && typeof input === 'object' && input.nodeType === 1 && typeof input.style === 'object' && typeof input.ownerDocument === 'object';
    }
    function isEmpty(input) {
        return isNullOrUndefined(input) || (isString(input) || isArray(input) || isNodeList(input)) && !input.length || isObject(input) && !Object.keys(input).length;
    }
    function isUrl(input) {
        // Accept a URL object
        if (instanceOf(input, window.URL)) return true;
        // Must be string from here
        if (!isString(input)) return false;
        // Add the protocol if required
        let string = input;
        if (!input.startsWith('http://') || !input.startsWith('https://')) string = `http://${input}`;
        try {
            return !isEmpty(new URL(string).hostname);
        } catch  {
            return false;
        }
    }
    var is = {
        nullOrUndefined: isNullOrUndefined,
        object: isObject,
        number: isNumber,
        string: isString,
        boolean: isBoolean,
        function: isFunction,
        array: isArray,
        weakMap: isWeakMap,
        nodeList: isNodeList,
        element: isElement,
        textNode: isTextNode,
        event: isEvent,
        keyboardEvent: isKeyboardEvent,
        cue: isCue,
        track: isTrack,
        promise: isPromise,
        url: isUrl,
        empty: isEmpty
    };
    // ==========================================================================
    // Animation utils
    // ==========================================================================
    const transitionEndEvent = (()=>{
        const element = document.createElement('span');
        const events = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };
        const type = Object.keys(events).find((event)=>element.style[event] !== undefined);
        return is.string(type) ? events[type] : false;
    })();
    // Force repaint of element
    function repaint(element, delay) {
        setTimeout(()=>{
            try {
                element.hidden = true;
                // eslint-disable-next-line no-unused-expressions
                element.offsetHeight;
                element.hidden = false;
            } catch  {}
        }, delay);
    }
    // ==========================================================================
    // Object utils
    // ==========================================================================
    // Clone nested objects
    function cloneDeep(object) {
        return JSON.parse(JSON.stringify(object));
    }
    // Get a nested value in an object
    function getDeep(object, path) {
        return path.split('.').reduce((obj, key)=>obj && obj[key], object);
    }
    // Deep extend destination object with N more objects
    function extend(target = {}, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
        if (!is.object(source)) return target;
        Object.keys(source).forEach((key)=>{
            if (is.object(source[key])) {
                if (!Object.keys(target).includes(key)) Object.assign(target, {
                    [key]: {}
                });
                extend(target[key], source[key]);
            } else Object.assign(target, {
                [key]: source[key]
            });
        });
        return extend(target, ...sources);
    }
    // ==========================================================================
    // Element utils
    // ==========================================================================
    // Wrap an element
    function wrap(elements, wrapper) {
        // Convert `elements` to an array, if necessary.
        const targets = elements.length ? elements : [
            elements
        ];
        // Loops backwards to prevent having to clone the wrapper on the
        // first element (see `child` below).
        Array.from(targets).reverse().forEach((element, index)=>{
            const child = index > 0 ? wrapper.cloneNode(true) : wrapper;
            // Cache the current parent and sibling.
            const parent = element.parentNode;
            const sibling = element.nextSibling;
            // Wrap the element (is automatically removed from its current
            // parent).
            child.appendChild(element);
            // If the element had a sibling, insert the wrapper before
            // the sibling to maintain the HTML structure; otherwise, just
            // append it to the parent.
            if (sibling) parent.insertBefore(child, sibling);
            else parent.appendChild(child);
        });
    }
    // Set attributes
    function setAttributes(element, attributes) {
        if (!is.element(element) || is.empty(attributes)) return;
        // Assume null and undefined attributes should be left out,
        // Setting them would otherwise convert them to "null" and "undefined"
        Object.entries(attributes).filter(([, value])=>!is.nullOrUndefined(value)).forEach(([key, value])=>element.setAttribute(key, value));
    }
    // Create a DocumentFragment
    function createElement(type, attributes, text) {
        // Create a new <element>
        const element = document.createElement(type);
        // Set all passed attributes
        if (is.object(attributes)) setAttributes(element, attributes);
        // Add text node
        if (is.string(text)) element.textContent = text;
        // Return built element
        return element;
    }
    // Insert an element after another
    function insertAfter(element, target) {
        if (!is.element(element) || !is.element(target)) return;
        target.parentNode.insertBefore(element, target.nextSibling);
    }
    // Insert a DocumentFragment
    function insertElement(type, parent, attributes, text) {
        if (!is.element(parent)) return;
        parent.appendChild(createElement(type, attributes, text));
    }
    // Remove element(s)
    function removeElement(element) {
        if (is.nodeList(element) || is.array(element)) {
            Array.from(element).forEach(removeElement);
            return;
        }
        if (!is.element(element) || !is.element(element.parentNode)) return;
        element.parentNode.removeChild(element);
    }
    // Remove all child elements
    function emptyElement(element) {
        if (!is.element(element)) return;
        let { length: length } = element.childNodes;
        while(length > 0){
            element.removeChild(element.lastChild);
            length -= 1;
        }
    }
    // Replace element
    function replaceElement(newChild, oldChild) {
        if (!is.element(oldChild) || !is.element(oldChild.parentNode) || !is.element(newChild)) return null;
        oldChild.parentNode.replaceChild(newChild, oldChild);
        return newChild;
    }
    // Get an attribute object from a string selector
    function getAttributesFromSelector(sel, existingAttributes) {
        // For example:
        // '.test' to { class: 'test' }
        // '#test' to { id: 'test' }
        // '[data-test="test"]' to { 'data-test': 'test' }
        if (!is.string(sel) || is.empty(sel)) return {};
        const attributes = {};
        const existing = extend({}, existingAttributes);
        sel.split(',').forEach((s)=>{
            // Remove whitespace
            const selector = s.trim();
            const className = selector.replace('.', '');
            const stripped = selector.replace(/[[\]]/g, '');
            // Get the parts and value
            const parts = stripped.split('=');
            const [key] = parts;
            const value = parts.length > 1 ? parts[1].replace(/["']/g, '') : '';
            // Get the first character
            const start = selector.charAt(0);
            switch(start){
                case '.':
                    // Add to existing classname
                    if (is.string(existing.class)) attributes.class = `${existing.class} ${className}`;
                    else attributes.class = className;
                    break;
                case '#':
                    // ID selector
                    attributes.id = selector.replace('#', '');
                    break;
                case '[':
                    // Attribute selector
                    attributes[key] = value;
                    break;
            }
        });
        return extend(existing, attributes);
    }
    // Toggle hidden
    function toggleHidden(element, hidden) {
        if (!is.element(element)) return;
        let hide = hidden;
        if (!is.boolean(hide)) hide = !element.hidden;
        element.hidden = hide;
    }
    // Mirror Element.classList.toggle, with IE compatibility for "force" argument
    function toggleClass(element, className, force) {
        if (is.nodeList(element)) return Array.from(element).map((e)=>toggleClass(e, className, force));
        if (is.element(element)) {
            let method = 'toggle';
            if (typeof force !== 'undefined') method = force ? 'add' : 'remove';
            element.classList[method](className);
            return element.classList.contains(className);
        }
        return false;
    }
    // Has class name
    function hasClass(element, className) {
        return is.element(element) && element.classList.contains(className);
    }
    // Element matches selector
    function matches(element, selector) {
        const { prototype: prototype } = Element;
        function match() {
            return Array.from(document.querySelectorAll(selector)).includes(this);
        }
        const method = prototype.matches || prototype.webkitMatchesSelector || prototype.mozMatchesSelector || prototype.msMatchesSelector || match;
        return method.call(element, selector);
    }
    // Closest ancestor element matching selector (also tests element itself)
    function closest$1(element, selector) {
        const { prototype: prototype } = Element;
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
        function closestElement() {
            let el = this;
            do {
                if (matches.matches(el, selector)) return el;
                el = el.parentElement || el.parentNode;
            }while (el !== null && el.nodeType === 1);
            return null;
        }
        const method = prototype.closest || closestElement;
        return method.call(element, selector);
    }
    // Find all elements
    function getElements(selector) {
        return this.elements.container.querySelectorAll(selector);
    }
    // Find a single element
    function getElement(selector) {
        return this.elements.container.querySelector(selector);
    }
    // Set focus and tab focus class
    function setFocus(element = null, focusVisible = false) {
        if (!is.element(element)) return;
        // Set regular focus
        element.focus({
            preventScroll: true,
            focusVisible: focusVisible
        });
    }
    // ==========================================================================
    // Plyr support checks
    // ==========================================================================
    // Default codecs for checking mimetype support
    const defaultCodecs = {
        'audio/ogg': 'vorbis',
        'audio/wav': '1',
        'video/webm': 'vp8, vorbis',
        'video/mp4': 'avc1.42E01E, mp4a.40.2',
        'video/ogg': 'theora'
    };
    // Check for feature support
    const support = {
        // Basic support
        audio: 'canPlayType' in document.createElement('audio'),
        video: 'canPlayType' in document.createElement('video'),
        // Check for support
        // Basic functionality vs full UI
        check (type, provider) {
            const api = support[type] || provider !== 'html5';
            const ui = api && support.rangeInput;
            return {
                api: api,
                ui: ui
            };
        },
        // Picture-in-picture support
        pip: (()=>{
            return document.pictureInPictureEnabled && !createElement('video').disablePictureInPicture;
        })(),
        // Airplay support
        // Safari only currently
        airplay: is.function(window.WebKitPlaybackTargetAvailabilityEvent),
        // Inline playback support
        // https://webkit.org/blog/6784/new-video-policies-for-ios/
        playsinline: 'playsInline' in document.createElement('video'),
        // Check for mime type support against a player instance
        // Credits: http://diveintohtml5.info/everything.html
        // Related: http://www.leanbackplayer.com/test/h5mt.html
        mime (input) {
            if (is.empty(input)) return false;
            const [mediaType] = input.split('/');
            let type = input;
            // Verify we're using HTML5 and there's no media type mismatch
            if (!this.isHTML5 || mediaType !== this.type) return false;
            // Add codec if required
            if (Object.keys(defaultCodecs).includes(type)) type += `; codecs="${defaultCodecs[input]}"`;
            try {
                return Boolean(type && this.media.canPlayType(type).replace(/no/, ''));
            } catch  {
                return false;
            }
        },
        // Check for textTracks support
        textTracks: 'textTracks' in document.createElement('video'),
        // <input type="range"> Sliders
        rangeInput: (()=>{
            const range = document.createElement('input');
            range.type = 'range';
            return range.type === 'range';
        })(),
        // Touch
        // NOTE: Remember a device can be mouse + touch enabled so we check on first touch event
        touch: 'ontouchstart' in document.documentElement,
        // Detect transitions support
        transitions: transitionEndEvent !== false,
        // Reduced motion iOS & MacOS setting
        // https://webkit.org/blog/7551/responsive-design-for-motion/
        reducedMotion: 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches
    };
    // ==========================================================================
    // Event utils
    // ==========================================================================
    // Check for passive event listener support
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // https://www.youtube.com/watch?v=NPM6172J22g
    const supportsPassiveListeners = (()=>{
        // Test via a getter in the options object to see if the passive property is accessed
        let supported = false;
        try {
            const options = Object.defineProperty({}, 'passive', {
                get () {
                    supported = true;
                    return null;
                }
            });
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        } catch  {}
        return supported;
    })();
    // Toggle event listener
    function toggleListener(element, event, callback, toggle = false, passive = true, capture = false) {
        // Bail if no element, event, or callback
        if (!element || !('addEventListener' in element) || is.empty(event) || !is.function(callback)) return;
        // Allow multiple events
        const events = event.split(' ');
        // Build options
        // Default to just the capture boolean for browsers with no passive listener support
        let options = capture;
        // If passive events listeners are supported
        if (supportsPassiveListeners) options = {
            passive: // Whether the listener can be passive (i.e. default never prevented)
            passive,
            capture: // Whether the listener is a capturing listener or not
            capture
        };
        // If a single node is passed, bind the event listener
        events.forEach((type)=>{
            if (this && this.eventListeners && toggle) // Cache event listener
            this.eventListeners.push({
                element: element,
                type: type,
                callback: callback,
                options: options
            });
            element[toggle ? 'addEventListener' : 'removeEventListener'](type, callback, options);
        });
    }
    // Bind event handler
    function on(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, true, passive, capture);
    }
    // Unbind event handler
    function off(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, false, passive, capture);
    }
    // Bind once-only event handler
    function once(element, events = '', callback, passive = true, capture = false) {
        const onceCallback = (...args)=>{
            off(element, events, onceCallback, passive, capture);
            callback.apply(this, args);
        };
        toggleListener.call(this, element, events, onceCallback, true, passive, capture);
    }
    // Trigger event
    function triggerEvent(element, type = '', bubbles = false, detail = {}) {
        // Bail if no element
        if (!is.element(element) || is.empty(type)) return;
        // Create and dispatch the event
        const event = new CustomEvent(type, {
            bubbles: bubbles,
            detail: {
                ...detail,
                plyr: this
            }
        });
        // Dispatch the event
        element.dispatchEvent(event);
    }
    // Unbind all cached event listeners
    function unbindListeners() {
        if (this && this.eventListeners) {
            this.eventListeners.forEach((item)=>{
                const { element: element, type: type, callback: callback, options: options } = item;
                element.removeEventListener(type, callback, options);
            });
            this.eventListeners = [];
        }
    }
    // Run method when / if player is ready
    function ready() {
        return new Promise((resolve)=>this.ready ? setTimeout(resolve, 0) : on.call(this, this.elements.container, 'ready', resolve)).then(()=>{});
    }
    /**
   * Silence a Promise-like object.
   * This is useful for avoiding non-harmful, but potentially confusing "uncaught
   * play promise" rejection error messages.
   * @param  {object} value An object that may or may not be `Promise`-like.
   */ function silencePromise(value) {
        if (is.promise(value)) value.then(null, ()=>{});
    }
    // ==========================================================================
    // Array utils
    // ==========================================================================
    // Remove duplicates in an array
    function dedupe(array) {
        if (!is.array(array)) return array;
        return array.filter((item, index)=>array.indexOf(item) === index);
    }
    // Get the closest value in an array
    function closest(array, value) {
        if (!is.array(array) || !array.length) return null;
        return array.reduce((prev, curr)=>Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    }
    // ==========================================================================
    // Style utils
    // ==========================================================================
    // Check support for a CSS declaration
    function supportsCSS(declaration) {
        if (!window || !window.CSS) return false;
        return window.CSS.supports(declaration);
    }
    // Standard/common aspect ratios
    const standardRatios = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((out, [x, y])=>({
            ...out,
            [x / y]: [
                x,
                y
            ]
        }), {});
    // Validate an aspect ratio
    function validateAspectRatio(input) {
        if (!is.array(input) && (!is.string(input) || !input.includes(':'))) return false;
        const ratio = is.array(input) ? input : input.split(':');
        return ratio.map(Number).every(is.number);
    }
    // Reduce an aspect ratio to it's lowest form
    function reduceAspectRatio(ratio) {
        if (!is.array(ratio) || !ratio.every(is.number)) return null;
        const [width, height] = ratio;
        const getDivider = (w, h)=>h === 0 ? w : getDivider(h, w % h);
        const divider = getDivider(width, height);
        return [
            width / divider,
            height / divider
        ];
    }
    // Calculate an aspect ratio
    function getAspectRatio(input) {
        const parse = (ratio)=>validateAspectRatio(ratio) ? ratio.split(':').map(Number) : null;
        // Try provided ratio
        let ratio = parse(input);
        // Get from config
        if (ratio === null) ratio = parse(this.config.ratio);
        // Get from embed
        if (ratio === null && !is.empty(this.embed) && is.array(this.embed.ratio)) ({ ratio: ratio } = this.embed);
        // Get from HTML5 video
        if (ratio === null && this.isHTML5) {
            const { videoWidth: videoWidth, videoHeight: videoHeight } = this.media;
            ratio = [
                videoWidth,
                videoHeight
            ];
        }
        return reduceAspectRatio(ratio);
    }
    // Set aspect ratio for responsive container
    function setAspectRatio(input) {
        if (!this.isVideo) return {};
        const { wrapper: wrapper } = this.elements;
        const ratio = getAspectRatio.call(this, input);
        if (!is.array(ratio)) return {};
        const [x, y] = reduceAspectRatio(ratio);
        const useNative = supportsCSS(`aspect-ratio: ${x}/${y}`);
        const padding = 100 / x * y;
        if (useNative) wrapper.style.aspectRatio = `${x}/${y}`;
        else wrapper.style.paddingBottom = `${padding}%`;
        // For Vimeo we have an extra <div> to hide the standard controls and UI
        if (this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const height = 100 / this.media.offsetWidth * Number.parseInt(window.getComputedStyle(this.media).paddingBottom, 10);
            const offset = (height - padding) / (height / 50);
            if (this.fullscreen.active) wrapper.style.paddingBottom = null;
            else this.media.style.transform = `translateY(-${offset}%)`;
        } else if (this.isHTML5) wrapper.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: padding,
            ratio: ratio
        };
    }
    // Round an aspect ratio to closest standard ratio
    function roundAspectRatio(x, y, tolerance = 0.05) {
        const ratio = x / y;
        const closestRatio = closest(Object.keys(standardRatios), ratio);
        // Check match is within tolerance
        if (Math.abs(closestRatio - ratio) <= tolerance) return standardRatios[closestRatio];
        // No match
        return [
            x,
            y
        ];
    }
    // Get the size of the viewport
    // https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
    function getViewportSize() {
        const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        return [
            width,
            height
        ];
    }
    // ==========================================================================
    // Plyr HTML5 helpers
    // ==========================================================================
    const html5 = {
        getSources () {
            if (!this.isHTML5) return [];
            const sources = Array.from(this.media.querySelectorAll('source'));
            // Filter out unsupported sources (if type is specified)
            return sources.filter((source)=>{
                const type = source.getAttribute('type');
                if (is.empty(type)) return true;
                return support.mime.call(this, type);
            });
        },
        // Get quality levels
        getQualityOptions () {
            // Whether we're forcing all options (e.g. for streaming)
            if (this.config.quality.forced) return this.config.quality.options;
            // Get sizes from <source> elements
            return html5.getSources.call(this).map((source)=>Number(source.getAttribute('size'))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const player = this;
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set aspect ratio if fixed
            if (!is.empty(this.config.ratio)) setAspectRatio.call(player);
            // Quality
            Object.defineProperty(player.media, 'quality', {
                get () {
                    // Get sources
                    const sources = html5.getSources.call(player);
                    const source = sources.find((s)=>s.getAttribute('src') === player.source);
                    // Return size, if match is found
                    return source && Number(source.getAttribute('size'));
                },
                set (input) {
                    if (player.quality === input) return;
                    // If we're using an external handler...
                    if (player.config.quality.forced && is.function(player.config.quality.onChange)) player.config.quality.onChange(input);
                    else {
                        // Get sources
                        const sources = html5.getSources.call(player);
                        // Get first match for requested size
                        const source = sources.find((s)=>Number(s.getAttribute('size')) === input);
                        // No matching source found
                        if (!source) return;
                        // Get current state
                        const { currentTime: currentTime, paused: paused, preload: preload, readyState: readyState, playbackRate: playbackRate } = player.media;
                        // Set new source
                        player.media.src = source.getAttribute('src');
                        // Prevent loading if preload="none" and the current source isn't loaded (#1044)
                        if (preload !== 'none' || readyState) {
                            // Restore time
                            player.once('loadedmetadata', ()=>{
                                player.speed = playbackRate;
                                player.currentTime = currentTime;
                                // Resume playing
                                if (!paused) silencePromise(player.play());
                            });
                            // Load new source
                            player.media.load();
                        }
                    }
                    // Trigger change event
                    triggerEvent.call(player, player.media, 'qualitychange', false, {
                        quality: input
                    });
                }
            });
        },
        // Cancel current network requests
        // See https://github.com/sampotts/plyr/issues/174
        cancelRequests () {
            if (!this.isHTML5) return;
            // Remove child sources
            removeElement(html5.getSources.call(this));
            // Set blank video src attribute
            // This is to prevent a MEDIA_ERR_SRC_NOT_SUPPORTED error
            // Info: http://stackoverflow.com/questions/32231579/how-to-properly-dispose-of-an-html5-video-and-close-socket-or-connection
            this.media.setAttribute('src', this.config.blankVideo);
            // Load the new empty source
            // This will cancel existing requests
            // See https://github.com/sampotts/plyr/issues/174
            this.media.load();
            // Debugging
            this.debug.log('Cancelled network requests');
        }
    };
    // ==========================================================================
    // Browser sniffing
    // Unfortunately, due to mixed support, UA sniffing is required
    // ==========================================================================
    const isIE = Boolean(window.document.documentMode);
    const isEdge = /Edge/.test(navigator.userAgent);
    const isWebKit = 'WebkitAppearance' in document.documentElement.style && !/Edge/.test(navigator.userAgent);
    // navigator.platform may be deprecated but this check is still required
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isIos = /iPad|iPhone|iPod/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
    var browser = {
        isIE: isIE,
        isEdge: isEdge,
        isWebKit: isWebKit,
        isIPadOS: isIPadOS,
        isIos: isIos
    };
    // ==========================================================================
    // String utils
    // ==========================================================================
    // Generate a random ID
    function generateId(prefix) {
        return `${prefix}-${Math.floor(Math.random() * 10000)}`;
    }
    // Format string
    function format(input, ...args) {
        if (is.empty(input)) return input;
        return input.toString().replace(/\{(\d+)\}/g, (_, i)=>args[i].toString());
    }
    // Get percentage
    function getPercentage(current, max) {
        if (current === 0 || max === 0 || Number.isNaN(current) || Number.isNaN(max)) return 0;
        return (current / max * 100).toFixed(2);
    }
    // Replace all occurrences of a string in a string
    function replaceAll(input = '', find = '', replace = '') {
        return input.replace(new RegExp(find.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g'), replace.toString());
    }
    // Convert to title case
    function toTitleCase(input = '') {
        return input.toString().replace(/\w\S*/g, (text)=>text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());
    }
    // Convert string to pascalCase
    function toPascalCase(input = '') {
        let string = input.toString();
        // Convert kebab case
        string = replaceAll(string, '-', ' ');
        // Convert snake case
        string = replaceAll(string, '_', ' ');
        // Convert to title case
        string = toTitleCase(string);
        // Convert to pascal case
        return replaceAll(string, ' ', '');
    }
    // Convert string to pascalCase
    function toCamelCase(input = '') {
        let string = input.toString();
        // Convert to pascal case
        string = toPascalCase(string);
        // Convert first character to lowercase
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    // Remove HTML from a string
    function stripHTML(source) {
        const fragment = document.createDocumentFragment();
        const element = document.createElement('div');
        fragment.appendChild(element);
        element.innerHTML = source;
        return fragment.firstChild.textContent;
    }
    // Like outerHTML, but also works for DocumentFragment
    function getHTML(element) {
        const wrapper = document.createElement('div');
        wrapper.appendChild(element);
        return wrapper.innerHTML;
    }
    // ==========================================================================
    // Plyr internationalization
    // ==========================================================================
    // Skip i18n for abbreviations and brand names
    const resources = {
        pip: 'PIP',
        airplay: 'AirPlay',
        html5: 'HTML5',
        vimeo: 'Vimeo',
        youtube: 'YouTube'
    };
    const i18n = {
        get (key = '', config = {}) {
            if (is.empty(key) || is.empty(config)) return '';
            let string = getDeep(config.i18n, key);
            if (is.empty(string)) {
                if (Object.keys(resources).includes(key)) return resources[key];
                return '';
            }
            const replace = {
                '{seektime}': config.seekTime,
                '{title}': config.title
            };
            Object.entries(replace).forEach(([k, v])=>{
                string = replaceAll(string, k, v);
            });
            return string;
        }
    };
    class Storage {
        constructor(player){
            _defineProperty$1(this, "get", (key)=>{
                if (!Storage.supported || !this.enabled) return null;
                const store = window.localStorage.getItem(this.key);
                if (is.empty(store)) return null;
                const json = JSON.parse(store);
                return is.string(key) && key.length ? json[key] : json;
            });
            _defineProperty$1(this, "set", (object)=>{
                // Bail if we don't have localStorage support or it's disabled
                if (!Storage.supported || !this.enabled) return;
                // Can only store objects
                if (!is.object(object)) return;
                // Get current storage
                let storage = this.get();
                // Default to empty object
                if (is.empty(storage)) storage = {};
                // Update the working copy of the values
                extend(storage, object);
                // Update storage
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(storage));
                } catch  {}
            });
            this.enabled = player.config.storage.enabled;
            this.key = player.config.storage.key;
        }
        // Check for actual support (see if we can use it)
        static get supported() {
            try {
                if (!('localStorage' in window)) return false;
                const test = '___test';
                // Try to use it (it might be disabled, e.g. user is in private mode)
                // see: https://github.com/sampotts/plyr/issues/131
                window.localStorage.setItem(test, test);
                window.localStorage.removeItem(test);
                return true;
            } catch  {
                return false;
            }
        }
    }
    // ==========================================================================
    // Fetch wrapper
    // Using XHR to avoid issues with older browsers
    // ==========================================================================
    function fetch(url, responseType = 'text', withCredentials = false) {
        return new Promise((resolve, reject)=>{
            try {
                const request = new XMLHttpRequest();
                // Check for CORS support
                if (!('withCredentials' in request)) return;
                // Set to true if needed for CORS
                if (withCredentials) request.withCredentials = true;
                request.addEventListener('load', ()=>{
                    if (responseType === 'text') try {
                        resolve(JSON.parse(request.responseText));
                    } catch  {
                        resolve(request.responseText);
                    }
                    else resolve(request.response);
                });
                request.addEventListener('error', ()=>{
                    throw new Error(request.status);
                });
                request.open('GET', url, true);
                request.responseType = responseType;
                request.send();
            } catch (error) {
                reject(error);
            }
        });
    }
    // ==========================================================================
    // Sprite loader
    // ==========================================================================
    // Load an external SVG sprite
    function loadSprite(url, id) {
        if (!is.string(url)) return;
        const prefix = 'cache';
        const hasId = is.string(id);
        let isCached = false;
        const exists = ()=>document.getElementById(id) !== null;
        const update = (container, data)=>{
            container.innerHTML = data;
            // Check again incase of race condition
            if (hasId && exists()) return;
            // Inject the SVG to the body
            document.body.insertAdjacentElement('afterbegin', container);
        };
        // Only load once if ID set
        if (!hasId || !exists()) {
            const useStorage = Storage.supported;
            // Create container
            const container = document.createElement('div');
            container.setAttribute('hidden', '');
            if (hasId) container.setAttribute('id', id);
            // Check in cache
            if (useStorage) {
                const cached = window.localStorage.getItem(`${prefix}-${id}`);
                isCached = cached !== null;
                if (isCached) {
                    const data = JSON.parse(cached);
                    update(container, data.content);
                }
            }
            // Get the sprite
            fetch(url).then((result)=>{
                if (is.empty(result)) return;
                if (useStorage) try {
                    window.localStorage.setItem(`${prefix}-${id}`, JSON.stringify({
                        content: result
                    }));
                } catch  {}
                update(container, result);
            }).catch(()=>{});
        }
    }
    // ==========================================================================
    // Time utils
    // ==========================================================================
    // Time helpers
    const getHours = (value)=>Math.trunc(value / 60 / 60 % 60, 10);
    const getMinutes = (value)=>Math.trunc(value / 60 % 60, 10);
    const getSeconds = (value)=>Math.trunc(value % 60, 10);
    // Format time to UI friendly string
    function formatTime(time = 0, displayHours = false, inverted = false) {
        // Bail if the value isn't a number
        if (!is.number(time)) return formatTime(undefined, displayHours, inverted);
        // Format time component to add leading zero
        const format = (value)=>`0${value}`.slice(-2);
        // Breakdown to hours, mins, secs
        let hours = getHours(time);
        const mins = getMinutes(time);
        const secs = getSeconds(time);
        // Do we need to display hours?
        if (displayHours || hours > 0) hours = `${hours}:`;
        else hours = '';
        // Render
        return `${inverted && time > 0 ? '-' : ''}${hours}${format(mins)}:${format(secs)}`;
    }
    // ==========================================================================
    // Plyr controls
    // TODO: This needs to be split into smaller files and cleaned up
    // ==========================================================================
    // TODO: Don't export a massive object - break down and create class
    const controls = {
        // Get icon URL
        getIconUrl () {
            const url = new URL(this.config.iconUrl, window.location);
            const host = window.location.host ? window.location.host : window.top.location.host;
            const cors = url.host !== host || browser.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: cors
            };
        },
        // Find the UI controls
        findElements () {
            try {
                this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper);
                // Buttons
                this.elements.buttons = {
                    play: getElements.call(this, this.config.selectors.buttons.play),
                    pause: getElement.call(this, this.config.selectors.buttons.pause),
                    restart: getElement.call(this, this.config.selectors.buttons.restart),
                    rewind: getElement.call(this, this.config.selectors.buttons.rewind),
                    fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
                    mute: getElement.call(this, this.config.selectors.buttons.mute),
                    pip: getElement.call(this, this.config.selectors.buttons.pip),
                    airplay: getElement.call(this, this.config.selectors.buttons.airplay),
                    settings: getElement.call(this, this.config.selectors.buttons.settings),
                    captions: getElement.call(this, this.config.selectors.buttons.captions),
                    fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
                };
                // Progress
                this.elements.progress = getElement.call(this, this.config.selectors.progress);
                // Inputs
                this.elements.inputs = {
                    seek: getElement.call(this, this.config.selectors.inputs.seek),
                    volume: getElement.call(this, this.config.selectors.inputs.volume)
                };
                // Display
                this.elements.display = {
                    buffer: getElement.call(this, this.config.selectors.display.buffer),
                    currentTime: getElement.call(this, this.config.selectors.display.currentTime),
                    duration: getElement.call(this, this.config.selectors.display.duration)
                };
                // Seek tooltip
                if (is.element(this.elements.progress)) this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`);
                return true;
            } catch (error) {
                // Log it
                this.debug.warn('It looks like there is a problem with your custom controls HTML', error);
                // Restore native video controls
                this.toggleNativeControls(true);
                return false;
            }
        },
        // Create <svg> icon
        createIcon (type, attributes) {
            const namespace = 'http://www.w3.org/2000/svg';
            const iconUrl = controls.getIconUrl.call(this);
            const iconPath = `${!iconUrl.cors ? iconUrl.url : ''}#${this.config.iconPrefix}`;
            // Create <svg>
            const icon = document.createElementNS(namespace, 'svg');
            setAttributes(icon, extend(attributes, {
                'aria-hidden': 'true',
                'focusable': 'false'
            }));
            // Create the <use> to reference sprite
            const use = document.createElementNS(namespace, 'use');
            const path = `${iconPath}-${type}`;
            // Set `href` attributes
            // https://github.com/sampotts/plyr/issues/460
            // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
            if ('href' in use) use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            // Always set the older attribute even though it's "deprecated" (it'll be around for ages)
            use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', path);
            // Add <use> to <svg>
            icon.appendChild(use);
            return icon;
        },
        // Create hidden text label
        createLabel (key, attr = {}) {
            const text = i18n.get(key, this.config);
            const attributes = {
                ...attr,
                class: [
                    attr.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(' ')
            };
            return createElement('span', attributes, text);
        },
        // Create a badge
        createBadge (text) {
            if (is.empty(text)) return null;
            const badge = createElement('span', {
                class: this.config.classNames.menu.value
            });
            badge.appendChild(createElement('span', {
                class: this.config.classNames.menu.badge
            }, text));
            return badge;
        },
        // Create a <button>
        createButton (buttonType, attr) {
            const attributes = extend({}, attr);
            let type = toCamelCase(buttonType);
            const props = {
                element: 'button',
                toggle: false,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            [
                'element',
                'icon',
                'label'
            ].forEach((key)=>{
                if (Object.keys(attributes).includes(key)) {
                    props[key] = attributes[key];
                    delete attributes[key];
                }
            });
            // Default to 'button' type to prevent form submission
            if (props.element === 'button' && !Object.keys(attributes).includes('type')) attributes.type = 'button';
            // Set class name
            if (Object.keys(attributes).includes('class')) {
                if (!attributes.class.split(' ').includes(this.config.classNames.control)) extend(attributes, {
                    class: `${attributes.class} ${this.config.classNames.control}`
                });
            } else attributes.class = this.config.classNames.control;
            // Large play button
            switch(buttonType){
                case 'play':
                    props.toggle = true;
                    props.label = 'play';
                    props.labelPressed = 'pause';
                    props.icon = 'play';
                    props.iconPressed = 'pause';
                    break;
                case 'mute':
                    props.toggle = true;
                    props.label = 'mute';
                    props.labelPressed = 'unmute';
                    props.icon = 'volume';
                    props.iconPressed = 'muted';
                    break;
                case 'captions':
                    props.toggle = true;
                    props.label = 'enableCaptions';
                    props.labelPressed = 'disableCaptions';
                    props.icon = 'captions-off';
                    props.iconPressed = 'captions-on';
                    break;
                case 'fullscreen':
                    props.toggle = true;
                    props.label = 'enterFullscreen';
                    props.labelPressed = 'exitFullscreen';
                    props.icon = 'enter-fullscreen';
                    props.iconPressed = 'exit-fullscreen';
                    break;
                case 'play-large':
                    attributes.class += ` ${this.config.classNames.control}--overlaid`;
                    type = 'play';
                    props.label = 'play';
                    props.icon = 'play';
                    break;
                default:
                    if (is.empty(props.label)) props.label = type;
                    if (is.empty(props.icon)) props.icon = buttonType;
            }
            const button = createElement(props.element);
            // Setup toggle icon and labels
            if (props.toggle) {
                // Icon
                button.appendChild(controls.createIcon.call(this, props.iconPressed, {
                    class: 'icon--pressed'
                }));
                button.appendChild(controls.createIcon.call(this, props.icon, {
                    class: 'icon--not-pressed'
                }));
                // Label/Tooltip
                button.appendChild(controls.createLabel.call(this, props.labelPressed, {
                    class: 'label--pressed'
                }));
                button.appendChild(controls.createLabel.call(this, props.label, {
                    class: 'label--not-pressed'
                }));
            } else {
                button.appendChild(controls.createIcon.call(this, props.icon));
                button.appendChild(controls.createLabel.call(this, props.label));
            }
            // Merge and set attributes
            extend(attributes, getAttributesFromSelector(this.config.selectors.buttons[type], attributes));
            setAttributes(button, attributes);
            // We have multiple play buttons
            if (type === 'play') {
                if (!is.array(this.elements.buttons[type])) this.elements.buttons[type] = [];
                this.elements.buttons[type].push(button);
            } else this.elements.buttons[type] = button;
            return button;
        },
        // Create an <input type='range'>
        createRange (type, attributes) {
            // Seek input
            const input = createElement('input', extend(getAttributesFromSelector(this.config.selectors.inputs[type]), {
                'type': 'range',
                'min': 0,
                'max': 100,
                'step': 0.01,
                'value': 0,
                'autocomplete': 'off',
                // A11y fixes for https://github.com/sampotts/plyr/issues/905
                'role': 'slider',
                'aria-label': i18n.get(type, this.config),
                'aria-valuemin': 0,
                'aria-valuemax': 100,
                'aria-valuenow': 0
            }, attributes));
            this.elements.inputs[type] = input;
            // Set the fill for webkit now
            controls.updateRangeFill.call(this, input);
            // Improve support on touch devices
            RangeTouch.setup(input);
            return input;
        },
        // Create a <progress>
        createProgress (type, attributes) {
            const progress = createElement('progress', extend(getAttributesFromSelector(this.config.selectors.display[type]), {
                'min': 0,
                'max': 100,
                'value': 0,
                'role': 'progressbar',
                'aria-hidden': true
            }, attributes));
            // Create the label inside
            if (type !== 'volume') {
                progress.appendChild(createElement('span', null, '0'));
                const suffixKey = {
                    played: 'played',
                    buffer: 'buffered'
                }[type];
                const suffix = suffixKey ? i18n.get(suffixKey, this.config) : '';
                progress.textContent = `% ${suffix.toLowerCase()}`;
            }
            this.elements.display[type] = progress;
            return progress;
        },
        // Create time display
        createTime (type, attrs) {
            const attributes = getAttributesFromSelector(this.config.selectors.display[type], attrs);
            const container = createElement('div', extend(attributes, {
                'class': `${attributes.class ? attributes.class : ''} ${this.config.classNames.display.time} `.trim(),
                'aria-label': i18n.get(type, this.config),
                'role': 'timer'
            }), '00:00');
            // Reference for updates
            this.elements.display[type] = container;
            return container;
        },
        // Bind keyboard shortcuts for a menu item
        // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        bindMenuItemShortcuts (menuItem, type) {
            // Navigate through menus via arrow keys and space
            on.call(this, menuItem, 'keydown keyup', (event)=>{
                // We only care about space and ⬆️ ⬇️️ ➡️
                if (![
                    ' ',
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight'
                ].includes(event.key)) return;
                // Prevent play / seek
                event.preventDefault();
                event.stopPropagation();
                // We're just here to prevent the keydown bubbling
                if (event.type === 'keydown') return;
                const isRadioButton = matches(menuItem, '[role="menuitemradio"]');
                // Show the respective menu
                if (!isRadioButton && [
                    ' ',
                    'ArrowRight'
                ].includes(event.key)) controls.showMenuPanel.call(this, type, true);
                else {
                    let target;
                    if (event.key !== ' ') {
                        if (event.key === 'ArrowDown' || isRadioButton && event.key === 'ArrowRight') {
                            target = menuItem.nextElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.firstElementChild;
                        } else {
                            target = menuItem.previousElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.lastElementChild;
                        }
                        setFocus.call(this, target, true);
                    }
                }
            }, false);
            // Enter will fire a `click` event but we still need to manage focus
            // So we bind to keyup which fires after and set focus here
            on.call(this, menuItem, 'keyup', (event)=>{
                if (event.key !== 'Return') return;
                controls.focusFirstMenuItem.call(this, null, true);
            });
        },
        // Create a settings menu item
        createMenuItem ({ value: value, list: list, type: type, title: title, badge: badge = null, checked: checked = false }) {
            const attributes = getAttributesFromSelector(this.config.selectors.inputs[type]);
            const menuItem = createElement('button', extend(attributes, {
                'type': 'button',
                'role': 'menuitemradio',
                'class': `${this.config.classNames.control} ${attributes.class ? attributes.class : ''}`.trim(),
                'aria-checked': checked,
                value: value
            }));
            const flex = createElement('span');
            // We have to set as HTML incase of special characters
            flex.innerHTML = title;
            if (is.element(badge)) flex.appendChild(badge);
            menuItem.appendChild(flex);
            // Replicate radio button behavior
            Object.defineProperty(menuItem, 'checked', {
                enumerable: true,
                get () {
                    return menuItem.getAttribute('aria-checked') === 'true';
                },
                set (check) {
                    // Ensure exclusivity
                    if (check) Array.from(menuItem.parentNode.children).filter((node)=>matches(node, '[role="menuitemradio"]')).forEach((node)=>node.setAttribute('aria-checked', 'false'));
                    menuItem.setAttribute('aria-checked', check ? 'true' : 'false');
                }
            });
            this.listeners.bind(menuItem, 'click keyup', (event)=>{
                if (is.keyboardEvent(event) && event.key !== ' ') return;
                event.preventDefault();
                event.stopPropagation();
                menuItem.checked = true;
                switch(type){
                    case 'language':
                        this.currentTrack = Number(value);
                        break;
                    case 'quality':
                        this.quality = value;
                        break;
                    case 'speed':
                        this.speed = Number.parseFloat(value);
                        break;
                }
                controls.showMenuPanel.call(this, 'home', is.keyboardEvent(event));
            }, type, false);
            controls.bindMenuItemShortcuts.call(this, menuItem, type);
            list.appendChild(menuItem);
        },
        // Format a time for display
        formatTime (time = 0, inverted = false) {
            // Bail if the value isn't a number
            if (!is.number(time)) return time;
            // Always display hours if duration is over an hour
            const forceHours = getHours(this.duration) > 0;
            return formatTime(time, forceHours, inverted);
        },
        // Update the displayed time
        updateTimeDisplay (target = null, time = 0, inverted = false) {
            // Bail if there's no element to display or the value isn't a number
            if (!is.element(target) || !is.number(time)) return;
            target.textContent = controls.formatTime(time, inverted);
        },
        // Update volume UI and storage
        updateVolume () {
            if (!this.supported.ui) return;
            // Update range
            if (is.element(this.elements.inputs.volume)) controls.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume);
            // Update mute state
            if (is.element(this.elements.buttons.mute)) this.elements.buttons.mute.pressed = this.muted || this.volume === 0;
        },
        // Update seek value and lower fill
        setRange (target, value = 0) {
            if (!is.element(target)) return;
            target.value = value;
            // Webkit range fill
            controls.updateRangeFill.call(this, target);
        },
        // Update <progress> elements
        updateProgress (event) {
            if (!this.supported.ui || !is.event(event)) return;
            let value = 0;
            const setProgress = (target, input)=>{
                const val = is.number(input) ? input : 0;
                const progress = is.element(target) ? target : this.elements.display.buffer;
                // Update value and label
                if (is.element(progress)) {
                    progress.value = val;
                    // Update text label inside
                    const label = progress.getElementsByTagName('span')[0];
                    if (is.element(label)) label.childNodes[0].nodeValue = val;
                }
            };
            if (event) switch(event.type){
                // Video playing
                case 'timeupdate':
                case 'seeking':
                case 'seeked':
                    value = getPercentage(this.currentTime, this.duration);
                    // Set seek range value only if it's a 'natural' time event
                    if (event.type === 'timeupdate') controls.setRange.call(this, this.elements.inputs.seek, value);
                    break;
                // Check buffer status
                case 'playing':
                case 'progress':
                    setProgress(this.elements.display.buffer, this.buffered * 100);
                    break;
            }
        },
        // Webkit polyfill for lower fill range
        updateRangeFill (target) {
            // Get range from event if event passed
            const range = is.event(target) ? target.target : target;
            // Needs to be a valid <input type='range'>
            if (!is.element(range) || range.getAttribute('type') !== 'range') return;
            // Set aria values for https://github.com/sampotts/plyr/issues/905
            if (matches(range, this.config.selectors.inputs.seek)) {
                range.setAttribute('aria-valuenow', this.currentTime);
                const currentTime = controls.formatTime(this.currentTime);
                const duration = controls.formatTime(this.duration);
                const format = i18n.get('seekLabel', this.config);
                range.setAttribute('aria-valuetext', format.replace('{currentTime}', currentTime).replace('{duration}', duration));
            } else if (matches(range, this.config.selectors.inputs.volume)) {
                const percent = range.value * 100;
                range.setAttribute('aria-valuenow', percent);
                range.setAttribute('aria-valuetext', `${percent.toFixed(1)}%`);
            } else range.setAttribute('aria-valuenow', range.value);
            // WebKit only
            if (!browser.isWebKit && !browser.isIPadOS) return;
            // Set CSS custom property
            range.style.setProperty('--value', `${range.value / range.max * 100}%`);
        },
        // Update hover tooltip for seeking
        updateSeekTooltip (event) {
            var _this$config$markers, _this$config$markers$;
            // Bail if setting not true
            if (!this.config.tooltips.seek || !is.element(this.elements.inputs.seek) || !is.element(this.elements.display.seekTooltip) || this.duration === 0) return;
            const tipElement = this.elements.display.seekTooltip;
            const visible = `${this.config.classNames.tooltip}--visible`;
            const toggle = (show)=>toggleClass(tipElement, visible, show);
            // Hide on touch
            if (this.touch) {
                toggle(false);
                return;
            }
            // Determine percentage, if already visible
            let percent = 0;
            const clientRect = this.elements.progress.getBoundingClientRect();
            if (is.event(event)) {
                const scrollLeft = event.pageX - event.clientX;
                percent = 100 / clientRect.width * (event.pageX - clientRect.left - scrollLeft);
            } else if (hasClass(tipElement, visible)) percent = Number.parseFloat(tipElement.style.left, 10);
            else return;
            // Set bounds
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const time = this.duration / 100 * percent;
            // Display the time a click would seek to
            tipElement.textContent = controls.formatTime(time);
            // Get marker point for time
            const point = (_this$config$markers = this.config.markers) === null || _this$config$markers === void 0 ? void 0 : (_this$config$markers$ = _this$config$markers.points) === null || _this$config$markers$ === void 0 ? void 0 : _this$config$markers$.find(({ time: t })=>t === Math.round(time));
            // Append the point label to the tooltip
            if (point) tipElement.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
            // Set position
            tipElement.style.left = `${percent}%`;
            // Show/hide the tooltip
            // If the event is a moues in/out and percentage is inside bounds
            if (is.event(event) && [
                'mouseenter',
                'mouseleave'
            ].includes(event.type)) toggle(event.type === 'mouseenter');
        },
        // Handle time change event
        timeUpdate (event) {
            // Only invert if only one time element is displayed and used for both duration and currentTime
            const invert = !is.element(this.elements.display.duration) && this.config.invertTime;
            // Duration
            controls.updateTimeDisplay.call(this, this.elements.display.currentTime, invert ? this.duration - this.currentTime : this.currentTime, invert);
            // Ignore updates while seeking
            if (event && event.type === 'timeupdate' && this.media.seeking) return;
            // Playing progress
            controls.updateProgress.call(this, event);
        },
        // Show the duration on metadataloaded or durationchange events
        durationUpdate () {
            // Bail if no UI or durationchange event triggered after playing/seek when invertTime is false
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            // If duration is the 2**32 (shaka), Infinity (HLS), DASH-IF (Number.MAX_SAFE_INTEGER || Number.MAX_VALUE) indicating live we hide the currentTime and progressbar.
            // https://github.com/video-dev/hls.js/blob/5820d29d3c4c8a46e8b75f1e3afa3e68c1a9a2db/src/controller/buffer-controller.js#L415
            // https://github.com/google/shaka-player/blob/4d889054631f4e1cf0fbd80ddd2b71887c02e232/lib/media/streaming_engine.js#L1062
            // https://github.com/Dash-Industry-Forum/dash.js/blob/69859f51b969645b234666800d4cb596d89c602d/src/dash/models/DashManifestModel.js#L338
            if (this.duration >= 2 ** 32) {
                toggleHidden(this.elements.display.currentTime, true);
                toggleHidden(this.elements.progress, true);
                return;
            }
            // Update ARIA values
            if (is.element(this.elements.inputs.seek)) this.elements.inputs.seek.setAttribute('aria-valuemax', this.duration);
            // If there's a spot to display duration
            const hasDuration = is.element(this.elements.display.duration);
            // If there's only one time display, display duration there
            if (!hasDuration && this.config.displayDuration && this.paused) controls.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration);
            // If there's a duration element, update content
            if (hasDuration) controls.updateTimeDisplay.call(this, this.elements.display.duration, this.duration);
            if (this.config.markers.enabled) controls.setMarkers.call(this);
            // Update the tooltip (if visible)
            controls.updateSeekTooltip.call(this);
        },
        // Hide/show a tab
        toggleMenuButton (setting, toggle) {
            toggleHidden(this.elements.settings.buttons[setting], !toggle);
        },
        // Update the selected setting
        updateSetting (setting, container, input) {
            const pane = this.elements.settings.panels[setting];
            let value = null;
            let list = container;
            if (setting === 'captions') value = this.currentTrack;
            else {
                value = !is.empty(input) ? input : this[setting];
                // Get default
                if (is.empty(value)) value = this.config[setting].default;
                // Unsupported value
                if (!is.empty(this.options[setting]) && !this.options[setting].includes(value)) {
                    this.debug.warn(`Unsupported value of '${value}' for ${setting}`);
                    return;
                }
                // Disabled value
                if (!this.config[setting].options.includes(value)) {
                    this.debug.warn(`Disabled value of '${value}' for ${setting}`);
                    return;
                }
            }
            // Get the list if we need to
            if (!is.element(list)) list = pane && pane.querySelector('[role="menu"]');
            // If there's no list it means it's not been rendered...
            if (!is.element(list)) return;
            // Update the label
            const label = this.elements.settings.buttons[setting].querySelector(`.${this.config.classNames.menu.value}`);
            label.innerHTML = controls.getLabel.call(this, setting, value);
            // Find the radio option and check it
            const target = list && list.querySelector(`[value="${value}"]`);
            if (is.element(target)) target.checked = true;
        },
        // Translate a value into a nice label
        getLabel (setting, value) {
            switch(setting){
                case 'speed':
                    return value === 1 ? i18n.get('normal', this.config) : `${value}&times;`;
                case 'quality':
                    if (is.number(value)) {
                        const label = i18n.get(`qualityLabel.${value}`, this.config);
                        if (!label.length) return `${value}p`;
                        return label;
                    }
                    return toTitleCase(value);
                case 'captions':
                    return captions.getLabel.call(this);
                default:
                    return null;
            }
        },
        // Set the quality menu
        setQualityMenu (options) {
            // Menu required
            if (!is.element(this.elements.settings.panels.quality)) return;
            const type = 'quality';
            const list = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            // Set options if passed and filter based on uniqueness and config
            if (is.array(options)) this.options.quality = dedupe(options).filter((quality)=>this.config.quality.options.includes(quality));
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.quality) && this.options.quality.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Get the badge HTML for HD, 4K etc
            const getBadge = (quality)=>{
                const label = i18n.get(`qualityBadge.${quality}`, this.config);
                if (!label.length) return null;
                return controls.createBadge.call(this, label);
            };
            // Sort options by the config and then render options
            this.options.quality.sort((a, b)=>{
                const sorting = this.config.quality.options;
                return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
            }).forEach((quality)=>{
                controls.createMenuItem.call(this, {
                    value: quality,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'quality', quality),
                    badge: getBadge(quality)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Set the looping options
        /* setLoopMenu() {
          // Menu required
          if (!is.element(this.elements.settings.panels.loop)) {
              return;
          }
           const options = ['start', 'end', 'all', 'reset'];
          const list = this.elements.settings.panels.loop.querySelector('[role="menu"]');
           // Show the pane and tab
          toggleHidden(this.elements.settings.buttons.loop, false);
          toggleHidden(this.elements.settings.panels.loop, false);
           // Toggle the pane and tab
          const toggle = !is.empty(this.loop.options);
          controls.toggleMenuButton.call(this, 'loop', toggle);
           // Empty the menu
          emptyElement(list);
           options.forEach(option => {
              const item = createElement('li');
               const button = createElement(
                  'button',
                  extend(getAttributesFromSelector(this.config.selectors.buttons.loop), {
                      type: 'button',
                      class: this.config.classNames.control,
                      'data-plyr-loop-action': option,
                  }),
                  i18n.get(option, this.config)
              );
               if (['start', 'end'].includes(option)) {
                  const badge = controls.createBadge.call(this, '00:00');
                  button.appendChild(badge);
              }
               item.appendChild(button);
              list.appendChild(item);
          });
      }, */ // Get current selected caption language
        // TODO: rework this to user the getter in the API?
        // Set a list of available captions languages
        setCaptionsMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.captions)) return;
            // TODO: Captions or language? Currently it's mixed
            const type = 'captions';
            const list = this.elements.settings.panels.captions.querySelector('[role="menu"]');
            const tracks = captions.getTracks.call(this);
            const toggle = Boolean(tracks.length);
            // Toggle the pane and tab
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If there's no captions, bail
            if (!toggle) return;
            // Generate options data
            const options = tracks.map((track, value)=>({
                    value: value,
                    checked: this.captions.toggled && this.currentTrack === value,
                    title: captions.getLabel.call(this, track),
                    badge: track.language && controls.createBadge.call(this, track.language.toUpperCase()),
                    list: list,
                    type: 'language'
                }));
            // Add the "Disabled" option to turn off captions
            options.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: i18n.get('disabled', this.config),
                list: list,
                type: 'language'
            });
            // Generate options
            options.forEach(controls.createMenuItem.bind(this));
            controls.updateSetting.call(this, type, list);
        },
        // Set a list of available captions languages
        setSpeedMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.speed)) return;
            const type = 'speed';
            const list = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            // Filter out invalid speeds
            this.options.speed = this.options.speed.filter((o)=>o >= this.minimumSpeed && o <= this.maximumSpeed);
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.speed) && this.options.speed.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Create items
            this.options.speed.forEach((speed)=>{
                controls.createMenuItem.call(this, {
                    value: speed,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'speed', speed)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Check if we need to hide/show the settings menu
        checkMenu () {
            const { buttons: buttons } = this.elements.settings;
            const visible = !is.empty(buttons) && Object.values(buttons).some((button)=>!button.hidden);
            toggleHidden(this.elements.settings.menu, !visible);
        },
        // Focus the first menu item in a given (or visible) menu
        focusFirstMenuItem (pane, focusVisible = false) {
            if (this.elements.settings.popup.hidden) return;
            let target = pane;
            if (!is.element(target)) target = Object.values(this.elements.settings.panels).find((p)=>!p.hidden);
            const firstItem = target.querySelector('[role^="menuitem"]');
            setFocus.call(this, firstItem, focusVisible);
        },
        // Show/hide menu
        toggleMenu (input) {
            const { popup: popup } = this.elements.settings;
            const button = this.elements.buttons.settings;
            // Menu and button are required
            if (!is.element(popup) || !is.element(button)) return;
            // True toggle by default
            const { hidden: hidden } = popup;
            let show = hidden;
            if (is.boolean(input)) show = input;
            else if (is.keyboardEvent(input) && input.key === 'Escape') show = false;
            else if (is.event(input)) {
                // If Plyr is in a shadowDOM, the event target is set to the component, instead of the
                // Element in the shadowDOM. The path, if available, is complete.
                const target = is.function(input.composedPath) ? input.composedPath()[0] : input.target;
                const isMenuItem = popup.contains(target);
                // If the click was inside the menu or if the click
                // wasn't the button or menu item and we're trying to
                // show the menu (a doc click shouldn't show the menu)
                if (isMenuItem || !isMenuItem && input.target !== button && show) return;
            }
            // Set button attributes
            button.setAttribute('aria-expanded', show);
            // Show the actual popup
            toggleHidden(popup, !show);
            // Add class hook
            toggleClass(this.elements.container, this.config.classNames.menu.open, show);
            // Focus the first item if key interaction
            if (show && is.keyboardEvent(input)) controls.focusFirstMenuItem.call(this, null, true);
            else if (!show && !hidden) // If closing, re-focus the button
            setFocus.call(this, button, is.keyboardEvent(input));
        },
        // Get the natural size of a menu panel
        getMenuSize (tab) {
            const clone = tab.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.opacity = 0;
            clone.removeAttribute('hidden');
            // Append to parent so we get the "real" size
            tab.parentNode.appendChild(clone);
            // Get the sizes before we remove
            const width = clone.scrollWidth;
            const height = clone.scrollHeight;
            // Remove from the DOM
            removeElement(clone);
            return {
                width: width,
                height: height
            };
        },
        // Show a panel in the menu
        showMenuPanel (type = '', focusVisible = false) {
            const target = this.elements.container.querySelector(`#plyr-settings-${this.id}-${type}`);
            // Nothing to show, bail
            if (!is.element(target)) return;
            // Hide all other panels
            const container = target.parentNode;
            const current = Array.from(container.children).find((node)=>!node.hidden);
            // If we can do fancy animations, we'll animate the height/width
            if (support.transitions && !support.reducedMotion) {
                // Set the current width as a base
                container.style.width = `${current.scrollWidth}px`;
                container.style.height = `${current.scrollHeight}px`;
                // Get potential sizes
                const size = controls.getMenuSize.call(this, target);
                // Restore auto height/width
                const restore = (event)=>{
                    // We're only bothered about height and width on the container
                    if (event.target !== container || ![
                        'width',
                        'height'
                    ].includes(event.propertyName)) return;
                    // Revert back to auto
                    container.style.width = '';
                    container.style.height = '';
                    // Only listen once
                    off.call(this, container, transitionEndEvent, restore);
                };
                // Listen for the transition finishing and restore auto height/width
                on.call(this, container, transitionEndEvent, restore);
                // Set dimensions to target
                container.style.width = `${size.width}px`;
                container.style.height = `${size.height}px`;
            }
            // Set attributes on current tab
            toggleHidden(current, true);
            // Set attributes on target
            toggleHidden(target, false);
            // Focus the first item
            controls.focusFirstMenuItem.call(this, target, focusVisible);
        },
        // Set the download URL
        setDownloadUrl () {
            const button = this.elements.buttons.download;
            // Bail if no button
            if (!is.element(button)) return;
            // Set attribute
            button.setAttribute('href', this.download);
        },
        // Build the default HTML
        create (data) {
            const { bindMenuItemShortcuts: bindMenuItemShortcuts, createButton: createButton, createProgress: createProgress, createRange: createRange, createTime: createTime, setQualityMenu: setQualityMenu, setSpeedMenu: setSpeedMenu, showMenuPanel: showMenuPanel } = controls;
            this.elements.controls = null;
            // Larger overlaid play button
            if (is.array(this.config.controls) && this.config.controls.includes('play-large')) this.elements.container.appendChild(createButton.call(this, 'play-large'));
            // Create the container
            const container = createElement('div', getAttributesFromSelector(this.config.selectors.controls.wrapper));
            this.elements.controls = container;
            // Default item attributes
            const defaultAttributes = {
                class: 'plyr__controls__item'
            };
            // Loop through controls in order
            dedupe(is.array(this.config.controls) ? this.config.controls : []).forEach((control)=>{
                // Restart button
                if (control === 'restart') container.appendChild(createButton.call(this, 'restart', defaultAttributes));
                // Rewind button
                if (control === 'rewind') container.appendChild(createButton.call(this, 'rewind', defaultAttributes));
                // Play/Pause button
                if (control === 'play') container.appendChild(createButton.call(this, 'play', defaultAttributes));
                // Fast forward button
                if (control === 'fast-forward') container.appendChild(createButton.call(this, 'fast-forward', defaultAttributes));
                // Progress
                if (control === 'progress') {
                    const progressContainer = createElement('div', {
                        class: `${defaultAttributes.class} plyr__progress__container`
                    });
                    const progress = createElement('div', getAttributesFromSelector(this.config.selectors.progress));
                    // Seek range slider
                    progress.appendChild(createRange.call(this, 'seek', {
                        id: `plyr-seek-${data.id}`
                    }));
                    // Buffer progress
                    progress.appendChild(createProgress.call(this, 'buffer'));
                    // TODO: Add loop display indicator
                    // Seek tooltip
                    if (this.config.tooltips.seek) {
                        const tooltip = createElement('span', {
                            class: this.config.classNames.tooltip
                        }, '00:00');
                        progress.appendChild(tooltip);
                        this.elements.display.seekTooltip = tooltip;
                    }
                    this.elements.progress = progress;
                    progressContainer.appendChild(this.elements.progress);
                    container.appendChild(progressContainer);
                }
                // Media current time display
                if (control === 'current-time') container.appendChild(createTime.call(this, 'currentTime', defaultAttributes));
                // Media duration display
                if (control === 'duration') container.appendChild(createTime.call(this, 'duration', defaultAttributes));
                // Volume controls
                if (control === 'mute' || control === 'volume') {
                    let { volume: volume } = this.elements;
                    // Create the volume container if needed
                    if (!is.element(volume) || !container.contains(volume)) {
                        volume = createElement('div', extend({}, defaultAttributes, {
                            class: `${defaultAttributes.class} plyr__volume`.trim()
                        }));
                        this.elements.volume = volume;
                        container.appendChild(volume);
                    }
                    // Toggle mute button
                    if (control === 'mute') volume.appendChild(createButton.call(this, 'mute'));
                    // Volume range control
                    // Ignored on iOS as it's handled globally
                    // https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
                    if (control === 'volume' && !browser.isIos && !browser.isIPadOS) {
                        // Set the attributes
                        const attributes = {
                            max: 1,
                            step: 0.05,
                            value: this.config.volume
                        };
                        // Create the volume range slider
                        volume.appendChild(createRange.call(this, 'volume', extend(attributes, {
                            id: `plyr-volume-${data.id}`
                        })));
                    }
                }
                // Toggle captions button
                if (control === 'captions') container.appendChild(createButton.call(this, 'captions', defaultAttributes));
                // Settings button / menu
                if (control === 'settings' && !is.empty(this.config.settings)) {
                    const wrapper = createElement('div', extend({}, defaultAttributes, {
                        class: `${defaultAttributes.class} plyr__menu`.trim(),
                        hidden: ''
                    }));
                    wrapper.appendChild(createButton.call(this, 'settings', {
                        'aria-haspopup': true,
                        'aria-controls': `plyr-settings-${data.id}`,
                        'aria-expanded': false
                    }));
                    const popup = createElement('div', {
                        class: 'plyr__menu__container',
                        id: `plyr-settings-${data.id}`,
                        hidden: ''
                    });
                    const inner = createElement('div');
                    const home = createElement('div', {
                        id: `plyr-settings-${data.id}-home`
                    });
                    // Create the menu
                    const menu = createElement('div', {
                        role: 'menu'
                    });
                    home.appendChild(menu);
                    inner.appendChild(home);
                    this.elements.settings.panels.home = home;
                    // Build the menu items
                    this.config.settings.forEach((type)=>{
                        // TODO: bundle this with the createMenuItem helper and bindings
                        const menuItem = createElement('button', extend(getAttributesFromSelector(this.config.selectors.buttons.settings), {
                            'type': 'button',
                            'class': `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            'role': 'menuitem',
                            'aria-haspopup': true,
                            'hidden': ''
                        }));
                        // Bind menu shortcuts for keyboard users
                        bindMenuItemShortcuts.call(this, menuItem, type);
                        // Show menu on click
                        on.call(this, menuItem, 'click', ()=>{
                            showMenuPanel.call(this, type, false);
                        });
                        const flex = createElement('span', null, i18n.get(type, this.config));
                        const value = createElement('span', {
                            class: this.config.classNames.menu.value
                        });
                        // Speed contains HTML entities
                        value.innerHTML = data[type];
                        flex.appendChild(value);
                        menuItem.appendChild(flex);
                        menu.appendChild(menuItem);
                        // Build the panes
                        const pane = createElement('div', {
                            id: `plyr-settings-${data.id}-${type}`,
                            hidden: ''
                        });
                        // Back button
                        const backButton = createElement('button', {
                            type: 'button',
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        // Visible label
                        backButton.appendChild(createElement('span', {
                            'aria-hidden': true
                        }, i18n.get(type, this.config)));
                        // Screen reader label
                        backButton.appendChild(createElement('span', {
                            class: this.config.classNames.hidden
                        }, i18n.get('menuBack', this.config)));
                        // Go back via keyboard
                        on.call(this, pane, 'keydown', (event)=>{
                            if (event.key !== 'ArrowLeft') return;
                            // Prevent seek
                            event.preventDefault();
                            event.stopPropagation();
                            // Show the respective menu
                            showMenuPanel.call(this, 'home', true);
                        }, false);
                        // Go back via button click
                        on.call(this, backButton, 'click', ()=>{
                            showMenuPanel.call(this, 'home', false);
                        });
                        // Add to pane
                        pane.appendChild(backButton);
                        // Menu
                        pane.appendChild(createElement('div', {
                            role: 'menu'
                        }));
                        inner.appendChild(pane);
                        this.elements.settings.buttons[type] = menuItem;
                        this.elements.settings.panels[type] = pane;
                    });
                    popup.appendChild(inner);
                    wrapper.appendChild(popup);
                    container.appendChild(wrapper);
                    this.elements.settings.popup = popup;
                    this.elements.settings.menu = wrapper;
                }
                // Picture in picture button
                if (control === 'pip' && support.pip) container.appendChild(createButton.call(this, 'pip', defaultAttributes));
                // Airplay button
                if (control === 'airplay' && support.airplay) container.appendChild(createButton.call(this, 'airplay', defaultAttributes));
                // Download button
                if (control === 'download') {
                    const attributes = extend({}, defaultAttributes, {
                        element: 'a',
                        href: this.download,
                        target: '_blank'
                    });
                    // Set download attribute for HTML5 only
                    if (this.isHTML5) attributes.download = '';
                    const { download: download } = this.config.urls;
                    if (!is.url(download) && this.isEmbed) extend(attributes, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    });
                    container.appendChild(createButton.call(this, 'download', attributes));
                }
                // Toggle fullscreen button
                if (control === 'fullscreen') container.appendChild(createButton.call(this, 'fullscreen', defaultAttributes));
            });
            // Set available quality levels
            if (this.isHTML5) setQualityMenu.call(this, html5.getQualityOptions.call(this));
            setSpeedMenu.call(this);
            return container;
        },
        // Insert controls
        inject () {
            // Sprite
            if (this.config.loadSprite) {
                const icon = controls.getIconUrl.call(this);
                // Only load external sprite using AJAX
                if (icon.cors) loadSprite(icon.url, 'sprite-plyr');
            }
            // Create a unique ID
            this.id = Math.floor(Math.random() * 10000);
            // Null by default
            let container = null;
            this.elements.controls = null;
            // Set template properties
            const props = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let update = true;
            // If function, run it and use output
            if (is.function(this.config.controls)) this.config.controls = this.config.controls.call(this, props);
            // Convert falsy controls to empty array (primarily for empty strings)
            if (!this.config.controls) this.config.controls = [];
            if (is.element(this.config.controls) || is.string(this.config.controls)) // HTMLElement or Non-empty string passed as the option
            container = this.config.controls;
            else {
                // Create controls
                container = controls.create.call(this, {
                    id: this.id,
                    seektime: this.config.seekTime,
                    speed: this.speed,
                    quality: this.quality,
                    captions: captions.getLabel.call(this)
                });
                update = false;
            }
            // Replace props with their value
            const replace = (input)=>{
                let result = input;
                Object.entries(props).forEach(([key, value])=>{
                    result = replaceAll(result, `{${key}}`, value);
                });
                return result;
            };
            // Update markup
            if (update) {
                if (is.string(this.config.controls)) container = replace(container);
            }
            // Controls container
            let target;
            // Inject to custom location
            if (is.string(this.config.selectors.controls.container)) target = document.querySelector(this.config.selectors.controls.container);
            // Inject into the container by default
            if (!is.element(target)) target = this.elements.container;
            // Inject controls HTML (needs to be before captions, hence "afterbegin")
            const insertMethod = is.element(container) ? 'insertAdjacentElement' : 'insertAdjacentHTML';
            target[insertMethod]('afterbegin', container);
            // Find the elements if need be
            if (!is.element(this.elements.controls)) controls.findElements.call(this);
            // Add pressed property to buttons
            if (!is.empty(this.elements.buttons)) {
                const addProperty = (button)=>{
                    const className = this.config.classNames.controlPressed;
                    button.setAttribute('aria-pressed', 'false');
                    Object.defineProperty(button, 'pressed', {
                        configurable: true,
                        enumerable: true,
                        get () {
                            return hasClass(button, className);
                        },
                        set (pressed = false) {
                            toggleClass(button, className, pressed);
                            button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
                        }
                    });
                };
                // Toggle classname when pressed property is set
                Object.values(this.elements.buttons).filter(Boolean).forEach((button)=>{
                    if (is.array(button) || is.nodeList(button)) Array.from(button).filter(Boolean).forEach(addProperty);
                    else addProperty(button);
                });
            }
            // Edge sometimes doesn't finish the paint so force a repaint
            if (browser.isEdge) repaint(target);
            // Setup tooltips
            if (this.config.tooltips.controls) {
                const { classNames: classNames, selectors: selectors } = this.config;
                const selector = `${selectors.controls.wrapper} ${selectors.labels} .${classNames.hidden}`;
                const labels = getElements.call(this, selector);
                Array.from(labels).forEach((label)=>{
                    toggleClass(label, this.config.classNames.hidden, false);
                    toggleClass(label, this.config.classNames.tooltip, true);
                });
            }
        },
        // Set media metadata
        setMediaMetadata () {
            try {
                if ('mediaSession' in navigator) navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                });
            } catch  {
            // Do nothing
            }
        },
        // Add markers
        setMarkers () {
            var _this$config$markers2, _this$config$markers3;
            if (!this.duration || this.elements.markers) return;
            // Get valid points
            const points = (_this$config$markers2 = this.config.markers) === null || _this$config$markers2 === void 0 ? void 0 : (_this$config$markers3 = _this$config$markers2.points) === null || _this$config$markers3 === void 0 ? void 0 : _this$config$markers3.filter(({ time: time })=>time > 0 && time < this.duration);
            if (!(points !== null && points !== void 0 && points.length)) return;
            const containerFragment = document.createDocumentFragment();
            const pointsFragment = document.createDocumentFragment();
            let tipElement = null;
            const tipVisible = `${this.config.classNames.tooltip}--visible`;
            const toggleTip = (show)=>toggleClass(tipElement, tipVisible, show);
            // Inject markers to progress container
            points.forEach((point)=>{
                const markerElement = createElement('span', {
                    class: this.config.classNames.marker
                }, '');
                const left = `${point.time / this.duration * 100}%`;
                if (tipElement) {
                    // Show on hover
                    markerElement.addEventListener('mouseenter', ()=>{
                        if (point.label) return;
                        tipElement.style.left = left;
                        tipElement.innerHTML = point.label;
                        toggleTip(true);
                    });
                    // Hide on leave
                    markerElement.addEventListener('mouseleave', ()=>{
                        toggleTip(false);
                    });
                }
                markerElement.addEventListener('click', ()=>{
                    this.currentTime = point.time;
                });
                markerElement.style.left = left;
                pointsFragment.appendChild(markerElement);
            });
            containerFragment.appendChild(pointsFragment);
            // Inject a tooltip if needed
            if (!this.config.tooltips.seek) {
                tipElement = createElement('span', {
                    class: this.config.classNames.tooltip
                }, '');
                containerFragment.appendChild(tipElement);
            }
            this.elements.markers = {
                points: pointsFragment,
                tip: tipElement
            };
            this.elements.progress.appendChild(containerFragment);
        }
    };
    // ==========================================================================
    // URL utils
    // ==========================================================================
    /**
   * Parse a string to a URL object
   * @param {string} input - the URL to be parsed
   * @param {boolean} safe - failsafe parsing
   */ function parseUrl(input, safe = true) {
        let url = input;
        if (safe) {
            const parser = document.createElement('a');
            parser.href = url;
            url = parser.href;
        }
        try {
            return new URL(url);
        } catch  {
            return null;
        }
    }
    // Convert object to URLSearchParams
    function buildUrlParams(input) {
        const params = new URLSearchParams();
        if (is.object(input)) Object.entries(input).forEach(([key, value])=>{
            params.set(key, value);
        });
        return params;
    }
    // ==========================================================================
    // Plyr Captions
    // TODO: Create as class
    // ==========================================================================
    const captions = {
        // Setup captions
        setup () {
            // Requires UI support
            if (!this.supported.ui) return;
            // Only Vimeo and HTML5 video supported at this point
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !support.textTracks) {
                // Clear menu and hide
                if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
                return;
            }
            // Inject the container
            if (!is.element(this.elements.captions)) {
                this.elements.captions = createElement('div', getAttributesFromSelector(this.config.selectors.captions));
                this.elements.captions.setAttribute('dir', 'auto');
                insertAfter(this.elements.captions, this.elements.wrapper);
            }
            // Fix IE captions if CORS is used
            // Fetch captions and inject as blobs instead (data URIs not supported!)
            if (browser.isIE && window.URL) {
                const elements = this.media.querySelectorAll('track');
                Array.from(elements).forEach((track)=>{
                    const src = track.getAttribute('src');
                    const url = parseUrl(src);
                    if (url !== null && url.hostname !== window.location.href.hostname && [
                        'http:',
                        'https:'
                    ].includes(url.protocol)) fetch(src, 'blob').then((blob)=>{
                        track.setAttribute('src', window.URL.createObjectURL(blob));
                    }).catch(()=>{
                        removeElement(track);
                    });
                });
            }
            // Get and set initial data
            // The "preferred" options are not realized unless / until the wanted language has a match
            // * languages: Array of user's browser languages.
            // * language:  The language preferred by user settings or config
            // * active:    The state preferred by user settings or config
            // * toggled:   The real captions state
            const browserLanguages = navigator.languages || [
                navigator.language || navigator.userLanguage || 'en'
            ];
            const languages = dedupe(browserLanguages.map((language)=>language.split('-')[0]));
            let language = (this.storage.get('language') || this.captions.language || this.config.captions.language || 'auto').toLowerCase();
            // Use first browser language when language is 'auto'
            if (language === 'auto') [language] = languages;
            let active = this.storage.get('captions') || this.captions.active;
            if (!is.boolean(active)) ({ active: active } = this.config.captions);
            Object.assign(this.captions, {
                toggled: false,
                active: active,
                language: language,
                languages: languages
            });
            // Watch changes to textTracks and update captions menu
            if (this.isHTML5) {
                const trackEvents = this.config.captions.update ? 'addtrack removetrack' : 'removetrack';
                on.call(this, this.media.textTracks, trackEvents, captions.update.bind(this));
            }
            // Update available languages in list next tick (the event must not be triggered before the listeners)
            setTimeout(captions.update.bind(this), 0);
        },
        // Update available language options in settings based on tracks
        update () {
            const tracks = captions.getTracks.call(this, true);
            // Get the wanted language
            const { active: active, language: language, meta: meta, currentTrackNode: currentTrackNode } = this.captions;
            const languageExists = Boolean(tracks.find((track)=>track.language === language));
            // Handle tracks (add event listener and "pseudo"-default)
            if (this.isHTML5 && this.isVideo) tracks.filter((track)=>!meta.get(track)).forEach((track)=>{
                this.debug.log('Track added', track);
                // Attempt to store if the original dom element was "default"
                meta.set(track, {
                    default: track.mode === 'showing'
                });
                // Turn off native caption rendering to avoid double captions
                // Note: mode='hidden' forces a track to download. To ensure every track
                // isn't downloaded at once, only 'showing' tracks should be reassigned
                if (track.mode === 'showing') track.mode = 'hidden';
                // Add event listener for cue changes
                on.call(this, track, 'cuechange', ()=>captions.updateCues.call(this));
            });
            // Update language first time it matches, or if the previous matching track was removed
            if (languageExists && this.language !== language || !tracks.includes(currentTrackNode)) {
                captions.setLanguage.call(this, language);
                captions.toggle.call(this, active && languageExists);
            }
            // Enable or disable captions based on track length
            if (this.elements) toggleClass(this.elements.container, this.config.classNames.captions.enabled, !is.empty(tracks));
            // Update available languages in list
            if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
        },
        // Toggle captions display
        // Used internally for the toggleCaptions method, with the passive option forced to false
        toggle (input, passive = true) {
            // If there's no full support
            if (!this.supported.ui) return;
            const { toggled: toggled } = this.captions; // Current state
            const activeClass = this.config.classNames.captions.active;
            // Get the next state
            // If the method is called without parameter, toggle based on current value
            const active = is.nullOrUndefined(input) ? !toggled : input;
            // Update state and trigger event
            if (active !== toggled) {
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.active = active;
                    this.storage.set({
                        captions: active
                    });
                }
                // Force language if the call isn't passive and there is no matching language to toggle to
                if (!this.language && active && !passive) {
                    const tracks = captions.getTracks.call(this);
                    const track = captions.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], true);
                    // Override user preferences to avoid switching languages if a matching track is added
                    this.captions.language = track.language;
                    // Set caption, but don't store in localStorage as user preference
                    captions.set.call(this, tracks.indexOf(track));
                    return;
                }
                // Toggle button if it's enabled
                if (this.elements.buttons.captions) this.elements.buttons.captions.pressed = active;
                // Add class hook
                toggleClass(this.elements.container, activeClass, active);
                this.captions.toggled = active;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // Trigger event (not used internally)
                triggerEvent.call(this, this.media, active ? 'captionsenabled' : 'captionsdisabled');
            }
            // Wait for the call stack to clear before setting mode='hidden'
            // on the active track - forcing the browser to download it
            setTimeout(()=>{
                if (active && this.captions.toggled) this.captions.currentTrackNode.mode = 'hidden';
            });
        },
        // Set captions by track index
        // Used internally for the currentTrack setter with the passive option forced to false
        set (index, passive = true) {
            const tracks = captions.getTracks.call(this);
            // Disable captions if setting to -1
            if (index === -1) {
                captions.toggle.call(this, false, passive);
                return;
            }
            if (!is.number(index)) {
                this.debug.warn('Invalid caption argument', index);
                return;
            }
            if (!(index in tracks)) {
                this.debug.warn('Track not found', index);
                return;
            }
            if (this.captions.currentTrack !== index) {
                this.captions.currentTrack = index;
                const track = tracks[index];
                const { language: language } = track || {};
                // Store reference to node for invalidation on remove
                this.captions.currentTrackNode = track;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.language = language;
                    this.storage.set({
                        language: language
                    });
                }
                // Handle Vimeo captions
                if (this.isVimeo) // Enable text track but don't render captions within the player
                // Since we handle that ourselves
                this.embed.enableTextTrack(language, null, false);
                // Trigger event
                triggerEvent.call(this, this.media, 'languagechange');
            }
            // Show captions
            captions.toggle.call(this, true, passive);
            if (this.isHTML5 && this.isVideo) // If we change the active track while a cue is already displayed we need to update it
            captions.updateCues.call(this);
        },
        // Set captions by language
        // Used internally for the language setter with the passive option forced to false
        setLanguage (input, passive = true) {
            if (!is.string(input)) {
                this.debug.warn('Invalid language argument', input);
                return;
            }
            // Normalize
            const language = input.toLowerCase();
            this.captions.language = language;
            // Set currentTrack
            const tracks = captions.getTracks.call(this);
            const track = captions.findTrack.call(this, [
                language
            ]);
            captions.set.call(this, tracks.indexOf(track), passive);
        },
        // Get current valid caption tracks
        // If update is false it will also ignore tracks without metadata
        // This is used to "freeze" the language options when captions.update is false
        getTracks (update = false) {
            // Handle media or textTracks missing or null
            const tracks = Array.from((this.media || {}).textTracks || []);
            // For HTML5, use cache instead of current tracks when it exists (if captions.update is false)
            // Filter out removed tracks and tracks that aren't captions/subtitles (for example metadata)
            return tracks.filter((track)=>!this.isHTML5 || update || this.captions.meta.has(track)).filter((track)=>[
                    'captions',
                    'subtitles'
                ].includes(track.kind));
        },
        // Match tracks based on languages and get the first
        findTrack (languages, force = false) {
            const tracks = captions.getTracks.call(this);
            const sortIsDefault = (track)=>Number((this.captions.meta.get(track) || {}).default);
            const sorted = Array.from(tracks).sort((a, b)=>sortIsDefault(b) - sortIsDefault(a));
            let track;
            languages.every((language)=>{
                track = sorted.find((t)=>t.language === language);
                return !track; // Break iteration if there is a match
            });
            // If no match is found but is required, get first
            return track || (force ? sorted[0] : undefined);
        },
        // Get the current track
        getCurrentTrack () {
            return captions.getTracks.call(this)[this.currentTrack];
        },
        // Get UI label for track
        getLabel (track) {
            let currentTrack = track;
            if (!is.track(currentTrack) && support.textTracks && this.captions.toggled) currentTrack = captions.getCurrentTrack.call(this);
            if (is.track(currentTrack)) {
                if (!is.empty(currentTrack.label)) return currentTrack.label;
                if (!is.empty(currentTrack.language)) return track.language.toUpperCase();
                return i18n.get('enabled', this.config);
            }
            return i18n.get('disabled', this.config);
        },
        // Update captions using current track's active cues
        // Also optional array argument in case there isn't any track (ex: vimeo)
        updateCues (input) {
            // Requires UI
            if (!this.supported.ui) return;
            if (!is.element(this.elements.captions)) {
                this.debug.warn('No captions element to render to');
                return;
            }
            // Only accept array or empty input
            if (!is.nullOrUndefined(input) && !Array.isArray(input)) {
                this.debug.warn('updateCues: Invalid input', input);
                return;
            }
            let cues = input;
            // Get cues from track
            if (!cues) {
                const track = captions.getCurrentTrack.call(this);
                cues = Array.from((track || {}).activeCues || []).map((cue)=>cue.getCueAsHTML()).map(getHTML);
            }
            // Set new caption text
            const content = cues.map((cueText)=>cueText.trim()).join('\n');
            const changed = content !== this.elements.captions.innerHTML;
            if (changed) {
                // Empty the container and create a new child element
                emptyElement(this.elements.captions);
                const caption = createElement('span', getAttributesFromSelector(this.config.selectors.caption));
                caption.innerHTML = content;
                this.elements.captions.appendChild(caption);
                // Trigger event
                triggerEvent.call(this, this.media, 'cuechange');
            }
        }
    };
    // ==========================================================================
    // Plyr default config
    // ==========================================================================
    const defaults = {
        // Disable
        enabled: true,
        // Custom media title
        title: '',
        // Logging to console
        debug: false,
        // Auto play (if supported)
        autoplay: false,
        // Only allow one media playing at once (vimeo only)
        autopause: true,
        // Allow inline playback on iOS
        playsinline: true,
        // Default time to skip when rewind/fast forward
        seekTime: 10,
        // Default volume
        volume: 1,
        muted: false,
        // Pass a custom duration
        duration: null,
        // Display the media duration on load in the current time position
        // If you have opted to display both duration and currentTime, this is ignored
        displayDuration: true,
        // Invert the current time to be a countdown
        invertTime: true,
        // Clicking the currentTime inverts it's value to show time left rather than elapsed
        toggleInvert: true,
        // Force an aspect ratio
        // The format must be `'w:h'` (e.g. `'16:9'`)
        ratio: null,
        // Click video container to play/pause
        clickToPlay: true,
        // Auto hide the controls
        hideControls: true,
        // Reset to start when playback ended
        resetOnEnd: false,
        // Disable the standard context menu
        disableContextMenu: true,
        // Sprite (for icons)
        loadSprite: true,
        iconPrefix: 'plyr',
        iconUrl: 'https://cdn.plyr.io/3.8.4/plyr.svg',
        // Blank video (used to prevent errors on source change)
        blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
        // Quality default
        quality: {
            default: 576,
            // The options to display in the UI, if available for the source media
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: false,
            onChange: null
        },
        // Set loops
        loop: {
            active: false
        },
        // Speed default and options to display
        speed: {
            selected: 1,
            // The options to display in the UI, if available for the source media (e.g. Vimeo and YouTube only support 0.5x-4x)
            options: [
                0.5,
                0.75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        // Keyboard shortcut settings
        keyboard: {
            focused: true,
            global: false
        },
        // Display tooltips
        tooltips: {
            controls: false,
            seek: true
        },
        // Captions settings
        captions: {
            active: false,
            language: 'auto',
            // Listen to new tracks added after Plyr is initialized.
            // This is needed for streaming captions, but may result in unselectable options
            update: false
        },
        // Fullscreen settings
        fullscreen: {
            enabled: true,
            // Allow fullscreen?
            fallback: true,
            // Fallback using full viewport/window
            iosNative: false // Use the native fullscreen in iOS (disables custom controls)
        },
        // Local storage
        storage: {
            enabled: true,
            key: 'plyr'
        },
        // Default controls
        controls: [
            'play-large',
            // 'restart',
            // 'rewind',
            'play',
            // 'fast-forward',
            'progress',
            'current-time',
            // 'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'pip',
            'airplay',
            // 'download',
            'fullscreen'
        ],
        settings: [
            'captions',
            'quality',
            'speed'
        ],
        // Localisation
        i18n: {
            restart: 'Restart',
            rewind: 'Rewind {seektime}s',
            play: 'Play',
            pause: 'Pause',
            fastForward: 'Forward {seektime}s',
            seek: 'Seek',
            seekLabel: '{currentTime} of {duration}',
            played: 'Played',
            buffered: 'Buffered',
            currentTime: 'Current time',
            duration: 'Duration',
            volume: 'Volume',
            mute: 'Mute',
            unmute: 'Unmute',
            enableCaptions: 'Enable captions',
            disableCaptions: 'Disable captions',
            download: 'Download',
            enterFullscreen: 'Enter fullscreen',
            exitFullscreen: 'Exit fullscreen',
            frameTitle: 'Player for {title}',
            captions: 'Captions',
            settings: 'Settings',
            pip: 'PIP',
            menuBack: 'Go back to previous menu',
            speed: 'Speed',
            normal: 'Normal',
            quality: 'Quality',
            loop: 'Loop',
            start: 'Start',
            end: 'End',
            all: 'All',
            reset: 'Reset',
            disabled: 'Disabled',
            enabled: 'Enabled',
            advertisement: 'Ad',
            qualityBadge: {
                2160: '4K',
                1440: 'HD',
                1080: 'HD',
                720: 'HD',
                576: 'SD',
                480: 'SD'
            }
        },
        // URLs
        urls: {
            download: null,
            vimeo: {
                sdk: 'https://player.vimeo.com/api/player.js',
                iframe: 'https://player.vimeo.com/video/{0}?{1}',
                api: 'https://vimeo.com/api/oembed.json?url={0}'
            },
            youtube: {
                sdk: 'https://www.youtube.com/iframe_api',
                api: 'https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}'
            },
            googleIMA: {
                sdk: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
            }
        },
        // Custom control listeners
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        // Events to watch and bubble
        events: [
            // Events to watch on HTML5 media elements and bubble
            // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
            'ended',
            'progress',
            'stalled',
            'playing',
            'waiting',
            'canplay',
            'canplaythrough',
            'loadstart',
            'loadeddata',
            'loadedmetadata',
            'timeupdate',
            'volumechange',
            'play',
            'pause',
            'error',
            'seeking',
            'seeked',
            'emptied',
            'ratechange',
            'cuechange',
            // Custom events
            'download',
            'enterfullscreen',
            'exitfullscreen',
            'captionsenabled',
            'captionsdisabled',
            'languagechange',
            'controlshidden',
            'controlsshown',
            'ready',
            // YouTube
            'statechange',
            // Quality
            'qualitychange',
            // Ads
            'adsloaded',
            'adscontentpause',
            'adscontentresume',
            'adstarted',
            'adsmidpoint',
            'adscomplete',
            'adsallcomplete',
            'adsimpression',
            'adsclick'
        ],
        // Selectors
        // Change these to match your template if using custom HTML
        selectors: {
            editable: 'input, textarea, select, [contenteditable]',
            container: '.plyr',
            controls: {
                container: null,
                wrapper: '.plyr__controls'
            },
            labels: '[data-plyr]',
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: '.plyr__time--current',
                duration: '.plyr__time--duration',
                buffer: '.plyr__progress__buffer',
                loop: '.plyr__progress__loop',
                // Used later
                volume: '.plyr__volume--display'
            },
            progress: '.plyr__progress',
            captions: '.plyr__captions',
            caption: '.plyr__caption'
        },
        // Class hooks added to the player in different states
        classNames: {
            type: 'plyr--{0}',
            provider: 'plyr--{0}',
            video: 'plyr__video-wrapper',
            embed: 'plyr__video-embed',
            videoFixedRatio: 'plyr__video-wrapper--fixed-ratio',
            embedContainer: 'plyr__video-embed__container',
            poster: 'plyr__poster',
            posterEnabled: 'plyr__poster-enabled',
            ads: 'plyr__ads',
            control: 'plyr__control',
            controlPressed: 'plyr__control--pressed',
            playing: 'plyr--playing',
            paused: 'plyr--paused',
            stopped: 'plyr--stopped',
            loading: 'plyr--loading',
            hover: 'plyr--hover',
            tooltip: 'plyr__tooltip',
            cues: 'plyr__cues',
            marker: 'plyr__progress__marker',
            hidden: 'plyr__sr-only',
            hideControls: 'plyr--hide-controls',
            isTouch: 'plyr--is-touch',
            uiSupported: 'plyr--full-ui',
            noTransition: 'plyr--no-transition',
            display: {
                time: 'plyr__time'
            },
            menu: {
                value: 'plyr__menu__value',
                badge: 'plyr__badge',
                open: 'plyr--menu-open'
            },
            captions: {
                enabled: 'plyr--captions-enabled',
                active: 'plyr--captions-active'
            },
            fullscreen: {
                enabled: 'plyr--fullscreen-enabled',
                fallback: 'plyr--fullscreen-fallback'
            },
            pip: {
                supported: 'plyr--pip-supported',
                active: 'plyr--pip-active'
            },
            airplay: {
                supported: 'plyr--airplay-supported',
                active: 'plyr--airplay-active'
            },
            previewThumbnails: {
                // Tooltip thumbs
                thumbContainer: 'plyr__preview-thumb',
                thumbContainerShown: 'plyr__preview-thumb--is-shown',
                imageContainer: 'plyr__preview-thumb__image-container',
                timeContainer: 'plyr__preview-thumb__time-container',
                // Scrubbing
                scrubbingContainer: 'plyr__preview-scrubbing',
                scrubbingContainerShown: 'plyr__preview-scrubbing--is-shown'
            }
        },
        // Embed attributes
        attributes: {
            embed: {
                provider: 'data-plyr-provider',
                id: 'data-plyr-embed-id',
                hash: 'data-plyr-embed-hash'
            }
        },
        // Advertisements plugin
        // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
        ads: {
            enabled: false,
            publisherId: '',
            tagUrl: ''
        },
        // Preview Thumbnails plugin
        previewThumbnails: {
            enabled: false,
            src: '',
            withCredentials: false
        },
        // Vimeo plugin
        vimeo: {
            byline: false,
            portrait: false,
            title: false,
            speed: true,
            transparent: false,
            // Custom settings from Plyr
            customControls: true,
            referrerPolicy: null,
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy
            // Whether the owner of the video has a Pro or Business account
            // (which allows us to properly hide controls without CSS hacks, etc)
            premium: false
        },
        // YouTube plugin
        youtube: {
            rel: 0,
            // No related vids
            showinfo: 0,
            // Hide info
            iv_load_policy: 3,
            // Hide annotations
            modestbranding: 1,
            // Hide logos as much as possible (they still show one in the corner when paused)
            // Custom settings from Plyr
            customControls: true,
            noCookie: false // Whether to use an alternative version of YouTube without cookies
        },
        // Media Metadata
        mediaMetadata: {
            title: '',
            artist: '',
            album: '',
            artwork: []
        },
        // Markers
        markers: {
            enabled: false,
            points: []
        }
    };
    // ==========================================================================
    // Plyr states
    // ==========================================================================
    const pip = {
        active: 'picture-in-picture',
        inactive: 'inline'
    };
    // ==========================================================================
    // Plyr supported types and providers
    // ==========================================================================
    const providers = {
        html5: 'html5',
        youtube: 'youtube',
        vimeo: 'vimeo'
    };
    const types = {
        audio: 'audio',
        video: 'video'
    };
    /**
   * Get provider by URL
   * @param {string} url
   */ function getProviderByUrl(url) {
        // YouTube
        if (/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) return providers.youtube;
        // Vimeo
        if (/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(url)) return providers.vimeo;
        return null;
    }
    // ==========================================================================
    // Console wrapper
    // ==========================================================================
    function noop() {}
    class Console {
        constructor(enabled = false){
            this.enabled = window.console && enabled;
            if (this.enabled) this.log('Debugging enabled');
        }
        get log() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.log, console) : noop;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : noop;
        }
    }
    class Fullscreen {
        constructor(player){
            _defineProperty$1(this, "onChange", ()=>{
                if (!this.supported) return;
                // Update toggle button
                const button = this.player.elements.buttons.fullscreen;
                if (is.element(button)) button.pressed = this.active;
                // Always trigger events on the plyr / media element (not a fullscreen container) and let them bubble up
                const target = this.target === this.player.media ? this.target : this.player.elements.container;
                // Trigger an event
                triggerEvent.call(this.player, target, this.active ? 'enterfullscreen' : 'exitfullscreen', true);
            });
            _defineProperty$1(this, "toggleFallback", (toggle = false)=>{
                // Store or restore scroll position
                if (toggle) {
                    var _window$scrollX, _window$scrollY;
                    this.scrollPosition = {
                        x: (_window$scrollX = window.scrollX) !== null && _window$scrollX !== void 0 ? _window$scrollX : 0,
                        y: (_window$scrollY = window.scrollY) !== null && _window$scrollY !== void 0 ? _window$scrollY : 0
                    };
                } else window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
                // Toggle scroll
                document.body.style.overflow = toggle ? 'hidden' : '';
                // Toggle class hook
                toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, toggle);
                // Force full viewport on iPhone X+
                if (browser.isIos) {
                    let viewport = document.head.querySelector('meta[name="viewport"]');
                    const property = 'viewport-fit=cover';
                    // Inject the viewport meta if required
                    if (!viewport) {
                        viewport = document.createElement('meta');
                        viewport.setAttribute('name', 'viewport');
                    }
                    // Check if the property already exists
                    const hasProperty = is.string(viewport.content) && viewport.content.includes(property);
                    if (toggle) {
                        this.cleanupViewport = !hasProperty;
                        if (!hasProperty) viewport.content += `,${property}`;
                    } else if (this.cleanupViewport) viewport.content = viewport.content.split(',').filter((part)=>part.trim() !== property).join(',');
                }
                // Toggle button and fire events
                this.onChange();
            });
            // Trap focus inside container
            _defineProperty$1(this, "trapFocus", (event)=>{
                // Bail if iOS/iPadOS, not active, not the tab key
                if (browser.isIos || browser.isIPadOS || !this.active || event.key !== 'Tab') return;
                // Get the current focused element
                const focused = document.activeElement;
                const focusable = getElements.call(this.player, 'a[href], button:not(:disabled), input:not(:disabled), [tabindex]');
                const [first] = focusable;
                const last = focusable[focusable.length - 1];
                if (focused === last && !event.shiftKey) {
                    // Move focus to first element that can be tabbed if Shift isn't used
                    first.focus();
                    event.preventDefault();
                } else if (focused === first && event.shiftKey) {
                    // Move focus to last element that can be tabbed if Shift is used
                    last.focus();
                    event.preventDefault();
                }
            });
            // Update UI
            _defineProperty$1(this, "update", ()=>{
                if (this.supported) {
                    let mode;
                    if (this.forceFallback) mode = 'Fallback (forced)';
                    else if (Fullscreen.nativeSupported) mode = 'Native';
                    else mode = 'Fallback';
                    this.player.debug.log(`${mode} fullscreen enabled`);
                } else this.player.debug.log('Fullscreen not supported and fallback disabled');
                // Add styling hook to show button
                toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            });
            // Make an element fullscreen
            _defineProperty$1(this, "enter", ()=>{
                if (!this.supported) return;
                // iOS native fullscreen doesn't need the request step
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    if (this.player.isVimeo) this.player.embed.requestFullscreen();
                    else this.target.webkitEnterFullscreen();
                } else if (!Fullscreen.nativeSupported || this.forceFallback) this.toggleFallback(true);
                else if (!this.prefix) this.target.requestFullscreen({
                    navigationUI: 'hide'
                });
                else if (!is.empty(this.prefix)) this.target[`${this.prefix}Request${this.property}`]();
            });
            // Bail from fullscreen
            _defineProperty$1(this, "exit", ()=>{
                if (!this.supported) return;
                // iOS native fullscreen
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    if (this.player.isVimeo) this.player.embed.exitFullscreen();
                    else this.target.webkitEnterFullscreen();
                    silencePromise(this.player.play());
                } else if (!Fullscreen.nativeSupported || this.forceFallback) this.toggleFallback(false);
                else if (!this.prefix) (document.cancelFullScreen || document.exitFullscreen).call(document);
                else if (!is.empty(this.prefix)) {
                    const action = this.prefix === 'moz' ? 'Cancel' : 'Exit';
                    document[`${this.prefix}${action}${this.property}`]();
                }
            });
            // Toggle state
            _defineProperty$1(this, "toggle", ()=>{
                if (!this.active) this.enter();
                else this.exit();
            });
            // Keep reference to parent
            this.player = player;
            // Get prefix
            this.prefix = Fullscreen.prefix;
            this.property = Fullscreen.property;
            // Scroll position
            this.scrollPosition = {
                x: 0,
                y: 0
            };
            // Force the use of 'full window/browser' rather than fullscreen
            this.forceFallback = player.config.fullscreen.fallback === 'force';
            // Get the fullscreen element
            // Checks container is an ancestor, defaults to null
            this.player.elements.fullscreen = player.config.fullscreen.container && closest$1(this.player.elements.container, player.config.fullscreen.container);
            // Register event listeners
            // Handle event (incase user presses escape etc)
            on.call(this.player, document, this.prefix === 'ms' ? 'MSFullscreenChange' : `${this.prefix}fullscreenchange`, ()=>{
                // TODO: Filter for target??
                this.onChange();
            });
            // Fullscreen toggle on double click
            on.call(this.player, this.player.elements.container, 'dblclick', (event)=>{
                // Ignore double click in controls
                if (is.element(this.player.elements.controls) && this.player.elements.controls.contains(event.target)) return;
                this.player.listeners.proxy(event, this.toggle, 'fullscreen');
            });
            // Tap focus when in fullscreen
            on.call(this, this.player.elements.container, 'keydown', (event)=>this.trapFocus(event));
            // Update the UI
            this.update();
        }
        // Determine if native supported
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        // If we're actually using native
        get useNative() {
            return Fullscreen.nativeSupported && !this.forceFallback;
        }
        // Get the prefix for handlers
        static get prefix() {
            // No prefix
            if (is.function(document.exitFullscreen)) return '';
            // Check for fullscreen support by vendor prefix
            let value = '';
            const prefixes = [
                'webkit',
                'moz',
                'ms'
            ];
            prefixes.some((pre)=>{
                if (is.function(document[`${pre}ExitFullscreen`]) || is.function(document[`${pre}CancelFullScreen`])) {
                    value = pre;
                    return true;
                }
                return false;
            });
            return value;
        }
        static get property() {
            return this.prefix === 'moz' ? 'FullScreen' : 'Fullscreen';
        }
        // Determine if fullscreen is supported
        get supported() {
            return [
                // Fullscreen is enabled in config
                this.player.config.fullscreen.enabled,
                // Must be a video
                this.player.isVideo,
                // Either native is supported or fallback enabled
                Fullscreen.nativeSupported || this.player.config.fullscreen.fallback,
                // YouTube has no way to trigger fullscreen, so on devices with no native support, playsinline
                // must be enabled and iosNative fullscreen must be disabled to offer the fullscreen fallback
                !this.player.isYouTube || Fullscreen.nativeSupported || !browser.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        // Get active state
        get active() {
            if (!this.supported) return false;
            // Fallback using classname
            if (!Fullscreen.nativeSupported || this.forceFallback) return hasClass(this.target, this.player.config.classNames.fullscreen.fallback);
            const element = !this.prefix ? this.target.getRootNode().fullscreenElement : this.target.getRootNode()[`${this.prefix}${this.property}Element`];
            return element && element.shadowRoot ? element === this.target.getRootNode().host : element === this.target;
        }
        // Get target element
        get target() {
            var _this$player$elements;
            return browser.isIos && this.player.config.fullscreen.iosNative ? this.player.media : (_this$player$elements = this.player.elements.fullscreen) !== null && _this$player$elements !== void 0 ? _this$player$elements : this.player.elements.container;
        }
    }
    // ==========================================================================
    // Load image avoiding xhr/fetch CORS issues
    // Server status can't be obtained this way unfortunately, so this uses "naturalWidth" to determine if the image has loaded
    // By default it checks if it is at least 1px, but you can add a second argument to change this
    // ==========================================================================
    function loadImage(src, minWidth = 1) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const handler = ()=>{
                delete image.onload;
                delete image.onerror;
                (image.naturalWidth >= minWidth ? resolve : reject)(image);
            };
            Object.assign(image, {
                onload: handler,
                onerror: handler,
                src: src
            });
        });
    }
    // ==========================================================================
    // Plyr UI
    // ==========================================================================
    const ui = {
        addStyleHook () {
            toggleClass(this.elements.container, this.config.selectors.container.replace('.', ''), true);
            toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        // Toggle native HTML5 media controls
        toggleNativeControls (toggle = false) {
            if (toggle && this.isHTML5) this.media.setAttribute('controls', '');
            else this.media.removeAttribute('controls');
        },
        // Setup the UI
        build () {
            // Re-attach media element listeners
            // TODO: Use event bubbling?
            this.listeners.media();
            // Don't setup interface if no support
            if (!this.supported.ui) {
                this.debug.warn(`Basic support only for ${this.provider} ${this.type}`);
                // Restore native controls
                ui.toggleNativeControls.call(this, true);
                // Bail
                return;
            }
            // Inject custom controls if not present
            if (!is.element(this.elements.controls)) {
                // Inject custom controls
                controls.inject.call(this);
                // Re-attach control listeners
                this.listeners.controls();
            }
            // Remove native controls
            ui.toggleNativeControls.call(this);
            // Setup captions for HTML5
            if (this.isHTML5) captions.setup.call(this);
            // Reset volume
            this.volume = null;
            // Reset mute state
            this.muted = null;
            // Reset loop state
            this.loop = null;
            // Reset quality setting
            this.quality = null;
            // Reset speed
            this.speed = null;
            // Reset volume display
            controls.updateVolume.call(this);
            // Reset time display
            controls.timeUpdate.call(this);
            // Reset duration display
            controls.durationUpdate.call(this);
            // Update the UI
            ui.checkPlaying.call(this);
            // Check for picture-in-picture support
            toggleClass(this.elements.container, this.config.classNames.pip.supported, support.pip && this.isHTML5 && this.isVideo);
            // Check for airplay support
            toggleClass(this.elements.container, this.config.classNames.airplay.supported, support.airplay && this.isHTML5);
            // Add touch class
            toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch);
            // Ready for API calls
            this.ready = true;
            // Ready event at end of execution stack
            setTimeout(()=>{
                triggerEvent.call(this, this.media, 'ready');
            }, 0);
            // Set the title
            ui.setTitle.call(this);
            // Assure the poster image is set, if the property was added before the element was created
            if (this.poster) ui.setPoster.call(this, this.poster, false).catch(()=>{});
            // Manually set the duration if user has overridden it.
            // The event listeners for it doesn't get called if preload is disabled (#701)
            if (this.config.duration) controls.durationUpdate.call(this);
            // Media metadata
            if (this.config.mediaMetadata) controls.setMediaMetadata.call(this);
        },
        // Setup aria attribute for play and iframe title
        setTitle () {
            // Find the current text
            let label = i18n.get('play', this.config);
            // If there's a media title set, use that for the label
            if (is.string(this.config.title) && !is.empty(this.config.title)) label += `, ${this.config.title}`;
            // If there's a play button, set label
            Array.from(this.elements.buttons.play || []).forEach((button)=>{
                button.setAttribute('aria-label', label);
            });
            // Set iframe title
            // https://github.com/sampotts/plyr/issues/124
            if (this.isEmbed) {
                const iframe = getElement.call(this, 'iframe');
                if (!is.element(iframe)) return;
                // Default to media type
                const title = !is.empty(this.config.title) ? this.config.title : 'video';
                const format = i18n.get('frameTitle', this.config);
                iframe.setAttribute('title', format.replace('{title}', title));
            }
        },
        // Toggle poster
        togglePoster (enable) {
            toggleClass(this.elements.container, this.config.classNames.posterEnabled, enable);
        },
        // Set the poster image (async)
        // Used internally for the poster setter, with the passive option forced to false
        setPoster (poster, passive = true) {
            // Don't override if call is passive
            if (passive && this.poster) return Promise.reject(new Error('Poster already set'));
            // Set property synchronously to respect the call order
            this.media.setAttribute('data-poster', poster);
            // Show the poster
            this.elements.poster.removeAttribute('hidden');
            // Wait until ui is ready
            return ready.call(this)// Load image
            .then(()=>loadImage(poster)).catch((error)=>{
                // Hide poster on error unless it's been set by another call
                if (poster === this.poster) ui.togglePoster.call(this, false);
                // Rethrow
                throw error;
            }).then(()=>{
                // Prevent race conditions
                if (poster !== this.poster) throw new Error('setPoster cancelled by later call to setPoster');
            }).then(()=>{
                Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${poster}')`,
                    // Reset backgroundSize as well (since it can be set to "cover" for padded thumbnails for youtube)
                    backgroundSize: ''
                });
                ui.togglePoster.call(this, true);
                return poster;
            });
        },
        // Check playing state
        checkPlaying (event) {
            // Class hooks
            toggleClass(this.elements.container, this.config.classNames.playing, this.playing);
            toggleClass(this.elements.container, this.config.classNames.paused, this.paused);
            toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped);
            // Set state
            Array.from(this.elements.buttons.play || []).forEach((target)=>{
                Object.assign(target, {
                    pressed: this.playing
                });
                target.setAttribute('aria-label', i18n.get(this.playing ? 'pause' : 'play', this.config));
            });
            // Only update controls on non timeupdate events
            if (is.event(event) && event.type === 'timeupdate') return;
            // Toggle controls
            ui.toggleControls.call(this);
        },
        // Check if media is loading
        checkLoading (event) {
            this.loading = [
                'stalled',
                'waiting'
            ].includes(event.type);
            // Clear timer
            clearTimeout(this.timers.loading);
            // Timer to prevent flicker when seeking
            this.timers.loading = setTimeout(()=>{
                // Update progress bar loading class state
                toggleClass(this.elements.container, this.config.classNames.loading, this.loading);
                // Update controls visibility
                ui.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        // Toggle controls based on state and `force` argument
        toggleControls (force) {
            const { controls: controlsElement } = this.elements;
            if (controlsElement && this.config.hideControls) {
                // Don't hide controls if a touch-device user recently seeked. (Must be limited to touch devices, or it occasionally prevents desktop controls from hiding.)
                const recentTouchSeek = this.touch && this.lastSeekTime + 2000 > Date.now();
                // Show controls if force, loading, paused, button interaction, or recent seek, otherwise hide
                this.toggleControls(Boolean(force || this.loading || this.paused || controlsElement.pressed || controlsElement.hover || recentTouchSeek));
            }
        },
        // Migrate any custom properties from the media to the parent
        migrateStyles () {
            // Loop through values (as they are the keys when the object is spread 🤔)
            Object.values({
                ...this.media.style
            })// We're only fussed about Plyr specific properties
            .filter((key)=>!is.empty(key) && is.string(key) && key.startsWith('--plyr')).forEach((key)=>{
                // Set on the container
                this.elements.container.style.setProperty(key, this.media.style.getPropertyValue(key));
                // Clean up from media element
                this.media.style.removeProperty(key);
            });
            // Remove attribute if empty
            if (is.empty(this.media.style)) this.media.removeAttribute('style');
        }
    };
    class Listeners {
        constructor(_player){
            // Device is touch enabled
            _defineProperty$1(this, "firstTouch", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                player.touch = true;
                // Add touch class
                toggleClass(elements.container, player.config.classNames.isTouch, true);
            });
            // Global window & document listeners
            _defineProperty$1(this, "global", (toggle = true)=>{
                const { player: player } = this;
                // Keyboard shortcuts
                if (player.config.keyboard.global) toggleListener.call(player, window, 'keydown keyup', this.handleKey, toggle, false);
                // Click anywhere closes menu
                toggleListener.call(player, document.body, 'click', this.toggleMenu, toggle);
                // Detect touch by events
                once.call(player, document.body, 'touchstart', this.firstTouch);
            });
            // Container listeners
            _defineProperty$1(this, "container", ()=>{
                const { player: player } = this;
                const { config: config, elements: elements, timers: timers } = player;
                // Keyboard shortcuts
                if (!config.keyboard.global && config.keyboard.focused) on.call(player, elements.container, 'keydown keyup', this.handleKey, false);
                // Toggle controls on mouse events and entering fullscreen
                on.call(player, elements.container, 'mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen', (event)=>{
                    const { controls: controlsElement } = elements;
                    // Remove button states for fullscreen
                    if (controlsElement && event.type === 'enterfullscreen') {
                        controlsElement.pressed = false;
                        controlsElement.hover = false;
                    }
                    // Show, then hide after a timeout unless another control event occurs
                    const show = [
                        'touchstart',
                        'touchmove',
                        'mousemove'
                    ].includes(event.type);
                    let delay = 0;
                    if (show) {
                        ui.toggleControls.call(player, true);
                        // Use longer timeout for touch devices
                        delay = player.touch ? 3000 : 2000;
                    }
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Set new timer to prevent flicker when seeking
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Set a gutter for Vimeo
                const setGutter = ()=>{
                    if (!player.isVimeo || player.config.vimeo.premium) return;
                    const target = elements.wrapper;
                    const { active: active } = player.fullscreen;
                    const [videoWidth, videoHeight] = getAspectRatio.call(player);
                    const useNativeAspectRatio = supportsCSS(`aspect-ratio: ${videoWidth} / ${videoHeight}`);
                    // If not active, remove styles
                    if (!active) {
                        if (useNativeAspectRatio) {
                            target.style.width = null;
                            target.style.height = null;
                        } else {
                            target.style.maxWidth = null;
                            target.style.margin = null;
                        }
                        return;
                    }
                    // Determine which dimension will overflow and constrain view
                    const [viewportWidth, viewportHeight] = getViewportSize();
                    const overflow = viewportWidth / viewportHeight > videoWidth / videoHeight;
                    if (useNativeAspectRatio) {
                        target.style.width = overflow ? 'auto' : '100%';
                        target.style.height = overflow ? '100%' : 'auto';
                    } else {
                        target.style.maxWidth = overflow ? `${viewportHeight / videoHeight * videoWidth}px` : null;
                        target.style.margin = overflow ? '0 auto' : null;
                    }
                };
                // Handle resizing
                const resized = ()=>{
                    clearTimeout(timers.resized);
                    timers.resized = setTimeout(setGutter, 50);
                };
                on.call(player, elements.container, 'enterfullscreen exitfullscreen', (event)=>{
                    const { target: target } = player.fullscreen;
                    // Ignore events not from target
                    if (target !== elements.container) return;
                    // If it's not an embed and no ratio specified
                    if (!player.isEmbed && is.empty(player.config.ratio)) return;
                    // Set Vimeo gutter
                    setGutter();
                    // Watch for resizes
                    const method = event.type === 'enterfullscreen' ? on : off;
                    method.call(player, window, 'resize', resized);
                });
            });
            // Listen for media events
            _defineProperty$1(this, "media", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // Time change on media
                on.call(player, player.media, 'timeupdate seeking seeked', (event)=>controls.timeUpdate.call(player, event));
                // Display duration
                on.call(player, player.media, 'durationchange loadeddata loadedmetadata', (event)=>controls.durationUpdate.call(player, event));
                // Handle the media finishing
                on.call(player, player.media, 'ended', ()=>{
                    // Show poster on end
                    if (player.isHTML5 && player.isVideo && player.config.resetOnEnd) {
                        // Restart
                        player.restart();
                        // Call pause otherwise IE11 will start playing the video again
                        player.pause();
                    }
                });
                // Check for buffer progress
                on.call(player, player.media, 'progress playing seeking seeked', (event)=>controls.updateProgress.call(player, event));
                // Handle volume changes
                on.call(player, player.media, 'volumechange', (event)=>controls.updateVolume.call(player, event));
                // Handle play/pause
                on.call(player, player.media, 'playing play pause ended emptied timeupdate', (event)=>ui.checkPlaying.call(player, event));
                // Loading state
                on.call(player, player.media, 'waiting canplay seeked playing', (event)=>ui.checkLoading.call(player, event));
                // Click video
                if (player.supported.ui && player.config.clickToPlay && !player.isAudio) {
                    // Re-fetch the wrapper
                    const wrapper = getElement.call(player, `.${player.config.classNames.video}`);
                    // Bail if there's no wrapper (this should never happen)
                    if (!is.element(wrapper)) return;
                    // On click play, pause or restart
                    on.call(player, elements.container, 'click', (event)=>{
                        const targets = [
                            elements.container,
                            wrapper
                        ];
                        // Ignore if click if not container or in video wrapper
                        if (!targets.includes(event.target) && !wrapper.contains(event.target)) return;
                        // Touch devices will just show controls (if hidden)
                        if (player.touch && player.config.hideControls) return;
                        if (player.ended) {
                            this.proxy(event, player.restart, 'restart');
                            this.proxy(event, ()=>{
                                silencePromise(player.play());
                            }, 'play');
                        } else this.proxy(event, ()=>{
                            silencePromise(player.togglePlay());
                        }, 'play');
                    });
                }
                // Disable right click
                if (player.supported.ui && player.config.disableContextMenu) on.call(player, elements.wrapper, 'contextmenu', (event)=>{
                    event.preventDefault();
                }, false);
                // Volume change
                on.call(player, player.media, 'volumechange', ()=>{
                    // Save to storage
                    player.storage.set({
                        volume: player.volume,
                        muted: player.muted
                    });
                });
                // Speed change
                on.call(player, player.media, 'ratechange', ()=>{
                    // Update UI
                    controls.updateSetting.call(player, 'speed');
                    // Save to storage
                    player.storage.set({
                        speed: player.speed
                    });
                });
                // Quality change
                on.call(player, player.media, 'qualitychange', (event)=>{
                    // Update UI
                    controls.updateSetting.call(player, 'quality', null, event.detail.quality);
                });
                // Update download link when ready and if quality changes
                on.call(player, player.media, 'ready qualitychange', ()=>{
                    controls.setDownloadUrl.call(player);
                });
                // Proxy events to container
                // Bubble up key events for Edge
                const proxyEvents = player.config.events.concat([
                    'keyup',
                    'keydown'
                ]).join(' ');
                on.call(player, player.media, proxyEvents, (event)=>{
                    let { detail: detail = {} } = event;
                    // Get error details from media
                    if (event.type === 'error') detail = player.media.error;
                    triggerEvent.call(player, elements.container, event.type, true, detail);
                });
            });
            // Run default and custom handlers
            _defineProperty$1(this, "proxy", (event, defaultHandler, customHandlerKey)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                let returned = true;
                // Execute custom handler
                if (hasCustomHandler) returned = customHandler.call(player, event);
                // Only call default handler if not prevented in custom handler
                if (returned !== false && is.function(defaultHandler)) defaultHandler.call(player, event);
            });
            // Trigger custom and default handlers
            _defineProperty$1(this, "bind", (element, type, defaultHandler, customHandlerKey, passive = true)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                on.call(player, element, type, (event)=>this.proxy(event, defaultHandler, customHandlerKey), passive && !hasCustomHandler);
            });
            // Listen for control events
            _defineProperty$1(this, "controls", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // IE doesn't support input event, so we fallback to change
                const inputEvent = browser.isIE ? 'change' : 'input';
                // Play/pause toggle
                if (elements.buttons.play) Array.from(elements.buttons.play).forEach((button)=>{
                    this.bind(button, 'click', ()=>{
                        silencePromise(player.togglePlay());
                    }, 'play');
                });
                // Pause
                this.bind(elements.buttons.restart, 'click', player.restart, 'restart');
                // Rewind
                this.bind(elements.buttons.rewind, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after rewind
                    player.lastSeekTime = Date.now();
                    player.rewind();
                }, 'rewind');
                // Rewind
                this.bind(elements.buttons.fastForward, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after fast forward
                    player.lastSeekTime = Date.now();
                    player.forward();
                }, 'fastForward');
                // Mute toggle
                this.bind(elements.buttons.mute, 'click', ()=>{
                    player.muted = !player.muted;
                }, 'mute');
                // Captions toggle
                this.bind(elements.buttons.captions, 'click', ()=>player.toggleCaptions());
                // Download
                this.bind(elements.buttons.download, 'click', ()=>{
                    triggerEvent.call(player, player.media, 'download');
                }, 'download');
                // Fullscreen toggle
                this.bind(elements.buttons.fullscreen, 'click', ()=>{
                    player.fullscreen.toggle();
                }, 'fullscreen');
                // Picture-in-Picture
                this.bind(elements.buttons.pip, 'click', ()=>{
                    player.pip = 'toggle';
                }, 'pip');
                // Airplay
                this.bind(elements.buttons.airplay, 'click', player.airplay, 'airplay');
                // Settings menu - click toggle
                this.bind(elements.buttons.settings, 'click', (event)=>{
                    // Prevent the document click listener closing the menu
                    event.stopPropagation();
                    event.preventDefault();
                    controls.toggleMenu.call(player, event);
                }, null, false); // Can't be passive as we're preventing default
                // Settings menu - keyboard toggle
                // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
                // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
                this.bind(elements.buttons.settings, 'keyup', (event)=>{
                    if (![
                        ' ',
                        'Enter'
                    ].includes(event.key)) return;
                    // Because return triggers a click anyway, all we need to do is set focus
                    if (event.key === 'Enter') {
                        controls.focusFirstMenuItem.call(player, null, true);
                        return;
                    }
                    // Prevent scroll
                    event.preventDefault();
                    // Prevent playing video (Firefox)
                    event.stopPropagation();
                    // Toggle menu
                    controls.toggleMenu.call(player, event);
                }, null, false // Can't be passive as we're preventing default
                );
                // Escape closes menu
                this.bind(elements.settings.menu, 'keydown', (event)=>{
                    if (event.key === 'Escape') controls.toggleMenu.call(player, event);
                });
                // Set range input alternative "value", which matches the tooltip time (#954)
                this.bind(elements.inputs.seek, 'mousedown mousemove', (event)=>{
                    const rect = elements.progress.getBoundingClientRect();
                    const scrollLeft = event.pageX - event.clientX;
                    const percent = 100 / rect.width * (event.pageX - rect.left - scrollLeft);
                    event.currentTarget.setAttribute('seek-value', percent);
                });
                // Pause while seeking
                this.bind(elements.inputs.seek, 'mousedown mouseup keydown keyup touchstart touchend', (event)=>{
                    const seek = event.currentTarget;
                    const attribute = 'play-on-seeked';
                    if (is.keyboardEvent(event) && ![
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) return;
                    // Record seek time so we can prevent hiding controls for a few seconds after seek
                    player.lastSeekTime = Date.now();
                    // Was playing before?
                    const play = seek.hasAttribute(attribute);
                    // Done seeking
                    const done = [
                        'mouseup',
                        'touchend',
                        'keyup'
                    ].includes(event.type);
                    // If we're done seeking and it was playing, resume playback
                    if (play && done) {
                        seek.removeAttribute(attribute);
                        silencePromise(player.play());
                    } else if (!done && player.playing) {
                        seek.setAttribute(attribute, '');
                        player.pause();
                    }
                });
                // Fix range inputs on iOS
                // Super weird iOS bug where after you interact with an <input type="range">,
                // it takes over further interactions on the page. This is a hack
                if (browser.isIos) {
                    const inputs = getElements.call(player, 'input[type="range"]');
                    Array.from(inputs).forEach((input)=>this.bind(input, inputEvent, (event)=>repaint(event.target)));
                }
                // Seek
                this.bind(elements.inputs.seek, inputEvent, (event)=>{
                    const seek = event.currentTarget;
                    // If it exists, use seek-value instead of "value" for consistency with tooltip time (#954)
                    let seekTo = seek.getAttribute('seek-value');
                    if (is.empty(seekTo)) seekTo = seek.value;
                    seek.removeAttribute('seek-value');
                    player.currentTime = seekTo / seek.max * player.duration;
                }, 'seek');
                // Seek tooltip
                this.bind(elements.progress, 'mouseenter mouseleave mousemove', (event)=>controls.updateSeekTooltip.call(player, event));
                // Preview thumbnails plugin
                // TODO: Really need to work on some sort of plug-in wide event bus or pub-sub for this
                this.bind(elements.progress, 'mousemove touchmove', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startMove(event);
                });
                // Hide thumbnail preview - on mouse click, mouse leave, and video play/seek. All four are required, e.g., for buffering
                this.bind(elements.progress, 'mouseleave touchend click', ()=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endMove(false, true);
                });
                // Show scrubbing preview
                this.bind(elements.progress, 'mousedown touchstart', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startScrubbing(event);
                });
                this.bind(elements.progress, 'mouseup touchend', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endScrubbing(event);
                });
                // Polyfill for lower fill in <input type="range"> for webkit
                if (browser.isWebKit) Array.from(getElements.call(player, 'input[type="range"]')).forEach((element)=>{
                    this.bind(element, 'input', (event)=>controls.updateRangeFill.call(player, event.target));
                });
                // Current time invert
                // Only if one time element is used for both currentTime and duration
                if (player.config.toggleInvert && !is.element(elements.display.duration)) this.bind(elements.display.currentTime, 'click', ()=>{
                    // Do nothing if we're at the start
                    if (player.currentTime === 0) return;
                    player.config.invertTime = !player.config.invertTime;
                    controls.timeUpdate.call(player);
                });
                // Volume
                this.bind(elements.inputs.volume, inputEvent, (event)=>{
                    player.volume = event.target.value;
                }, 'volume');
                // Update controls.hover state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mouseenter mouseleave', (event)=>{
                    elements.controls.hover = !player.touch && event.type === 'mouseenter';
                });
                // Also update controls.hover state for any non-player children of fullscreen element (as above)
                if (elements.fullscreen) Array.from(elements.fullscreen.children).filter((c)=>!c.contains(elements.container)).forEach((child)=>{
                    this.bind(child, 'mouseenter mouseleave', (event)=>{
                        if (elements.controls) elements.controls.hover = !player.touch && event.type === 'mouseenter';
                    });
                });
                // Update controls.pressed state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mousedown mouseup touchstart touchend touchcancel', (event)=>{
                    elements.controls.pressed = [
                        'mousedown',
                        'touchstart'
                    ].includes(event.type);
                });
                // Show controls when they receive focus (e.g., when using keyboard tab key)
                this.bind(elements.controls, 'focusin', ()=>{
                    const { config: config, timers: timers } = player;
                    // Skip transition to prevent focus from scrolling the parent element
                    toggleClass(elements.controls, config.classNames.noTransition, true);
                    // Toggle
                    ui.toggleControls.call(player, true);
                    // Restore transition
                    setTimeout(()=>{
                        toggleClass(elements.controls, config.classNames.noTransition, false);
                    }, 0);
                    // Delay a little more for mouse users
                    const delay = this.touch ? 3000 : 4000;
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Hide again after delay
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Mouse wheel for volume
                this.bind(elements.inputs.volume, 'wheel', (event)=>{
                    // Detect "natural" scroll - supported on OS X Safari only
                    // Other browsers on OS X will be inverted until support improves
                    const inverted = event.webkitDirectionInvertedFromDevice;
                    // Get delta from event. Invert if `inverted` is true
                    const [x, y] = [
                        event.deltaX,
                        -event.deltaY
                    ].map((value)=>inverted ? -value : value);
                    // Using the biggest delta, normalize to 1 or -1 (or 0 if no delta)
                    const direction = Math.sign(Math.abs(x) > Math.abs(y) ? x : y);
                    // Change the volume by 2%
                    player.increaseVolume(direction / 50);
                    // Don't break page scrolling at max and min
                    const { volume: volume } = player.media;
                    if (direction === 1 && volume < 1 || direction === -1 && volume > 0) event.preventDefault();
                }, 'volume', false);
            });
            this.player = _player;
            this.lastKey = null;
            this.focusTimer = null;
            this.lastKeyDown = null;
            this.handleKey = this.handleKey.bind(this);
            this.toggleMenu = this.toggleMenu.bind(this);
            this.firstTouch = this.firstTouch.bind(this);
        }
        // Handle key presses
        handleKey(event) {
            const { player: player } = this;
            const { elements: elements } = player;
            const { key: key, type: type, altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
            const pressed = type === 'keydown';
            const repeat = pressed && key === this.lastKey;
            // Bail if a modifier key is set
            if (altKey || ctrlKey || metaKey || shiftKey) return;
            // If the event is bubbled from the media element
            // Firefox doesn't get the key for whatever reason
            if (!key) return;
            // Seek by increment
            const seekByIncrement = (increment)=>{
                // Divide the max duration into 10th's and times by the number value
                player.currentTime = player.duration / 10 * increment;
            };
            // Handle the key on keydown
            // Reset on keyup
            if (pressed) {
                // Check focused element
                // and if the focused element is not editable (e.g. text input)
                // and any that accept key input http://webaim.org/techniques/keyboard/
                const focused = document.activeElement;
                if (is.element(focused)) {
                    const { editable: editable } = player.config.selectors;
                    const { seek: seek } = elements.inputs;
                    if (focused !== seek && matches(focused, editable)) return;
                    if (event.key === ' ' && matches(focused, 'button, [role^="menuitem"]')) return;
                }
                // Which keys should we prevent default
                const preventDefault = [
                    ' ',
                    'ArrowLeft',
                    'ArrowUp',
                    'ArrowRight',
                    'ArrowDown',
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    'c',
                    'f',
                    'k',
                    'l',
                    'm'
                ];
                // If the key is found prevent default (e.g. prevent scrolling for arrows)
                if (preventDefault.includes(key)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                switch(key){
                    case '0':
                    case '1':
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                    case '6':
                    case '7':
                    case '8':
                    case '9':
                        if (!repeat) seekByIncrement(Number.parseInt(key, 10));
                        break;
                    case ' ':
                    case 'k':
                        if (!repeat) silencePromise(player.togglePlay());
                        break;
                    case 'ArrowUp':
                        player.increaseVolume(0.1);
                        break;
                    case 'ArrowDown':
                        player.decreaseVolume(0.1);
                        break;
                    case 'm':
                        if (!repeat) player.muted = !player.muted;
                        break;
                    case 'ArrowRight':
                        player.forward();
                        break;
                    case 'ArrowLeft':
                        player.rewind();
                        break;
                    case 'f':
                        player.fullscreen.toggle();
                        break;
                    case 'c':
                        if (!repeat) player.toggleCaptions();
                        break;
                    case 'l':
                        player.loop = !player.loop;
                        break;
                }
                // Escape is handle natively when in full screen
                // So we only need to worry about non native
                if (key === 'Escape' && !player.fullscreen.usingNative && player.fullscreen.active) player.fullscreen.toggle();
                // Store last key for next cycle
                this.lastKey = key;
            } else this.lastKey = null;
        }
        // Toggle menu
        toggleMenu(event) {
            controls.toggleMenu.call(this.player, event);
        }
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var loadjs_umd$1 = {
        exports: {}
    };
    var loadjs_umd = loadjs_umd$1.exports;
    var hasRequiredLoadjs_umd;
    function requireLoadjs_umd() {
        if (hasRequiredLoadjs_umd) return loadjs_umd$1.exports;
        hasRequiredLoadjs_umd = 1;
        (function(module1, exports) {
            (function(root, factory) {
                module1.exports = factory();
            })(loadjs_umd, function() {
                /**
         * Global dependencies.
         * @global {Object} document - DOM
         */ var devnull = function() {}, bundleIdCache = {}, bundleResultCache = {}, bundleCallbackQueue = {};
                /**
         * Subscribe to bundle load event.
         * @param {string[]} bundleIds - Bundle ids
         * @param {Function} callbackFn - The callback function
         */ function subscribe(bundleIds, callbackFn) {
                    // listify
                    bundleIds = bundleIds.push ? bundleIds : [
                        bundleIds
                    ];
                    var depsNotFound = [], i = bundleIds.length, numWaiting = i, fn, bundleId, r, q;
                    // define callback function
                    fn = function(bundleId, pathsNotFound) {
                        if (pathsNotFound.length) depsNotFound.push(bundleId);
                        numWaiting--;
                        if (!numWaiting) callbackFn(depsNotFound);
                    };
                    // register callback
                    while(i--){
                        bundleId = bundleIds[i];
                        // execute callback if in result cache
                        r = bundleResultCache[bundleId];
                        if (r) {
                            fn(bundleId, r);
                            continue;
                        }
                        // add to callback queue
                        q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
                        q.push(fn);
                    }
                }
                /**
         * Publish bundle load event.
         * @param {string} bundleId - Bundle id
         * @param {string[]} pathsNotFound - List of files not found
         */ function publish(bundleId, pathsNotFound) {
                    // exit if id isn't defined
                    if (!bundleId) return;
                    var q = bundleCallbackQueue[bundleId];
                    // cache result
                    bundleResultCache[bundleId] = pathsNotFound;
                    // exit if queue is empty
                    if (!q) return;
                    // empty callback queue
                    while(q.length){
                        q[0](bundleId, pathsNotFound);
                        q.splice(0, 1);
                    }
                }
                /**
         * Execute callbacks.
         * @param {Object or Function} args - The callback args
         * @param {string[]} depsNotFound - List of dependencies not found
         */ function executeCallbacks(args, depsNotFound) {
                    // accept function as argument
                    if (args.call) args = {
                        success: args
                    };
                    // success and error callbacks
                    if (depsNotFound.length) (args.error || devnull)(depsNotFound);
                    else (args.success || devnull)(args);
                }
                /**
         * Load individual file.
         * @param {string} path - The file path
         * @param {Function} callbackFn - The callback function
         */ function loadFile(path, callbackFn, args, numTries) {
                    var doc = document, async = args.async, maxTries = (args.numRetries || 0) + 1, beforeCallbackFn = args.before || devnull, pathname = path.replace(/[\?|#].*$/, ''), pathStripped = path.replace(/^(css|img|module|nomodule)!/, ''), isLegacyIECss, hasModuleSupport, e;
                    numTries = numTries || 0;
                    if (/(^css!|\.css$)/.test(pathname)) {
                        // css
                        e = doc.createElement('link');
                        e.rel = 'stylesheet';
                        e.href = pathStripped;
                        // tag IE9+
                        isLegacyIECss = 'hideFocus' in e;
                        // use preload in IE Edge (to detect load errors)
                        if (isLegacyIECss && e.relList) {
                            isLegacyIECss = 0;
                            e.rel = 'preload';
                            e.as = 'style';
                        }
                    } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
                        // image
                        e = doc.createElement('img');
                        e.src = pathStripped;
                    } else {
                        // javascript
                        e = doc.createElement('script');
                        e.src = pathStripped;
                        e.async = async === undefined ? true : async;
                        // handle es modules
                        // modern browsers:
                        //   module: add to dom with type="module"
                        //   nomodule: call success() callback without adding to dom
                        // legacy browsers:
                        //   module: call success() callback without adding to dom
                        //   nomodule: add to dom with default type ("text/javascript")
                        hasModuleSupport = 'noModule' in e;
                        if (/^module!/.test(pathname)) {
                            if (!hasModuleSupport) return callbackFn(path, 'l');
                            e.type = "module";
                        } else if (/^nomodule!/.test(pathname) && hasModuleSupport) return callbackFn(path, 'l');
                    }
                    e.onload = e.onerror = e.onbeforeload = function(ev) {
                        var result = ev.type[0];
                        // treat empty stylesheets as failures to get around lack of onerror
                        // support in IE9-11
                        if (isLegacyIECss) try {
                            if (!e.sheet.cssText.length) result = 'e';
                        } catch (x) {
                            // sheets objects created from load errors don't allow access to
                            // `cssText` (unless error is Code:18 SecurityError)
                            if (x.code != 18) result = 'e';
                        }
                        // handle retries in case of load failure
                        if (result == 'e') {
                            // increment counter
                            numTries += 1;
                            // exit function and try again
                            if (numTries < maxTries) return loadFile(path, callbackFn, args, numTries);
                        } else if (e.rel == 'preload' && e.as == 'style') // activate preloaded stylesheets
                        return e.rel = 'stylesheet'; // jshint ignore:line
                        // execute callback
                        callbackFn(path, result, ev.defaultPrevented);
                    };
                    // add to document (unless callback returns `false`)
                    if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
                }
                /**
         * Load multiple files.
         * @param {string[]} paths - The file paths
         * @param {Function} callbackFn - The callback function
         */ function loadFiles(paths, callbackFn, args) {
                    // listify paths
                    paths = paths.push ? paths : [
                        paths
                    ];
                    var numWaiting = paths.length, x = numWaiting, pathsNotFound = [], fn, i;
                    // define callback function
                    fn = function(path, result, defaultPrevented) {
                        // handle error
                        if (result == 'e') pathsNotFound.push(path);
                        // handle beforeload event. If defaultPrevented then that means the load
                        // will be blocked (ex. Ghostery/ABP on Safari)
                        if (result == 'b') {
                            if (defaultPrevented) pathsNotFound.push(path);
                            else return;
                        }
                        numWaiting--;
                        if (!numWaiting) callbackFn(pathsNotFound);
                    };
                    // load scripts
                    for(i = 0; i < x; i++)loadFile(paths[i], fn, args);
                }
                /**
         * Initiate script load and register bundle.
         * @param {(string|string[])} paths - The file paths
         * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
         *   callback or (3) object literal with success/error arguments, numRetries,
         *   etc.
         * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
         *   literal with success/error arguments, numRetries, etc.
         */ function loadjs(paths, arg1, arg2) {
                    var bundleId, args;
                    // bundleId (if string)
                    if (arg1 && arg1.trim) bundleId = arg1;
                    // args (default is {})
                    args = (bundleId ? arg2 : arg1) || {};
                    // throw error if bundle is already defined
                    if (bundleId) {
                        if (bundleId in bundleIdCache) throw "LoadJS";
                        else bundleIdCache[bundleId] = true;
                    }
                    function loadFn(resolve, reject) {
                        loadFiles(paths, function(pathsNotFound) {
                            // execute callbacks
                            executeCallbacks(args, pathsNotFound);
                            // resolve Promise
                            if (resolve) executeCallbacks({
                                success: resolve,
                                error: reject
                            }, pathsNotFound);
                            // publish bundle load event
                            publish(bundleId, pathsNotFound);
                        }, args);
                    }
                    if (args.returnPromise) return new Promise(loadFn);
                    else loadFn();
                }
                /**
         * Execute callbacks when dependencies have been satisfied.
         * @param {(string|string[])} deps - List of bundle ids
         * @param {Object} args - success/error arguments
         */ loadjs.ready = function ready(deps, args) {
                    // subscribe to bundle load event
                    subscribe(deps, function(depsNotFound) {
                        // execute callbacks
                        executeCallbacks(args, depsNotFound);
                    });
                    return loadjs;
                };
                /**
         * Manually satisfy bundle dependencies.
         * @param {string} bundleId - The bundle id
         */ loadjs.done = function done(bundleId) {
                    publish(bundleId, []);
                };
                /**
         * Reset loadjs dependencies statuses
         */ loadjs.reset = function reset() {
                    bundleIdCache = {};
                    bundleResultCache = {};
                    bundleCallbackQueue = {};
                };
                /**
         * Determine if bundle has already been defined
         * @param String} bundleId - The bundle id
         */ loadjs.isDefined = function isDefined(bundleId) {
                    return bundleId in bundleIdCache;
                };
                // export
                return loadjs;
            });
        })(loadjs_umd$1);
        return loadjs_umd$1.exports;
    }
    var loadjs_umdExports = requireLoadjs_umd();
    var loadjs = /*@__PURE__*/ getDefaultExportFromCjs(loadjs_umdExports);
    // ==========================================================================
    // Load an external script
    // ==========================================================================
    function loadScript(url) {
        return new Promise((resolve, reject)=>{
            loadjs(url, {
                success: resolve,
                error: reject
            });
        });
    }
    // ==========================================================================
    // Vimeo plugin
    // ==========================================================================
    // Parse Vimeo ID from URL
    function parseId$1(url) {
        if (is.empty(url)) return null;
        if (is.number(Number(url))) return url;
        // eslint-disable-next-line regexp/optimal-quantifier-concatenation
        const regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
        const match = url.match(regex);
        return match ? match[2] : url;
    }
    // Try to extract a hash for private videos from the URL
    function parseHash(url) {
        /* This regex matches a hexadecimal hash if given in any of these forms:
     *  - [https://player.]vimeo.com/video/{id}/{hash}[?params]
     *  - [https://player.]vimeo.com/video/{id}?h={hash}[&params]
     *  - [https://player.]vimeo.com/video/{id}?[params]&h={hash}
     *  - video/{id}/{hash}
     * If matched, the hash is available in capture group 4
     */ const regex = /^.*(vimeo.com\/|video\/)(\d+)(\?.*h=|\/)+([\d,a-f]+)/;
        const found = url.match(regex);
        return found && found.length === 5 ? found[4] : null;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState$1(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    const vimeo = {
        setup () {
            const player = this;
            // Add embed class for responsive
            toggleClass(player.elements.wrapper, player.config.classNames.embed, true);
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set initial ratio
            setAspectRatio.call(player);
            // Load the SDK if not already
            if (!is.object(window.Vimeo)) loadScript(player.config.urls.vimeo.sdk).then(()=>{
                vimeo.ready.call(player);
            }).catch((error)=>{
                player.debug.warn('Vimeo SDK (player.js) failed to load', error);
            });
            else vimeo.ready.call(player);
        },
        // API Ready
        ready () {
            const player = this;
            const config = player.config.vimeo;
            const { premium: premium, referrerPolicy: referrerPolicy, ...frameParams } = config;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            let hash = '';
            // Get from <div> if needed
            if (is.empty(source)) {
                source = player.media.getAttribute(player.config.attributes.embed.id);
                // hash can also be set as attribute on the <div>
                hash = player.media.getAttribute(player.config.attributes.embed.hash);
            } else hash = parseHash(source);
            const hashParam = hash ? {
                h: hash
            } : {};
            // If the owner has a pro or premium account then we can hide controls etc
            if (premium) Object.assign(frameParams, {
                controls: false,
                sidedock: false
            });
            // Get Vimeo params for the iframe
            const params = buildUrlParams({
                loop: player.config.loop.active,
                autoplay: player.autoplay,
                muted: player.muted,
                gesture: 'media',
                playsinline: player.config.playsinline,
                // hash has to be added to iframe-URL
                ...hashParam,
                ...frameParams
            });
            const id = parseId$1(source);
            // Build an iframe
            const iframe = createElement('iframe');
            const src = format(player.config.urls.vimeo.iframe, id, params);
            iframe.setAttribute('src', src);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', [
                'autoplay',
                'fullscreen',
                'picture-in-picture',
                'encrypted-media',
                'accelerometer',
                'gyroscope'
            ].join('; '));
            // Set the referrer policy if required
            if (!is.empty(referrerPolicy)) iframe.setAttribute('referrerPolicy', referrerPolicy);
            // Inject the package
            if (premium || !config.customControls) {
                iframe.setAttribute('data-poster', player.poster);
                player.media = replaceElement(iframe, player.media);
            } else {
                const wrapper = createElement('div', {
                    'class': player.config.classNames.embedContainer,
                    'data-poster': player.poster
                });
                wrapper.appendChild(iframe);
                player.media = replaceElement(wrapper, player.media);
            }
            // Get poster image
            if (!config.customControls) fetch(format(player.config.urls.vimeo.api, src)).then((response)=>{
                if (is.empty(response) || !response.thumbnail_url) return;
                // Set and show poster
                ui.setPoster.call(player, response.thumbnail_url).catch(()=>{});
            });
            // Setup instance
            // https://github.com/vimeo/player.js
            player.embed = new window.Vimeo.Player(iframe, {
                autopause: player.config.autopause,
                muted: player.muted
            });
            player.media.paused = true;
            player.media.currentTime = 0;
            // Disable native text track rendering
            if (player.supported.ui) player.embed.disableTextTrack();
            // Create a faux HTML5 API using the Vimeo API
            player.media.play = ()=>{
                assurePlaybackState$1.call(player, true);
                return player.embed.play();
            };
            player.media.pause = ()=>{
                assurePlaybackState$1.call(player, false);
                return player.embed.pause();
            };
            player.media.stop = ()=>{
                player.pause();
                player.currentTime = 0;
            };
            // Seeking
            let { currentTime: currentTime } = player.media;
            Object.defineProperty(player.media, 'currentTime', {
                get () {
                    return currentTime;
                },
                set (time) {
                    // Vimeo will automatically play on seek if the video hasn't been played before
                    // Get current paused state and volume etc
                    const { embed: embed, media: media, paused: paused, volume: volume } = player;
                    const restorePause = paused && !embed.hasPlayed;
                    // Set seeking state and trigger event
                    media.seeking = true;
                    triggerEvent.call(player, media, 'seeking');
                    // If paused, mute until seek is complete
                    Promise.resolve(restorePause && embed.setVolume(0))// Seek
                    .then(()=>embed.setCurrentTime(time))// Restore paused
                    .then(()=>restorePause && embed.pause())// Restore volume
                    .then(()=>restorePause && embed.setVolume(volume)).catch(()=>{
                    // Do nothing
                    });
                }
            });
            // Playback speed
            let speed = player.config.speed.selected;
            Object.defineProperty(player.media, 'playbackRate', {
                get () {
                    return speed;
                },
                set (input) {
                    player.embed.setPlaybackRate(input).then(()=>{
                        speed = input;
                        triggerEvent.call(player, player.media, 'ratechange');
                    }).catch(()=>{
                        // Cannot set Playback Rate, Video is probably not on Pro account
                        player.options.speed = [
                            1
                        ];
                    });
                }
            });
            // Volume
            let { volume: volume } = player.config;
            Object.defineProperty(player.media, 'volume', {
                get () {
                    return volume;
                },
                set (input) {
                    player.embed.setVolume(input).then(()=>{
                        volume = input;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Muted
            let { muted: muted } = player.config;
            Object.defineProperty(player.media, 'muted', {
                get () {
                    return muted;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : false;
                    player.embed.setMuted(toggle ? true : player.config.muted).then(()=>{
                        muted = toggle;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Loop
            let { loop: loop } = player.config;
            Object.defineProperty(player.media, 'loop', {
                get () {
                    return loop;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : player.config.loop.active;
                    player.embed.setLoop(toggle).then(()=>{
                        loop = toggle;
                    });
                }
            });
            // Source
            let currentSrc;
            player.embed.getVideoUrl().then((value)=>{
                currentSrc = value;
                controls.setDownloadUrl.call(player);
            }).catch((error)=>{
                this.debug.warn(error);
            });
            Object.defineProperty(player.media, 'currentSrc', {
                get () {
                    return currentSrc;
                }
            });
            // Ended
            Object.defineProperty(player.media, 'ended', {
                get () {
                    return player.currentTime === player.duration;
                }
            });
            // Set aspect ratio based on video size
            Promise.all([
                player.embed.getVideoWidth(),
                player.embed.getVideoHeight()
            ]).then((dimensions)=>{
                const [width, height] = dimensions;
                player.embed.ratio = roundAspectRatio(width, height);
                setAspectRatio.call(this);
            });
            // Set autopause
            player.embed.setAutopause(player.config.autopause).then((state)=>{
                player.config.autopause = state;
            });
            // Get title
            player.embed.getVideoTitle().then((title)=>{
                player.config.title = title;
                ui.setTitle.call(this);
            });
            // Get current time
            player.embed.getCurrentTime().then((value)=>{
                currentTime = value;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            // Get duration
            player.embed.getDuration().then((value)=>{
                player.media.duration = value;
                triggerEvent.call(player, player.media, 'durationchange');
            });
            // Get captions
            player.embed.getTextTracks().then((tracks)=>{
                player.media.textTracks = tracks;
                captions.setup.call(player);
            });
            player.embed.on('cuechange', ({ cues: cues = [] })=>{
                const strippedCues = cues.map((cue)=>stripHTML(cue.text));
                captions.updateCues.call(player, strippedCues);
            });
            player.embed.on('loaded', ()=>{
                // Assure state and events are updated on autoplay
                player.embed.getPaused().then((paused)=>{
                    assurePlaybackState$1.call(player, !paused);
                    if (!paused) triggerEvent.call(player, player.media, 'playing');
                });
                if (is.element(player.embed.element) && player.supported.ui) {
                    const frame = player.embed.element;
                    // Fix keyboard focus issues
                    // https://github.com/sampotts/plyr/issues/317
                    frame.setAttribute('tabindex', -1);
                }
            });
            player.embed.on('bufferstart', ()=>{
                triggerEvent.call(player, player.media, 'waiting');
            });
            player.embed.on('bufferend', ()=>{
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('play', ()=>{
                assurePlaybackState$1.call(player, true);
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('pause', ()=>{
                assurePlaybackState$1.call(player, false);
            });
            player.embed.on('timeupdate', (data)=>{
                player.media.seeking = false;
                currentTime = data.seconds;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            player.embed.on('progress', (data)=>{
                player.media.buffered = data.percent;
                triggerEvent.call(player, player.media, 'progress');
                // Check all loaded
                if (Number.parseInt(data.percent, 10) === 1) triggerEvent.call(player, player.media, 'canplaythrough');
                // Get duration as if we do it before load, it gives an incorrect value
                // https://github.com/sampotts/plyr/issues/891
                player.embed.getDuration().then((value)=>{
                    if (value !== player.media.duration) {
                        player.media.duration = value;
                        triggerEvent.call(player, player.media, 'durationchange');
                    }
                });
            });
            player.embed.on('seeked', ()=>{
                player.media.seeking = false;
                triggerEvent.call(player, player.media, 'seeked');
            });
            player.embed.on('ended', ()=>{
                player.media.paused = true;
                triggerEvent.call(player, player.media, 'ended');
            });
            player.embed.on('error', (detail)=>{
                player.media.error = detail;
                triggerEvent.call(player, player.media, 'error');
            });
            // Rebuild UI
            if (config.customControls) setTimeout(()=>ui.build.call(player), 0);
        }
    };
    // ==========================================================================
    // YouTube plugin
    // ==========================================================================
    // Parse YouTube ID from URL
    function parseId(url) {
        if (is.empty(url)) return null;
        const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regex);
        return match && match[2] ? match[2] : url;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    function getHost(config) {
        if (config.noCookie) return 'https://www.youtube-nocookie.com';
        if (window.location.protocol === 'http:') return 'http://www.youtube.com';
        // Use YouTube's default
        return undefined;
    }
    const youtube = {
        setup () {
            // Add embed class for responsive
            toggleClass(this.elements.wrapper, this.config.classNames.embed, true);
            // Setup API
            if (is.object(window.YT) && is.function(window.YT.Player)) youtube.ready.call(this);
            else {
                // Reference current global callback
                const callback = window.onYouTubeIframeAPIReady;
                // Set callback to process queue
                window.onYouTubeIframeAPIReady = ()=>{
                    // Call global callback if set
                    if (is.function(callback)) callback();
                    youtube.ready.call(this);
                };
                // Load the SDK
                loadScript(this.config.urls.youtube.sdk).catch((error)=>{
                    this.debug.warn('YouTube API failed to load', error);
                });
            }
        },
        // Get the media title
        getTitle (videoId) {
            const url = format(this.config.urls.youtube.api, videoId);
            fetch(url).then((data)=>{
                if (is.object(data)) {
                    const { title: title, height: height, width: width } = data;
                    // Set title
                    this.config.title = title;
                    ui.setTitle.call(this);
                    // Set aspect ratio
                    this.embed.ratio = roundAspectRatio(width, height);
                }
                setAspectRatio.call(this);
            }).catch(()=>{
                // Set aspect ratio
                setAspectRatio.call(this);
            });
        },
        // API ready
        ready () {
            const player = this;
            const config = player.config.youtube;
            // Ignore already setup (race condition)
            const currentId = player.media && player.media.getAttribute('id');
            if (!is.empty(currentId) && currentId.startsWith('youtube-')) return;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            // Get from <div> if needed
            if (is.empty(source)) source = player.media.getAttribute(this.config.attributes.embed.id);
            // Replace the <iframe> with a <div> due to YouTube API issues
            const videoId = parseId(source);
            const id = generateId(player.provider);
            // Replace media element
            const container = createElement('div', {
                id: id,
                'data-poster': config.customControls ? player.poster : undefined
            });
            player.media = replaceElement(container, player.media);
            // Only load the poster when using custom controls
            if (config.customControls) {
                const posterSrc = (s)=>`https://i.ytimg.com/vi/${videoId}/${s}default.jpg`;
                // Check thumbnail images in order of quality, but reject fallback thumbnails (120px wide)
                loadImage(posterSrc('maxres'), 121) // Highest quality and un-padded
                .catch(()=>loadImage(posterSrc('sd'), 121)) // 480p padded 4:3
                .catch(()=>loadImage(posterSrc('hq'))) // 360p padded 4:3. Always exists
                .then((image)=>ui.setPoster.call(player, image.src)).then((src)=>{
                    // If the image is padded, use background-size "cover" instead (like youtube does too with their posters)
                    if (!src.includes('maxres')) player.elements.poster.style.backgroundSize = 'cover';
                }).catch(()=>{});
            }
            // Setup instance
            // https://developers.google.com/youtube/iframe_api_reference
            player.embed = new window.YT.Player(player.media, {
                videoId: videoId,
                host: getHost(config),
                playerVars: extend({}, {
                    // Autoplay
                    autoplay: player.config.autoplay ? 1 : 0,
                    // iframe interface language
                    hl: player.config.hl,
                    // Only show controls if not fully supported or opted out
                    controls: player.supported.ui && config.customControls ? 0 : 1,
                    // Disable keyboard as we handle it
                    disablekb: 1,
                    // Allow iOS inline playback
                    playsinline: player.config.playsinline && !player.config.fullscreen.iosNative ? 1 : 0,
                    // Captions are flaky on YouTube
                    cc_load_policy: player.captions.active ? 1 : 0,
                    cc_lang_pref: player.config.captions.language,
                    // Tracking for stats
                    widget_referrer: window ? window.location.href : null
                }, config),
                events: {
                    onError (event) {
                        // YouTube may fire onError twice, so only handle it once
                        if (!player.media.error) {
                            const code = event.data;
                            // Messages copied from https://developers.google.com/youtube/iframe_api_reference#onError
                            const message = {
                                2: 'The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.',
                                5: 'The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.',
                                100: 'The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.',
                                101: 'The owner of the requested video does not allow it to be played in embedded players.',
                                150: 'The owner of the requested video does not allow it to be played in embedded players.'
                            }[code] || 'An unknown error occurred';
                            player.media.error = {
                                code: code,
                                message: message
                            };
                            triggerEvent.call(player, player.media, 'error');
                        }
                    },
                    onPlaybackRateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Get current speed
                        player.media.playbackRate = instance.getPlaybackRate();
                        triggerEvent.call(player, player.media, 'ratechange');
                    },
                    onReady (event) {
                        // Bail if onReady has already been called. See issue #1108
                        if (is.function(player.media.play)) return;
                        // Get the instance
                        const instance = event.target;
                        // Get the title
                        youtube.getTitle.call(player, videoId);
                        // Create a faux HTML5 API using the YouTube API
                        player.media.play = ()=>{
                            assurePlaybackState.call(player, true);
                            instance.playVideo();
                        };
                        player.media.pause = ()=>{
                            assurePlaybackState.call(player, false);
                            instance.pauseVideo();
                        };
                        player.media.stop = ()=>{
                            instance.stopVideo();
                        };
                        player.media.duration = instance.getDuration();
                        player.media.paused = true;
                        // Seeking
                        player.media.currentTime = 0;
                        Object.defineProperty(player.media, 'currentTime', {
                            get () {
                                return Number(instance.getCurrentTime());
                            },
                            set (time) {
                                // If paused and never played, mute audio preventively (YouTube starts playing on seek if the video hasn't been played yet).
                                if (player.paused && !player.embed.hasPlayed) player.embed.mute();
                                // Set seeking state and trigger event
                                player.media.seeking = true;
                                triggerEvent.call(player, player.media, 'seeking');
                                // Seek after events sent
                                instance.seekTo(time);
                            }
                        });
                        // Playback speed
                        Object.defineProperty(player.media, 'playbackRate', {
                            get () {
                                return instance.getPlaybackRate();
                            },
                            set (input) {
                                instance.setPlaybackRate(input);
                            }
                        });
                        // Volume
                        let { volume: volume } = player.config;
                        Object.defineProperty(player.media, 'volume', {
                            get () {
                                return volume;
                            },
                            set (input) {
                                volume = input;
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Muted
                        let { muted: muted } = player.config;
                        Object.defineProperty(player.media, 'muted', {
                            get () {
                                return muted;
                            },
                            set (input) {
                                const toggle = is.boolean(input) ? input : muted;
                                muted = toggle;
                                instance[toggle ? 'mute' : 'unMute']();
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Source
                        Object.defineProperty(player.media, 'currentSrc', {
                            get () {
                                return instance.getVideoUrl();
                            }
                        });
                        // Ended
                        Object.defineProperty(player.media, 'ended', {
                            get () {
                                return player.currentTime === player.duration;
                            }
                        });
                        // Get available speeds
                        const speeds = instance.getAvailablePlaybackRates();
                        // Filter based on config
                        player.options.speed = speeds.filter((s)=>player.config.speed.options.includes(s));
                        // Set the tabindex to avoid focus entering iframe
                        if (player.supported.ui && config.customControls) player.media.setAttribute('tabindex', -1);
                        triggerEvent.call(player, player.media, 'timeupdate');
                        triggerEvent.call(player, player.media, 'durationchange');
                        // Reset timer
                        clearInterval(player.timers.buffering);
                        // Setup buffering
                        player.timers.buffering = setInterval(()=>{
                            // Get loaded % from YouTube
                            player.media.buffered = instance.getVideoLoadedFraction();
                            // Trigger progress only when we actually buffer something
                            if (player.media.lastBuffered === null || player.media.lastBuffered < player.media.buffered) triggerEvent.call(player, player.media, 'progress');
                            // Set last buffer point
                            player.media.lastBuffered = player.media.buffered;
                            // Bail if we're at 100%
                            if (player.media.buffered === 1) {
                                clearInterval(player.timers.buffering);
                                // Trigger event
                                triggerEvent.call(player, player.media, 'canplaythrough');
                            }
                        }, 200);
                        // Rebuild UI
                        if (config.customControls) setTimeout(()=>ui.build.call(player), 50);
                    },
                    onStateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Reset timer
                        clearInterval(player.timers.playing);
                        const seeked = player.media.seeking && [
                            1,
                            2
                        ].includes(event.data);
                        if (seeked) {
                            // Unset seeking and fire seeked event
                            player.media.seeking = false;
                            triggerEvent.call(player, player.media, 'seeked');
                        }
                        // Handle events
                        // -1   Unstarted
                        // 0    Ended
                        // 1    Playing
                        // 2    Paused
                        // 3    Buffering
                        // 5    Video cued
                        switch(event.data){
                            case -1:
                                // Update scrubber
                                triggerEvent.call(player, player.media, 'timeupdate');
                                // Get loaded % from YouTube
                                player.media.buffered = instance.getVideoLoadedFraction();
                                triggerEvent.call(player, player.media, 'progress');
                                break;
                            case 0:
                                assurePlaybackState.call(player, false);
                                // YouTube doesn't support loop for a single video, so mimick it.
                                if (player.media.loop) {
                                    // YouTube needs a call to `stopVideo` before playing again
                                    instance.stopVideo();
                                    instance.playVideo();
                                } else triggerEvent.call(player, player.media, 'ended');
                                break;
                            case 1:
                                // Restore paused state (YouTube starts playing on seek if the video hasn't been played yet)
                                if (config.customControls && !player.config.autoplay && player.media.paused && !player.embed.hasPlayed) player.media.pause();
                                else {
                                    assurePlaybackState.call(player, true);
                                    triggerEvent.call(player, player.media, 'playing');
                                    // Poll to get playback progress
                                    player.timers.playing = setInterval(()=>{
                                        triggerEvent.call(player, player.media, 'timeupdate');
                                    }, 50);
                                    // Check duration again due to YouTube bug
                                    // https://github.com/sampotts/plyr/issues/374
                                    // https://code.google.com/p/gdata-issues/issues/detail?id=8690
                                    if (player.media.duration !== instance.getDuration()) {
                                        player.media.duration = instance.getDuration();
                                        triggerEvent.call(player, player.media, 'durationchange');
                                    }
                                }
                                break;
                            case 2:
                                // Restore audio (YouTube starts playing on seek if the video hasn't been played yet)
                                if (!player.muted) player.embed.unMute();
                                assurePlaybackState.call(player, false);
                                break;
                            case 3:
                                // Trigger waiting event to add loading classes to container as the video buffers.
                                triggerEvent.call(player, player.media, 'waiting');
                                break;
                        }
                        triggerEvent.call(player, player.elements.container, 'statechange', false, {
                            code: event.data
                        });
                    }
                }
            });
        }
    };
    // ==========================================================================
    // Plyr Media
    // ==========================================================================
    const media = {
        // Setup media
        setup () {
            // If there's no media, bail
            if (!this.media) {
                this.debug.warn('No media element found!');
                return;
            }
            // Add type class
            toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', this.type), true);
            // Add provider class
            toggleClass(this.elements.container, this.config.classNames.provider.replace('{0}', this.provider), true);
            // Add video class for embeds
            // This will require changes if audio embeds are added
            if (this.isEmbed) toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', 'video'), true);
            // Inject the player wrapper
            if (this.isVideo) {
                // Create the wrapper div
                this.elements.wrapper = createElement('div', {
                    class: this.config.classNames.video
                });
                // Wrap the video in a container
                wrap(this.media, this.elements.wrapper);
                // Poster image container
                this.elements.poster = createElement('div', {
                    class: this.config.classNames.poster
                });
                this.elements.wrapper.appendChild(this.elements.poster);
            }
            if (this.isHTML5) html5.setup.call(this);
            else if (this.isYouTube) youtube.setup.call(this);
            else if (this.isVimeo) vimeo.setup.call(this);
        }
    };
    function destroy(instance) {
        // Destroy our adsManager
        if (instance.manager) instance.manager.destroy();
        // Destroy our adsManager
        if (instance.elements.displayContainer) instance.elements.displayContainer.destroy();
        instance.elements.container.remove();
    }
    class Ads {
        /**
     * Ads constructor.
     * @param {object} player
     * @return {Ads}
     */ constructor(player){
            /**
       * Load the IMA SDK
       */ _defineProperty$1(this, "load", ()=>{
                if (!this.enabled) return;
                // Check if the Google IMA3 SDK is loaded or load it ourselves
                if (!is.object(window.google) || !is.object(window.google.ima)) loadScript(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    // Script failed to load or is blocked
                    this.trigger('error', new Error('Google IMA SDK failed to load'));
                });
                else this.ready();
            });
            /**
       * Get the ads instance ready
       */ _defineProperty$1(this, "ready", ()=>{
                // Double check we're enabled
                if (!this.enabled) destroy(this);
                // Start ticking our safety timer. If the whole advertisement
                // thing doesn't resolve within our set time; we bail
                this.startSafetyTimer(12000, 'ready()');
                // Clear the safety timer
                this.managerPromise.then(()=>{
                    this.clearSafetyTimer('onAdsManagerLoaded()');
                });
                // Set listeners on the Plyr instance
                this.listeners();
                // Setup the IMA SDK
                this.setupIMA();
            });
            /**
       * In order for the SDK to display ads for our video, we need to tell it where to put them,
       * so here we define our ad container. This div is set up to render on top of the video player.
       * Using the code below, we tell the SDK to render ads within that div. We also provide a
       * handle to the content video player - the SDK will poll the current time of our player to
       * properly place mid-rolls. After we create the ad display container, we initialize it. On
       * mobile devices, this initialization is done as the result of a user action.
       */ _defineProperty$1(this, "setupIMA", ()=>{
                // Create the container for our advertisements
                this.elements.container = createElement('div', {
                    class: this.player.config.classNames.ads
                });
                this.player.elements.container.appendChild(this.elements.container);
                // So we can run VPAID2
                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
                // Set language
                google.ima.settings.setLocale(this.player.config.ads.language);
                // Set playback for iOS10+
                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline);
                // We assume the adContainer is the video container of the plyr element that will house the ads
                this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media);
                // Create ads loader
                this.loader = new google.ima.AdsLoader(this.elements.displayContainer);
                // Listen and respond to ads loaded and error events
                this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (event)=>this.onAdsManagerLoaded(event), false);
                this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error), false);
                // Request video ads to be pre-loaded
                this.requestAds();
            });
            /**
       * Request advertisements
       */ _defineProperty$1(this, "requestAds", ()=>{
                const { container: container } = this.player.elements;
                try {
                    // Request video ads
                    const request = new google.ima.AdsRequest();
                    request.adTagUrl = this.tagUrl;
                    // Specify the linear and nonlinear slot sizes. This helps the SDK
                    // to select the correct creative if multiple are returned
                    request.linearAdSlotWidth = container.offsetWidth;
                    request.linearAdSlotHeight = container.offsetHeight;
                    request.nonLinearAdSlotWidth = container.offsetWidth;
                    request.nonLinearAdSlotHeight = container.offsetHeight;
                    // We only overlay ads as we only support video.
                    request.forceNonLinearFullSlot = false;
                    // Mute based on current state
                    request.setAdWillPlayMuted(!this.player.muted);
                    this.loader.requestAds(request);
                } catch (error) {
                    this.onAdError(error);
                }
            });
            /**
       * Update the ad countdown
       * @param {boolean} start
       */ _defineProperty$1(this, "pollCountdown", (start = false)=>{
                if (!start) {
                    clearInterval(this.countdownTimer);
                    this.elements.container.removeAttribute('data-badge-text');
                    return;
                }
                const update = ()=>{
                    const time = formatTime(Math.max(this.manager.getRemainingTime(), 0));
                    const label = `${i18n.get('advertisement', this.player.config)} - ${time}`;
                    this.elements.container.setAttribute('data-badge-text', label);
                };
                this.countdownTimer = setInterval(update, 100);
            });
            /**
       * This method is called whenever the ads are ready inside the AdDisplayContainer
       * @param {Event} event - adsManagerLoadedEvent
       */ _defineProperty$1(this, "onAdsManagerLoaded", (event)=>{
                // Load could occur after a source change (race condition)
                if (!this.enabled) return;
                // Get the ads manager
                const settings = new google.ima.AdsRenderingSettings();
                // Tell the SDK to save and restore content video state on our behalf
                settings.restoreCustomPlaybackStateOnAdBreakComplete = true;
                settings.enablePreloading = true;
                // The SDK is polling currentTime on the contentPlayback. And needs a duration
                // so it can determine when to start the mid- and post-roll
                this.manager = event.getAdsManager(this.player, settings);
                // Get the cue points for any mid-rolls by filtering out the pre- and post-roll
                this.cuePoints = this.manager.getCuePoints();
                // Add listeners to the required events
                // Advertisement error events
                this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error));
                // Advertisement regular events
                Object.keys(google.ima.AdEvent.Type).forEach((type)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[type], (e)=>this.onAdEvent(e));
                });
                // Resolve our adsManager
                this.trigger('loaded');
            });
            _defineProperty$1(this, "addCuePoints", ()=>{
                // Add advertisement cue's within the time line if available
                if (!is.empty(this.cuePoints)) this.cuePoints.forEach((cuePoint)=>{
                    if (cuePoint !== 0 && cuePoint !== -1 && cuePoint < this.player.duration) {
                        const seekElement = this.player.elements.progress;
                        if (is.element(seekElement)) {
                            const cuePercentage = 100 / this.player.duration * cuePoint;
                            const cue = createElement('span', {
                                class: this.player.config.classNames.cues
                            });
                            cue.style.left = `${cuePercentage.toString()}%`;
                            seekElement.appendChild(cue);
                        }
                    }
                });
            });
            /**
       * This is where all the event handling takes place. Retrieve the ad from the event. Some
       * events (e.g. ALL_ADS_COMPLETED) don't have the ad object associated
       * https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdEvent.Type
       * @param {Event} event
       */ _defineProperty$1(this, "onAdEvent", (event)=>{
                const { container: container } = this.player.elements;
                // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
                // don't have ad object associated
                const ad = event.getAd();
                const adData = event.getAdData();
                // Proxy event
                const dispatchEvent = (type)=>{
                    triggerEvent.call(this.player, this.player.media, `ads${type.replace(/_/g, '').toLowerCase()}`);
                };
                // Bubble the event
                dispatchEvent(event.type);
                switch(event.type){
                    case google.ima.AdEvent.Type.LOADED:
                        // This is the first event sent for an ad - it is possible to determine whether the
                        // ad is a video ad or an overlay
                        this.trigger('loaded');
                        // Start countdown
                        this.pollCountdown(true);
                        if (!ad.isLinear()) {
                            // Position AdDisplayContainer correctly for overlay
                            ad.width = container.offsetWidth;
                            ad.height = container.offsetHeight;
                        }
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        // Set volume to match player
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        // All ads for the current videos are done. We can now request new advertisements
                        // in case the video is re-played
                        // TODO: Example for what happens when a next video in a playlist would be loaded.
                        // So here we load a new video when all ads are done.
                        // Then we load new ads within a new adsManager. When the video
                        // Is started - after - the ads are loaded, then we get ads.
                        // You can also easily test cancelling and reloading by running
                        // player.ads.cancel() and player.ads.play from the console I guess.
                        // this.player.source = {
                        //     type: 'video',
                        //     title: 'View From A Blue Moon',
                        //     sources: [{
                        //         src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.mp4', type:
                        // 'video/mp4', }], poster:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg', tracks:
                        // [ { kind: 'captions', label: 'English', srclang: 'en', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.en.vtt',
                        // default: true, }, { kind: 'captions', label: 'French', srclang: 'fr', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.fr.vtt', }, ],
                        // };
                        // TODO: So there is still this thing where a video should only be allowed to start
                        // playing when the IMA SDK is ready or has failed
                        if (this.player.ended) this.loadAds();
                        else // The SDK won't allow new ads to be called without receiving a contentComplete()
                        this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        // This event indicates the ad has started - the video player can adjust the UI,
                        // for example display a pause button and remaining time. Fired when content should
                        // be paused. This usually happens right before an ad is about to cover the content
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        // This event indicates the ad has finished - the video player can perform
                        // appropriate UI actions, such as removing the timer for remaining time detection.
                        // Fired when content should be resumed. This usually happens when an ad finishes
                        // or collapses
                        this.pollCountdown();
                        this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        if (adData.adError) this.player.debug.warn(`Non-fatal ad error: ${adData.adError.getMessage()}`);
                        break;
                }
            });
            /**
       * Any ad error handling comes through here
       * @param {Event} event
       */ _defineProperty$1(this, "onAdError", (event)=>{
                this.cancel();
                this.player.debug.warn('Ads error', event);
            });
            /**
       * Setup hooks for Plyr and window events. This ensures
       * the mid- and post-roll launch at the correct time. And
       * resize the advertisement when the player resizes
       */ _defineProperty$1(this, "listeners", ()=>{
                const { container: container } = this.player.elements;
                let time;
                this.player.on('canplay', ()=>{
                    this.addCuePoints();
                });
                this.player.on('ended', ()=>{
                    this.loader.contentComplete();
                });
                this.player.on('timeupdate', ()=>{
                    time = this.player.currentTime;
                });
                this.player.on('seeked', ()=>{
                    const seekedTime = this.player.currentTime;
                    if (is.empty(this.cuePoints)) return;
                    this.cuePoints.forEach((cuePoint, index)=>{
                        if (time < cuePoint && cuePoint < seekedTime) {
                            this.manager.discardAdBreak();
                            this.cuePoints.splice(index, 1);
                        }
                    });
                });
                // Listen to the resizing of the window. And resize ad accordingly
                // TODO: eventually implement ResizeObserver
                window.addEventListener('resize', ()=>{
                    if (this.manager) this.manager.resize(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            });
            /**
       * Initialize the adsManager and start playing advertisements
       */ _defineProperty$1(this, "play", ()=>{
                const { container: container } = this.player.elements;
                if (!this.managerPromise) this.resumeContent();
                // Play the requested advertisement whenever the adsManager is ready
                this.managerPromise.then(()=>{
                    // Set volume to match player
                    this.manager.setVolume(this.player.volume);
                    // Initialize the container. Must be done via a user action on mobile devices
                    this.elements.displayContainer.initialize();
                    try {
                        if (!this.initialized) {
                            // Initialize the ads manager. Ad rules playlist will start at this time
                            this.manager.init(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                            // Call play to start showing the ad. Single video and overlay ads will
                            // start at this time; the call will be ignored for ad rules
                            this.manager.start();
                        }
                        this.initialized = true;
                    } catch (adError) {
                        // An error may be thrown if there was a problem with the
                        // VAST response
                        this.onAdError(adError);
                    }
                }).catch(()=>{});
            });
            /**
       * Resume our video
       */ _defineProperty$1(this, "resumeContent", ()=>{
                // Hide the advertisement container
                this.elements.container.style.zIndex = '';
                // Ad is stopped
                this.playing = false;
                // Play video
                silencePromise(this.player.media.play());
            });
            /**
       * Pause our video
       */ _defineProperty$1(this, "pauseContent", ()=>{
                // Show the advertisement container
                this.elements.container.style.zIndex = 3;
                // Ad is playing
                this.playing = true;
                // Pause our video.
                this.player.media.pause();
            });
            /**
       * Destroy the adsManager so we can grab new ads after this. If we don't then we're not
       * allowed to call new ads based on google policies, as they interpret this as an accidental
       * video requests. https://developers.google.com/interactive-
       * media-ads/docs/sdks/android/faq#8
       */ _defineProperty$1(this, "cancel", ()=>{
                // Pause our video
                if (this.initialized) this.resumeContent();
                // Tell our instance that we're done for now
                this.trigger('error');
                // Re-create our adsManager
                this.loadAds();
            });
            /**
       * Re-create our adsManager
       */ _defineProperty$1(this, "loadAds", ()=>{
                // Tell our adsManager to go bye bye
                this.managerPromise.then(()=>{
                    // Destroy our adsManager
                    if (this.manager) this.manager.destroy();
                    // Re-set our adsManager promises
                    this.managerPromise = new Promise((resolve)=>{
                        this.on('loaded', resolve);
                        this.player.debug.log(this.manager);
                    });
                    // Now that the manager has been destroyed set it to also be un-initialized
                    this.initialized = false;
                    // Now request some new advertisements
                    this.requestAds();
                }).catch(()=>{});
            });
            /**
       * Handles callbacks after an ad event was invoked
       * @param {string} event - Event type
       * @param args
       */ _defineProperty$1(this, "trigger", (event, ...args)=>{
                const handlers = this.events[event];
                if (is.array(handlers)) handlers.forEach((handler)=>{
                    if (is.function(handler)) handler.apply(this, args);
                });
            });
            /**
       * Add event listeners
       * @param {string} event - Event type
       * @param {Function} callback - Callback for when event occurs
       * @return {Ads}
       */ _defineProperty$1(this, "on", (event, callback)=>{
                if (!is.array(this.events[event])) this.events[event] = [];
                this.events[event].push(callback);
                return this;
            });
            /**
       * Setup a safety timer for when the ad network doesn't respond for whatever reason.
       * The advertisement has 12 seconds to get its things together. We stop this timer when the
       * advertisement is playing, or when a user action is required to start, then we clear the
       * timer on ad ready
       * @param {number} time
       * @param {string} from
       */ _defineProperty$1(this, "startSafetyTimer", (time, from)=>{
                this.player.debug.log(`Safety timer invoked from: ${from}`);
                this.safetyTimer = setTimeout(()=>{
                    this.cancel();
                    this.clearSafetyTimer('startSafetyTimer()');
                }, time);
            });
            /**
       * Clear our safety timer(s)
       * @param {string} from
       */ _defineProperty$1(this, "clearSafetyTimer", (from)=>{
                if (!is.nullOrUndefined(this.safetyTimer)) {
                    this.player.debug.log(`Safety timer cleared from: ${from}`);
                    clearTimeout(this.safetyTimer);
                    this.safetyTimer = null;
                }
            });
            this.player = player;
            this.config = player.config.ads;
            this.playing = false;
            this.initialized = false;
            this.elements = {
                container: null,
                displayContainer: null
            };
            this.manager = null;
            this.loader = null;
            this.cuePoints = null;
            this.events = {};
            this.safetyTimer = null;
            this.countdownTimer = null;
            // Setup a promise to resolve when the IMA manager is ready
            this.managerPromise = new Promise((resolve, reject)=>{
                // The ad is loaded and ready
                this.on('loaded', resolve);
                // Ads failed
                this.on('error', reject);
            });
            this.load();
        }
        get enabled() {
            const { config: config } = this;
            return this.player.isHTML5 && this.player.isVideo && config.enabled && (!is.empty(config.publisherId) || is.url(config.tagUrl));
        }
        // Build the tag URL
        get tagUrl() {
            const { config: config } = this;
            if (is.url(config.tagUrl)) return config.tagUrl;
            const params = {
                AV_PUBLISHERID: '58c25bb0073ef448b1087ad6',
                AV_CHANNELID: '5a0458dc28a06145e4519d21',
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: config.publisherId
            };
            const base = 'https://go.aniview.com/api/adserver6/vast/';
            return `${base}?${buildUrlParams(params)}`;
        }
    }
    /**
   * Returns a number whose value is limited to the given range.
   *
   * Example: limit the output of this computation to between 0 and 255
   * (x * 255).clamp(0, 255)
   *
   * @param {number} input
   * @param {number} min The lower boundary of the output range
   * @param {number} max The upper boundary of the output range
   * @returns A number within the bounds of min and max
   * @type Number
   */ function clamp(input = 0, min = 0, max = 255) {
        return Math.min(Math.max(input, min), max);
    }
    // Arg: vttDataString example: "WEBVTT\n\n1\n00:00:05.000 --> 00:00:10.000\n1080p-00001.jpg"
    function parseVtt(vttDataString) {
        const processedList = [];
        const frames = vttDataString.split(/\r\n\r\n|\n\n|\r\r/);
        frames.forEach((frame)=>{
            const result = {};
            const lines = frame.split(/\r\n|\n|\r/);
            lines.forEach((line)=>{
                if (!is.number(result.startTime)) {
                    // The line with start and end times on it is the first line of interest
                    const matchTimes = line.match(/(\d{2})?:?(\d{2}):(\d{2}).(\d{2,3})( ?--> ?)(\d{2})?:?(\d{2}):(\d{2}).(\d{2,3})/); // Note that this currently ignores caption formatting directives that are optionally on the end of this line - fine for non-captions VTT
                    if (matchTimes) {
                        result.startTime = Number(matchTimes[1] || 0) * 3600 + Number(matchTimes[2]) * 60 + Number(matchTimes[3]) + Number(`0.${matchTimes[4]}`);
                        result.endTime = Number(matchTimes[6] || 0) * 3600 + Number(matchTimes[7]) * 60 + Number(matchTimes[8]) + Number(`0.${matchTimes[9]}`);
                    }
                } else if (!is.empty(line.trim()) && is.empty(result.text)) {
                    // If we already have the startTime, then we're definitely up to the text line(s)
                    const lineSplit = line.trim().split('#xywh=');
                    [result.text] = lineSplit;
                    // If there's content in lineSplit[1], then we have sprites. If not, then it's just one frame per image
                    if (lineSplit[1]) [result.x, result.y, result.w, result.h] = lineSplit[1].split(',');
                }
            });
            if (result.text) processedList.push(result);
        });
        return processedList;
    }
    /**
   * Preview thumbnails for seek hover and scrubbing
   * Seeking: Hover over the seek bar (desktop only): shows a small preview container above the seek bar
   * Scrubbing: Click and drag the seek bar (desktop and mobile): shows the preview image over the entire video, as if the video is scrubbing at very high speed
   *
   * Notes:
   * - Thumbs are set via JS settings on Plyr init, not HTML5 'track' property. Using the track property would be a bit gross, because it doesn't support custom 'kinds'. kind=metadata might be used for something else, and we want to allow multiple thumbnails tracks. Tracks must have a unique combination of 'kind' and 'label'. We would have to do something like kind=metadata,label=thumbnails1 / kind=metadata,label=thumbnails2. Square peg, round hole
   * - VTT info: the image URL is relative to the VTT, not the current document. But if the url starts with a slash, it will naturally be relative to the current domain. https://support.jwplayer.com/articles/how-to-add-preview-thumbnails
   * - This implementation uses multiple separate img elements. Other implementations use background-image on one element. This would be nice and simple, but Firefox and Safari have flickering issues with replacing backgrounds of larger images. It seems that YouTube perhaps only avoids this because they don't have the option for high-res previews (even the fullscreen ones, when mousedown/seeking). Images appear over the top of each other, and previous ones are discarded once the new ones have been rendered
   */ function fitRatio(ratio, outer) {
        const targetRatio = outer.width / outer.height;
        const result = {};
        if (ratio > targetRatio) {
            result.width = outer.width;
            result.height = 1 / ratio * outer.width;
        } else {
            result.height = outer.height;
            result.width = ratio * outer.height;
        }
        return result;
    }
    class PreviewThumbnails {
        /**
     * PreviewThumbnails constructor.
     * @param {Plyr} player
     * @return {PreviewThumbnails}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                // Toggle the regular seek tooltip
                if (this.player.elements.display.seekTooltip) this.player.elements.display.seekTooltip.hidden = this.enabled;
                if (!this.enabled) return;
                this.getThumbnails().then(()=>{
                    if (!this.enabled) return;
                    // Render DOM elements
                    this.render();
                    // Check to see if thumb container size was specified manually in CSS
                    this.determineContainerAutoSizing();
                    // Set up listeners
                    this.listeners();
                    this.loaded = true;
                });
            });
            // Download VTT files and parse them
            _defineProperty$1(this, "getThumbnails", ()=>{
                return new Promise((resolve)=>{
                    const { src: src } = this.player.config.previewThumbnails;
                    if (is.empty(src)) throw new Error('Missing previewThumbnails.src config attribute');
                    // Resolve promise
                    const sortAndResolve = ()=>{
                        // Sort smallest to biggest (e.g., [120p, 480p, 1080p])
                        this.thumbnails.sort((x, y)=>x.height - y.height);
                        this.player.debug.log('Preview thumbnails', this.thumbnails);
                        resolve();
                    };
                    // Via callback()
                    if (is.function(src)) src((thumbnails)=>{
                        this.thumbnails = thumbnails;
                        sortAndResolve();
                    });
                    else {
                        // If string, convert into single-element list
                        const urls = is.string(src) ? [
                            src
                        ] : src;
                        // Loop through each src URL. Download and process the VTT file, storing the resulting data in this.thumbnails
                        const promises = urls.map((u)=>this.getThumbnail(u));
                        // Resolve
                        Promise.all(promises).then(sortAndResolve);
                    }
                });
            });
            // Process individual VTT file
            _defineProperty$1(this, "getThumbnail", (url)=>{
                return new Promise((resolve)=>{
                    fetch(url, undefined, this.player.config.previewThumbnails.withCredentials).then((response)=>{
                        const thumbnail = {
                            frames: parseVtt(response),
                            height: null,
                            urlPrefix: ''
                        };
                        // If the URLs don't start with '/', then we need to set their relative path to be the location of the VTT file
                        // If the URLs do start with '/', then they obviously don't need a prefix, so it will remain blank
                        // If the thumbnail URLs start with with none of '/', 'http://' or 'https://', then we need to set their relative path to be the location of the VTT file
                        if (!thumbnail.frames[0].text.startsWith('/') && !thumbnail.frames[0].text.startsWith('http://') && !thumbnail.frames[0].text.startsWith('https://')) thumbnail.urlPrefix = url.substring(0, url.lastIndexOf('/') + 1);
                        // Download the first frame, so that we can determine/set the height of this thumbnailsDef
                        const tempImage = new Image();
                        tempImage.onload = ()=>{
                            thumbnail.height = tempImage.naturalHeight;
                            thumbnail.width = tempImage.naturalWidth;
                            this.thumbnails.push(thumbnail);
                            resolve();
                        };
                        tempImage.src = thumbnail.urlPrefix + thumbnail.frames[0].text;
                    });
                });
            });
            _defineProperty$1(this, "startMove", (event)=>{
                if (!this.loaded) return;
                if (!is.event(event) || ![
                    'touchmove',
                    'mousemove'
                ].includes(event.type)) return;
                // Wait until media has a duration
                if (!this.player.media.duration) return;
                if (event.type === 'touchmove') // Calculate seek hover position as approx video seconds
                this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                else {
                    var _this$player$config$m, _this$player$config$m2;
                    // Calculate seek hover position as approx video seconds
                    const clientRect = this.player.elements.progress.getBoundingClientRect();
                    const percentage = 100 / clientRect.width * (event.pageX - clientRect.left);
                    this.seekTime = this.player.media.duration * (percentage / 100);
                    if (this.seekTime < 0) // The mousemove fires for 10+px out to the left
                    this.seekTime = 0;
                    if (this.seekTime > this.player.media.duration - 1) // Took 1 second off the duration for safety, because different players can disagree on the real duration of a video
                    this.seekTime = this.player.media.duration - 1;
                    this.mousePosX = event.pageX;
                    // Set time text inside image container
                    this.elements.thumb.time.textContent = formatTime(this.seekTime);
                    // Get marker point for time
                    const point = (_this$player$config$m = this.player.config.markers) === null || _this$player$config$m === void 0 ? void 0 : (_this$player$config$m2 = _this$player$config$m.points) === null || _this$player$config$m2 === void 0 ? void 0 : _this$player$config$m2.find(({ time: t })=>t === Math.round(this.seekTime));
                    // Append the point label to the tooltip
                    if (point) // this.elements.thumb.time.innerText.concat('\n');
                    this.elements.thumb.time.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
                }
                // Download and show image
                this.showImageAtCurrentTime();
            });
            _defineProperty$1(this, "endMove", ()=>{
                this.toggleThumbContainer(false, true);
            });
            _defineProperty$1(this, "startScrubbing", (event)=>{
                // Only act on left mouse button (0), or touch device (event.button does not exist or is false)
                if (is.nullOrUndefined(event.button) || event.button === false || event.button === 0) {
                    this.mouseDown = true;
                    // Wait until media has a duration
                    if (this.player.media.duration) {
                        this.toggleScrubbingContainer(true);
                        this.toggleThumbContainer(false, true);
                        // Download and show image
                        this.showImageAtCurrentTime();
                    }
                }
            });
            _defineProperty$1(this, "endScrubbing", ()=>{
                this.mouseDown = false;
                // Hide scrubbing preview. But wait until the video has successfully seeked before hiding the scrubbing preview
                if (Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)) // The video was already seeked/loaded at the chosen time - hide immediately
                this.toggleScrubbingContainer(false);
                else // The video hasn't seeked yet. Wait for that
                once.call(this.player, this.player.media, 'timeupdate', ()=>{
                    // Re-check mousedown - we might have already started scrubbing again
                    if (!this.mouseDown) this.toggleScrubbingContainer(false);
                });
            });
            /**
       * Setup hooks for Plyr and window events
       */ _defineProperty$1(this, "listeners", ()=>{
                // Hide thumbnail preview - on mouse click, mouse leave (in listeners.js for now), and video play/seek. All four are required, e.g., for buffering
                this.player.on('play', ()=>{
                    this.toggleThumbContainer(false, true);
                });
                this.player.on('seeked', ()=>{
                    this.toggleThumbContainer(false);
                });
                this.player.on('timeupdate', ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            });
            /**
       * Create HTML elements for image containers
       */ _defineProperty$1(this, "render", ()=>{
                // Create HTML element: plyr__preview-thumbnail-container
                this.elements.thumb.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                });
                // Wrapper for the image for styling
                this.elements.thumb.imageContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                });
                this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                // Create HTML element, parent+span: time text (e.g., 01:32:00)
                const timeContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = createElement('span', {}, '00:00');
                timeContainer.appendChild(this.elements.thumb.time);
                this.elements.thumb.imageContainer.appendChild(timeContainer);
                // Inject the whole thumb
                if (is.element(this.player.elements.progress)) this.player.elements.progress.appendChild(this.elements.thumb.container);
                // Create HTML element: plyr__preview-scrubbing-container
                this.elements.scrubbing.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                });
                this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            });
            _defineProperty$1(this, "destroy", ()=>{
                if (this.elements.thumb.container) this.elements.thumb.container.remove();
                if (this.elements.scrubbing.container) this.elements.scrubbing.container.remove();
            });
            _defineProperty$1(this, "showImageAtCurrentTime", ()=>{
                if (this.mouseDown) this.setScrubbingContainerSize();
                else this.setThumbContainerSizeAndPos();
                // Find the desired thumbnail index
                // TODO: Handle a video longer than the thumbs where thumbNum is null
                const thumbNum = this.thumbnails[0].frames.findIndex((frame)=>this.seekTime >= frame.startTime && this.seekTime <= frame.endTime);
                const hasThumb = thumbNum >= 0;
                let qualityIndex = 0;
                // Show the thumb container if we're not scrubbing
                if (!this.mouseDown) this.toggleThumbContainer(hasThumb);
                // No matching thumb found
                if (!hasThumb) return;
                // Check to see if we've already downloaded higher quality versions of this image
                this.thumbnails.forEach((thumbnail, index)=>{
                    if (this.loadedImages.includes(thumbnail.frames[thumbNum].text)) qualityIndex = index;
                });
                // Only proceed if either thumb num or thumbfilename has changed
                if (thumbNum !== this.showingThumb) {
                    this.showingThumb = thumbNum;
                    this.loadImage(qualityIndex);
                }
            });
            // Show the image that's currently specified in this.showingThumb
            _defineProperty$1(this, "loadImage", (qualityIndex = 0)=>{
                const thumbNum = this.showingThumb;
                const thumbnail = this.thumbnails[qualityIndex];
                const { urlPrefix: urlPrefix } = thumbnail;
                const frame = thumbnail.frames[thumbNum];
                const thumbFilename = thumbnail.frames[thumbNum].text;
                const thumbUrl = urlPrefix + thumbFilename;
                if (!this.currentImageElement || this.currentImageElement.dataset.filename !== thumbFilename) {
                    // If we're already loading a previous image, remove its onload handler - we don't want it to load after this one
                    // Only do this if not using sprites. Without sprites we really want to show as many images as possible, as a best-effort
                    if (this.loadingImage && this.usingSprites) this.loadingImage.onload = null;
                    // We're building and adding a new image. In other implementations of similar functionality (YouTube), background image
                    // is instead used. But this causes issues with larger images in Firefox and Safari - switching between background
                    // images causes a flicker. Putting a new image over the top does not
                    const previewImage = new Image();
                    previewImage.src = thumbUrl;
                    previewImage.dataset.index = thumbNum;
                    previewImage.dataset.filename = thumbFilename;
                    this.showingThumbFilename = thumbFilename;
                    this.player.debug.log(`Loading image: ${thumbUrl}`);
                    // For some reason, passing the named function directly causes it to execute immediately. So I've wrapped it in an anonymous function...
                    previewImage.onload = ()=>this.showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename, true);
                    this.loadingImage = previewImage;
                    this.removeOldImages(previewImage);
                } else {
                    // Update the existing image
                    this.showImage(this.currentImageElement, frame, qualityIndex, thumbNum, thumbFilename, false);
                    this.currentImageElement.dataset.index = thumbNum;
                    this.removeOldImages(this.currentImageElement);
                }
            });
            _defineProperty$1(this, "showImage", (previewImage, frame, qualityIndex, thumbNum, thumbFilename, newImage = true)=>{
                this.player.debug.log(`Showing thumb: ${thumbFilename}. num: ${thumbNum}. qual: ${qualityIndex}. newimg: ${newImage}`);
                this.setImageSizeAndOffset(previewImage, frame);
                if (newImage) {
                    this.currentImageContainer.appendChild(previewImage);
                    this.currentImageElement = previewImage;
                    if (!this.loadedImages.includes(thumbFilename)) this.loadedImages.push(thumbFilename);
                }
                // Preload images before and after the current one
                // Show higher quality of the same frame
                // Each step here has a short time delay, and only continues if still hovering/seeking the same spot. This is to protect slow connections from overloading
                this.preloadNearby(thumbNum, true).then(this.preloadNearby(thumbNum, false)).then(this.getHigherQuality(qualityIndex, previewImage, frame, thumbFilename));
            });
            // Remove all preview images that aren't the designated current image
            _defineProperty$1(this, "removeOldImages", (currentImage)=>{
                // Get a list of all images, convert it from a DOM list to an array
                Array.from(this.currentImageContainer.children).forEach((image)=>{
                    if (image.tagName.toLowerCase() !== 'img') return;
                    const removeDelay = this.usingSprites ? 500 : 1000;
                    if (image.dataset.index !== currentImage.dataset.index && !image.dataset.deleting) {
                        // Wait 200ms, as the new image can take some time to show on certain browsers (even though it was downloaded before showing). This will prevent flicker, and show some generosity towards slower clients
                        // First set attribute 'deleting' to prevent multi-handling of this on repeat firing of this function
                        image.dataset.deleting = true;
                        // This has to be set before the timeout - to prevent issues switching between hover and scrub
                        const { currentImageContainer: currentImageContainer } = this;
                        setTimeout(()=>{
                            currentImageContainer.removeChild(image);
                            this.player.debug.log(`Removing thumb: ${image.dataset.filename}`);
                        }, removeDelay);
                    }
                });
            });
            // Preload images before and after the current one. Only if the user is still hovering/seeking the same frame
            // This will only preload the lowest quality
            _defineProperty$1(this, "preloadNearby", (thumbNum, forward = true)=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        const oldThumbFilename = this.thumbnails[0].frames[thumbNum].text;
                        if (this.showingThumbFilename === oldThumbFilename) {
                            // Find the nearest thumbs with different filenames. Sometimes it'll be the next index, but in the case of sprites, it might be 100+ away
                            let thumbnailsClone;
                            if (forward) thumbnailsClone = this.thumbnails[0].frames.slice(thumbNum);
                            else thumbnailsClone = this.thumbnails[0].frames.slice(0, thumbNum).reverse();
                            let foundOne = false;
                            thumbnailsClone.forEach((frame)=>{
                                const newThumbFilename = frame.text;
                                if (newThumbFilename !== oldThumbFilename) // Found one with a different filename. Make sure it hasn't already been loaded on this page visit
                                {
                                    if (!this.loadedImages.includes(newThumbFilename)) {
                                        foundOne = true;
                                        this.player.debug.log(`Preloading thumb filename: ${newThumbFilename}`);
                                        const { urlPrefix: urlPrefix } = this.thumbnails[0];
                                        const thumbURL = urlPrefix + newThumbFilename;
                                        const previewImage = new Image();
                                        previewImage.src = thumbURL;
                                        previewImage.onload = ()=>{
                                            this.player.debug.log(`Preloaded thumb filename: ${newThumbFilename}`);
                                            if (!this.loadedImages.includes(newThumbFilename)) this.loadedImages.push(newThumbFilename);
                                            // We don't resolve until the thumb is loaded
                                            resolve();
                                        };
                                    }
                                }
                            });
                            // If there are none to preload then we want to resolve immediately
                            if (!foundOne) resolve();
                        }
                    }, 300);
                });
            });
            // If user has been hovering current image for half a second, look for a higher quality one
            _defineProperty$1(this, "getHigherQuality", (currentQualityIndex, previewImage, frame, thumbFilename)=>{
                if (currentQualityIndex < this.thumbnails.length - 1) {
                    // Only use the higher quality version if it's going to look any better - if the current thumb is of a lower pixel density than the thumbnail container
                    let previewImageHeight = previewImage.naturalHeight;
                    if (this.usingSprites) previewImageHeight = frame.h;
                    if (previewImageHeight < this.thumbContainerHeight) // Recurse back to the loadImage function - show a higher quality one, but only if the viewer is on this frame for a while
                    setTimeout(()=>{
                        // Make sure the mouse hasn't already moved on and started hovering at another image
                        if (this.showingThumbFilename === thumbFilename) {
                            this.player.debug.log(`Showing higher quality thumb for: ${thumbFilename}`);
                            this.loadImage(currentQualityIndex + 1);
                        }
                    }, 300);
                }
            });
            _defineProperty$1(this, "toggleThumbContainer", (toggle = false, clearShowing = false)=>{
                const className = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(className, toggle);
                if (!toggle && clearShowing) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "toggleScrubbingContainer", (toggle = false)=>{
                const className = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(className, toggle);
                if (!toggle) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "determineContainerAutoSizing", ()=>{
                if (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) // This will prevent auto sizing in this.setThumbContainerSizeAndPos()
                this.sizeSpecifiedInCSS = true;
            });
            // Set the size to be about a quarter of the size of video. Unless option dynamicSize === false, in which case it needs to be set in CSS
            _defineProperty$1(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: imageContainer } = this.elements.thumb;
                if (!this.sizeSpecifiedInCSS) {
                    const thumbWidth = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    imageContainer.style.height = `${this.thumbContainerHeight}px`;
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight > 20 && imageContainer.clientWidth < 20) {
                    const thumbWidth = Math.floor(imageContainer.clientHeight * this.thumbAspectRatio);
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight < 20 && imageContainer.clientWidth > 20) {
                    const thumbHeight = Math.floor(imageContainer.clientWidth / this.thumbAspectRatio);
                    imageContainer.style.height = `${thumbHeight}px`;
                }
                this.setThumbContainerPos();
            });
            _defineProperty$1(this, "setThumbContainerPos", ()=>{
                const scrubberRect = this.player.elements.progress.getBoundingClientRect();
                const containerRect = this.player.elements.container.getBoundingClientRect();
                const { container: container } = this.elements.thumb;
                // Find the lowest and highest desired left-position, so we don't slide out the side of the video container
                const min = containerRect.left - scrubberRect.left + 10;
                const max = containerRect.right - scrubberRect.left - container.clientWidth - 10;
                // Set preview container position to: mousepos, minus seekbar.left, minus half of previewContainer.clientWidth
                const position = this.mousePosX - scrubberRect.left - container.clientWidth / 2;
                const clamped = clamp(position, min, max);
                // Move the popover position
                container.style.left = `${clamped}px`;
                // The arrow can follow the cursor
                container.style.setProperty('--preview-arrow-offset', `${position - clamped}px`);
            });
            // Can't use 100% width, in case the video is a different aspect ratio to the video container
            _defineProperty$1(this, "setScrubbingContainerSize", ()=>{
                const { width: width, height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${width}px`;
                this.elements.scrubbing.container.style.height = `${height}px`;
            });
            // Sprites need to be offset to the correct location
            _defineProperty$1(this, "setImageSizeAndOffset", (previewImage, frame)=>{
                if (!this.usingSprites) return;
                // Find difference between height and preview container height
                const multiplier = this.thumbContainerHeight / frame.h;
                previewImage.style.height = `${previewImage.naturalHeight * multiplier}px`;
                previewImage.style.width = `${previewImage.naturalWidth * multiplier}px`;
                previewImage.style.left = `-${frame.x * multiplier}px`;
                previewImage.style.top = `-${frame.y * multiplier}px`;
            });
            this.player = player;
            this.thumbnails = [];
            this.loaded = false;
            this.lastMouseMoveTime = Date.now();
            this.mouseDown = false;
            this.loadedImages = [];
            this.elements = {
                thumb: {},
                scrubbing: {}
            };
            this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes('w');
        }
        get thumbAspectRatio() {
            if (this.usingSprites) return this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h;
            return this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return height;
            }
            // If css is used this needs to return the css height for sprites to work (see setImageSizeAndOffset)
            if (this.sizeSpecifiedInCSS) return this.elements.thumb.imageContainer.clientHeight;
            return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(element) {
            if (this.mouseDown) this.currentScrubbingImageElement = element;
            else this.currentThumbnailImageElement = element;
        }
    }
    // ==========================================================================
    // Plyr source update
    // ==========================================================================
    const source = {
        // Add elements to HTML5 media (source, tracks, etc)
        insertElements (type, attributes) {
            if (is.string(attributes)) insertElement(type, this.media, {
                src: attributes
            });
            else if (is.array(attributes)) attributes.forEach((attribute)=>{
                insertElement(type, this.media, attribute);
            });
        },
        // Update source
        // Sources are not checked for support so be careful
        change (input) {
            if (!getDeep(input, 'sources.length')) {
                this.debug.warn('Invalid source format');
                return;
            }
            // Cancel current network requests
            html5.cancelRequests.call(this);
            // Destroy instance and re-setup
            this.destroy(()=>{
                // Reset quality options
                this.options.quality = [];
                // Remove elements
                removeElement(this.media);
                this.media = null;
                // Reset class name
                if (is.element(this.elements.container)) this.elements.container.removeAttribute('class');
                // Set the type and provider
                const { sources: sources, type: type } = input;
                const [{ provider: provider = providers.html5, src: src }] = sources;
                const tagName = provider === 'html5' ? type : 'div';
                const attributes = provider === 'html5' ? {} : {
                    src: src
                };
                Object.assign(this, {
                    provider: provider,
                    type: type,
                    // Check for support
                    supported: support.check(type, provider, this.config.playsinline),
                    // Create new element
                    media: createElement(tagName, attributes)
                });
                // Inject the new element
                this.elements.container.appendChild(this.media);
                // Autoplay the new source?
                if (is.boolean(input.autoplay)) this.config.autoplay = input.autoplay;
                // Set attributes for audio and video
                if (this.isHTML5) {
                    if (this.config.crossorigin) this.media.setAttribute('crossorigin', '');
                    if (this.config.autoplay) this.media.setAttribute('autoplay', '');
                    if (!is.empty(input.poster)) this.poster = input.poster;
                    if (this.config.loop.active) this.media.setAttribute('loop', '');
                    if (this.config.muted) this.media.setAttribute('muted', '');
                    if (this.config.playsinline) this.media.setAttribute('playsinline', '');
                }
                // Restore class hook
                ui.addStyleHook.call(this);
                // Set new sources for html5
                if (this.isHTML5) source.insertElements.call(this, 'source', sources);
                // Set video title
                this.config.title = input.title;
                // Set up from scratch
                media.setup.call(this);
                // HTML5 stuff
                if (this.isHTML5) // Setup captions
                {
                    if (Object.keys(input).includes('tracks')) source.insertElements.call(this, 'track', input.tracks);
                }
                // If HTML5 or embed but not fully supported, setupInterface and call ready now
                if (this.isHTML5 || this.isEmbed && !this.supported.ui) // Setup interface
                ui.build.call(this);
                // Load HTML5 sources
                if (this.isHTML5) this.media.load();
                // Update previewThumbnails config & reload plugin
                if (!is.empty(input.previewThumbnails)) {
                    Object.assign(this.config.previewThumbnails, input.previewThumbnails);
                    // Cleanup previewThumbnails plugin if it was loaded
                    if (this.previewThumbnails && this.previewThumbnails.loaded) {
                        this.previewThumbnails.destroy();
                        this.previewThumbnails = null;
                    }
                    // Create new instance if it is still enabled
                    if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
                }
                // Update the fullscreen support
                this.fullscreen.update();
            }, true);
        }
    };
    // Private properties
    // TODO: Use a WeakMap for private globals
    // const globals = new WeakMap();
    // Plyr instance
    class Plyr {
        constructor(target, options){
            /**
       * Play the media, or play the advertisement (if they are not blocked)
       */ _defineProperty$1(this, "play", ()=>{
                if (!is.function(this.media.play)) return null;
                // Intecept play with ads
                if (this.ads && this.ads.enabled) this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>silencePromise(this.media.play()));
                // Return the promise (for HTML5)
                return this.media.play();
            });
            /**
       * Pause the media
       */ _defineProperty$1(this, "pause", ()=>{
                if (!this.playing || !is.function(this.media.pause)) return null;
                return this.media.pause();
            });
            /**
       * Toggle playback based on current status
       * @param {boolean} input
       */ _defineProperty$1(this, "togglePlay", (input)=>{
                // Toggle based on current state if nothing passed
                const toggle = is.boolean(input) ? input : !this.playing;
                if (toggle) return this.play();
                return this.pause();
            });
            /**
       * Stop playback
       */ _defineProperty$1(this, "stop", ()=>{
                if (this.isHTML5) {
                    this.pause();
                    this.restart();
                } else if (is.function(this.media.stop)) this.media.stop();
            });
            /**
       * Restart playback
       */ _defineProperty$1(this, "restart", ()=>{
                this.currentTime = 0;
            });
            /**
       * Rewind
       * @param {number} seekTime - how far to rewind in seconds. Defaults to the config.seekTime
       */ _defineProperty$1(this, "rewind", (seekTime)=>{
                this.currentTime -= is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            /**
       * Fast forward
       * @param {number} seekTime - how far to fast forward in seconds. Defaults to the config.seekTime
       */ _defineProperty$1(this, "forward", (seekTime)=>{
                this.currentTime += is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            /**
       * Increase volume
       * @param {boolean} step - How much to decrease by (between 0 and 1)
       */ _defineProperty$1(this, "increaseVolume", (step)=>{
                const volume = this.media.muted ? 0 : this.volume;
                this.volume = volume + (is.number(step) ? step : 0);
            });
            /**
       * Decrease volume
       * @param {boolean} step - How much to decrease by (between 0 and 1)
       */ _defineProperty$1(this, "decreaseVolume", (step)=>{
                this.increaseVolume(-step);
            });
            /**
       * Trigger the airplay dialog
       * TODO: update player with state, support, enabled
       */ _defineProperty$1(this, "airplay", ()=>{
                // Show dialog if supported
                if (support.airplay) this.media.webkitShowPlaybackTargetPicker();
            });
            /**
       * Toggle the player controls
       * @param {boolean} [toggle] - Whether to show the controls
       */ _defineProperty$1(this, "toggleControls", (toggle)=>{
                // Don't toggle if missing UI support or if it's audio
                if (this.supported.ui && !this.isAudio) {
                    // Get state before change
                    const isHidden = hasClass(this.elements.container, this.config.classNames.hideControls);
                    // Negate the argument if not undefined since adding the class to hides the controls
                    const force = typeof toggle === 'undefined' ? undefined : !toggle;
                    // Apply and get updated state
                    const hiding = toggleClass(this.elements.container, this.config.classNames.hideControls, force);
                    // Close menu
                    if (hiding && is.array(this.config.controls) && this.config.controls.includes('settings') && !is.empty(this.config.settings)) controls.toggleMenu.call(this, false);
                    // Trigger event on change
                    if (hiding !== isHidden) {
                        const eventName = hiding ? 'controlshidden' : 'controlsshown';
                        triggerEvent.call(this, this.media, eventName);
                    }
                    return !hiding;
                }
                return false;
            });
            /**
       * Add event listeners
       * @param {string} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */ _defineProperty$1(this, "on", (event, callback)=>{
                on.call(this, this.elements.container, event, callback);
            });
            /**
       * Add event listeners once
       * @param {string} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */ _defineProperty$1(this, "once", (event, callback)=>{
                once.call(this, this.elements.container, event, callback);
            });
            /**
       * Remove event listeners
       * @param {string} event - Event type
       * @param {Function} callback - Callback for when event occurs
       */ _defineProperty$1(this, "off", (event, callback)=>{
                off(this.elements.container, event, callback);
            });
            /**
       * Destroy an instance
       * Event listeners are removed when elements are removed
       * http://stackoverflow.com/questions/12528049/if-a-dom-element-is-removed-are-its-listeners-also-removed-from-memory
       * @param {Function} callback - Callback for when destroy is complete
       * @param {boolean} soft - Whether it's a soft destroy (for source changes etc)
       */ _defineProperty$1(this, "destroy", (callback, soft = false)=>{
                if (!this.ready) return;
                const done = ()=>{
                    // Reset overflow (incase destroyed while in fullscreen)
                    document.body.style.overflow = '';
                    // GC for embed
                    this.embed = null;
                    // If it's a soft destroy, make minimal changes
                    if (soft) {
                        if (Object.keys(this.elements).length) {
                            // Remove elements
                            removeElement(this.elements.buttons.play);
                            removeElement(this.elements.captions);
                            removeElement(this.elements.controls);
                            removeElement(this.elements.wrapper);
                            // Clear for GC
                            this.elements.buttons.play = null;
                            this.elements.captions = null;
                            this.elements.controls = null;
                            this.elements.wrapper = null;
                        }
                        // Callback
                        if (is.function(callback)) callback();
                    } else {
                        // Unbind listeners
                        unbindListeners.call(this);
                        // Cancel current network requests
                        html5.cancelRequests.call(this);
                        // Replace the container with the original element provided
                        replaceElement(this.elements.original, this.elements.container);
                        // Event
                        triggerEvent.call(this, this.elements.original, 'destroyed', true);
                        // Callback
                        if (is.function(callback)) callback.call(this.elements.original);
                        // Reset state
                        this.ready = false;
                        // Clear for garbage collection
                        setTimeout(()=>{
                            this.elements = null;
                            this.media = null;
                        }, 200);
                    }
                };
                // Stop playback
                this.stop();
                // Clear timeouts
                clearTimeout(this.timers.loading);
                clearTimeout(this.timers.controls);
                clearTimeout(this.timers.resized);
                // Provider specific stuff
                if (this.isHTML5) {
                    // Restore native video controls
                    ui.toggleNativeControls.call(this, true);
                    // Clean up
                    done();
                } else if (this.isYouTube) {
                    // Clear timers
                    clearInterval(this.timers.buffering);
                    clearInterval(this.timers.playing);
                    // Destroy YouTube API
                    if (this.embed !== null && is.function(this.embed.destroy)) this.embed.destroy();
                    // Clean up
                    done();
                } else if (this.isVimeo) {
                    // Destroy Vimeo API
                    // then clean up (wait, to prevent postmessage errors)
                    if (this.embed !== null) this.embed.unload().then(done);
                    // Vimeo does not always return
                    setTimeout(done, 200);
                }
            });
            /**
       * Check for support for a mime type (HTML5 only)
       * @param {string} type - Mime type
       */ _defineProperty$1(this, "supports", (type)=>support.mime.call(this, type));
            this.timers = {};
            // State
            this.ready = false;
            this.loading = false;
            this.failed = false;
            // Touch device
            this.touch = support.touch;
            // Set the media element
            this.media = target;
            // String selector passed
            if (is.string(this.media)) this.media = document.querySelectorAll(this.media);
            // jQuery, NodeList or Array passed, use first element
            if (window.jQuery && this.media instanceof jQuery || is.nodeList(this.media) || is.array(this.media)) this.media = this.media[0];
            // Set config
            this.config = extend({}, defaults, Plyr.defaults, options || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute('data-plyr-config'));
                } catch  {
                    return {};
                }
            })());
            // Elements cache
            this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            };
            // Captions
            this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap()
            };
            // Fullscreen
            this.fullscreen = {
                active: false
            };
            // Options
            this.options = {
                speed: [],
                quality: []
            };
            // Debugging
            // TODO: move to globals
            this.debug = new Console(this.config.debug);
            // Log config options and support
            this.debug.log('Config', this.config);
            this.debug.log('Support', support);
            // We need an element to setup
            if (is.nullOrUndefined(this.media) || !is.element(this.media)) {
                this.debug.error('Setup failed: no suitable element passed');
                return;
            }
            // Bail if the element is initialized
            if (this.media.plyr) {
                this.debug.warn('Target already setup');
                return;
            }
            // Bail if not enabled
            if (!this.config.enabled) {
                this.debug.error('Setup failed: disabled by config');
                return;
            }
            // Bail if disabled or no basic support
            // You may want to disable certain UAs etc
            if (!support.check().api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            // Cache original element state for .destroy()
            const clone = this.media.cloneNode(true);
            clone.autoplay = false;
            this.elements.original = clone;
            // Set media type based on tag or data attribute
            // Supported: video, audio, vimeo, youtube
            const _type = this.media.tagName.toLowerCase();
            // Embed properties
            let iframe = null;
            let url = null;
            // Different setup based on type
            switch(_type){
                case 'div':
                    // Find the frame
                    iframe = this.media.querySelector('iframe');
                    // <iframe> type
                    if (is.element(iframe)) {
                        // Detect provider
                        url = parseUrl(iframe.getAttribute('src'));
                        this.provider = getProviderByUrl(url.toString());
                        // Rework elements
                        this.elements.container = this.media;
                        this.media = iframe;
                        // Reset classname
                        this.elements.container.className = '';
                        // Get attributes from URL and set config
                        if (url.search.length) {
                            const truthy = [
                                '1',
                                'true'
                            ];
                            if (truthy.includes(url.searchParams.get('autoplay'))) this.config.autoplay = true;
                            if (truthy.includes(url.searchParams.get('loop'))) this.config.loop.active = true;
                            // TODO: replace fullscreen.iosNative with this playsinline config option
                            // YouTube requires the playsinline in the URL
                            if (this.isYouTube) {
                                this.config.playsinline = truthy.includes(url.searchParams.get('playsinline'));
                                this.config.youtube.hl = url.searchParams.get('hl'); // TODO: Should this be setting language?
                            } else this.config.playsinline = true;
                        }
                    } else {
                        // <div> with attributes
                        this.provider = this.media.getAttribute(this.config.attributes.embed.provider);
                        // Remove attribute
                        this.media.removeAttribute(this.config.attributes.embed.provider);
                    }
                    // Unsupported or missing provider
                    if (is.empty(this.provider) || !Object.values(providers).includes(this.provider)) {
                        this.debug.error('Setup failed: Invalid provider');
                        return;
                    }
                    // Audio will come later for external providers
                    this.type = types.video;
                    break;
                case 'video':
                case 'audio':
                    this.type = _type;
                    this.provider = providers.html5;
                    // Get config from attributes
                    if (this.media.hasAttribute('crossorigin')) this.config.crossorigin = true;
                    if (this.media.hasAttribute('autoplay')) this.config.autoplay = true;
                    if (this.media.hasAttribute('playsinline') || this.media.hasAttribute('webkit-playsinline')) this.config.playsinline = true;
                    if (this.media.hasAttribute('muted')) this.config.muted = true;
                    if (this.media.hasAttribute('loop')) this.config.loop.active = true;
                    break;
                default:
                    this.debug.error('Setup failed: unsupported type');
                    return;
            }
            // Check for support again but with type
            this.supported = support.check(this.type, this.provider);
            // If no support for even API, bail
            if (!this.supported.api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            this.eventListeners = [];
            // Create listeners
            this.listeners = new Listeners(this);
            // Setup local storage for user settings
            this.storage = new Storage(this);
            // Store reference
            this.media.plyr = this;
            // Wrap media
            if (!is.element(this.elements.container)) {
                this.elements.container = createElement('div');
                wrap(this.media, this.elements.container);
            }
            // Migrate custom properties from media to container (so they work 😉)
            ui.migrateStyles.call(this);
            // Add style hook
            ui.addStyleHook.call(this);
            // Setup media
            media.setup.call(this);
            // Listen for events if debugging
            if (this.config.debug) on.call(this, this.elements.container, this.config.events.join(' '), (event)=>{
                this.debug.log(`event: ${event.type}`);
            });
            // Setup fullscreen
            this.fullscreen = new Fullscreen(this);
            // Setup interface
            // If embed but not fully supported, build interface now to avoid flash of controls
            if (this.isHTML5 || this.isEmbed && !this.supported.ui) ui.build.call(this);
            // Container listeners
            this.listeners.container();
            // Global listeners
            this.listeners.global();
            // Setup ads if provided
            if (this.config.ads.enabled) this.ads = new Ads(this);
            // Autoplay if required
            if (this.isHTML5 && this.config.autoplay) this.once('canplay', ()=>silencePromise(this.play()));
            // Seek time will be recorded (in listeners.js) so we can prevent hiding controls for a few seconds after seek
            this.lastSeekTime = 0;
            // Setup preview thumbnails if enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        // ---------------------------------------
        // API
        // ---------------------------------------
        /**
     * Types and provider helpers
     */ get isHTML5() {
            return this.provider === providers.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === providers.youtube;
        }
        get isVimeo() {
            return this.provider === providers.vimeo;
        }
        get isVideo() {
            return this.type === types.video;
        }
        get isAudio() {
            return this.type === types.audio;
        }
        /**
     * Get playing state
     */ get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        /**
     * Get paused state
     */ get paused() {
            return Boolean(this.media.paused);
        }
        /**
     * Get stopped state
     */ get stopped() {
            return Boolean(this.paused && this.currentTime === 0);
        }
        /**
     * Get ended state
     */ get ended() {
            return Boolean(this.media.ended);
        }
        /**
     * Seek to a time
     * @param {number} input - where to seek to in seconds. Defaults to 0 (the start)
     */ set currentTime(input) {
            // Bail if media duration isn't available yet
            if (!this.duration) return;
            // Validate input
            const inputIsValid = is.number(input) && input > 0;
            // Set
            this.media.currentTime = inputIsValid ? Math.min(input, this.duration) : 0;
            // Logging
            this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        /**
     * Get current time
     */ get currentTime() {
            return Number(this.media.currentTime);
        }
        /**
     * Get buffered
     */ get buffered() {
            const { buffered: buffered } = this.media;
            // YouTube / Vimeo return a float between 0-1
            if (is.number(buffered)) return buffered;
            // HTML5
            // TODO: Handle buffered chunks of the media
            // (i.e. seek to another section buffers only that section)
            if (buffered && buffered.length && this.duration > 0) return buffered.end(0) / this.duration;
            return 0;
        }
        /**
     * Get seeking status
     */ get seeking() {
            return Boolean(this.media.seeking);
        }
        /**
     * Get the duration of the current media
     */ get duration() {
            // Faux duration set via config
            const fauxDuration = Number.parseFloat(this.config.duration);
            // Media duration can be NaN or Infinity before the media has loaded
            const realDuration = (this.media || {}).duration;
            const duration = !is.number(realDuration) || realDuration === Infinity ? 0 : realDuration;
            // If config duration is funky, use regular duration
            return fauxDuration || duration;
        }
        /**
     * Set the player volume
     * @param {number} value - must be between 0 and 1. Defaults to the value from local storage and config.volume if not set in storage
     */ set volume(value) {
            let volume = value;
            const max = 1;
            const min = 0;
            if (is.string(volume)) volume = Number(volume);
            // Load volume from storage if no value specified
            if (!is.number(volume)) volume = this.storage.get('volume');
            // Use config if all else fails
            if (!is.number(volume)) ({ volume: volume } = this.config);
            // Maximum is volumeMax
            if (volume > max) volume = max;
            // Minimum is volumeMin
            if (volume < min) volume = min;
            // Update config
            this.config.volume = volume;
            // Set the player volume
            this.media.volume = volume;
            // If muted, and we're increasing volume manually, reset muted state
            if (!is.empty(value) && this.muted && volume > 0) this.muted = false;
        }
        /**
     * Get the current player volume
     */ get volume() {
            return Number(this.media.volume);
        }
        /**
     * Set muted state
     * @param {boolean} mute
     */ set muted(mute) {
            let toggle = mute;
            // Load muted state from storage
            if (!is.boolean(toggle)) toggle = this.storage.get('muted');
            // Use config if all else fails
            if (!is.boolean(toggle)) toggle = this.config.muted;
            // Update config
            this.config.muted = toggle;
            // Set mute on the player
            this.media.muted = toggle;
        }
        /**
     * Get current muted state
     */ get muted() {
            return Boolean(this.media.muted);
        }
        /**
     * Check if the media has audio
     */ get hasAudio() {
            // Assume yes for all non HTML5 (as we can't tell...)
            if (!this.isHTML5) return true;
            if (this.isAudio) return true;
            // Get audio tracks
            return Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        /**
     * Set playback speed
     * @param {number} input - the speed of playback (0.5-2.0)
     */ set speed(input) {
            let speed = null;
            if (is.number(input)) speed = input;
            if (!is.number(speed)) speed = this.storage.get('speed');
            if (!is.number(speed)) speed = this.config.speed.selected;
            // Clamp to min/max
            const { minimumSpeed: min, maximumSpeed: max } = this;
            speed = clamp(speed, min, max);
            // Update config
            this.config.speed.selected = speed;
            // Set media speed
            setTimeout(()=>{
                if (this.media) this.media.playbackRate = speed;
            }, 0);
        }
        /**
     * Get current playback speed
     */ get speed() {
            return Number(this.media.playbackRate);
        }
        /**
     * Get the minimum allowed speed
     */ get minimumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.min(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 0.5;
            // https://stackoverflow.com/a/32320020/1191319
            return 0.0625;
        }
        /**
     * Get the maximum allowed speed
     */ get maximumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.max(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 2;
            // https://stackoverflow.com/a/32320020/1191319
            return 16;
        }
        /**
     * Set playback quality
     * Currently HTML5 & YouTube only
     * @param {number} input - Quality level
     */ set quality(input) {
            const config = this.config.quality;
            const options = this.options.quality;
            if (!options.length) return;
            let quality = [
                !is.empty(input) && Number(input),
                this.storage.get('quality'),
                config.selected,
                config.default
            ].find(is.number);
            let updateStorage = true;
            if (!options.includes(quality)) {
                const value = closest(options, quality);
                this.debug.warn(`Unsupported quality option: ${quality}, using ${value} instead`);
                quality = value;
                // Don't update storage if quality is not supported
                updateStorage = false;
            }
            // Update config
            config.selected = quality;
            // Set quality
            this.media.quality = quality;
            // Save to storage
            if (updateStorage) this.storage.set({
                quality: quality
            });
        }
        /**
     * Get current quality level
     */ get quality() {
            return this.media.quality;
        }
        /**
     * Toggle loop
     * TODO: Finish fancy new logic. Set the indicator on load as user may pass loop as config
     * @param {boolean} input - Whether to loop or not
     */ set loop(input) {
            const toggle = is.boolean(input) ? input : this.config.loop.active;
            this.config.loop.active = toggle;
            this.media.loop = toggle;
        // Set default to be a true toggle
        /* const type = ['start', 'end', 'all', 'none', 'toggle'].includes(input) ? input : 'toggle';
           switch (type) {
              case 'start':
                  if (this.config.loop.end && this.config.loop.end <= this.currentTime) {
                      this.config.loop.end = null;
                  }
                  this.config.loop.start = this.currentTime;
                  // this.config.loop.indicator.start = this.elements.display.played.value;
                  break;
               case 'end':
                  if (this.config.loop.start >= this.currentTime) {
                      return this;
                  }
                  this.config.loop.end = this.currentTime;
                  // this.config.loop.indicator.end = this.elements.display.played.value;
                  break;
               case 'all':
                  this.config.loop.start = 0;
                  this.config.loop.end = this.duration - 2;
                  this.config.loop.indicator.start = 0;
                  this.config.loop.indicator.end = 100;
                  break;
               case 'toggle':
                  if (this.config.loop.active) {
                      this.config.loop.start = 0;
                      this.config.loop.end = null;
                  } else {
                      this.config.loop.start = 0;
                      this.config.loop.end = this.duration - 2;
                  }
                  break;
               default:
                  this.config.loop.start = 0;
                  this.config.loop.end = null;
                  break;
          } */ }
        /**
     * Get current loop state
     */ get loop() {
            return Boolean(this.media.loop);
        }
        /**
     * Set new media source
     * @param {object} input - The new source object (see docs)
     */ set source(input) {
            source.change.call(this, input);
        }
        /**
     * Get current source
     */ get source() {
            return this.media.currentSrc;
        }
        /**
     * Get a download URL (either source or custom)
     */ get download() {
            const { download: download } = this.config.urls;
            return is.url(download) ? download : this.source;
        }
        /**
     * Set the download URL
     */ set download(input) {
            if (!is.url(input)) return;
            this.config.urls.download = input;
            controls.setDownloadUrl.call(this);
        }
        /**
     * Set the poster image for a video
     * @param {string} input - the URL for the new poster image
     */ set poster(input) {
            if (!this.isVideo) {
                this.debug.warn('Poster can only be set for video');
                return;
            }
            ui.setPoster.call(this, input, false).catch(()=>{});
        }
        /**
     * Get the current poster image
     */ get poster() {
            if (!this.isVideo) return null;
            return this.media.getAttribute('poster') || this.media.getAttribute('data-poster');
        }
        /**
     * Get the current aspect ratio in use
     */ get ratio() {
            if (!this.isVideo) return null;
            const ratio = reduceAspectRatio(getAspectRatio.call(this));
            return is.array(ratio) ? ratio.join(':') : ratio;
        }
        /**
     * Set video aspect ratio
     */ set ratio(input) {
            if (!this.isVideo) {
                this.debug.warn('Aspect ratio can only be set for video');
                return;
            }
            if (!is.string(input) || !validateAspectRatio(input)) {
                this.debug.error(`Invalid aspect ratio specified (${input})`);
                return;
            }
            this.config.ratio = reduceAspectRatio(input);
            setAspectRatio.call(this);
        }
        /**
     * Set the autoplay state
     * @param {boolean} input - Whether to autoplay or not
     */ set autoplay(input) {
            this.config.autoplay = is.boolean(input) ? input : this.config.autoplay;
        }
        /**
     * Get the current autoplay state
     */ get autoplay() {
            return Boolean(this.config.autoplay);
        }
        /**
     * Toggle captions
     * @param {boolean} input - Whether to enable captions
     */ toggleCaptions(input) {
            captions.toggle.call(this, input, false);
        }
        /**
     * Set the caption track by index
     * @param {number} input - Caption index
     */ set currentTrack(input) {
            captions.set.call(this, input, false);
            captions.setup.call(this);
        }
        /**
     * Get the current caption track index (-1 if disabled)
     */ get currentTrack() {
            const { toggled: toggled, currentTrack: currentTrack } = this.captions;
            return toggled ? currentTrack : -1;
        }
        /**
     * Set the wanted language for captions
     * Since tracks can be added later it won't update the actual caption track until there is a matching track
     * @param {string} input - Two character ISO language code (e.g. EN, FR, PT, etc)
     */ set language(input) {
            captions.setLanguage.call(this, input, false);
        }
        /**
     * Get the current track's language
     */ get language() {
            return (captions.getCurrentTrack.call(this) || {}).language;
        }
        /**
     * Toggle picture-in-picture playback on WebKit/MacOS
     * TODO: update player with state, support, enabled
     * TODO: detect outside changes
     */ set pip(input) {
            // Bail if no support
            if (!support.pip) return;
            // Toggle based on current state if not passed
            const toggle = is.boolean(input) ? input : !this.pip;
            // Toggle based on current state
            // Safari
            if (is.function(this.media.webkitSetPresentationMode)) this.media.webkitSetPresentationMode(toggle ? pip.active : pip.inactive);
            // Chrome
            if (is.function(this.media.requestPictureInPicture)) {
                if (!this.pip && toggle) this.media.requestPictureInPicture();
                else if (this.pip && !toggle) document.exitPictureInPicture();
            }
        }
        /**
     * Get the current picture-in-picture state
     */ get pip() {
            if (!support.pip) return null;
            // Safari
            if (!is.empty(this.media.webkitPresentationMode)) return this.media.webkitPresentationMode === pip.active;
            // Chrome
            return this.media === document.pictureInPictureElement;
        }
        /**
     * Sets the preview thumbnails for the current source
     */ setPreviewThumbnails(thumbnailSource) {
            if (this.previewThumbnails && this.previewThumbnails.loaded) {
                this.previewThumbnails.destroy();
                this.previewThumbnails = null;
            }
            Object.assign(this.config.previewThumbnails, thumbnailSource);
            // Create new instance if it is still enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        /**
     * Check for support
     * @param {string} type - Player type (audio/video)
     * @param {string} provider - Provider (html5/youtube/vimeo)
     */ static supported(type, provider) {
            return support.check(type, provider);
        }
        /**
     * Load an SVG sprite into the page
     * @param {string} url - URL for the SVG sprite
     * @param {string} [id] - Unique ID
     */ static loadSprite(url, id) {
            return loadSprite(url, id);
        }
        /**
     * Setup multiple instances
     * @param {*} selector
     * @param {object} options
     */ static setup(selector, options = {}) {
            let targets = null;
            if (is.string(selector)) targets = Array.from(document.querySelectorAll(selector));
            else if (is.nodeList(selector)) targets = Array.from(selector);
            else if (is.array(selector)) targets = selector.filter(is.element);
            if (is.empty(targets)) return null;
            return targets.map((t)=>new Plyr(t, options));
        }
    }
    Plyr.defaults = cloneDeep(defaults);
    return Plyr;
}); //# sourceMappingURL=plyr.js.map

});

parcelRegister("e9hcU", function(module, exports) {

$parcel$export(module.exports, "celebratePreset", () => $02a8810c1975c803$export$c57921a8446a3d70);
/**
 * Efectos de celebración (confeti, fuegos artificiales, destellos).
 * @module utils/Celebrations
 */ 
var $1Fbaj = parcelRequire("1Fbaj");
const $02a8810c1975c803$var$CELEBRATION_TOUCH = {
    overlayIcon: 'celebration'
};
/**
 * Texto u ícono del overlay de `pageTouch` durante la celebración.
 * @param {{ overlayText?: string, overlayIcon?: string }} source
 */ function $02a8810c1975c803$var$buildTouchOpts(source) {
    const t = {
        ...$02a8810c1975c803$var$CELEBRATION_TOUCH
    };
    if (typeof source.overlayText === 'string' && source.overlayText.trim()) t.overlayText = source.overlayText.trim();
    if (typeof source.overlayIcon === 'string' && source.overlayIcon.trim()) t.overlayIcon = source.overlayIcon.trim();
    return t;
}
/**
 * Separa opciones del efecto de las de touch (overlayText, overlayIcon, noPageTouch).
 * @param {Record<string, unknown>} options
 */ function $02a8810c1975c803$var$splitCelebrateOptions(options) {
    const noPageTouch = options.noPageTouch ?? false;
    const effectOpts = {
        ...options
    };
    delete effectOpts.noPageTouch;
    delete effectOpts.overlayText;
    delete effectOpts.overlayIcon;
    return {
        noPageTouch: noPageTouch,
        touchOpts: $02a8810c1975c803$var$buildTouchOpts(options),
        effectOpts: effectOpts
    };
}
const $02a8810c1975c803$var$CELEBRATION_COLORS = [
    '#ffb265',
    '#ffd700',
    '#00c566',
    '#3b82f6',
    '#a855f7',
    '#ff3b9d',
    '#ff3b3b',
    '#ffffff'
];
/**
 * Reduce motion → celebración muy suave en lugar de partículas.
 * @returns {boolean}
 */ function $02a8810c1975c803$var$prefersReducedCelebrationMotion() {
    try {
        return typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return false;
    }
}
/** @returns {boolean} true si se aplicó modo reducido y no hay más que hacer */ function $02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts = $02a8810c1975c803$var$CELEBRATION_TOUCH) {
    if (!$02a8810c1975c803$var$prefersReducedCelebrationMotion()) return false;
    $02a8810c1975c803$var$celebrateSoftFlash();
    (0, $1Fbaj.pageTouch)(true, true, {
        ...touchOpts,
        releaseAfterMs: 560
    });
    return true;
}
/**
 * Capa fullscreen fija, sin interferir con toques (`pointer-events: none`).
 */ function $02a8810c1975c803$var$createCelebrationRoot() {
    const root = document.createElement('div');
    root.className = 'celebration-layer';
    root.setAttribute('aria-hidden', 'true');
    root.style.cssText = [
        'position:fixed',
        'inset:0',
        'pointer-events:none',
        'z-index:9500',
        'overflow:hidden'
    ].join(';');
    document.body.appendChild(root);
    return root;
}
function $02a8810c1975c803$var$celebrateSoftFlash(duration = 340) {
    const root = $02a8810c1975c803$var$createCelebrationRoot();
    root.style.background = 'radial-gradient(circle at 50% 40%,rgba(255,210,96,0.35),transparent 62%)';
    const anim = root.animate([
        {
            opacity: 0
        },
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ], {
        duration: duration,
        easing: 'ease-out',
        fill: 'forwards'
    });
    anim.onfinish = ()=>root.remove();
}
/**
 * @param {'strip'|'rod'} shape
 * @returns {HTMLSpanElement}
 */ function $02a8810c1975c803$var$createConfettiParticle(shape = 'rod') {
    const el = document.createElement('span');
    el.style.position = 'absolute';
    el.style.borderRadius = '2px';
    el.style.pointerEvents = 'none';
    if (shape === 'strip') {
        el.style.width = '10px';
        el.style.height = '14px';
    } else {
        el.style.width = '7px';
        el.style.height = '11px';
    }
    el.style.background = $02a8810c1975c803$var$CELEBRATION_COLORS[Math.floor(Math.random() * $02a8810c1975c803$var$CELEBRATION_COLORS.length)];
    el.style.opacity = String(0.85 + Math.random() * 0.15);
    el.style.boxShadow = '0 1px 2px rgba(0,0,0,0.15)';
    return el;
}
/**
 * Ráfaga radial de confeti desde un punto (px).
 * @param {HTMLDivElement} root
 * @param {number} cx
 * @param {number} cy
 * @param {{ duration?: number, count?: number }} opts
 */ function $02a8810c1975c803$var$confettiBurstAt(root, cx, cy, opts = {}) {
    const { duration: duration = 1600, count: count = 44 } = opts;
    const rect = root.getBoundingClientRect();
    const w = rect.width || (typeof window !== 'undefined' ? window.innerWidth : 400);
    const h = rect.height || (typeof window !== 'undefined' ? window.innerHeight : 600);
    for(let i = 0; i < count; i++){
        const p = $02a8810c1975c803$var$createConfettiParticle('rod');
        const angle = Math.PI * 2 * (i / count) * (0.88 + Math.random() * 0.24);
        const thrust = Math.min(w, h) * (0.2 + Math.random() * 0.42);
        const vx = Math.cos(angle) * thrust;
        const vy = Math.sin(angle) * thrust;
        p.style.left = `${cx}px`;
        p.style.top = `${cy}px`;
        p.style.transform = 'translate(-50%, -50%)';
        root.appendChild(p);
        p.animate([
            {
                transform: 'translate(-50%, -50%) scale(1) rotate(0deg)',
                opacity: 1
            },
            {
                transform: `translate(calc(-50% + ${vx}px), calc(-50% + ${vy}px)) scale(0.5) rotate(${180 + Math.random() * 420}deg)`,
                opacity: 0
            }
        ], {
            duration: duration,
            delay: Math.random() * 120,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards'
        });
    }
}
/** Mismo easing que la lluvia: arranca más lenta y acelera hacia el final. */ const $02a8810c1975c803$var$CONFETTI_RAIN_EASING = 'cubic-bezier(0.33, 0.06, 0.72, 1)';
/** Factor < 1 → caída un poco más rápida, sin cambiar la curva. */ const $02a8810c1975c803$var$CONFETTI_RAIN_FALL_SPEED = 0.82;
function $02a8810c1975c803$export$be1601e85103a5d9(options = {}) {
    const { noPageTouch: noPageTouch, touchOpts: touchOpts, effectOpts: effectOpts } = $02a8810c1975c803$var$splitCelebrateOptions(options);
    const { duration: duration = 5800, count: count = 150, sway: sway = true, delaySpread: delaySpread = 3000 } = effectOpts;
    if ($02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts)) return;
    if (!noPageTouch) (0, $1Fbaj.pageTouch)(true, true, touchOpts);
    const root = $02a8810c1975c803$var$createCelebrationRoot();
    const h = typeof window !== 'undefined' ? window.innerHeight : 800;
    const fallEasing = $02a8810c1975c803$var$CONFETTI_RAIN_EASING;
    const fallSpeed = $02a8810c1975c803$var$CONFETTI_RAIN_FALL_SPEED;
    /**
     * @param {number} delay — retraso antes de empezar la caída (ms)
     */ function addRainParticle(delay) {
        const p = $02a8810c1975c803$var$createConfettiParticle(Math.random() > 0.45 ? 'strip' : 'rod');
        const startXPercent = Math.random() * 100;
        const fallDuration = duration * (0.64 + Math.random() * 0.28) * fallSpeed;
        p.style.left = `${startXPercent}vw`;
        p.style.top = '-24px';
        p.style.transform = `translate(-50%, 0) rotate(${Math.random() * 360}deg)`;
        root.appendChild(p);
        const swayPx = sway ? -52 + Math.random() * 104 : 0;
        const rotations = Math.random() * 1260;
        const fadeStart = 0.66 + Math.random() * 0.16;
        p.animate([
            {
                transform: 'translate(-50%, 0) rotate(0deg)'
            },
            {
                transform: `translate(calc(-50% + ${swayPx}px), ${h + 64}px) rotate(${rotations}deg)`
            }
        ], {
            duration: fallDuration,
            delay: delay,
            easing: fallEasing,
            fill: 'forwards'
        });
        p.animate([
            {
                opacity: 1,
                offset: 0
            },
            {
                opacity: 1,
                offset: fadeStart
            },
            {
                opacity: 0,
                offset: 1
            }
        ], {
            duration: fallDuration,
            delay: delay,
            easing: 'linear',
            fill: 'forwards'
        });
    }
    /* Ráfaga inicial para que empiece bien poblado. */ const initialBurst = Math.max(22, Math.min(72, Math.floor(count * 0.32)));
    for(let i = 0; i < initialBurst; i++)addRainParticle(Math.random() * 360);
    const tSpawn0 = performance.now();
    /** Copos nuevos hasta que pase **`delaySpread`** (ms desde ahora). */ const spawnSpreadMs = delaySpread;
    function spawnTick() {
        const elapsed = performance.now() - tSpawn0;
        if (elapsed >= spawnSpreadMs) return;
        const extra = Math.max(0, Math.floor((count - 120) / 90));
        const batchSize = 2 + Math.floor(Math.random() * 3) + extra;
        for(let j = 0; j < batchSize; j++)addRainParticle(0);
        setTimeout(spawnTick, 36 + Math.random() * 52);
    }
    spawnTick();
    /** Últimos copos aparecen casi en `spawnSpreadMs`; tiempo máx. de caída + fade. */ const maxFall = duration * 0.92 * fallSpeed;
    const cleanupDelay = spawnSpreadMs + maxFall + 480;
    if (!noPageTouch) setTimeout(()=>{
        root.remove();
        (0, $1Fbaj.pageTouch)(false);
    }, cleanupDelay);
    else setTimeout(()=>root.remove(), cleanupDelay);
}
function $02a8810c1975c803$export$e5a6a5107a8f1e66(options = {}) {
    const { noPageTouch: noPageTouch, touchOpts: touchOpts, effectOpts: effectOpts } = $02a8810c1975c803$var$splitCelebrateOptions(options);
    const { duration: duration = 1600, count: count = 56, origin: origin = 'bottom' } = effectOpts;
    if ($02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts)) return;
    if (!noPageTouch) (0, $1Fbaj.pageTouch)(true, true, touchOpts);
    const root = $02a8810c1975c803$var$createCelebrationRoot();
    const w = typeof window !== 'undefined' ? window.innerWidth : 400;
    const h = typeof window !== 'undefined' ? window.innerHeight : 600;
    const cx = w * 0.5;
    const cy = origin === 'center' ? h * 0.42 : h - Math.min(120, Math.max(56, h * 0.12));
    $02a8810c1975c803$var$confettiBurstAt(root, cx, cy, {
        duration: duration,
        count: count
    });
    const cleanupDelay = duration + 900;
    if (!noPageTouch) setTimeout(()=>{
        root.remove();
        (0, $1Fbaj.pageTouch)(false);
    }, cleanupDelay);
    else setTimeout(()=>root.remove(), cleanupDelay);
}
function $02a8810c1975c803$export$7df7224ecebdd349(options = {}) {
    const { noPageTouch: noPageTouch, touchOpts: touchOpts, effectOpts: effectOpts } = $02a8810c1975c803$var$splitCelebrateOptions(options);
    const { waves: waves = 5, particlesPerWave: particlesPerWave = 46, burstDuration: burstDuration = 1750, waveGapMin: waveGapMin = 380, waveGapMax: waveGapMax = 920 } = effectOpts;
    if ($02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts)) return;
    if (!noPageTouch) (0, $1Fbaj.pageTouch)(true, true, touchOpts);
    const root = $02a8810c1975c803$var$createCelebrationRoot();
    const w = typeof window !== 'undefined' ? window.innerWidth : 400;
    const h = typeof window !== 'undefined' ? window.innerHeight : 600;
    const marginX = w * 0.1;
    const marginTop = h * 0.08;
    const skyHeight = h * 0.48;
    let t = 0;
    let maxEnd = 0;
    for(let wv = 0; wv < waves; wv++){
        const delay = t;
        const cx = marginX + Math.random() * (w - 2 * marginX);
        const cy = marginTop + Math.random() * skyHeight;
        setTimeout(()=>{
            $02a8810c1975c803$var$confettiBurstAt(root, cx, cy, {
                duration: burstDuration,
                count: particlesPerWave
            });
        }, delay);
        t += waveGapMin + Math.random() * (waveGapMax - waveGapMin);
        maxEnd = Math.max(maxEnd, delay + burstDuration + 80);
    }
    const cleanupDelay = maxEnd + 220;
    if (!noPageTouch) setTimeout(()=>{
        root.remove();
        (0, $1Fbaj.pageTouch)(false);
    }, cleanupDelay);
    else setTimeout(()=>root.remove(), cleanupDelay);
}
function $02a8810c1975c803$export$6315c752df865b8e(options = {}) {
    const { noPageTouch: noPageTouch, touchOpts: touchOpts, effectOpts: effectOpts } = $02a8810c1975c803$var$splitCelebrateOptions(options);
    const { duration: duration = 2000, count: count = 102 } = effectOpts;
    if ($02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts)) return;
    if (!noPageTouch) (0, $1Fbaj.pageTouch)(true, true, touchOpts);
    const root = $02a8810c1975c803$var$createCelebrationRoot();
    const w = typeof window !== 'undefined' ? window.innerWidth : 400;
    const h = typeof window !== 'undefined' ? window.innerHeight : 600;
    const cx = w * 0.5;
    const cy = h * 0.38;
    for(let i = 0; i < count; i++){
        const dot = document.createElement('span');
        dot.style.position = 'absolute';
        dot.style.width = `${4 + Math.random() * 5}px`;
        dot.style.height = dot.style.width;
        dot.style.borderRadius = '50%';
        dot.style.left = `${cx}px`;
        dot.style.top = `${cy}px`;
        dot.style.background = $02a8810c1975c803$var$CELEBRATION_COLORS[(i + Math.floor(Math.random() * 3)) % $02a8810c1975c803$var$CELEBRATION_COLORS.length];
        dot.style.boxShadow = '0 0 8px rgba(255,235,170,0.9)';
        root.appendChild(dot);
        const angle = Math.random() * Math.PI * 2;
        const r = Math.min(w, h) * (0.12 + Math.random() * 0.22);
        const vx = Math.cos(angle) * r;
        const vy = Math.sin(angle) * r;
        dot.animate([
            {
                transform: 'translate(-50%, -50%) scale(1)',
                opacity: 1
            },
            {
                transform: `translate(calc(-50% + ${vx}px), calc(-50% + ${vy}px)) scale(0.35)`,
                opacity: 0
            }
        ], {
            duration: duration * (0.75 + Math.random() * 0.35),
            easing: 'cubic-bezier(0.05, 0.9, 0.25, 1)',
            fill: 'forwards'
        });
    }
    const cleanupDelay = duration + 720;
    if (!noPageTouch) setTimeout(()=>{
        root.remove();
        (0, $1Fbaj.pageTouch)(false);
    }, cleanupDelay);
    else setTimeout(()=>root.remove(), cleanupDelay);
}
function $02a8810c1975c803$export$bf7be1c373bc07e7(options = {}) {
    const touchOpts = $02a8810c1975c803$var$buildTouchOpts(options);
    if ($02a8810c1975c803$var$bailReducedCelebrationFlash(touchOpts)) return;
    const estimateReleaseMs = (o, delay)=>{
        const rn = o.rain ?? {};
        const fw = o.fireworks ?? {};
        const rd = rn.duration ?? 5800;
        const rds = rn.delaySpread ?? 3000;
        const rainEnd = rds + rd * 0.92 * $02a8810c1975c803$var$CONFETTI_RAIN_FALL_SPEED + 920;
        const w = fw.waves ?? 8;
        const gapMax = fw.waveGapMax ?? 920;
        const bd = fw.burstDuration ?? 1750;
        const fireworksSpan = w * gapMax + bd + 780;
        return Math.max(rainEnd, delay + fireworksSpan) + 320;
    };
    const { rain: rain = {}, fireworks: fireworks = {}, fireworksDelay: fireworksDelay = 750 } = options;
    (0, $1Fbaj.pageTouch)(true, true, {
        ...touchOpts,
        releaseAfterMs: estimateReleaseMs(options, fireworksDelay)
    });
    $02a8810c1975c803$export$be1601e85103a5d9({
        ...rain,
        noPageTouch: true
    });
    setTimeout(()=>{
        $02a8810c1975c803$export$7df7224ecebdd349({
            ...fireworks,
            noPageTouch: true
        });
    }, fireworksDelay);
}
function $02a8810c1975c803$export$c57921a8446a3d70(preset, overrides = {}) {
    switch(preset){
        case 'burst':
            $02a8810c1975c803$export$e5a6a5107a8f1e66(overrides);
            break;
        case 'sparks':
            $02a8810c1975c803$export$6315c752df865b8e(overrides);
            break;
        case 'fireworks':
            $02a8810c1975c803$export$7df7224ecebdd349(overrides);
            break;
        case 'grand':
            $02a8810c1975c803$export$bf7be1c373bc07e7(overrides);
            break;
        case 'rain':
        default:
            $02a8810c1975c803$export$be1601e85103a5d9(overrides);
            break;
    }
}

});



var $cm03h = parcelRequire("cm03h");

var $hLcer = parcelRequire("hLcer");

var $3kyGY = parcelRequire("3kyGY");

var $45fvw = parcelRequire("45fvw");
parcelRequire("fdK23");
(0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale('es');
/**
 * Clase para manejo de autenticación
 * Implementa patrón Singleton
 * @class AppAuth
 */ class $2f0d5f4a5929f6e7$export$ae272252f695d119 {
    /**
	 * Constructor del AppAuth (Singleton)
	 */ constructor(){
        if ($2f0d5f4a5929f6e7$export$ae272252f695d119._instance) return $2f0d5f4a5929f6e7$export$ae272252f695d119._instance;
        /** @type {boolean} */ this.initialized = false;
        /** @type {string|null} */ this.token = null;
        /** @type {AppManager|null} */ this.app = null;
        $2f0d5f4a5929f6e7$export$ae272252f695d119._instance = this;
    }
    /**
	 * Inicializa el módulo de autenticación
	 * @async
	 * @param {AppManager} app - Instancia de AppManager
	 * @returns {Promise<void>}
	 * @throws {Error} Si hay error en la inicialización
	 */ async init(app) {
        if (this.initialized) return;
        try {
            this.app = app;
            const access = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('access');
            if (access && access.token && (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().isBefore(access.expiration)) this.token = access.token;
            else this.token = null;
            this.initialized = true;
        } catch (error) {
            this.token = null;
            this.initialized = true;
            throw error;
        }
    }
    /**
	 * Verifica si el usuario está autenticado
	 * @async
	 * @returns {Promise<boolean>} true si está autenticado
	 */ async isAuthenticated() {
        try {
            const access = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('access');
            if (access && access.token) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().isBefore(access.expiration)) {
                    this.token = access.token;
                    return true;
                } else return false;
            } else return false;
        } catch (error) {
            throw error;
        }
    }
    /**
	 * Inicia sesión con username y password
	 * @async
	 * @param {string} username - Nombre de usuario
	 * @param {string} password - Contraseña
	 * @param {Function} success - Callback de éxito
	 * @param {Function} failure - Callback de fallo
	 * @returns {Promise<void>}
	 */ async login(username, password, success, failure) {
        if (!username || !password) return;
        (0, $cm03h.Toast).show("Iniciando Sesi\xf3n", 'warning', 2000);
        try {
            const url = `/token?username=${encodeURIComponent(username)}`;
            const data = await (0, $hLcer.apiCall)(url, {
                method: 'GET',
                requireAuth: false,
                headers: {
                    'Authorization': 'Basic ' + btoa(`${username}:${password}`)
                }
            });
            if (data.class === 'success') {
                await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('access', data.info);
                this.token = data.info.token;
                await this.app.db.updateMember(data.member);
                await this.app.db.updateApplications(data.applications);
                if (typeof success === 'function') success(data);
            } else {
                (0, $cm03h.Toast).show(data.html, data.class);
                if (typeof failure === 'function') failure(data);
            }
        } catch (error) {
            throw error;
        }
    }
    /**
	 * Cierra sesión del usuario
	 * @async
	 * @returns {Promise<void>}
	 */ async logout() {
        try {
            if (!this.token || !this.app.db.member?.member_id) return;
            const url = `/logout?token=${this.token}&member_id=${this.app.db.member.member_id}`;
            await (0, $hLcer.apiGet)(url, {
                requireAuth: false
            });
        } catch (error) {
            throw error;
        } finally{
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).clear();
            if (this.app && (this.app.getCurrentControllerName() === null || this.app.getCurrentControllerName() !== 'login')) this.app.load('login');
        }
    }
    async clear() {
        await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).clear();
        if ('serviceWorker' in navigator) try {
            await caches.delete(await this.app.getVersion());
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of registrations)await registration.unregister();
            window.location.replace(window.location.href);
        } catch (error) {
            throw error;
        }
    }
    /**
	 * Solicita recuperación de contraseña
	 * @async
	 * @param {string} username - Nombre de usuario
	 * @param {Function} success - Callback de éxito
	 * @param {Function} failure - Callback de fallo
	 * @returns {Promise<void>}
	 */ async recoverPassword(username, success, failure) {
        if (!username) return;
        try {
            const url = `/recover?username=${encodeURIComponent(username)}`;
            const data = await (0, $hLcer.apiGet)(url, {
                requireAuth: false
            });
            (0, $cm03h.Toast).show(data.html, data.class);
            if (data.class === 'success') {
                if (typeof success === 'function') success(data);
            } else if (typeof failure === 'function') failure(data);
        } catch (error) {
            if (typeof failure === 'function') failure(error);
            throw error;
        }
    }
}



var $cm03h = parcelRequire("cm03h");

var $3kyGY = parcelRequire("3kyGY");

var $45fvw = parcelRequire("45fvw");
parcelRequire("fdK23");

var $hLcer = parcelRequire("hLcer");
(0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale('es');
/**
 * Clase para manejo de base de datos local (IndexedDB)
 * Implementa patrón Singleton
 * @class AppDB
 */ class $e651340288ba3db3$export$c91d04c0fa74c77 {
    /**
     * Constructor del AppDB (Singleton)
     */ constructor(){
        if ($e651340288ba3db3$export$c91d04c0fa74c77._instance) return $e651340288ba3db3$export$c91d04c0fa74c77._instance;
        /** @type {boolean} */ this.initialized = false;
        /** @type {AppManager|null} */ this.app = null;
        /** @type {number|null} */ this.currentTripId = null;
        /** @type {Object|null} */ this.member = null;
        /** @type {Object|null} */ this.applications = null;
        /** @type {Object|null} */ this.trip = null;
        /** @type {Object|null} */ this.subprogram = null;
        $e651340288ba3db3$export$c91d04c0fa74c77._instance = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).config({
            driver: (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).INDEXEDDB,
            name: 'WETAG',
            version: 1.0,
            storeName: 'main'
        });
    }
    /**
     * Inicializa el módulo de base de datos
     * @async
     * @param {AppManager} app - Instancia de AppManager
     * @returns {Promise<void>}
     * @throws {Error} Si hay error en la inicialización
     */ /**
     * Inicializa el módulo de base de datos
     * @async
     * @param {AppManager} app - Instancia de AppManager
     * @returns {Promise<void>}
     * @throws {Error} Si hay error en la inicialización
     */ async init(app) {
        if (this.initialized) return;
        try {
            this.app = app;
            const isAuthenticated = app.auth && await app.auth.isAuthenticated();
            if (isAuthenticated) {
                try {
                    await this.getMember();
                } catch (error) {
                    throw error;
                }
                try {
                    await this.getApplications();
                } catch (error) {
                    throw error;
                }
                try {
                    await this.getCurrentTripId();
                } catch (error) {
                    throw error;
                }
                try {
                    await this.getTrip();
                } catch (error) {
                    throw error;
                }
            }
            this.initialized = true;
        } catch (error) {
            this.initialized = true;
            throw error;
        }
    }
    /**
     * Obtiene los datos del miembro (con cache)
     * @async
     * @param {boolean} [reload=false] - Forzar recarga desde servidor
     * @param {number|false} [memberId=false] - ID del miembro (opcional)
     * @returns {Promise<Object>} Datos del miembro
     * @throws {Error} Si hay error al obtener datos o no se encuentra memberId
     */ async getMember(reload = false, memberId = false) {
        try {
            const table = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('member');
            const expired = table ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(table.timestamp), 'days', true) > 1 : true;
            if (table && !reload && !expired) {
                this.member = table.data;
                return table.data;
            }
            memberId = memberId || this.member?.member_id || table && table.data.member_id;
            if (!memberId) throw new Error('No Member ID');
            const results = await (0, $hLcer.apiGet)(`/member/${memberId}?reload`);
            if (results.class === 'success') {
                await this.updateMember(results.data);
                return results.data;
            } else {
                (0, $cm03h.Toast).show(results.html, results.class);
                throw new Error(results.html);
            }
        } catch (error) {
            throw error;
        }
    }
    /**
     * Actualiza el member haciendo merge en this.member y localforage
     * @async
     * @param {Object} memberData - Datos del member a actualizar
     * @returns {Promise<void>}
     */ async updateMember(memberData) {
        if (!memberData) return;
        const memberTable = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('member');
        if (memberTable && memberTable.data) {
            Object.assign(memberTable.data, memberData);
            memberTable.timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format();
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('member', memberTable);
        } else await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('member', {
            timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format(),
            data: memberData
        });
        if (this.member) Object.assign(this.member, memberData);
        else this.member = memberData;
        if (memberData.applications) {
            this.applications = memberData.applications;
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('applications', {
                timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format(),
                data: memberData.applications
            });
        }
    }
    /**
     * Obtiene las applications (con cache)
     * @async
     * @param {boolean} [reload=false] - Forzar recarga desde servidor
     * @param {number|false} [memberId=false] - ID del miembro (opcional)
     * @returns {Promise<Object>} Datos de las applications (keyed by application_id)
     * @throws {Error} Si hay error al obtener datos o no se encuentra memberId
     */ async getApplications(reload = false, memberId = false) {
        try {
            const table = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('applications');
            const expired = table ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(table.timestamp), 'hours', true) > 1 : true;
            if (table && !reload && !expired) {
                this.applications = table.data;
                return table.data;
            }
            memberId = memberId || this.member?.member_id;
            if (!memberId) {
                const memberTable = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('member');
                memberId = memberTable?.data?.member_id;
            }
            if (!memberId) throw new Error('No Member ID');
            const results = await (0, $hLcer.apiGet)(`/member/${memberId}/applications?reload`);
            if (results.class === 'success') {
                await this.updateApplications(results.data);
                return results.data;
            } else {
                (0, $cm03h.Toast).show(results.html, results.class);
                throw new Error(results.html);
            }
        } catch (error) {
            throw error;
        }
    }
    /**
     * Actualiza las applications haciendo merge en localforage usando application_id como índice
     * @async
     * @param {Object} applicationsData - Objeto con las applications a actualizar (keyed by application_id)
     * @returns {Promise<void>}
     */ async updateApplications(applicationsData) {
        if (!applicationsData || typeof applicationsData !== 'object') return;
        let applicationsTable = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('applications');
        if (!applicationsTable) applicationsTable = {
            timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format(),
            data: {}
        };
        if (!applicationsTable.data) applicationsTable.data = {};
        Object.values(applicationsData).forEach((applicationData)=>{
            const applicationId = applicationData.application_id;
            if (applicationId) applicationsTable.data[applicationId] = applicationData;
        });
        applicationsTable.timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format();
        await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('applications', applicationsTable);
        if (this.applications) Object.assign(this.applications, applicationsData);
        else this.applications = applicationsData;
    }
    /**
     * Actualiza una application haciendo merge en localforage usando application_id como índice
     * @async
     * @param {Object} applicationData - Datos de la application a actualizar (debe incluir application_id)
     * @returns {Promise<void>}
     */ async updateApplication(applicationData) {
        if (!applicationData || !applicationData.application_id) return;
        let applicationsTable = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('applications');
        if (!applicationsTable) applicationsTable = {
            timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format(),
            data: {}
        };
        if (!applicationsTable.data) applicationsTable.data = {};
        const applicationId = applicationData.application_id;
        if (applicationsTable.data[applicationId]) Object.assign(applicationsTable.data[applicationId], applicationData);
        else applicationsTable.data[applicationId] = applicationData;
        applicationsTable.timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format();
        await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('applications', applicationsTable);
    }
    /**
     * Obtiene el ID del viaje actual
     * @async
     * @param {number|false} [tripId=false] - ID del viaje a usar directamente
     * @returns {Promise<number|false>} ID del viaje actual o false si no está disponible
     * @throws {Error} Si hay error al obtener el trip ID
     */ async getCurrentTripId(tripId = false) {
        try {
            if (tripId) {
                this.setCurrentTripId(tripId);
                return tripId;
            }
            const storedTripId = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('currentTripId');
            if (storedTripId) {
                this.currentTripId = storedTripId;
                return this.currentTripId;
            }
            if (!this.applications) await this.getApplications();
            const applications = this.applications;
            if (applications && typeof applications === 'object') {
                const applicationsArray = Object.values(applications);
                if (applicationsArray.length > 0) {
                    const applicationsByDate = applicationsArray.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(b.date) - (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(a.date));
                    const lastApplicationId = applicationsByDate[0]?.application_id;
                    if (lastApplicationId) {
                        await this.setCurrentTripId(lastApplicationId);
                        return lastApplicationId;
                    }
                }
            }
            return false;
        } catch (error) {
            throw error;
        }
    }
    /**
     * Establece el ID del viaje actual y carga los datos del viaje
     * @async
     * @param {number} tripId - ID del viaje a establecer
     * @returns {Promise<void>}
     */ async setCurrentTripId(tripId) {
        if (tripId) {
            const oldTripId = this.currentTripId;
            this.currentTripId = tripId;
            (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('currentTripId', parseInt(tripId));
            if (!oldTripId || oldTripId !== tripId) await this.getTrip(true, tripId);
        }
    }
    /**
     * Obtiene los datos del viaje (con cache)
     * @async
     * @param {boolean} [reload=false] - Forzar recarga desde servidor
     * @param {number|false} [tripId=false] - ID del viaje (opcional)
     * @returns {Promise<Object>} Datos del viaje
     * @throws {Error} Si hay error al obtener datos o no se encuentra tripId
     */ async getTrip(reload = false, tripId = false) {
        try {
            const table = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('trip');
            const expired = table ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().diff((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(table.timestamp), 'minutes') > 10 : true;
            if (table && !reload && !expired) {
                this.trip = table.data;
                return table.data;
            } else {
                const resolvedTripId = await this.getCurrentTripId(tripId);
                if (resolvedTripId) {
                    const results = await (0, $hLcer.apiGet)(`/trip/${resolvedTripId}?reload`);
                    if (results.class === 'success') {
                        await this.updateTrip(results.data);
                        return results.data;
                    } else {
                        (0, $cm03h.Toast).show(results.html, results.class);
                        throw new Error(results.html);
                    }
                } else {
                    if (this.app && this.app.auth) this.app.auth.logout();
                    throw new Error('No Trip ID');
                }
            }
        } catch (error) {
            throw error;
        }
    }
    /**
     * Actualiza el trip haciendo merge en this.trip y localforage
     * @async
     * @param {Object} tripData - Datos del trip a actualizar
     * @returns {Promise<void>}
     */ async updateTrip(tripData) {
        if (!tripData) return;
        const tripTable = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('trip');
        if (tripTable && tripTable.data) {
            Object.assign(tripTable.data, tripData);
            tripTable.timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format();
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('trip', tripTable);
        } else await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('trip', {
            timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format(),
            data: tripData
        });
        if (this.trip) Object.assign(this.trip, tripData);
        else this.trip = tripData;
        if (tripData.member) await this.updateMember(tripData.member);
        if (tripData.application) await this.updateApplication(tripData.application);
    }
}


/**
 * Gestor de stack de navegación
 * @module classes/navigation/StackManager
 */ 
var $3kyGY = parcelRequire("3kyGY");
class $5b924e0b42be2567$export$684ba9bf82385717 {
    /**
     * Constructor del StackManager
     */ constructor(){
        this.maxStackSize = 5;
    }
    /**
     * Agrega una entrada al stack (args se clonan: no persisten claves que empiecen con `_`).
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @param {Object|boolean} originalArgs - Argumentos del controlador
     * @param {number} scrollPosition - Posición de scroll
     */ async addToStack(controllerName, originalArgs = false, scrollPosition = 0) {
        if (!controllerName) return;
        try {
            const stack = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
            /** @type {Object|false} */ let stackArgs = false;
            if (originalArgs && typeof originalArgs === 'object') {
                stackArgs = {
                    ...originalArgs
                };
                for (const key of Object.keys(stackArgs))if (key.startsWith('_')) delete stackArgs[key];
                if (stackArgs.params && typeof stackArgs.params === 'object') {
                    stackArgs.params = {
                        ...stackArgs.params
                    };
                    for (const key of Object.keys(stackArgs.params))if (key.startsWith('_')) delete stackArgs.params[key];
                    if (Object.keys(stackArgs.params).length === 0) delete stackArgs.params;
                }
            }
            if (stack.length > 0 && stack[stack.length - 1].controllerName === controllerName) stack[stack.length - 1] = {
                controllerName: controllerName,
                args: stackArgs,
                scrollPosition: scrollPosition
            };
            else {
                stack.push({
                    controllerName: controllerName,
                    args: stackArgs,
                    scrollPosition: scrollPosition
                });
                if (stack.length > this.maxStackSize) stack.splice(0, stack.length - this.maxStackSize);
            }
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('appStack', stack);
        } catch (error) {
            throw error;
        }
    }
    /**
     * Remueve la última entrada del stack
     * @async
     */ async removeFromStack() {
        try {
            const stack = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
            stack.pop();
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('appStack', stack);
        } catch (error) {
            throw error;
        }
    }
    /**
     * Establece la posición de scroll para el controlador actual
     * @async
     * @param {string} currentControllerName - Nombre del controlador actual
     * @param {number} scrollPosition - Posición de scroll
     */ async setScrollPosition(currentControllerName, scrollPosition) {
        if (!currentControllerName) return;
        try {
            const stack = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
            if (stack.length > 0 && stack[stack.length - 1].controllerName === currentControllerName) {
                stack[stack.length - 1].scrollPosition = scrollPosition;
                await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('appStack', stack);
            }
        } catch (error) {
            throw error;
        }
    }
    /**
     * Establece el estado de elementos guardados
     * @async
     * @param {string} currentControllerName - Nombre del controlador actual
     * @param {Object} elementsStatus - Estado de los elementos
     */ async setSavedStatusElements(currentControllerName, elementsStatus) {
        if (!currentControllerName || !elementsStatus) return;
        try {
            const stack = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
            if (stack.length > 0 && stack[stack.length - 1].controllerName === currentControllerName) {
                if (!stack[stack.length - 1].args) stack[stack.length - 1].args = {};
                stack[stack.length - 1].args.elementsStatus = elementsStatus;
                await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).setItem('appStack', stack);
            }
        } catch (error) {
            throw error;
        }
    }
    /**
     * Obtiene la última página restaurable
     * @async
     * @returns {Promise<Object|null>} Última página restaurable o null
     */ async getLastRestorablePage() {
        try {
            const stack = await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
            if (stack.length > 0) for(let i = stack.length - 1; i >= 0; i--){
                const item = stack[i];
                if (item && item.args && item.args.restorable) return item;
            }
            return null;
        } catch (error) {
            throw error;
        }
    }
    /**
     * Limpia el stack
     * @async
     */ async clearStack() {
        try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).removeItem('appStack');
        } catch (error) {
            throw error;
        }
    }
    /**
     * Obtiene el stack completo
     * @async
     * @returns {Promise<Array>} Stack completo
     */ async getStack() {
        try {
            return await (0, (/*@__PURE__*/$parcel$interopDefault($3kyGY))).getItem('appStack') || [];
        } catch (error) {
            throw error;
        }
    }
    /**
     * Guarda el estado de la página actual antes de cambiar a otra
     * @async
     * @param {HTMLElement} oldPage - Elemento de la página anterior
     * @param {Function} getSavedStatusElements - Función para obtener elementos guardados
     * @returns {Promise<HTMLElement|null>} Elemento de la página anterior o null
     */ async saveToStack(oldPage, getSavedStatusElements) {
        if (!oldPage) return null;
        const isRestorable = oldPage.getAttribute('data-restorable');
        if (isRestorable) {
            const currentControllerName = oldPage.getAttribute('data-controller');
            if (currentControllerName) {
                const content = document.querySelector('.app-content');
                const savedScrollPosition = content ? content.scrollTop : 0;
                await this.setScrollPosition(currentControllerName, savedScrollPosition);
                await this.setSavedStatusElements(currentControllerName, getSavedStatusElements(oldPage));
            }
        }
        return oldPage;
    }
}


/**
 * Cargador de controladores
 * @module classes/navigation/ControllerLoader
 */ /**
 * Clase para gestionar la carga de controladores
 * @class ControllerLoader
 */ 












class $f69df13d1943b4ac$export$8b48dc46ee49638f {
    /**
     * Constructor del ControllerLoader
     */ constructor(){
        /** @type {Map<string, Object>} */ this.controllerCache = new Map();
        this.controllers = {
            login: ()=>(parcelRequire("iL6vn")),
            trip: ()=>(parcelRequire("6NLMO")),
            explore: ()=>(parcelRequire("1fxu9")),
            //experience: () => import('../../controllers/Experience.js'),
            profile: ()=>(parcelRequire("dmeRL")),
            uploadField: ()=>(parcelRequire("dJzqN")),
            uploadFile: ()=>(parcelRequire("ir0N9")),
            uploadForm: ()=>(parcelRequire("lg8ne")),
            uploadLink: ()=>(parcelRequire("dwLw8")),
            uploadPayment: ()=>(parcelRequire("akgT4")),
            uploadJobOffer: ()=>(parcelRequire("lGJNv")),
            reader: ()=>(parcelRequire("46YEJ")),
            viewer: ()=>(parcelRequire("8Q0Vh")),
            challenge: ()=>(parcelRequire("i8rwJ"))
        };
    }
    /**
     * Obtiene un controlador por nombre (con cache)
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @returns {Promise<Object|null>} Módulo del controlador o null
     */ async getController(controllerName) {
        if (!controllerName) return null;
        if (this.controllerCache.has(controllerName)) return this.controllerCache.get(controllerName);
        if (this.controllers[controllerName]) try {
            const module = await this.controllers[controllerName]();
            this.controllerCache.set(controllerName, module);
            return module;
        } catch (error) {
            throw error;
        }
        return null;
    }
    /**
     * Verifica si un controlador es restaurable
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @returns {Promise<boolean>} true si es restaurable
     */ async isRestorable(controllerName) {
        if (!controllerName) return true;
        const module = await this.getController(controllerName);
        if (module && typeof module.default === 'function') return typeof module.default.restorable === 'undefined' ? true : module.default.restorable;
        return true;
    }
    /**
     * Verifica si un controlador oculta la navegación principal
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @returns {Promise<boolean>} true si oculta la navegación
     */ async hasHideMainNav(controllerName) {
        if (!controllerName) return false;
        const module = await this.getController(controllerName);
        if (module && typeof module.default === 'function') return typeof module.default.hideMainNav === 'undefined' ? false : module.default.hideMainNav;
        return false;
    }
    /**
     * Preload de un controlador
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @returns {Promise<Object|null>} Módulo del controlador
     */ async preloadController(controllerName) {
        if (this.controllerCache.has(controllerName)) return this.controllerCache.get(controllerName);
        try {
            const module = await this.getController(controllerName);
            if (module) return module;
        } catch (error) {
            throw error;
        }
    }
}


/**
 * Gestor de preload de recursos
 * @module classes/navigation/PreloadManager
 */ /**
 * Clase para gestionar el preload de páginas y templates
 * @class PreloadManager
 */ class $57fe3c3f9761087c$export$9dd13bb4eebc7944 {
    /**
     * Constructor del PreloadManager
     * @param {ControllerLoader} controllerLoader - Instancia del ControllerLoader
     */ constructor(controllerLoader){
        this.controllerLoader = controllerLoader;
        /** @type {Map<string, string>} */ this.templateCache = new Map();
        /** En dev: no cachear templates para que los .html editados se vean sin recargar la app completa */ this.templatesSkipCache = false;
    }
    /**
     * Preload de todas las páginas
     * @async
     */ async preloadPages() {
        const pagesToPreload = [
            {
                controller: 'login',
                template: 'page-login.html'
            },
            {
                controller: 'trip',
                template: 'page-trip.html'
            },
            {
                controller: 'explore',
                template: 'page-explore.html'
            },
            //{ controller: 'experience', template: 'page-experience.html' },
            {
                controller: 'profile',
                template: 'page-profile.html'
            },
            {
                controller: 'uploadField',
                template: 'page-upload.field.html'
            },
            {
                controller: 'uploadFile',
                template: 'page-upload.file.html'
            },
            {
                controller: 'uploadForm',
                template: 'page-upload.form.html'
            },
            {
                controller: 'uploadLink',
                template: 'page-upload.link.html'
            },
            {
                controller: 'uploadPayment',
                template: 'page-upload.payment.html'
            },
            {
                controller: 'uploadJobOffer',
                template: 'page-upload.joboffer.html'
            },
            {
                controller: 'reader',
                template: 'page-reader.html'
            },
            {
                controller: 'viewer',
                template: 'page-viewer.html'
            },
            {
                controller: 'challenge',
                template: 'page-challenge.html'
            }
        ];
        if ('requestIdleCallback' in window) requestIdleCallback(()=>{
            this.runPreload(pagesToPreload);
        }, {
            timeout: 5000
        });
        else setTimeout(()=>this.runPreload(pagesToPreload), 1000);
    }
    /**
     * Ejecuta el preload de páginas
     * @async
     * @param {Array} pages - Array de páginas a preload
     */ async runPreload(pages) {
        let preloadedCount = 0;
        for (const page of pages)try {
            const [controllerResult, templateResult] = await Promise.allSettled([
                this.controllerLoader.preloadController(page.controller),
                this.preloadTemplate(page.template)
            ]);
            if (controllerResult.status === 'fulfilled' && templateResult.status === 'fulfilled') preloadedCount++;
            await new Promise((resolve)=>setTimeout(resolve, 100));
        } catch (error) {}
    }
    /**
     * Preload de un template
     * @async
     * @param {string} templateFile - Nombre del archivo template
     * @returns {Promise<string>} Contenido del template
     */ async preloadTemplate(templateFile) {
        if (!this.templatesSkipCache && this.templateCache.has(templateFile)) return this.templateCache.get(templateFile);
        try {
            const url = this.templatesSkipCache ? `${templateFile}?reload` : templateFile;
            const response = await fetch(url, {
                cache: this.templatesSkipCache ? 'no-store' : 'default'
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            const html = await response.text();
            if (!this.templatesSkipCache) this.templateCache.set(templateFile, html);
            return html;
        } catch (error) {
            throw error;
        }
    }
    /**
     * Obtiene un template del cache o lo carga
     * @async
     * @param {string} templateFile - Nombre del archivo template
     * @returns {Promise<string>} Contenido del template
     */ async getTemplate(templateFile) {
        if (!this.templatesSkipCache && this.templateCache.has(templateFile)) return this.templateCache.get(templateFile);
        return await this.preloadTemplate(templateFile);
    }
}


parcelRequire("3kyGY");
var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});



var $4KWEf = parcelRequire("4KWEf");

var $bUw5l = parcelRequire("bUw5l");

var $1Fbaj = parcelRequire("1Fbaj");
/**
 * Gestor principal de la aplicación WETAG
 * Implementa patrón Singleton para mantener una única instancia
 * @class AppManager
 */ class $572f0c6bf2810aa6$var$AppManager {
    /**
     * Constructor del AppManager (Singleton)
     */ constructor(){
        if ($572f0c6bf2810aa6$var$AppManager._instance) return $572f0c6bf2810aa6$var$AppManager._instance;
        /** @type {AppAuth|null} */ this.auth = null;
        /** @type {AppDB|null} */ this.db = null;
        /** @type {Object|null} */ this.settings = null;
        /** @type {boolean} */ this.initialized = false;
        /** @type {HTMLElement|null} */ this.oldPage = null;
        /** @type {boolean} */ this.isLoading = false;
        /** @type {StackManager} */ this.stackManager = new (0, $5b924e0b42be2567$export$684ba9bf82385717)();
        /** @type {ControllerLoader} */ this.controllerLoader = new (0, $f69df13d1943b4ac$export$8b48dc46ee49638f)();
        /** @type {PreloadManager} */ this.preloadManager = new (0, $57fe3c3f9761087c$export$9dd13bb4eebc7944)(this.controllerLoader);
        this.assignTargetEvents(document.body);
        $572f0c6bf2810aa6$var$AppManager._instance = this;
    }
    /**
     * Inicializa la aplicación
     * @async
     * @returns {Promise<void>}
     * @throws {Error} Si hay error en la inicialización
     */ async init() {
        if (this.initialized) return;
        try {
            this.auth = new (0, $2f0d5f4a5929f6e7$export$ae272252f695d119)();
            this.db = new (0, $e651340288ba3db3$export$c91d04c0fa74c77)();
            this.settings = {
                restUrl: 'https://crm.wetag.ar/app',
                contentUrl: 'https://crm.wetag.ar/content'
            };
            window.App = this;
            window.AppAuth = this.auth;
            window.AppDB = this.db;
            window.AppSettings = this.settings;
            await this.auth.init(this);
            await this.db.init(this);
            this.initialized = true;
            this.oldPage = null;
            const isLoggedIn = await this.auth.isAuthenticated();
            if (!isLoggedIn) {
                const startParams = new URLSearchParams(window.location.search);
                if (startParams.get('page') === 'experience') await this.load('experience');
                else await this.load('login');
            } else await this.loadInitialPage();
            setTimeout(()=>this.preloadManager.preloadPages(), 5000);
        } catch (error) {
            this.handleError('App initialization error', error);
            throw error;
        }
    }
    /**
     * Carga la página inicial según parámetros URL o última página restaurable
     * @async
     * @returns {Promise<boolean>} true si se cargó correctamente
     */ async loadInitialPage() {
        try {
            const params = new URLSearchParams(window.location.search);
            const page = params.get('page');
            const validPages = [
                'trip',
                'profile',
                'explore',
                'experience'
            ];
            if (page && validPages.includes(page)) await this.load(page);
            else {
                const lastPage = await this.stackManager.getLastRestorablePage();
                if (lastPage) await this.load(lastPage.controllerName, lastPage.args);
                else await this.load('trip');
            }
            return true;
        } catch (error) {
            this.handleError('Initial page load error', error);
            return false;
        }
    }
    /**
     * Resetea la aplicación
     * @async
     * @returns {Promise<void>}
     */ async reset() {
        this.auth = null;
        this.db = null;
        this.settings = null;
        this.initialized = false;
        this.oldPage = null;
        this.isLoading = false;
        delete window.App;
        delete window.AppAuth;
        delete window.AppDB;
        delete window.AppSettings;
        await this.init();
    }
    /**
     * Carga un controlador y renderiza la página
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @param {Object|boolean} args - Argumentos para el controlador
     * @param {number} scrollPosition - Posición de scroll a restaurar
     * @returns {Promise<boolean>} true si se cargó correctamente
     */ async load(controllerName, args = false, scrollPosition = 0) {
        if (this.isLoading) {
            console.warn(`[AppManager] Already loading, ignoring request for: ${controllerName}`);
            return false;
        }
        try {
            const isLoggedIn = await this.auth.isAuthenticated();
            const publicControllers = [
                'login',
                'experience'
            ];
            if (!isLoggedIn && !publicControllers.includes(controllerName)) {
                if (this.getCurrentControllerName() !== 'login') await this.load('login');
                return false;
            }
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.size > 0) {
                args = args || {};
                if (urlParams.has('reload')) {
                    args._reload = true;
                    urlParams.delete('reload');
                }
                args.params = Object.fromEntries(urlParams);
                const newUrl = window.location.pathname + window.location.hash;
                window.history.replaceState({}, '', newUrl);
            }
            this.isLoading = true;
            (0, $1Fbaj.pageTouch)(true, true);
            const oldPage = document.querySelector('.app-page');
            if (oldPage) this.oldPage = await this.stackManager.saveToStack(oldPage, (page)=>this.getSavedStatusElements(page));
            const module = await this.getController(controllerName);
            if (!module || typeof module.default !== 'function') {
                await this.loadInitialPage();
                this.isLoading = false;
                (0, $1Fbaj.pageTouch)(false);
                return false;
            }
            const page = document.createElement('div');
            page.className = 'app-page z-1 position-relative';
            page.setAttribute('data-controller', controllerName);
            page.style.opacity = 0;
            document.body.appendChild(page);
            const restorable = await this.controllerLoader.isRestorable(controllerName);
            if (restorable) {
                page.setAttribute('data-restorable', true);
                if (args) args.restorable = true;
                else args = {
                    restorable: true
                };
            }
            await this.stackManager.addToStack(controllerName, args, scrollPosition);
            Object.keys(module).filter((key)=>key !== 'default' && typeof module[key] === 'function').forEach((fn)=>{
                window[fn] = module[fn];
            });
            try {
                await module.default(page, args, scrollPosition);
            } catch (error) {
                this.isLoading = false;
                (0, $1Fbaj.pageTouch)(false);
                this.handleError(`Controller Error: ${controllerName}`, error);
                return false;
            }
            this.isLoading = false;
            return true;
        } catch (error) {
            this.isLoading = false;
            (0, $1Fbaj.pageTouch)(false);
            this.handleError(`Load controller error: ${controllerName}`, error);
            return false;
        }
    }
    /**
     * Renderiza una página usando un template Mustache
     * @async
     * @param {HTMLElement} page - Elemento de la página
     * @param {string} templateFile - Ruta del template
     * @param {number} scrollPosition - Posición de scroll
     * @param {Object} fields - Datos para el template
     * @returns {Promise<HTMLElement>} Elemento de la página renderizado
     */ async render(page, templateFile, scrollPosition = 0, fields = {}) {
        return new Promise(async (resolve, reject)=>{
            const controllerName = this.getCurrentControllerName(page);
            if (!controllerName) {
                reject(new Error('No Controller Found'));
                return;
            }
            this.preloadManager.getTemplate(templateFile).then((template)=>{
                this.buildTemplate(template, page, fields, scrollPosition, controllerName, resolve);
            }).catch((error)=>{
                this.handleError(`Error loading template ${templateFile}`, error);
                reject(error);
            });
        });
    }
    /**
     * Construye el template renderizado y configura eventos
     * @param {string} template - Template de Mustache
     * @param {HTMLElement} page - Elemento de la página
     * @param {Object} fields - Datos para el template
     * @param {number} scrollPosition - Posición de scroll
     * @param {string} controllerName - Nombre del controlador
     * @param {Function} resolve - Función de resolución de la promesa
     */ buildTemplate(template, page, fields, scrollPosition, controllerName, resolve) {
        page.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, fields);
        this.assignTargetEvents(page);
        this.assingBackEvents(page);
        this.assignSaveStatusElementsEvents(controllerName, page);
        (0, (/*@__PURE__*/$parcel$interopDefault($bUw5l)))('event', 'screen_view', {
            screen_name: controllerName
        });
        (0, $1Fbaj.pageTouch)(false);
        const event = new CustomEvent('App:Rendered', {
            detail: {
                page: page,
                controllerName: controllerName,
                fields: fields
            }
        });
        document.dispatchEvent(event);
        requestAnimationFrame(async ()=>{
            try {
                if (!page || !document.body.contains(page)) {
                    console.warn(`[AppManager] Page element no longer exists: ${controllerName}`);
                    resolve(page);
                    return;
                }
                if (this.oldPage && this.oldPage !== page) {
                    this.oldPage.remove();
                    this.oldPage = null;
                }
                document.querySelectorAll('.app-page').forEach((otherPage)=>{
                    if (otherPage !== page) otherPage.remove();
                });
                const content = page.querySelector('.app-content');
                if (content) content.scrollTop = scrollPosition;
                page.style.transition = 'opacity 0.3s ease';
                if (page && page.style) page.style.opacity = 1;
                const mainNav = document.querySelector('.app-main-nav');
                if (mainNav) {
                    const hideNav = await this.controllerLoader.hasHideMainNav(controllerName);
                    if (hideNav) mainNav.classList.add('d-none');
                    else mainNav.classList.remove('d-none');
                }
            } catch (error) {
                this.handleError('Error in buildTemplate', error);
                if (page && page.style && document.body.contains(page)) page.style.opacity = 1;
                (0, $1Fbaj.pageTouch)(false);
            }
            resolve(page);
        });
    }
    /**
     * Asigna eventos a elementos con data-target
     * @async
     * @param {HTMLElement} target - Elemento contenedor
     * @returns {Promise<void>}
     */ async assignTargetEvents(target) {
        if (!target) return;
        target.querySelectorAll('[data-target]').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                el.blur();
                const target = el.getAttribute('data-target');
                const args = el.getAttribute('data-args') || false;
                if (target) try {
                    this.load(target, JSON.parse(args));
                } catch (e) {
                    this.load(target, args);
                }
            });
        });
    }
    /**
     * Asigna eventos a elementos con data-back
     * @async
     * @param {HTMLElement} target - Elemento contenedor
     * @returns {Promise<void>}
     */ async assingBackEvents(target) {
        if (!target) return;
        const controllerName = this.getCurrentControllerName(target);
        target.querySelectorAll('[data-back]').forEach((el)=>{
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopImmediatePropagation();
                this.loadPreviousPage(controllerName);
            });
        });
    }
    /**
     * Asigna observadores para elementos con data-save-status
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @param {HTMLElement} page - Elemento de la página
     * @returns {Promise<void>}
     */ async assignSaveStatusElementsEvents(controllerName, page) {
        const saveStatusElements = page.querySelectorAll('[data-save-status]');
        saveStatusElements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                mutations.forEach((mutation)=>{
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-status') this.setSavedStatusElements(controllerName, this.getSavedStatusElements(page));
                });
            });
            observer.observe(element, {
                attributes: true,
                attributeFilter: [
                    'data-status'
                ]
            });
        });
    }
    /**
     * Carga la página anterior del stack
     * @async
     * @param {string|false} currentControllerName - Nombre del controlador actual
     * @returns {Promise<null>}
     */ async loadPreviousPage(currentControllerName = false) {
        const stack = await this.stackManager.getStack();
        if (stack.length < 1) return null;
        const last = stack[stack.length - 1];
        if (currentControllerName && last.controllerName === currentControllerName) {
            if (stack.length < 2) return null;
            await this.stackManager.removeFromStack();
        }
        const updatedStack = await this.stackManager.getStack();
        const previous = updatedStack[updatedStack.length - 1];
        if (previous) await this.load(previous.controllerName, previous.args, previous.scrollPosition || 0);
        return null;
    }
    /**
     * Agrega una página al stack
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @param {Object|boolean} args - Argumentos
     * @param {number} scrollPosition - Posición de scroll
     * @returns {Promise<void>}
     */ async addToStack(controllerName, args = false, scrollPosition = 0) {
        return this.stackManager.addToStack(controllerName, args, scrollPosition);
    }
    /**
     * Remueve una página del stack
     * @async
     * @returns {Promise<void>}
     */ async removeFromStack() {
        return this.stackManager.removeFromStack();
    }
    /**
     * Establece los elementos con estado guardado
     * @async
     * @param {string} currentControllerName - Nombre del controlador actual
     * @param {Object} elementsStatus - Estados de los elementos
     * @returns {Promise<void>}
     */ async setSavedStatusElements(currentControllerName, elementsStatus) {
        return this.stackManager.setSavedStatusElements(currentControllerName, elementsStatus);
    }
    /**
    * Obtiene los elementos con estado guardado
    * @param {HTMLElement} page - Elemento de la página
    * @returns {Object} Objeto con los estados guardados
    */ getSavedStatusElements(page) {
        const elements = page.querySelectorAll('[data-save-status][data-status="open"]');
        const status = {};
        elements.forEach((el)=>{
            const key = el.getAttribute('data-save-status');
            const value = el.getAttribute('data-status');
            if (key) status[key] = value;
        });
        return status;
    }
    /**
     * Obtiene la última página restaurable
     * @async
     * @returns {Promise<Object|null>}
     */ async getLastRestorablePage() {
        return this.stackManager.getLastRestorablePage();
    }
    /**
     * Limpia el stack
     * @async
     * @returns {Promise<void>}
     */ async clearStack() {
        return this.stackManager.clearStack();
    }
    /**
     * Fuerza el preload de un controlador y template
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @param {string|null} templateFile - Ruta del template (opcional)
     * @returns {Promise<void>}
     */ async forcePreload(controllerName, templateFile) {
        try {
            await Promise.all([
                this.controllerLoader.preloadController(controllerName),
                templateFile ? this.preloadManager.preloadTemplate(templateFile) : Promise.resolve()
            ]);
            console.info(`[AppManager] Forced Preload Done: ${controllerName}`);
        } catch (error) {
            this.handleError(`Error Forced Preloading - ${controllerName}`, error);
        }
    }
    /**
     * Limpia el cache de preload
     */ clearPreload() {
        this.controllerLoader.controllerCache.clear();
        this.preloadManager.templateCache.clear();
        console.info('[AppManager] Preload Cache Cleared');
    }
    /**
     * Obtiene un controlador por nombre (con cache)
     * @async
     * @param {string} controllerName - Nombre del controlador
     * @returns {Promise<Object|null>} Módulo del controlador o null
     */ async getController(controllerName) {
        return this.controllerLoader.getController(controllerName);
    }
    /**
     * Obtiene el nombre del controlador actual
     * @param {HTMLElement|null} page - Elemento de la página (opcional)
     * @returns {string|null} Nombre del controlador o null
     */ getCurrentControllerName(page = null) {
        if (page) return page.getAttribute('data-controller') || null;
        const currentPage = document.querySelector('.app-page');
        return currentPage ? currentPage.getAttribute('data-controller') || null : null;
    }
    /**
     * Obtiene la versión del service worker (misma cadena que `version` en service-worker.js).
     * Usa `navigator.serviceWorker.ready` para no leer antes de que exista un worker activo
     * (p. ej. tras desregistrar y recargar, o si register() aún no terminó).
     * @async
     * @returns {Promise<string|null>} Versión o null
     */ async getVersion() {
        try {
            if (!('serviceWorker' in navigator)) return 0, $4KWEf.SERVICE_WORKER_CACHE_VERSION;
            let registration;
            try {
                registration = await navigator.serviceWorker.ready;
            } catch  {
                return 0, $4KWEf.SERVICE_WORKER_CACHE_VERSION;
            }
            if (!registration?.active) return 0, $4KWEf.SERVICE_WORKER_CACHE_VERSION;
            const versionFromSw = await new Promise((resolve)=>{
                const ms = 4000;
                const to = setTimeout(()=>resolve(null), ms);
                const messageChannel = new MessageChannel();
                messageChannel.port1.onmessage = (event)=>{
                    clearTimeout(to);
                    resolve(event.data?.version ?? null);
                };
                try {
                    registration.active.postMessage({
                        type: 'GET_VERSION'
                    }, [
                        messageChannel.port2
                    ]);
                } catch  {
                    clearTimeout(to);
                    resolve(null);
                }
            });
            return versionFromSw || (0, $4KWEf.SERVICE_WORKER_CACHE_VERSION);
        } catch (error) {
            this.handleError('Get Service Worker Version Error', error);
            return 0, $4KWEf.SERVICE_WORKER_CACHE_VERSION;
        }
    }
    /**
     * Guarda archivos en el cache del service worker
     * @async
     * @param {string[]} files - URLs de archivos a cachear
     * @returns {Promise<void>}
     */ async saveToCache(files = []) {
        if (!Array.isArray(files) || files.length === 0) return;
        if (!('caches' in window)) return;
        try {
            const version = await this.getVersion();
            if (!version) return;
            const cache = await caches.open(version);
            await Promise.allSettled(files.map((file)=>cache.add(file)));
        } catch (error) {
            this.handleError('Cache Save Error', error);
        }
    }
    /**
     * Maneja errores de forma centralizada
     * @param {string} message - Mensaje del error
     * @param {Error|*} error - Objeto de error
     */ handleError(message, error) {
        console.error(`[AppManager] ${message}`, error);
        const errorMessage = error instanceof Error ? error.message : error?.message || String(error);
        const isAuthError = errorMessage && (errorMessage.includes('401') || errorMessage.includes('Unauthorized') || errorMessage.includes('Authentication token not available') || errorMessage.includes('Token Incorrecto') || errorMessage.includes('Encabezado Auth Inexistente') || errorMessage.includes('Token Inexistente'));
        if (isAuthError) {
            console.warn('[AppManager] Authentication error detected, logging out');
            if (this.auth) this.auth.logout().catch((logoutError)=>{
                console.error('[AppManager] Error logging out', logoutError);
            });
        }
    }
}
var $572f0c6bf2810aa6$export$2e2bcd8739ae039 = $572f0c6bf2810aa6$var$AppManager;



var $cm03h = parcelRequire("cm03h");

var $bUw5l = parcelRequire("bUw5l");
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ''));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, '');
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? 'element' : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(',') : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = 'alert';
const $e9dd36436aec3b21$var$DATA_KEY$a = 'bs.alert';
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = 'button';
const $e9dd36436aec3b21$var$DATA_KEY$9 = 'bs.button';
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = '.data-api';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = 'swipe';
const $e9dd36436aec3b21$var$EVENT_KEY$9 = '.bs.swipe';
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = 'touch';
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = 'pen';
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = 'carousel';
const $e9dd36436aec3b21$var$DATA_KEY$8 = 'bs.carousel';
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = '.data-api';
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = 'next';
const $e9dd36436aec3b21$var$ORDER_PREV = 'prev';
const $e9dd36436aec3b21$var$DIRECTION_LEFT = 'left';
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = 'right';
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = 'carousel';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = 'slide';
const $e9dd36436aec3b21$var$CLASS_NAME_END = 'carousel-item-end';
const $e9dd36436aec3b21$var$CLASS_NAME_START = 'carousel-item-start';
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = '.active';
const $e9dd36436aec3b21$var$SELECTOR_ITEM = '.carousel-item';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = 'collapse';
const $e9dd36436aec3b21$var$DATA_KEY$7 = 'bs.collapse';
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = 'collapse';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $e9dd36436aec3b21$var$WIDTH = 'width';
const $e9dd36436aec3b21$var$HEIGHT = 'height';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = 'dropdown';
const $e9dd36436aec3b21$var$DATA_KEY$6 = 'bs.dropdown';
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = 'Escape';
const $e9dd36436aec3b21$var$TAB_KEY$1 = 'Tab';
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = 'dropup';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = 'dropend';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = 'dropstart';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = '.navbar';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? 'top-end' : 'top-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? 'top-start' : 'top-end';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? 'left-start' : 'right-start';
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? 'right-start' : 'left-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = 'top';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = 'backdrop';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = 'show';
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = 'focustrap';
const $e9dd36436aec3b21$var$DATA_KEY$5 = 'bs.focustrap';
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = 'Tab';
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = 'forward';
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = 'backward';
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $e9dd36436aec3b21$var$PROPERTY_PADDING = 'padding-right';
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = 'modal';
const $e9dd36436aec3b21$var$DATA_KEY$4 = 'bs.modal';
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = 'Escape';
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = 'modal-open';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = 'modal-static';
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = '.modal.show';
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = '.modal-dialog';
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = '.modal-body';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = 'offcanvas';
const $e9dd36436aec3b21$var$DATA_KEY$3 = 'bs.offcanvas';
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = 'Escape';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = 'showing';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = 'hiding';
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $e9dd36436aec3b21$var$OPEN_SELECTOR = '.offcanvas.show';
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = 'TemplateFactory';
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = 'tooltip';
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = 'modal';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $e9dd36436aec3b21$var$TRIGGER_HOVER = 'hover';
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = 'focus';
const $e9dd36436aec3b21$var$TRIGGER_CLICK = 'click';
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = 'manual';
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = 'hide';
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = 'hidden';
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = 'shown';
const $e9dd36436aec3b21$var$EVENT_INSERTED = 'inserted';
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = 'click';
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = 'focusin';
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = 'focusout';
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = 'mouseenter';
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = 'mouseleave';
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $e9dd36436aec3b21$var$isRTL() ? 'right' : 'left'
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = 'popover';
const $e9dd36436aec3b21$var$SELECTOR_TITLE = '.popover-header';
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = '.popover-body';
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = 'scrollspy';
const $e9dd36436aec3b21$var$DATA_KEY$2 = 'bs.scrollspy';
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = '.data-api';
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = '[href]';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = '.nav-link';
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = '.dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = 'tab';
const $e9dd36436aec3b21$var$DATA_KEY$1 = 'bs.tab';
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $e9dd36436aec3b21$var$ARROW_UP_KEY = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = 'ArrowDown';
const $e9dd36436aec3b21$var$HOME_KEY = 'Home';
const $e9dd36436aec3b21$var$END_KEY = 'End';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = 'show';
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = 'dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = 'toast';
const $e9dd36436aec3b21$var$DATA_KEY = 'bs.toast';
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = 'showing';
const $e9dd36436aec3b21$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);


(0, $bUw5l.install)('G-Z1TCCW3ELM', {
    'send_page_view': false
});
window.addEventListener('online', ()=>{
    let offlineToast = document.querySelector('.toast-offline');
    if (offlineToast) offlineToast.remove();
    document.body.classList.remove('app-offline');
    document.body.classList.add('app-online');
    if (window.App && window.App.initialized) window.App.load('trip', {
        _reload: true
    });
});
window.addEventListener('offline', ()=>{
    document.body.classList.remove('app-online');
    document.body.classList.add('app-offline');
    (0, $cm03h.Toast).show("No est\xe1s conectado a internet. Algunas acciones pueden estar desactivadas.", 'danger', true, false, 'toast-offline');
});
if (!navigator.onLine) document.body.classList.add('app-offline');
window.addEventListener('beforeinstallprompt', (event)=>{
    event.userChoice.then((response)=>{
        (0, $bUw5l.gtag)('event', 'add_to_home', {
            value: response.outcome
        });
    });
});
document.addEventListener('App:Rendered', async (e)=>{
    const splashEvent = new CustomEvent('App:Splashed');
    if (!document.body.dataset.appInitialized) {
        document.body.dataset.appInitialized = 'true';
        setTimeout(()=>{
            const splash = document.querySelector('.app-splash');
            splash.classList.add('animate__fadeOut');
            splash.addEventListener('animationend', (e)=>{
                e.target.remove();
            });
            document.dispatchEvent(splashEvent);
        }, 1200);
    } else document.dispatchEvent(splashEvent);
    let followLinks = document.querySelectorAll('.follow-link');
    if (followLinks) followLinks.forEach((link)=>{
        link.addEventListener('click', function(e) {
            e.preventDefault();
            window.open(this.href, '_blank', 'location=no');
        });
    });
    if (await window.App.auth.isAuthenticated()) {
        const supportBtn = document.querySelector('.open-support');
        if (supportBtn) {
            let phone = '5491159540923';
            const trip = await window.App.db.getTrip();
            if (trip.application.subprogram_id === 1) phone = '5491123913856';
            supportBtn.addEventListener('click', function(e) {
                e.preventDefault();
                window.open('whatsapp://send?phone=' + phone, '_system', 'hidden=yes');
            });
        }
    }
    const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
    const dropdownList = [
        ...dropdownElementList
    ].map((dropdownToggleEl)=>new $e9dd36436aec3b21$export$931cbfb6bfb85fc(dropdownToggleEl));
    const collapseElementList = document.querySelectorAll('.collapse');
    const collapseList = [
        ...collapseElementList
    ].map((collapseEl)=>new $e9dd36436aec3b21$export$78768a9af065a7b(collapseEl, {
            toggle: false
        }));
    const copyElements = document.querySelectorAll('.copy-clipboard');
    copyElements.forEach((element)=>{
        element.addEventListener('click', async function(e) {
            e.preventDefault();
            const text = this.dataset.text || this.textContent || this.innerText;
            if (!text || !text.trim()) return;
            try {
                await navigator.clipboard.writeText(text.trim());
                (0, $cm03h.Toast).show('Copiado', 'success');
            } catch (error) {
                (0, $cm03h.Toast).show('Error al Copiar', 'danger');
            }
        });
    });
});
var $86f3c1290e33b61e$export$798f88e18b87ff57 = {
    height: 300,
    playerVars: {
        enablejsapi: 1,
        controls: 1,
        modestbranding: 1,
        rel: 0,
        origin: "https://app.wetag.ar",
        showinfo: 0
    }
};



var $cm03h = parcelRequire("cm03h");
const $11488f63ad8f7044$var$SILENT_UPDATE_KEY = 'wetag-sw-silent-reload';
let $11488f63ad8f7044$var$nsw;
let $11488f63ad8f7044$var$swRegistration = null;
let $11488f63ad8f7044$var$updateToastShown = false;
let $11488f63ad8f7044$var$isCheckingUpdate = false;
let $11488f63ad8f7044$var$isActivating = false;
let $11488f63ad8f7044$var$initialCheckDone = false;
let $11488f63ad8f7044$var$lastUpdateSource = 'initial';
async function $11488f63ad8f7044$var$getRegistration() {
    return $11488f63ad8f7044$var$swRegistration ?? await navigator.serviceWorker.getRegistration();
}
/**
 * Activa el SW en waiting (siempre usa reg.waiting actual) y recarga la página.
 */ async function $11488f63ad8f7044$var$activateWaitingWorker() {
    if ($11488f63ad8f7044$var$isActivating) return;
    $11488f63ad8f7044$var$isActivating = true;
    try {
        const reg = await $11488f63ad8f7044$var$getRegistration();
        if (!reg?.waiting || !navigator.serviceWorker.controller) {
            sessionStorage.removeItem($11488f63ad8f7044$var$SILENT_UPDATE_KEY);
            window.location.reload();
            return;
        }
        const waiting = reg.waiting;
        await new Promise((resolve)=>{
            let settled = false;
            const finish = ()=>{
                if (settled) return;
                settled = true;
                resolve();
            };
            navigator.serviceWorker.addEventListener('controllerchange', finish, {
                once: true
            });
            try {
                waiting.postMessage({
                    type: 'SKIP_WAITING'
                });
            } catch (err) {
                console.error('SKIP_WAITING postMessage failed', err);
                finish();
                return;
            }
            setTimeout(finish, 3000);
        });
        sessionStorage.removeItem($11488f63ad8f7044$var$SILENT_UPDATE_KEY);
        window.location.reload();
    } catch (err) {
        console.error('activateWaitingWorker failed', err);
        $11488f63ad8f7044$var$isActivating = false;
        window.location.reload();
    }
}
function $11488f63ad8f7044$var$showUpdateToast() {
    if ($11488f63ad8f7044$var$updateToastShown) return;
    $11488f63ad8f7044$var$updateToastShown = true;
    (0, $cm03h.Toast).show("Hay una nueva versi\xf3n disponible, hac\xe9 click ac\xe1 para actualizar.", 'warning', true, function() {
        $11488f63ad8f7044$var$activateWaitingWorker();
    });
}
function $11488f63ad8f7044$var$handleWaitingWorker(source) {
    if (!navigator.serviceWorker.controller) return;
    if (source === 'initial') {
        if (sessionStorage.getItem($11488f63ad8f7044$var$SILENT_UPDATE_KEY)) {
            $11488f63ad8f7044$var$showUpdateToast();
            return;
        }
        sessionStorage.setItem($11488f63ad8f7044$var$SILENT_UPDATE_KEY, '1');
        $11488f63ad8f7044$var$activateWaitingWorker();
    } else $11488f63ad8f7044$var$showUpdateToast();
}
async function $11488f63ad8f7044$var$checkForServiceWorkerUpdate(source = 'focus') {
    if ($11488f63ad8f7044$var$isCheckingUpdate || $11488f63ad8f7044$var$isActivating) return;
    $11488f63ad8f7044$var$isCheckingUpdate = true;
    $11488f63ad8f7044$var$lastUpdateSource = source;
    try {
        const reg = await $11488f63ad8f7044$var$getRegistration();
        if (!reg) return;
        await reg.update();
        if (!reg.waiting) sessionStorage.removeItem($11488f63ad8f7044$var$SILENT_UPDATE_KEY);
        else if (navigator.serviceWorker.controller) $11488f63ad8f7044$var$handleWaitingWorker(source);
    } catch (err) {
        console.error('Service Worker update check failed', err);
    } finally{
        $11488f63ad8f7044$var$isCheckingUpdate = false;
    }
}
function $11488f63ad8f7044$var$onAppVisible() {
    if (!$11488f63ad8f7044$var$initialCheckDone) return;
    $11488f63ad8f7044$var$checkForServiceWorkerUpdate('focus');
}
var $c7d901ab34d46143$exports = {};
$c7d901ab34d46143$exports = import.meta.resolve("10JDG");


if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    const swPath = new URL($c7d901ab34d46143$exports).href;
    navigator.serviceWorker.register(swPath, {
        scope: '/',
        updateViaCache: 'none'
    }).then((registration)=>{
        $11488f63ad8f7044$var$swRegistration = registration;
        registration.addEventListener('updatefound', ()=>{
            const sourceForThisInstall = $11488f63ad8f7044$var$lastUpdateSource;
            $11488f63ad8f7044$var$nsw = registration.installing;
            if (!$11488f63ad8f7044$var$nsw) return;
            let handled = false;
            $11488f63ad8f7044$var$nsw.addEventListener('statechange', ()=>{
                if (handled || $11488f63ad8f7044$var$nsw.state !== 'installed' || !registration.waiting || !navigator.serviceWorker.controller) return;
                handled = true;
                $11488f63ad8f7044$var$handleWaitingWorker(sourceForThisInstall);
            });
        });
        return $11488f63ad8f7044$var$checkForServiceWorkerUpdate('initial');
    }).then(()=>{
        $11488f63ad8f7044$var$initialCheckDone = true;
    }).catch((err)=>console.error('Service Worker Error', err));
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') $11488f63ad8f7044$var$onAppVisible();
    });
    window.addEventListener('focus', $11488f63ad8f7044$var$onAppVisible);
    window.addEventListener('pageshow', (event)=>{
        if (event.persisted) $11488f63ad8f7044$var$onAppVisible();
    });
});



/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$h, getOwnPropertyNames: $27fcf98b67c2a783$var$r, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$b = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $27fcf98b67c2a783$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $27fcf98b67c2a783$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$r(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = (t)=>t, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$h = "$lit$", $e5ed8027d647799b$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$n = "?" + $e5ed8027d647799b$var$o, $e5ed8027d647799b$var$r = `<${$e5ed8027d647799b$var$n}>`, $e5ed8027d647799b$var$l = document, $e5ed8027d647799b$var$c = ()=>$e5ed8027d647799b$var$l.createComment(""), $e5ed8027d647799b$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$u = Array.isArray, $e5ed8027d647799b$var$d = (t)=>$e5ed8027d647799b$var$u(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$f = "[ \t\n\f\r]", $e5ed8027d647799b$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$f}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$f}*=${$e5ed8027d647799b$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$x(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$x(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$x(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$C = new WeakMap, $e5ed8027d647799b$var$P = $e5ed8027d647799b$var$l.createTreeWalker($e5ed8027d647799b$var$l, 129);
function $e5ed8027d647799b$var$V(t, i) {
    if (!$e5ed8027d647799b$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $e5ed8027d647799b$var$v ? "!--" === u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[1] ? c = $e5ed8027d647799b$var$m : void 0 !== u[2] ? ($e5ed8027d647799b$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$p) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$p ? ">" === u[0] ? (c = n ?? $e5ed8027d647799b$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$p : '"' === u[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : c === $e5ed8027d647799b$var$$ || c === $e5ed8027d647799b$var$g ? c = $e5ed8027d647799b$var$p : c === $e5ed8027d647799b$var$_ || c === $e5ed8027d647799b$var$m ? c = $e5ed8027d647799b$var$v : (c = $e5ed8027d647799b$var$p, n = void 0);
        const x = c === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$v ? s + $e5ed8027d647799b$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $e5ed8027d647799b$var$h + s.slice(d) + $e5ed8027d647799b$var$o + x) : s + $e5ed8027d647799b$var$o + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$N(t, i);
        if (this.el = $e5ed8027d647799b$var$S.createElement(f, e), $e5ed8027d647799b$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$I : "?" === e[1] ? $e5ed8027d647799b$var$L : "@" === e[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$y.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $e5ed8027d647799b$var$c()), $e5ed8027d647799b$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $e5ed8027d647799b$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $e5ed8027d647799b$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$M(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$l).importNode(i, !0);
        $e5ed8027d647799b$var$P.currentNode = e;
        let h = $e5ed8027d647799b$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $e5ed8027d647799b$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $e5ed8027d647799b$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $e5ed8027d647799b$var$P.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$P.currentNode = $e5ed8027d647799b$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$M(this, t, i), $e5ed8027d647799b$var$a(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$S.createElement($e5ed8027d647799b$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$C.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$C.set(t.strings, i = new $e5ed8027d647799b$var$S(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$k(this.O($e5ed8027d647799b$var$c()), this.O($e5ed8027d647799b$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $e5ed8027d647799b$var$i(t).nextSibling;
            $e5ed8027d647799b$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$M(this, t, i, 0), o = !$e5ed8027d647799b$var$a(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$M(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$a(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$M(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$M(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$h,
    P: $e5ed8027d647799b$var$o,
    A: $e5ed8027d647799b$var$n,
    C: 1,
    L: $e5ed8027d647799b$var$N,
    R: $e5ed8027d647799b$var$R,
    D: $e5ed8027d647799b$var$d,
    V: $e5ed8027d647799b$var$M,
    I: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$H,
    N: $e5ed8027d647799b$var$L,
    U: $e5ed8027d647799b$var$z,
    B: $e5ed8027d647799b$var$I,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$B?.($e5ed8027d647799b$var$S, $e5ed8027d647799b$var$k), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.2");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$k(i.insertBefore($e5ed8027d647799b$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fe586ba0757c37f7$var$s = globalThis;
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, $fe586ba0757c37f7$var$s.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$o = $fe586ba0757c37f7$var$s.litElementPolyfillSupport;
$fe586ba0757c37f7$var$o?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($fe586ba0757c37f7$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $27fcf98b67c2a783$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $27fcf98b67c2a783$export$53a6892c50694894)
}, $b2fdcbe153c88f81$export$8d623b1670eb40f4 = (t = $b2fdcbe153c88f81$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $b2fdcbe153c88f81$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $b2fdcbe153c88f81$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(r) {
    return (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $15c76e2f7983b497$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $15c76e2f7983b497$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $24ba95ebfbdcf6b8$var$e;
function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $15c76e2f7983b497$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($24ba95ebfbdcf6b8$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $15c76e2f7983b497$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $43ca3aec390b0561$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $15c76e2f7983b497$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $15c76e2f7983b497$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e5c059fc79abe53$export$56cc687933817664 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});




var $eed90f3bb627ac73$var$l = {
    d: (e, t)=>{
        for(var a in t)$eed90f3bb627ac73$var$l.o(t, a) && !$eed90f3bb627ac73$var$l.o(e, a) && Object.defineProperty(e, a, {
            enumerable: !0,
            get: t[a]
        });
    },
    o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t),
    r: (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }
}, $eed90f3bb627ac73$var$i = {};
$eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$i, {
    k: ()=>$eed90f3bb627ac73$var$Ze
});
var $eed90f3bb627ac73$var$o = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$o), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$o, {
    templates: ()=>$eed90f3bb627ac73$var$ee
});
var $eed90f3bb627ac73$var$s = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$s), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$s, {
    templates: ()=>$eed90f3bb627ac73$var$te
});
var $eed90f3bb627ac73$var$n = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$n), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$n, {
    templates: ()=>$eed90f3bb627ac73$var$ae
});
var $eed90f3bb627ac73$var$r = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$r), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$r, {
    templates: ()=>$eed90f3bb627ac73$var$le
});
var $eed90f3bb627ac73$var$d = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$d), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$d, {
    templates: ()=>$eed90f3bb627ac73$var$ie
});
var $eed90f3bb627ac73$var$p = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$p), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$p, {
    templates: ()=>$eed90f3bb627ac73$var$oe
});
var $eed90f3bb627ac73$var$c = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$c), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$c, {
    templates: ()=>$eed90f3bb627ac73$var$se
});
var $eed90f3bb627ac73$var$b = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$b), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$b, {
    templates: ()=>$eed90f3bb627ac73$var$ne
});
var $eed90f3bb627ac73$var$g = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$g), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$g, {
    templates: ()=>$eed90f3bb627ac73$var$re
});
var $eed90f3bb627ac73$var$h = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$h), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$h, {
    templates: ()=>$eed90f3bb627ac73$var$de
});
var $eed90f3bb627ac73$var$m = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$m), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$m, {
    templates: ()=>$eed90f3bb627ac73$var$pe
});
var $eed90f3bb627ac73$var$f = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$f), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$f, {
    templates: ()=>$eed90f3bb627ac73$var$ce
});
var $eed90f3bb627ac73$var$u = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$u), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$u, {
    templates: ()=>$eed90f3bb627ac73$var$be
});
var $eed90f3bb627ac73$var$w = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$w), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$w, {
    templates: ()=>$eed90f3bb627ac73$var$ge
});
var $eed90f3bb627ac73$var$v = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$v), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$v, {
    templates: ()=>$eed90f3bb627ac73$var$he
});
var $eed90f3bb627ac73$var$y = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$y), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$y, {
    templates: ()=>$eed90f3bb627ac73$var$me
});
var $eed90f3bb627ac73$var$x = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$x), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$x, {
    templates: ()=>$eed90f3bb627ac73$var$fe
});
var $eed90f3bb627ac73$var$k = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$k), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$k, {
    templates: ()=>$eed90f3bb627ac73$var$ue
});
var $eed90f3bb627ac73$var$D = {};
$eed90f3bb627ac73$var$l.r($eed90f3bb627ac73$var$D), $eed90f3bb627ac73$var$l.d($eed90f3bb627ac73$var$D, {
    templates: ()=>$eed90f3bb627ac73$var$we
});
const $eed90f3bb627ac73$var$A = ((e)=>{
    var t = {};
    return $eed90f3bb627ac73$var$l.d(t, e), t;
})({
    LitElement: ()=>$fe586ba0757c37f7$export$3f2f9f5909897157,
    css: ()=>$3233927aa82734f9$export$dbf350e5966cf602,
    html: ()=>$e5ed8027d647799b$export$c0bb0b647f701bb5
}), $eed90f3bb627ac73$var$E = (e, t, a)=>{
    let l = e[0];
    for(let i = 1; i < e.length; i++)l += t[a ? a[i - 1] : i - 1], l += e[i];
    return l;
}, $eed90f3bb627ac73$var$_ = (e)=>{
    var t;
    return "string" != typeof (t = e) && "strTag" in t ? $eed90f3bb627ac73$var$E(e.strings, e.values) : e;
}, $eed90f3bb627ac73$var$j = "lit-localize-status";
class $eed90f3bb627ac73$var$z {
    constructor(e){
        this.__litLocalizeEventHandler = (e)=>{
            "ready" === e.detail.status && this.host.requestUpdate();
        }, this.host = e;
    }
    hostConnected() {
        window.addEventListener($eed90f3bb627ac73$var$j, this.__litLocalizeEventHandler);
    }
    hostDisconnected() {
        window.removeEventListener($eed90f3bb627ac73$var$j, this.__litLocalizeEventHandler);
    }
}
const $eed90f3bb627ac73$var$S = (e)=>e.addController(new $eed90f3bb627ac73$var$z(e));
class $eed90f3bb627ac73$var$P {
    constructor(){
        this.settled = !1, this.promise = new Promise((e, t)=>{
            this._resolve = e, this._reject = t;
        });
    }
    resolve(e) {
        this.settled = !0, this._resolve(e);
    }
    reject(e) {
        this.settled = !0, this._reject(e);
    }
}
const $eed90f3bb627ac73$var$L = [];
for(let e = 0; e < 256; e++)$eed90f3bb627ac73$var$L[e] = (e >> 4 & 15).toString(16) + (15 & e).toString(16);
const $eed90f3bb627ac73$var$$ = "", $eed90f3bb627ac73$var$I = "h", $eed90f3bb627ac73$var$C = "s";
function $eed90f3bb627ac73$var$R(e, t) {
    return (t ? $eed90f3bb627ac73$var$I : $eed90f3bb627ac73$var$C) + function(e) {
        let t = 0, a = 8997, l = 0, i = 33826, o = 0, s = 40164, n = 0, r = 52210;
        for(let d = 0; d < e.length; d++)a ^= e.charCodeAt(d), t = 435 * a, l = 435 * i, o = 435 * s, n = 435 * r, o += a << 8, n += i << 8, l += t >>> 16, a = 65535 & t, o += l >>> 16, i = 65535 & l, r = n + (o >>> 16) & 65535, s = 65535 & o;
        return $eed90f3bb627ac73$var$L[r >> 8] + $eed90f3bb627ac73$var$L[255 & r] + $eed90f3bb627ac73$var$L[s >> 8] + $eed90f3bb627ac73$var$L[255 & s] + $eed90f3bb627ac73$var$L[i >> 8] + $eed90f3bb627ac73$var$L[255 & i] + $eed90f3bb627ac73$var$L[a >> 8] + $eed90f3bb627ac73$var$L[255 & a];
    }("string" == typeof e ? e : e.join($eed90f3bb627ac73$var$$));
}
const $eed90f3bb627ac73$var$M = new WeakMap, $eed90f3bb627ac73$var$T = new Map;
function $eed90f3bb627ac73$var$H(e, t, a) {
    if (e) {
        const l = a?.id ?? function(e) {
            const t = "string" == typeof e ? e : e.strings;
            let a = $eed90f3bb627ac73$var$T.get(t);
            void 0 === a && (a = $eed90f3bb627ac73$var$R(t, "string" != typeof e && !("strTag" in e)), $eed90f3bb627ac73$var$T.set(t, a));
            return a;
        }(t), i = e[l];
        if (i) {
            if ("string" == typeof i) return i;
            if ("strTag" in i) return $eed90f3bb627ac73$var$E(i.strings, t.values, i.values);
            {
                let e = $eed90f3bb627ac73$var$M.get(i);
                return void 0 === e && (e = i.values, $eed90f3bb627ac73$var$M.set(i, e)), {
                    ...i,
                    values: e.map((e)=>t.values[e])
                };
            }
        }
    }
    return $eed90f3bb627ac73$var$_(t);
}
function $eed90f3bb627ac73$var$O(e) {
    window.dispatchEvent(new CustomEvent($eed90f3bb627ac73$var$j, {
        detail: e
    }));
}
let $eed90f3bb627ac73$var$B, $eed90f3bb627ac73$var$q, $eed90f3bb627ac73$var$U, $eed90f3bb627ac73$var$Y, $eed90f3bb627ac73$var$Z, $eed90f3bb627ac73$var$W = "", $eed90f3bb627ac73$var$N = new $eed90f3bb627ac73$var$P;
$eed90f3bb627ac73$var$N.resolve();
let $eed90f3bb627ac73$var$V = 0;
const $eed90f3bb627ac73$var$F = ()=>$eed90f3bb627ac73$var$W, $eed90f3bb627ac73$var$G = (e)=>{
    if (e === ($eed90f3bb627ac73$var$B ?? $eed90f3bb627ac73$var$W)) return $eed90f3bb627ac73$var$N.promise;
    if (!$eed90f3bb627ac73$var$U || !$eed90f3bb627ac73$var$Y) throw Error("Internal error");
    if (!$eed90f3bb627ac73$var$U.has(e)) throw Error("Invalid locale code");
    $eed90f3bb627ac73$var$V++;
    const t = $eed90f3bb627ac73$var$V;
    $eed90f3bb627ac73$var$B = e, $eed90f3bb627ac73$var$N.settled && ($eed90f3bb627ac73$var$N = new $eed90f3bb627ac73$var$P), $eed90f3bb627ac73$var$O({
        status: "loading",
        loadingLocale: e
    });
    return (e === $eed90f3bb627ac73$var$q ? Promise.resolve({
        templates: void 0
    }) : $eed90f3bb627ac73$var$Y(e)).then((a)=>{
        $eed90f3bb627ac73$var$V === t && ($eed90f3bb627ac73$var$W = e, $eed90f3bb627ac73$var$B = void 0, $eed90f3bb627ac73$var$Z = a.templates, $eed90f3bb627ac73$var$O({
            status: "ready",
            readyLocale: e
        }), $eed90f3bb627ac73$var$N.resolve());
    }, (a)=>{
        $eed90f3bb627ac73$var$V === t && ($eed90f3bb627ac73$var$O({
            status: "error",
            errorLocale: e,
            errorMessage: a.toString()
        }), $eed90f3bb627ac73$var$N.reject(a));
    }), $eed90f3bb627ac73$var$N.promise;
};
let $eed90f3bb627ac73$var$J = $eed90f3bb627ac73$var$_, $eed90f3bb627ac73$var$K = !1;
const $eed90f3bb627ac73$var$Q = ((e)=>{
    var t = {};
    return $eed90f3bb627ac73$var$l.d(t, e), t;
})({
    customElement: ()=>$07706bf0c990b886$export$da64fc29f17f9d0e,
    property: ()=>$b2fdcbe153c88f81$export$d541bacb2bda4494,
    state: ()=>$7162e77b40ffab5c$export$ca000e230c0caa3e
}), $eed90f3bb627ac73$var$X = [
    "cs",
    "de",
    "el",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "nl",
    "no",
    "pl",
    "pt",
    "ru",
    "sr",
    "sv",
    "tr",
    "uk",
    "zh",
    "zh-CN"
], $eed90f3bb627ac73$var$ee = {
    s182ab2d6c997515f: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0435\u0433\u043E \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.",
    s1b9047d53d9f9d22: '2) \u041D\u0430\u0436\u0430\u0442\u044C "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"',
    s37a9e8aec5713460: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    s5c6aad7a7e4a1437: '3) \u041D\u0430\u0436\u0430\u0442\u044C "\u041D\u0430 \u044D\u043A\u0440\u0430\u043D \xab\u0414\u043E\u043C\u043E\u0439\xbb"',
    s6196153c4b0c1ea0: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
    s922329d6f6213590: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 Dock",
    sa5ef80b4bb9b39f8: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    sa7551383d1897fcc: '2) \u041D\u0430\u0436\u043C\u0438\u0442\u0435 "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 Dock"',
    sba52286c21552a4e: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u044D\u0442\u043E \u043D\u0430 \u0432\u0430\u0448\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.",
    sc79fd7641eb9a975: "\u0421\u043F\u0440\u044F\u0442\u0430\u0442\u044C \u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E",
    scdaf4bbff76674c8: "\u041D\u0430 \u044D\u043A\u0440\u0430\u043D \xab\u0414\u043E\u043C\u043E\u0439\xbb",
    sdfe23506a3b0cdc8: "1) \u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Safari \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435",
    se740f75b95a51807: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0435\u0433\u043E \u0432 Dock, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.",
    sfea652f6580ff086: "\u042D\u0442\u043E\u0442 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442 \u0438\u043C\u0435\u0435\u0442 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F."
}, $eed90f3bb627ac73$var$te = {
    s182ab2d6c997515f: "Daha iyi bir deneyim ve kolay eri\u015Fim i\xe7in Ana Ekran\u0131n\u0131za ekleyin.",
    s1b9047d53d9f9d22: "2) Gezinme \xe7ubu\u011Funda Payla\u015F'a bas\u0131n",
    s37a9e8aec5713460: "Daha Fazla",
    s5c6aad7a7e4a1437: "3) Ana Ekrana Ekle'ye bas\u0131n",
    s6196153c4b0c1ea0: "Y\xfckle",
    s922329d6f6213590: "Dock\u2019a Ekle",
    sa5ef80b4bb9b39f8: "K\xfc\xe7\xfclt",
    sa7551383d1897fcc: "2) Dock\u2019a ekleye bas\u0131n",
    sba52286c21552a4e: "Daha iyi bir deneyim ve kolay eri\u015Fim i\xe7in cihaz\u0131n\u0131za y\xfckleyin.",
    sc79fd7641eb9a975: "Talimatlar\u0131 gizle",
    scdaf4bbff76674c8: "Ana Ekrana Ekle",
    sdfe23506a3b0cdc8: "1) Safari taray\u0131c\u0131s\u0131nda a\xe7\u0131n",
    se740f75b95a51807: "Daha iyi bir deneyim ve kolay eri\u015Fim i\xe7in Dock\u2019a ekleyin.",
    sfea652f6580ff086: "Bu site uygulama i\u015Flevselli\u011Fine sahiptir."
}, $eed90f3bb627ac73$var$ae = {
    s182ab2d6c997515f: "F\xfcgen Sie es zu Ihrem Startbildschirm hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.",
    s1b9047d53d9f9d22: "2) Dr\xfccken Sie auf Teilen in der Navigationsleiste",
    s37a9e8aec5713460: "Mehr",
    s5c6aad7a7e4a1437: "3) Dr\xfccken Sie Hinzuf\xfcgen zum Startbildschirm",
    s6196153c4b0c1ea0: "Installieren",
    s922329d6f6213590: "Zum Dock hinzuf\xfcgen",
    sa5ef80b4bb9b39f8: "Weniger",
    sa7551383d1897fcc: "2) Dr\xfccken Sie auf Zum Dock hinzuf\xfcgen",
    sba52286c21552a4e: "Installieren Sie es auf Ihrem Ger\xe4t f\xfcr eine umfassende Erfahrung und einen leichten Zugriff.",
    sc79fd7641eb9a975: "Anleitung ausblenden",
    scdaf4bbff76674c8: "Hinzuf\xfcgen zum Startbildschirm",
    sdfe23506a3b0cdc8: "1) In Safari-Browser \xf6ffnen",
    se740f75b95a51807: "F\xfcgen Sie es zu Ihrem Dock hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.",
    sfea652f6580ff086: "Diese Website verf\xfcgt \xfcber App-Funktionalit\xe4t."
}, $eed90f3bb627ac73$var$le = {
    s182ab2d6c997515f: "A\xf1\xe1delo a tu pantalla de inicio para una experiencia amplia y acceso f\xe1cil.",
    s1b9047d53d9f9d22: "2) Presionar Compartir en la barra de direcciones",
    s37a9e8aec5713460: "M\xe1s",
    s5c6aad7a7e4a1437: "3) Presionar A\xf1adir a pantalla de inicio",
    s6196153c4b0c1ea0: "Instalar",
    s922329d6f6213590: "A\xf1adir al Dock",
    sa5ef80b4bb9b39f8: "Menos",
    sa7551383d1897fcc: "2) Presionar A\xf1adir al Dock",
    sba52286c21552a4e: "Inst\xe1lalo en tu dispositivo para una experiencia amplia y acceso f\xe1cil.",
    sc79fd7641eb9a975: "Esconder instrucciones",
    scdaf4bbff76674c8: "A\xf1adir a pantalla de inicio",
    sdfe23506a3b0cdc8: "1) Abrir en el navegador web Safari",
    se740f75b95a51807: "A\xf1\xe1delo a tu Dock para una experiencia amplia y acceso f\xe1cil.",
    sfea652f6580ff086: "Este sitio tiene funcionalidad de aplicaci\xf3n."
}, $eed90f3bb627ac73$var$ie = {
    s182ab2d6c997515f: "Voeg het toe aan je startscherm voor een uitgebreide ervaring en gemakkelijke toegang.",
    s1b9047d53d9f9d22: "2) Druk op delen in de navigatiebalk",
    s37a9e8aec5713460: "Meer",
    s5c6aad7a7e4a1437: "3) Druk op Toevoegen aan het startscherm",
    s6196153c4b0c1ea0: "Installeren",
    s922329d6f6213590: "Toevoegen aan Dock",
    sa5ef80b4bb9b39f8: "Minder",
    sa7551383d1897fcc: "2) Druk op Toevoegen aan Dock",
    sba52286c21552a4e: "Installeer het op je apparaat voor een uitgebreide ervaring en gemakkelijke toegang.",
    sc79fd7641eb9a975: "Instructie verbergen",
    scdaf4bbff76674c8: "Toevoegen aan het startscherm",
    sdfe23506a3b0cdc8: "1) Open in Safari-browser",
    se740f75b95a51807: "Voeg het toe aan je Dock voor een uitgebreide ervaring en makkelijke toegang.",
    sfea652f6580ff086: "Deze site heeft app-functionaliteit."
}, $eed90f3bb627ac73$var$oe = {
    s182ab2d6c997515f: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03C4\u03B7\u03BD \u03BF\u03B8\u03CC\u03BD\u03B7 \u0391\u03C6\u03B5\u03C4\u03B7\u03C1\u03AF\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03BA\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7.",
    s1b9047d53d9f9d22: "2) \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u039A\u03BF\u03B9\u03BD\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE \u03C0\u03BB\u03BF\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2",
    s37a9e8aec5713460: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1",
    s5c6aad7a7e4a1437: "3) \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B7\u03BD \u03BF\u03B8\u03CC\u03BD\u03B7 \u0391\u03C6\u03B5\u03C4\u03B7\u03C1\u03AF\u03B1\u03C2",
    s6196153c4b0c1ea0: "\u0395\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7",
    s922329d6f6213590: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B7\u03BD \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7",
    sa5ef80b4bb9b39f8: "\u039B\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1",
    sa7551383d1897fcc: "2) \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B7\u03BD \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7",
    sba52286c21552a4e: "\u0395\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03BA\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7.",
    sc79fd7641eb9a975: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u039F\u03B4\u03B7\u03B3\u03B9\u03CE\u03BD",
    scdaf4bbff76674c8: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B7\u03BD \u039F\u03B8\u03CC\u03BD\u03B7 \u0391\u03C6\u03B5\u03C4\u03B7\u03C1\u03AF\u03B1\u03C2",
    sdfe23506a3b0cdc8: "1) \u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03C4\u03AE Safari",
    se740f75b95a51807: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03C4\u03B7\u03BD \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03BA\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7.",
    sfea652f6580ff086: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03BF\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03B9\u03BA\u03AE \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2."
}, $eed90f3bb627ac73$var$se = {
    s182ab2d6c997515f: "Ajoutez-le \xe0 votre \xe9cran d'accueil pour une exp\xe9rience \xe9tendue et un acc\xe8s facile.",
    s1b9047d53d9f9d22: "2) Appuyez sur Partager dans la barre de navigation",
    s37a9e8aec5713460: "Plus",
    s5c6aad7a7e4a1437: "3) Appuyez sur Ajouter \xe0 l'\xe9cran d'accueil",
    s6196153c4b0c1ea0: "Installer",
    s922329d6f6213590: "Ajouter au Dock",
    sa5ef80b4bb9b39f8: "Moins",
    sa7551383d1897fcc: "2) Appuyez sur Ajouter au Dock",
    sba52286c21552a4e: "Installez-le sur votre appareil pour une exp\xe9rience compl\xe8te et un acc\xe8s facile.",
    sc79fd7641eb9a975: "Masquer les instructions",
    scdaf4bbff76674c8: "Ajouter \xe0 l'\xe9cran d'accueil",
    sdfe23506a3b0cdc8: "1) Ouvrir dans le navigateur Safari",
    se740f75b95a51807: "Ajoutez-le \xe0 votre Dock pour une exp\xe9rience \xe9tendue et un acc\xe8s facile.",
    sfea652f6580ff086: "Ce site poss\xe8de des fonctionnalit\xe9s d'application."
}, $eed90f3bb627ac73$var$ne = {
    s182ab2d6c997515f: "\u0414\u043E\u0434\u0430\u0458\u0442\u0435 \u0433\u0430 \u043D\u0430 Home Screen \u0437\u0430 \u0448\u0438\u0440\u043E\u043A\u0435 \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u0438 \u043B\u0430\u043A \u043F\u0440\u0438\u0441\u0442\u0443\u043F.",
    s1b9047d53d9f9d22: "2) \u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 Share \u0443 \u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043E\u0458 \u0442\u0440\u0430\u0446\u0438",
    s37a9e8aec5713460: "\u0412\u0438\u0448\u0435",
    s5c6aad7a7e4a1437: "3) \u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 Add to Home Screen",
    s6196153c4b0c1ea0: "\u0418\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0458",
    sa5ef80b4bb9b39f8: "\u041C\u0430\u045A\u0435",
    sa7551383d1897fcc: "3) \u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 Add to Dock",
    sba52286c21552a4e: "\u0418\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0458\u0442\u0435 \u0433\u0430 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0440\u0435\u0452\u0430\u0458\u0443 \u0437\u0430 \u0448\u0438\u0440\u043E\u043A\u0435 \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u0438 \u043B\u0430\u043A \u043F\u0440\u0438\u0441\u0442\u0443\u043F.",
    sc79fd7641eb9a975: "\u0421\u0430\u043A\u0440\u0438\u0458 \u0443\u043F\u0443\u0442\u0441\u0442\u0432\u043E",
    sdfe23506a3b0cdc8: "1) \u041E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u0443 Safari \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0447\u0443",
    se740f75b95a51807: "\u0414\u043E\u0434\u0430\u0458\u0442\u0435 \u0433\u0430 \u0443 \u0432\u0430\u0448\u0443 Dock \u0437\u0430 \u0448\u0438\u0440\u043E\u043A\u0435 \u043C\u043E\u0433\u0443\u045B\u043D\u043E\u0441\u0442\u0438 \u0438 \u043B\u0430\u043A \u043F\u0440\u0438\u0441\u0442\u0443\u043F.",
    sfea652f6580ff086: "\u041E\u0432\u0430\u0458 \u0441\u0430\u0458\u0442 \u0438\u043C\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043D\u043E\u0441\u0442 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0435.",
    s922329d6f6213590: "Add to Dock",
    scdaf4bbff76674c8: "Add to Home Screen"
}, $eed90f3bb627ac73$var$re = {
    s182ab2d6c997515f: "Dodaj do swojego Ekranu G\u0142\xf3wnego, aby uzyska\u0107 bogate do\u015Bwiadczenie i \u0142atwy dost\u0119p.",
    s1b9047d53d9f9d22: '2) Wybierz "Udost\u0119pnij"',
    s37a9e8aec5713460: "Wi\u0119cej",
    s5c6aad7a7e4a1437: '3) Wybierz "Dodaj do Ekranu G\u0142\xf3wnego"',
    s6196153c4b0c1ea0: "Zainstaluj",
    s922329d6f6213590: "Dodaj do Docka",
    sa5ef80b4bb9b39f8: "Mniej",
    sa7551383d1897fcc: '2) Wybierz "Dodaj do Docka"',
    sba52286c21552a4e: "Zainstaluj na swoim urz\u0105dzeniu, aby uzyska\u0107 bogate do\u015Bwiadczenie i \u0142atwy dost\u0119p.",
    sc79fd7641eb9a975: "Ukryj instrukcj\u0119",
    scdaf4bbff76674c8: "Dodaj do Ekranu G\u0142\xf3wnego",
    sdfe23506a3b0cdc8: "1) Otw\xf3rz przegl\u0105dark\u0119 Safari",
    se740f75b95a51807: "Dodaj do swojego Docka, aby uzyska\u0107 bogate do\u015Bwiadczenie i \u0142atwy dost\u0119p.",
    sfea652f6580ff086: "Ta strona posiada funkcje aplikacji."
}, $eed90f3bb627ac73$var$de = {
    s182ab2d6c997515f: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043D\u0430 \u0414\u043E\u043C\u0430\u0448\u043D\u0456\u0439 \u0435\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0437\u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0442\u0430 \u0448\u0438\u0440\u0448\u0438\u0445 \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439.",
    s1b9047d53d9f9d22: "2) \u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \xab\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F\xbb",
    s37a9e8aec5713460: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0456\u0448\u0435",
    s5c6aad7a7e4a1437: "3) \u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \xab\u041D\u0430 \u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0435\u043A\u0440\u0430\u043D\xbb",
    s6196153c4b0c1ea0: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438",
    s922329d6f6213590: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u0430 Dock",
    sa5ef80b4bb9b39f8: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
    sa7551383d1897fcc: "2) \u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \xab\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u0430 Dock\xbb",
    sba52286c21552a4e: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0456\u0442\u044C \u043D\u0430 \u0432\u0430\u0448 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u0434\u043B\u044F \u0437\u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0442\u0430 \u0448\u0438\u0440\u0448\u0438\u0445 \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439.",
    sc79fd7641eb9a975: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0406\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u044E",
    scdaf4bbff76674c8: "\u041D\u0430 \u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u044D\u043A\u0440\u0430\u043D",
    sdfe23506a3b0cdc8: "1) \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 Safari \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456",
    se740f75b95a51807: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u044C Dock \u0434\u043B\u044F \u0437\u0440\u0443\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0442\u0430 \u0448\u0438\u0440\u0448\u0438\u0445 \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439.",
    sfea652f6580ff086: "\u0426\u0435\u0439 \u0441\u0430\u0439\u0442 \u043C\u0430\u0454 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0434\u043E\u0434\u0430\u0442\u043A\u0443."
}, $eed90f3bb627ac73$var$pe = {
    s182ab2d6c997515f: "\u5C07\u5176\u52A0\u5165\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u7372\u5F97\u66F4\u8C50\u5BCC\u7684\u9AD4\u9A57\u548C\u4FBF\u6377\u8A2A\u554F\u3002",
    s1b9047d53d9f9d22: "2) \u9EDE\u64CA\u5217\u8868\u4E0A\u7684\u5206\u4EAB\u6309\u9215",
    s37a9e8aec5713460: "\u8A73\u7D30\u8CC7\u8A0A",
    s5c6aad7a7e4a1437: "3) \u9EDE\u64CA\u52A0\u5165\u4E3B\u756B\u9762",
    s6196153c4b0c1ea0: "\u5B89\u88DD",
    s922329d6f6213590: "\u6DFB\u52A0\u5230Dock\u6B04",
    sa5ef80b4bb9b39f8: "\u7C21\u77ED\u8CC7\u8A0A",
    sa7551383d1897fcc: "2) \u9EDE\u9078\u6DFB\u52A0\u5230Dock\u6B04",
    sba52286c21552a4e: "\u5728\u60A8\u7684\u88DD\u7F6E\u4E0A\u5B89\u88DD\u5B83\uFF0C\u4EE5\u7372\u5F97\u66F4\u8C50\u5BCC\u7684\u9AD4\u9A57\u548C\u4FBF\u6377\u8A2A\u554F\u3002",
    sc79fd7641eb9a975: "\u96B1\u85CF\u5B89\u88DD\u6D41\u7A0B",
    scdaf4bbff76674c8: "\u5C07App\u52A0\u5165\u4E3B\u756B\u9762",
    sdfe23506a3b0cdc8: "1) \u5728Safari\u4E0A\u700F\u89BD\u6B64\u7DB2\u9801",
    se740f75b95a51807: "\u5C07\u5176\u52A0\u5165\u4F60\u7684Dock\u6B04\uFF0C\u4EE5\u7372\u5F97\u66F4\u8C50\u5BCC\u7684\u9AD4\u9A57\u548C\u4FBF\u6377\u8A2A\u554F\u3002",
    sfea652f6580ff086: "\u6B64\u7DB2\u7AD9\u5177\u6709\u61C9\u7528\u7A0B\u5F0F\u529F\u80FD\u3002"
}, $eed90f3bb627ac73$var$ce = {
    s182ab2d6c997515f: "\u5C06\u5176\u6DFB\u52A0\u5230\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u4EAB\u53D7\u66F4\u5168\u9762\u7684\u4F53\u9A8C\u5E76\u4FBF\u4E8E\u8BBF\u95EE\u3002",
    s1b9047d53d9f9d22: "2) \u70B9\u51FB\u5217\u8868\u4E0A\u7684\u5206\u4EAB\u6309\u94AE",
    s37a9e8aec5713460: "\u8BE6\u7EC6\u8D44\u8BAF",
    s5c6aad7a7e4a1437: "3) \u70B9\u51FB\u52A0\u5165\u4E3B\u753B\u9762",
    s6196153c4b0c1ea0: "\u5B89\u88C5",
    s922329d6f6213590: "\u6DFB\u52A0\u5230Dock",
    sa5ef80b4bb9b39f8: "\u7B80\u77ED\u8D44\u8BAF",
    sa7551383d1897fcc: "2) \u6309\u4E0B\u6DFB\u52A0\u5230Dock",
    sba52286c21552a4e: "\u5728\u60A8\u7684\u8BBE\u5907\u4E0A\u5B89\u88C5\uFF0C\u4EE5\u4EAB\u6709\u66F4\u5168\u9762\u7684\u4F53\u9A8C\u548C\u4FBF\u6377\u7684\u8BBF\u95EE\u3002",
    sc79fd7641eb9a975: "\u9690\u85CF\u5B89\u88C5\u6D41\u7A0B",
    scdaf4bbff76674c8: "\u5C06App\u52A0\u5165\u4E3B\u753B\u9762",
    sdfe23506a3b0cdc8: "1) \u5728Safari\u4E0A\u6D4F\u89C8\u6B64\u7F51\u9875",
    se740f75b95a51807: "\u5C06\u5176\u6DFB\u52A0\u5230\u60A8\u7684Dock\uFF0C\u4EE5\u4EAB\u53D7\u66F4\u5168\u9762\u7684\u4F53\u9A8C\u5E76\u4FBF\u4E8E\u8BBF\u95EE\u3002",
    sfea652f6580ff086: "\u6B64\u7F51\u7AD9\u5177\u5907app\u7684\u529F\u80FD\u6027\u3002"
}, $eed90f3bb627ac73$var$be = {
    s182ab2d6c997515f: "Aggiungilo alla schermata principale per un'esperienza pi\xf9 completa e un accesso facile.",
    s1b9047d53d9f9d22: "2) Premi Condividi nella barra di navigazione",
    s37a9e8aec5713460: "Pi\xf9",
    s5c6aad7a7e4a1437: "3) Premi Aggiungi alla schermata principale",
    s6196153c4b0c1ea0: "Installa",
    s922329d6f6213590: "Aggiungi al Dock",
    sa5ef80b4bb9b39f8: "Meno",
    sa7551383d1897fcc: "2) Premi Aggiungi al Dock",
    sba52286c21552a4e: "Installalo sul tuo dispositivo per un'esperienza pi\xf9 completa e un accesso facile.",
    sc79fd7641eb9a975: "Nascondi istruzioni",
    scdaf4bbff76674c8: "Aggiungi alla schermata principale",
    sdfe23506a3b0cdc8: "1) Apri nel browser Safari",
    se740f75b95a51807: "Aggiungilo al Dock per un'esperienza pi\xf9 completa e un accesso facile.",
    sfea652f6580ff086: "Questo sito ha funzionalit\xe0 di app."
}, $eed90f3bb627ac73$var$ge = {
    s182ab2d6c997515f: "P\u0159idejte jej na plochu pro roz\u0161\xed\u0159en\xe9 vyu\u017Eit\xed a snadn\xfd p\u0159\xedstup.",
    s1b9047d53d9f9d22: "2) Stiskn\u011Bte tla\u010D\xedtko Sd\xedlet na naviga\u010Dn\xedm panelu",
    s37a9e8aec5713460: "Vice",
    s5c6aad7a7e4a1437: "3) Stiskn\u011Bte tla\u010D\xedtko P\u0159idat na plochu",
    s6196153c4b0c1ea0: "Nainstalovat",
    s922329d6f6213590: "P\u0159idat do Docku",
    sa5ef80b4bb9b39f8: "M\xe9n\u011B",
    sa7551383d1897fcc: "2) Stiskn\u011Bte P\u0159idat do Docku",
    sba52286c21552a4e: "Nainstalujte si jej na sv\xe9 za\u0159\xedzen\xed pro roz\u0161\xed\u0159en\xe9 vyu\u017Eit\xed a snadn\xfd p\u0159\xedstup.",
    sc79fd7641eb9a975: "Skr\xfdt instrukce",
    scdaf4bbff76674c8: "P\u0159idat na plochu",
    sdfe23506a3b0cdc8: "1) Otev\u0159ete v prohl\xed\u017Ee\u010Di Safari",
    se740f75b95a51807: "P\u0159idejte jej do sv\xe9ho Docku pro roz\u0161\xed\u0159en\xe9 vyu\u017Eit\xed a snadn\xfd p\u0159\xedstup.",
    sfea652f6580ff086: "Tento web m\xe1 funkce aplikace."
}, $eed90f3bb627ac73$var$he = {
    s182ab2d6c997515f: "Legg den til p\xe5 Hjem-skjermen din for \xe5 f\xe5 en bedre brukeropplevelse og raskere tilgang.",
    s1b9047d53d9f9d22: "2) Trykk p\xe5 Del-knappen i navigasjonslinjen",
    s37a9e8aec5713460: "Mer",
    s5c6aad7a7e4a1437: "3) Velg Legg til p\xe5 Hjem-skjerm",
    s6196153c4b0c1ea0: "Installer",
    s922329d6f6213590: "Legg til i Dock",
    sa5ef80b4bb9b39f8: "Mindre",
    sa7551383d1897fcc: "2) Velg Legg til i Dock",
    sba52286c21552a4e: "Installer den p\xe5 enheten din for \xe5 f\xe5 en bedre brukeropplevelse og raskere tilgang.",
    sc79fd7641eb9a975: "Skjul instruksjoner",
    scdaf4bbff76674c8: "Legg til p\xe5 Hjem-skjerm",
    sdfe23506a3b0cdc8: "1) \xc5pne i Safari",
    se740f75b95a51807: "Legg den til i Docken din for \xe5 f\xe5 en bedre brukeropplevelse og raskere tilgang.",
    sfea652f6580ff086: "Denne siden har app-funksjonalitet."
}, $eed90f3bb627ac73$var$me = {
    s182ab2d6c997515f: "Adicione \xe0 Tela de In\xedcio para uma melhor experi\xeancia e mais f\xe1cil acesso.",
    s1b9047d53d9f9d22: "2) Pressione Compartilhar na barra de endere\xe7o",
    s37a9e8aec5713460: "Mais",
    s5c6aad7a7e4a1437: "3) Pressione Adicionar \xe0 Tela de In\xedcio",
    s6196153c4b0c1ea0: "Instalar",
    s922329d6f6213590: "Adicionar ao Dock",
    sa5ef80b4bb9b39f8: "Menos",
    sa7551383d1897fcc: "2) Pressione Adicionar ao Dock",
    sba52286c21552a4e: "Instale no dispositivo para uma melhor experi\xeancia e mais f\xe1cil acesso.",
    sc79fd7641eb9a975: "Ocultar Instru\xe7\xf5es",
    scdaf4bbff76674c8: "Adicionar \xe0 Tela de In\xedcio",
    sdfe23506a3b0cdc8: "1) Abra no navegador Safari",
    se740f75b95a51807: "Adicione ao Dock para uma melhor experi\xeancia e mais f\xe1cil acesso.",
    sfea652f6580ff086: "Este site possui funcionalidade de aplicativo."
}, $eed90f3bb627ac73$var$fe = {
    s182ab2d6c997515f: "\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8FFD\u52A0\u3057\u3066\u3001\u5E45\u5E83\u3044\u4F53\u9A13\u3068\u7C21\u5358\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u5B9F\u73FE\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    s1b9047d53d9f9d22: "2) \u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u30D0\u30FC\u3067\u5171\u6709\u3092\u62BC\u3059",
    s37a9e8aec5713460: "\u5C55\u958B",
    s5c6aad7a7e4a1437: "3) \u300C\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8FFD\u52A0\u300D\u3092\u62BC\u3059",
    s6196153c4b0c1ea0: "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    s922329d6f6213590: "Dock\u306B\u8FFD\u52A0",
    sa5ef80b4bb9b39f8: "\u6298\u308A\u305F\u305F\u3080",
    sa7551383d1897fcc: "2) \u300CDock\u306B\u8FFD\u52A0\u300D\u3092\u62BC\u3059",
    sba52286c21552a4e: "\u30C7\u30D0\u30A4\u30B9\u306B\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u5145\u5B9F\u3057\u305F\u4F53\u9A13\u3068\u7C21\u5358\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u5B9F\u73FE\u3067\u304D\u307E\u3059\u3002",
    sc79fd7641eb9a975: "\u8AAC\u660E\u3092\u975E\u8868\u793A",
    scdaf4bbff76674c8: "\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8FFD\u52A0",
    sdfe23506a3b0cdc8: "1) Safari\u3067\u958B\u304F",
    se740f75b95a51807: "\u30C9\u30C3\u30AF\u306B\u8FFD\u52A0\u3057\u3066\u3001\u5E45\u5E83\u3044\u4F53\u9A13\u3068\u7C21\u5358\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u5B9F\u73FE\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    sfea652f6580ff086: "\u3053\u306E\u30B5\u30A4\u30C8\u306F\u30A2\u30D7\u30EA\u6A5F\u80FD\u304C\u3042\u308A\u307E\u3059\u3002"
}, $eed90f3bb627ac73$var$ue = {
    s182ab2d6c997515f: "L\xe4gg till p\xe5 hemsk\xe4rmen f\xf6r att f\xe5 en b\xe4ttre anv\xe4ndarupplevelse och enklare \xe5tkomst.",
    s1b9047d53d9f9d22: "2) Tryck p\xe5 Dela-knappen i verktygsf\xe4ltet",
    s37a9e8aec5713460: "Mer",
    s5c6aad7a7e4a1437: "3) V\xe4lj L\xe4gg till p\xe5 hemsk\xe4rmen",
    s6196153c4b0c1ea0: "Installera",
    s922329d6f6213590: "L\xe4gg till i Dock",
    sa5ef80b4bb9b39f8: "Mindre",
    sa7551383d1897fcc: "2) V\xe4lj L\xe4gg till i Dock",
    sba52286c21552a4e: "Installera den p\xe5 din enhet f\xf6r att f\xe5 en b\xe4ttre anv\xe4ndarupplevelse och enklare \xe5tkomst.",
    sc79fd7641eb9a975: "G\xf6m instruktioner",
    scdaf4bbff76674c8: "L\xe4gg till p\xe5 hemsk\xe4rmen",
    sdfe23506a3b0cdc8: "1) \xd6ppna i Safari",
    se740f75b95a51807: "L\xe4gg till i Dock f\xf6r att f\xe5 en b\xe4ttre anv\xe4ndarupplevelse och enklare \xe5tkomst.",
    sfea652f6580ff086: "Denna webbsajt har app-funktionalitet."
}, $eed90f3bb627ac73$var$we = {
    s182ab2d6c997515f: "\uB354 \uB9CE\uC740 \uAE30\uB2A5\uACFC \uC26C\uC6B4 \uC811\uADFC\uC744 \uC704\uD574 \uD648 \uD654\uBA74\uC5D0 \uCD94\uAC00\uD574\uC8FC\uC138\uC694.",
    s1b9047d53d9f9d22: "2) \uB0B4\uBE44\uAC8C\uC774\uC158 \uBC14\uC5D0\uC11C \uACF5\uC720 \uBC84\uD2BC \uB204\uB974\uAE30",
    s37a9e8aec5713460: "\uB354\uBCF4\uAE30",
    s5c6aad7a7e4a1437: "3) \uD648 \uD654\uBA74\uC5D0 \uCD94\uAC00 \uBC84\uD2BC \uB204\uB974\uAE30",
    s6196153c4b0c1ea0: "\uC124\uCE58",
    s922329d6f6213590: "Dock\uC5D0 \uCD94\uAC00",
    sa5ef80b4bb9b39f8: "\uB2EB\uAE30",
    sa7551383d1897fcc: "2) Dock\uC5D0 \uCD94\uAC00 \uBC84\uD2BC \uB204\uB974\uAE30",
    sba52286c21552a4e: "\uB354 \uB9CE\uC740 \uAE30\uB2A5\uACFC \uC26C\uC6B4 \uC811\uADFC\uC744 \uC704\uD574 \uAE30\uAE30\uC5D0 \uC124\uCE58\uD574\uC8FC\uC138\uC694.",
    sc79fd7641eb9a975: "\uC548\uB0B4 \uC228\uAE30\uAE30",
    scdaf4bbff76674c8: "\uD648 \uD654\uBA74\uC5D0 \uCD94\uAC00",
    sdfe23506a3b0cdc8: "1) Safari \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uC5F4\uAE30",
    se740f75b95a51807: "\uB354 \uB9CE\uC740 \uAE30\uB2A5\uACFC \uC26C\uC6B4 \uC811\uADFC\uC744 \uC704\uD574 Dock\uC5D0 \uCD94\uAC00\uD574\uC8FC\uC138\uC694.",
    sfea652f6580ff086: "\uC774 \uC0AC\uC774\uD2B8\uB294 \uC571 \uAE30\uB2A5\uC744 \uAC00\uC9C0\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
}, $eed90f3bb627ac73$var$ve = new Map([
    [
        "ru",
        $eed90f3bb627ac73$var$o
    ],
    [
        "tr",
        $eed90f3bb627ac73$var$s
    ],
    [
        "de",
        $eed90f3bb627ac73$var$n
    ],
    [
        "es",
        $eed90f3bb627ac73$var$r
    ],
    [
        "nl",
        $eed90f3bb627ac73$var$d
    ],
    [
        "el",
        $eed90f3bb627ac73$var$p
    ],
    [
        "fr",
        $eed90f3bb627ac73$var$c
    ],
    [
        "sr",
        $eed90f3bb627ac73$var$b
    ],
    [
        "pl",
        $eed90f3bb627ac73$var$g
    ],
    [
        "uk",
        $eed90f3bb627ac73$var$h
    ],
    [
        "zh",
        $eed90f3bb627ac73$var$m
    ],
    [
        "zh-CN",
        $eed90f3bb627ac73$var$f
    ],
    [
        "it",
        $eed90f3bb627ac73$var$u
    ],
    [
        "cs",
        $eed90f3bb627ac73$var$w
    ],
    [
        "no",
        $eed90f3bb627ac73$var$v
    ],
    [
        "pt",
        $eed90f3bb627ac73$var$y
    ],
    [
        "ja",
        $eed90f3bb627ac73$var$x
    ],
    [
        "sv",
        $eed90f3bb627ac73$var$k
    ],
    [
        "ko",
        $eed90f3bb627ac73$var$D
    ]
]), { getLocale: $eed90f3bb627ac73$var$ye, setLocale: $eed90f3bb627ac73$var$xe } = ($eed90f3bb627ac73$var$ke = {
    sourceLocale: "en",
    targetLocales: $eed90f3bb627ac73$var$X,
    loadLocale: async (e)=>$eed90f3bb627ac73$var$ve.get(e)
}, function(e) {
    if ($eed90f3bb627ac73$var$K) throw Error("lit-localize can only be configured once");
    $eed90f3bb627ac73$var$J = e, $eed90f3bb627ac73$var$K = !0;
}((e, t)=>$eed90f3bb627ac73$var$H($eed90f3bb627ac73$var$Z, e, t)), $eed90f3bb627ac73$var$W = $eed90f3bb627ac73$var$q = $eed90f3bb627ac73$var$ke.sourceLocale, $eed90f3bb627ac73$var$U = new Set($eed90f3bb627ac73$var$ke.targetLocales), $eed90f3bb627ac73$var$U.add($eed90f3bb627ac73$var$ke.sourceLocale), $eed90f3bb627ac73$var$Y = $eed90f3bb627ac73$var$ke.loadLocale, {
    getLocale: $eed90f3bb627ac73$var$F,
    setLocale: $eed90f3bb627ac73$var$G
});
var $eed90f3bb627ac73$var$ke;
class $eed90f3bb627ac73$var$De {
    constructor(){
        this.icons = [
            {
                src: ""
            }
        ], this.screenshots = void 0, this.short_name = "PWA", this.name = "Progressive web application", this.description = "Progressive web application";
    }
}
const $eed90f3bb627ac73$var$Ae = $eed90f3bb627ac73$var$A.css`.gallery{position:relative;--scrollbar-background-color:#fff;--scrollbar-thumb-color:rgb(146, 146, 146);--scrollbar-thumb-hover-color:rgb(100, 100, 100);--nav-btn-background-color:#fff;--nav-btn-fill-color:#141414}.gallery .gallery_scroller{scroll-snap-type:x mandatory;overflow-x:auto;overflow-y:hidden;display:flex;align-items:center;padding:10px 13px;padding-bottom:10px;margin:0 10px;-webkit-overflow-scrolling:touch}.gallery .gallery_scroller img{border-radius:6px;max-height:min(45vh,500px);box-shadow:0 3px 10px 0 rgba(0,0,0,.15);scroll-snap-align:center;scroll-snap-stop:always;position:relative}.gallery .gallery_scroller img+img{margin-left:15px}.gallery .gallery_scroller::-webkit-scrollbar{width:4px;height:2px}.gallery .gallery_scroller::-webkit-scrollbar-thumb{background:var(--scrollbar-thumb-color);border-radius:4px}.gallery .gallery_scroller::-webkit-scrollbar-thumb:hover{background:var(--scrollbar-thumb-hover-color)}.gallery .gallery_scroller::-webkit-scrollbar-track{background:var(--scrollbar-background-color);border-radius:4px}.gallery .gallery_scroller .scroller_wrap{display:flex;flex-direction:row;padding-right:13px}.gallery .btn{position:absolute;display:flex;align-items:center;-webkit-user-select:none;user-select:none;top:50%;transform:translateY(-50%);height:30px;width:30px;border-radius:50%;background-color:var(--nav-btn-background-color);box-shadow:rgba(0,0,0,.3) 2px 4px 4px 1px;background-repeat:no-repeat;opacity:.8;z-index:1}.gallery .btn.prev{left:5px}.gallery .btn.prev svg{margin-left:4px}.gallery .btn.next{right:5px}.gallery .btn.next svg{transform:rotate(180deg);margin-left:6px}.gallery .btn:hover{box-shadow:rgba(0,0,0,.5) 2px 4px 4px 1px;cursor:pointer;opacity:1}.gallery .btn svg{width:20px;height:20px}.gallery .btn svg path{fill:var(--nav-btn-fill-color)}.gallery.apple_desktop{--scrollbar-background-color:rgba(0, 0, 0, 0.1);--scrollbar-thumb-color:rgb(100, 100, 100);--scrollbar-thumb-hover-color:rgba(0, 0, 0, 0.85)}.gallery.apple_desktop .gallery_scroller{margin:0;padding-top:15px}.gallery.apple_desktop .btn{height:26px;width:26px;box-shadow:rgba(0,0,0,.3) 0 2px 2px 1px}.gallery.apple_desktop .btn:hover{box-shadow:rgba(0,0,0,.3) 0 2px 2px 1px}.gallery.apple_desktop .btn:active{filter:brightness(95%)}.gallery.apple_desktop .btn:active .svg{filter:brightness(110%)}.gallery.apple_desktop .btn svg{width:12px;height:auto;opacity:1}.gallery.apple_desktop .btn svg{margin-left:7px}.gallery.apple_mobile .btn.prev svg{margin-left:7px}.gallery.apple_mobile .btn svg{width:16px;height:auto}.gallery.apple_desktop .btn,.gallery.apple_mobile .btn{opacity:1}@media(hover:none)and (pointer:coarse){.gallery .btn.next,.gallery .btn.prev{display:none}.gallery_scroller::-webkit-scrollbar{display:none}}@media(prefers-color-scheme:dark){.gallery{--scrollbar-background-color:#424242;--nav-btn-background-color:#555555;--nav-btn-fill-color:#fff}.gallery.apple_desktop{--scrollbar-thumb-color:var(--nav-btn-fill-color);--scrollbar-background-color:var(--nav-btn-background-color);--scrollbar-thumb-hover-color:var(--nav-btn-fill-color)}.gallery.apple_desktop .btn:active{filter:brightness(110%)}.gallery.apple_desktop .btn:active .svg{filter:brightness(90%)}}`, $eed90f3bb627ac73$var$Ee = (e, t, a, l)=>$eed90f3bb627ac73$var$A.html`${e ? $eed90f3bb627ac73$var$A.html`<div id="paginated_gallery" class="gallery ${t}"><div class="gallery_scroller"><div class="scroller_wrap">${e.map((e)=>$eed90f3bb627ac73$var$A.html`<img draggable="false" src='${e.src}'>`)}</div></div><span class="btn prev" @click="${l}">${"default" != t ? $eed90f3bb627ac73$var$A.html`<svg id="arrow-left" viewBox="0 0 23.023 18.518"><path fill="currentColor" d="M0 9.253c0 .305.134.586.378.818l8.106 8.093c.244.232.5.342.793.342.598 0 1.075-.44 1.075-1.05 0-.293-.11-.586-.306-.769l-2.734-2.783-4.834-4.407-.256.598 3.93.244h15.442c.635 0 1.075-.451 1.075-1.086s-.44-1.087-1.075-1.087H6.152l-3.93.245.256.61 4.834-4.419 2.734-2.783a1.09 1.09 0 0 0 .306-.77C10.352.44 9.875 0 9.277 0c-.293 0-.549.098-.818.366L.38 8.436c-.247.23-.38.511-.38.816Z"/></svg>` : $eed90f3bb627ac73$var$A.html`<svg id="arrow-left" viewBox="0 0 96 96"><path d="M39.3756,48.0022l30.47-25.39a6.0035,6.0035,0,0,0-7.6878-9.223L26.1563,43.3906a6.0092,6.0092,0,0,0,0,9.2231L62.1578,82.615a6.0035,6.0035,0,0,0,7.6878-9.2231Z" fill="%23999" fill-rule="evenodd"/></svg>`}</span><span class="btn next" @click="${a}">${$eed90f3bb627ac73$var$A.html`<svg height="15" width="15"><use href="#arrow-left"></use></svg>`}</span></div>` : ""}`;
var $eed90f3bb627ac73$var$_e = function(e, t, a, l) {
    var i, o = arguments.length, s = o < 3 ? t : null === l ? l = Object.getOwnPropertyDescriptor(t, a) : l;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, a, l);
    else for(var n = e.length - 1; n >= 0; n--)(i = e[n]) && (s = (o < 3 ? i(s) : o > 3 ? i(t, a, s) : i(t, a)) || s);
    return o > 3 && s && Object.defineProperty(t, a, s), s;
}, $eed90f3bb627ac73$var$je = function(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
};
let $eed90f3bb627ac73$var$ze = class extends $eed90f3bb627ac73$var$A.LitElement {
    constructor(){
        super(...arguments), this.screenshots = [], this.theme = "default", this.calcScrollSize = ()=>{
            const e = this.shadowRoot.querySelector("#paginated_gallery");
            if (!e) return;
            const t = e.querySelector(".gallery_scroller");
            if (!t) return;
            const a = Array.from(t.querySelectorAll("img"));
            if (!a) return;
            const l = a.find((e)=>e.offsetWidth + e.offsetLeft >= t.scrollLeft);
            return l ? {
                scroller: t,
                item: l
            } : void 0;
        }, this.scrollToNextPage = ()=>{
            const e = this.calcScrollSize();
            e && e.item.nextElementSibling && e.scroller.scrollTo({
                top: 0,
                left: e.scroller.scrollLeft + e.scroller.clientWidth + e.item.nextElementSibling.clientWidth / 2,
                behavior: "smooth"
            });
        }, this.scrollToPrevPage = ()=>{
            const e = this.calcScrollSize();
            e && e.item.previousElementSibling && e.scroller.scrollTo({
                top: 0,
                left: e.scroller.scrollLeft - e.scroller.clientWidth - e.item.previousElementSibling.clientWidth / 2,
                behavior: "smooth"
            });
        }, this._init = ()=>{};
    }
    static get styles() {
        return $eed90f3bb627ac73$var$Ae;
    }
    firstUpdated() {
        const e = this.calcScrollSize();
        e && setTimeout(()=>{
            e.scroller.scrollTo({
                top: 0,
                left: 0
            });
        }, 300);
    }
    connectedCallback() {
        super.connectedCallback(), this._init();
    }
    render() {
        return $eed90f3bb627ac73$var$A.html`${$eed90f3bb627ac73$var$Ee(this.screenshots, this.theme, this.scrollToNextPage, this.scrollToPrevPage)}`;
    }
};
$eed90f3bb627ac73$var$_e([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$je("design:type", Object)
], $eed90f3bb627ac73$var$ze.prototype, "screenshots", void 0), $eed90f3bb627ac73$var$_e([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$je("design:type", String)
], $eed90f3bb627ac73$var$ze.prototype, "theme", void 0), $eed90f3bb627ac73$var$ze = $eed90f3bb627ac73$var$_e([
    (0, $eed90f3bb627ac73$var$Q.customElement)("pwa-gallery")
], $eed90f3bb627ac73$var$ze);
const $eed90f3bb627ac73$var$Se = $eed90f3bb627ac73$var$ze, $eed90f3bb627ac73$var$Pe = (e, t, a, l)=>$eed90f3bb627ac73$var$A.html`<div class="touch-header" id="touch-header"></div><div class="body-header"><div class="icon"><img src="${a}" alt="icon" class="icon-image"></div><div class="about"><div class="name"><label>${e}</label></div><div class="hostname">${location.hostname}</div></div><button class="material-button primary install" @click='${l}'>${$eed90f3bb627ac73$var$J("Install")}</button></div>${t ? $eed90f3bb627ac73$var$A.html`<div class="description">${t}</div>` : ""}`, $eed90f3bb627ac73$var$Le = (e, t, a)=>{
    const l = new CustomEvent(t, {
        detail: {
            message: a
        }
    });
    e.dispatchEvent(l);
};
class $eed90f3bb627ac73$var$$e {
    static isAppleMobile() {
        return !(!([
            "iPhone",
            "iPad",
            "iPod"
        ].includes(navigator.platform) || navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) || !("serviceWorker" in navigator));
    }
    static isAppleDesktop() {
        const e = navigator.userAgent.toLowerCase();
        if (navigator.maxTouchPoints || !e.match(/macintosh/)) return !1;
        const t = /version\/(\d{2})\./.exec(e);
        if (!(t && t[1] && parseInt(t[1]) >= 17)) return !1;
        const a = !!document.createElement("audio").canPlayType('audio/wav; codecs="1"'), l = !!new OffscreenCanvas(1, 1).getContext("webgl");
        return a && l;
    }
    static isStandalone() {
        return !!(window.matchMedia("(display-mode: standalone)").matches || "standalone" in navigator && !0 === navigator.standalone);
    }
    static async getInstalledRelatedApps() {
        if ("getInstalledRelatedApps" in navigator) try {
            await navigator.getInstalledRelatedApps().then((e)=>e);
        } catch (e) {}
        return [];
    }
    static async isRelatedAppsInstalled() {
        return !!(await this.getInstalledRelatedApps()).length;
    }
    static eventInstalledSuccess(e) {
        $eed90f3bb627ac73$var$Le(e, "pwa-install-success-event", "App install success (Chromium/Android only)");
    }
    static eventInstalledFail(e) {
        $eed90f3bb627ac73$var$Le(e, "pwa-install-fail-event", "App install failed (Chromium/Android only)");
    }
    static eventUserChoiceResult(e, t) {
        $eed90f3bb627ac73$var$Le(e, "pwa-user-choice-result-event", t);
    }
    static eventInstallAvailable(e) {
        $eed90f3bb627ac73$var$Le(e, "pwa-install-available-event", "App install available");
    }
    static eventInstallHowTo(e) {
        $eed90f3bb627ac73$var$Le(e, "pwa-install-how-to-event", "App install instruction showed");
    }
    static eventGallery(e) {
        $eed90f3bb627ac73$var$Le(e, "pwa-install-gallery-event", "App install gallery showed");
    }
}
var $eed90f3bb627ac73$var$Ie = function(e, t, a, l) {
    var i, o = arguments.length, s = o < 3 ? t : null === l ? l = Object.getOwnPropertyDescriptor(t, a) : l;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, a, l);
    else for(var n = e.length - 1; n >= 0; n--)(i = e[n]) && (s = (o < 3 ? i(s) : o > 3 ? i(t, a, s) : i(t, a)) || s);
    return o > 3 && s && Object.defineProperty(t, a, s), s;
}, $eed90f3bb627ac73$var$Ce = function(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
};
let $eed90f3bb627ac73$var$Re = class extends $eed90f3bb627ac73$var$A.LitElement {
    constructor(){
        super(...arguments), this.props = {
            name: "",
            description: "",
            icon: ""
        }, this.install = {
            handleEvent: ()=>{}
        }, this.hideDialog = ()=>{}, this.disableClose = !1, this._callInstall = ()=>{
            this.install.handleEvent();
        }, this._callHide = ()=>{
            this.hideDialog(), this.setupAppearence();
        }, this.bindedElement = null, this._saveBodyStyle = document.body.style.overscrollBehaviorY, this.dragMobileSheet = (e, t, a)=>{
            if (!e || !t || !a) return null;
            let l = 0;
            const i = t.clientHeight + a.clientHeight, o = (e)=>e.clientY || (e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientY : 0), s = (e)=>{
                window.addEventListener("mouseup", n), window.addEventListener("mousemove", r), window.addEventListener("touchend", n), window.addEventListener("touchmove", r), l = o(e) - t.getBoundingClientRect().top, document.body.style.overscrollBehaviorY = "none";
            }, n = (t)=>{
                if (document.body.style.overscrollBehaviorY = this._saveBodyStyle, !this.disableClose && o(t) >= window.innerHeight - 25) d(t, window.innerHeight + 50, !0);
                else if (window.innerHeight - o(t) > e.clientHeight / 2.5) {
                    d(t, window.innerHeight - e.clientHeight);
                    try {
                        $eed90f3bb627ac73$var$$e.eventGallery(this.getRootNode().host);
                    } catch (t) {}
                } else d(t, window.innerHeight - i - 35);
            }, r = (t)=>{
                const a = o(t);
                this.disableClose && window.innerHeight - a < 70 || a <= window.innerHeight - e.clientHeight + l || (e.style.setProperty("transition", "none"), e.style.setProperty("--translateY", `translateY(${a - l}px)`));
            }, d = (a, l, d)=>{
                window.removeEventListener("mouseup", n), window.removeEventListener("mousemove", r), window.removeEventListener("touchend", n), window.removeEventListener("touchmove", r), window.innerWidth >= 768 || (!l && o(a) >= window.innerHeight - i ? e.style.setProperty("--translateY", `translateY(calc(100vh - ${i}px))`) : e.style.setProperty("--translateY", `translateY(${(l || o(a)) + 35}px)`), e.style.setProperty("transition", "transform 500ms cubic-bezier(0.4, 0, 0, 1) 0s"), d && (t.removeEventListener("mousedown", s), t.removeEventListener("touchstart", s), setTimeout(this._callHide, 250)));
            };
            return t.addEventListener("mousedown", s), t.addEventListener("touchstart", s, {
                passive: !0
            }), d(new MouseEvent("mouseup"), window.innerHeight - i - 35), {
                touchElement: t,
                listener: s
            };
        }, this.setupAppearence = ()=>{
            this.bindedElement && (this.bindedElement.touchElement.removeEventListener("mousedown", this.bindedElement.listener), this.bindedElement.touchElement.removeEventListener("touchstart", this.bindedElement.listener)), this.bindedElement = this.dragMobileSheet(this.parentElement?.parentElement, this.parentElement?.getElementsByClassName("touch-header")[0], this.parentElement?.getElementsByClassName("body-header")[0]);
        }, this._init = ()=>{
            this.setupAppearence(), window.addEventListener("resize", this.setupAppearence);
        };
    }
    firstUpdated() {
        this._init();
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return $eed90f3bb627ac73$var$A.html`${$eed90f3bb627ac73$var$Pe(this.props.name, this.props.description, this.props.icon, this._callInstall)}`;
    }
};
$eed90f3bb627ac73$var$Ie([
    (0, $eed90f3bb627ac73$var$Q.property)({
        type: Object
    }),
    $eed90f3bb627ac73$var$Ce("design:type", Object)
], $eed90f3bb627ac73$var$Re.prototype, "props", void 0), $eed90f3bb627ac73$var$Ie([
    (0, $eed90f3bb627ac73$var$Q.property)({
        type: Object
    }),
    $eed90f3bb627ac73$var$Ce("design:type", Object)
], $eed90f3bb627ac73$var$Re.prototype, "install", void 0), $eed90f3bb627ac73$var$Ie([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$Ce("design:type", Object)
], $eed90f3bb627ac73$var$Re.prototype, "hideDialog", void 0), $eed90f3bb627ac73$var$Ie([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$Ce("design:type", Object)
], $eed90f3bb627ac73$var$Re.prototype, "disableClose", void 0), $eed90f3bb627ac73$var$Re = $eed90f3bb627ac73$var$Ie([
    (0, $eed90f3bb627ac73$var$Q.customElement)("pwa-bottom-sheet")
], $eed90f3bb627ac73$var$Re);
const $eed90f3bb627ac73$var$Me = $eed90f3bb627ac73$var$Re, $eed90f3bb627ac73$var$Te = $eed90f3bb627ac73$var$A.css`#pwa-install-element{-webkit-user-select:none;user-select:none}#pwa-install-element .install-dialog{--text-color-normal:#212121;--background-color:#fff;--border-bottom-color:#DBDCDE;--scrollbar-background-color:#fff;font-family:Roboto,"Segoe UI",system-ui;position:fixed;display:inline-block;opacity:0;visibility:hidden;z-index:2147483001}#pwa-install-element .install-dialog.chrome{max-width:380px;width:90%;min-height:90px;margin:0 auto;right:150px;left:auto;background-color:var(--background-color);filter:drop-shadow(0 5px 15px rgba(0, 0, 0, .3));font-size:15px;color:var(--text-color-normal);border-radius:8px;top:-100px;transition:top .5s ease-in-out,opacity .8s ease-in-out,max-height .35s ease-in-out}#pwa-install-element .install-dialog.chrome.available{opacity:1;top:28px;visibility:visible}#pwa-install-element .install-dialog.chrome .dialog-body{display:grid;grid-template-columns:70px 1fr}#pwa-install-element .install-dialog.chrome .dialog-body .icon{display:flex;align-items:flex-start}#pwa-install-element .install-dialog.chrome .dialog-body .icon .icon-image{width:48px;height:48px;margin:0 auto;margin-top:10px;border-radius:6px}#pwa-install-element .install-dialog.chrome .dialog-body .about{display:grid;grid-template-rows:30px auto}#pwa-install-element .install-dialog.chrome .dialog-body .about .hostname,#pwa-install-element .install-dialog.chrome .dialog-body .about .name{padding:0 5px;overflow:hidden}#pwa-install-element .install-dialog.chrome .dialog-body .about .name{font-weight:500;font-size:18px;line-height:24px;margin-top:5px;align-items:flex-start;display:flex}#pwa-install-element .install-dialog.chrome .dialog-body .about .name label{text-overflow:ellipsis;word-break:break-all;white-space:nowrap;overflow:hidden}#pwa-install-element .install-dialog.chrome .dialog-body .about .hostname{font-size:13px;font-weight:400;opacity:.7;line-height:14px;overflow-x:hidden;text-overflow:ellipsis;text-align:left;word-break:break-all;white-space:nowrap}#pwa-install-element .install-dialog.chrome .dialog-body .about+hr{margin-top:10px}#pwa-install-element .install-dialog.chrome .dialog-body .description{font-weight:400;line-height:20px;grid-column:1/3;padding:0 6px;margin:10px 5px 5px;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;max-height:115px;overflow:hidden;overflow-y:auto;text-overflow:ellipsis;text-align:left}#pwa-install-element .install-dialog.chrome .dialog-body .app-description{font-size:13px;margin-bottom:10px}#pwa-install-element .install-dialog.chrome .dialog-body .app-description::-webkit-scrollbar{width:4px;height:4px}#pwa-install-element .install-dialog.chrome .dialog-body .app-description::-webkit-scrollbar-thumb{background:#929292;border-radius:4px}#pwa-install-element .install-dialog.chrome .dialog-body .app-description::-webkit-scrollbar-thumb:hover{background:#646464}#pwa-install-element .install-dialog.chrome .dialog-body .app-description::-webkit-scrollbar-track{background:var(--scrollbar-background-color);border-radius:4px}#pwa-install-element .install-dialog.chrome .dialog-body .install-description{font-size:14px}#pwa-install-element .install-dialog.chrome .dialog-body hr{height:1px;width:100%;grid-column:1/3;background-color:var(--border-bottom-color);border:none;margin:0}#pwa-install-element .install-dialog.chrome .dialog-body .action-buttons{display:grid;grid-template-columns:50% auto;grid-column-start:1;grid-column-end:3;gap:10px;padding:10px 10px}#pwa-install-element .install-dialog.chrome .dialog-body .action-buttons .primary{grid-column-start:2}#pwa-install-element .install-dialog.chrome .dialog-body pwa-gallery{grid-column:1/3;max-height:0;opacity:0;transition:opacity ease-in-out .5s,max-height .5s ease-in-out;overflow:hidden}#pwa-install-element .install-dialog.chrome.gallery pwa-gallery{transition:opacity .3s ease-in-out .2s,max-height .5s ease-in-out;max-height:70vh;opacity:1}#pwa-install-element .install-dialog.mobile{--touch-header-color:#DBDCE0;top:0;max-width:414px;width:100%;bottom:auto;left:0;right:0;transition:none;transform:translateY(100vh);border-radius:0;border-top-left-radius:15px;border-top-right-radius:15px;padding-bottom:35px}#pwa-install-element .install-dialog.mobile .dialog-body{grid-template-columns:1fr}#pwa-install-element .install-dialog.mobile .dialog-body .touch-header{height:30px;width:100%;padding-top:10px;box-sizing:border-box;cursor:grab}#pwa-install-element .install-dialog.mobile .dialog-body .touch-header:active{cursor:grabbing}#pwa-install-element .install-dialog.mobile .dialog-body .touch-header::before{content:"";width:40px;height:5px;border-radius:3px;background:var(--touch-header-color);margin:0 auto;display:block}#pwa-install-element .install-dialog.mobile .dialog-body .body-header{display:grid;grid-template-columns:max-content 1fr max-content;grid-gap:15px;padding:18px 20px;padding-top:0;border-bottom:1px solid var(--border-bottom-color)}#pwa-install-element .install-dialog.mobile .dialog-body .body-header .install{text-transform:capitalize;height:40px;padding:0 23px}#pwa-install-element .install-dialog.mobile .dialog-body .body-header .about{grid-template-rows:auto auto;grid-gap:6px}#pwa-install-element .install-dialog.mobile .dialog-body .body-header .about .name{padding:0;line-height:20px;font-size:16px}#pwa-install-element .install-dialog.mobile .dialog-body .body-header .about .hostname{font-size:14px;font-weight:400;opacity:.7;line-height:14px;overflow-x:hidden;text-overflow:ellipsis;word-break:break-all;white-space:nowrap;padding:0}#pwa-install-element .install-dialog.mobile .dialog-body .body-header .icon .icon-image{margin:0;width:45px;height:45px}#pwa-install-element .install-dialog.mobile .dialog-body .description{padding:15px 20px 0;margin:0;margin-bottom:15px;-webkit-line-clamp:6;max-height:150px}#pwa-install-element .install-dialog.mobile .dialog-body pwa-gallery{max-height:100%;padding-bottom:15px;opacity:1}#pwa-install-element .install-dialog.mobile .material-button{border-radius:20px}#pwa-install-element .install-dialog.mobile.available{--translateY:translateY(calc(100vh - 85px));opacity:1;top:0;visibility:visible;transform:var(--translateY)}#pwa-install-element .material-button{--text-color-primary:#fff;--text-color-secondary:#374fc6;--background-color-primary:#374fc6;--background-color-ripple:#fff;position:relative;display:inline-block;box-sizing:border-box;border:none;border-radius:6px;padding:0 16px;min-width:64px;height:36px;vertical-align:middle;text-align:center;text-overflow:ellipsis;text-transform:uppercase;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);font-family:Roboto,"Segoe UI",BlinkMacSystemFont,system-ui,-apple-system;font-size:14px;font-weight:500;line-height:37px;overflow:hidden;outline:0;cursor:pointer;transition:box-shadow .2s}#pwa-install-element .material-button.primary{color:var(--text-color-primary);background-color:var(--background-color-primary)}#pwa-install-element .material-button.secondary{background-color:rgba(0,0,0,0);color:var(--text-color-secondary);box-shadow:none}#pwa-install-element .material-button.secondary::after,#pwa-install-element .material-button.secondary::before{background-color:var(--background-color-primary)}#pwa-install-element .material-button.secondary:active,#pwa-install-element .material-button.secondary:hover{box-shadow:none}#pwa-install-element .material-button.secondary.close{height:26px;min-width:26px;line-height:0;margin-right:0;margin-left:auto;padding:0;border-radius:50%}#pwa-install-element .material-button.secondary.close svg{width:16px;fill:var(--text-color-secondary)}#pwa-install-element .material-button.secondary.close::after{width:25px;height:25px;border-radius:50%}#pwa-install-element .material-button.secondary.close::before{border-radius:50%}#pwa-install-element .material-button::before{content:"";position:absolute;top:0;bottom:0;left:0;right:0;background-color:var(--background-color-ripple);opacity:0;transition:opacity .2s}#pwa-install-element .material-button::after{content:"";position:absolute;left:50%;top:50%;border-radius:50%;padding:50%;width:32px;height:32px;background-color:var(--background-color-ripple);opacity:0;transform:translate(-50%,-50%) scale(1);transition:opacity 1s,transform .5s}#pwa-install-element .material-button:hover{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}#pwa-install-element .material-button:hover::before{opacity:.08}#pwa-install-element .material-button:hover:focus::before{opacity:.3}#pwa-install-element .material-button:active{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}#pwa-install-element .material-button:active::after{opacity:.32;transform:translate(-50%,-50%) scale(0);transition:transform 0s}@media(prefers-color-scheme:dark){#pwa-install-element .install-dialog{--text-color-normal:#fff;--background-color:#1e1e1e;--border-bottom-color:#404140;--scrollbar-background-color:#424242}#pwa-install-element .install-dialog.mobile{--touch-header-color:#3f403f}#pwa-install-element .install-dialog .material-button{--text-color-primary:#1B222C;--text-color-secondary:#a7c7fa;--background-color-primary:#a7c7fa}}@media(max-width:767px)and (min-height:495px){#pwa-install-element .install-dialog.chrome.mobile{display:inline-block}#pwa-install-element .install-dialog.chrome{display:none}}@media(min-width:768px),(max-height:495px){#pwa-install-element .install-dialog.chrome.mobile{display:none}#pwa-install-element .install-dialog.chrome{display:inline-block}}@media(max-height:420px){#pwa-install-element .install-dialog.chrome .dialog-body .description{-webkit-line-clamp:3;max-height:70px}}@media(hover:none)and (pointer:coarse){#pwa-install-element .install-dialog.chrome .dialog-body .description::-webkit-scrollbar{display:none}}`, $eed90f3bb627ac73$var$He = $eed90f3bb627ac73$var$A.css`#pwa-install-element .install-dialog.apple{--text-color-normal:#333;--text-color-description:#333;--background-color:rgba(255, 255, 255, 0.8);--text-color-button:#fff;--background-color-button:#fff;--background-color-button-active:#DBDAE0;--border-bottom-color:rgba(0, 0, 0, 0.1);--icon-how-to-color:#527AFB;font-family:system-ui,-apple-system,HelveticaNeue,BlinkMacSystemFont,Roboto,"Segoe UI";max-width:380px;width:auto;margin:0 auto;right:0;left:0;font-size:15px;color:var(--text-color-normal);bottom:0;transition:transform .4s cubic-bezier(.33,1,.66,1),opacity .5s cubic-bezier(1,0,1,-2),border .35s ease-in-out;overflow:hidden;pointer-events:none;opacity:0;visibility:visible;transform:translateY(100%);will-change:opacity,transform}#pwa-install-element .install-dialog.apple.dialog-body{display:grid;grid-template-columns:95px 1fr;grid-template-rows:1fr auto;grid-template-areas:"icon description" "welcome welcome" "how-to how-to" "gallery gallery" "button button";border-radius:10px;border-bottom:1px solid transparent;background-color:var(--background-color);filter:drop-shadow(0 5px 15px rgba(0, 0, 0, .5));backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}#pwa-install-element .install-dialog.apple.dialog-body .icon{display:flex;align-items:center;grid-area:icon;border-bottom:1px solid var(--border-bottom-color)}#pwa-install-element .install-dialog.apple.dialog-body .icon .icon-image{width:64px;height:64px;margin:0 auto;border-radius:6px}#pwa-install-element .install-dialog.apple.dialog-body .close{height:26px;min-width:26px;line-height:0;margin-right:7px;margin-top:7px;margin-left:auto;padding:0;border-radius:50%;opacity:.5;outline:0;color:var(--text-color-normal);border:none;background-color:rgba(0,0,0,0);cursor:pointer;transition:opacity .2s ease-in-out,background-color .2s ease-in-out;grid-area:description}#pwa-install-element .install-dialog.apple.dialog-body .close svg{fill:var(--text-color-normal);width:18px}#pwa-install-element .install-dialog.apple.dialog-body .close:active,#pwa-install-element .install-dialog.apple.dialog-body .close:hover{opacity:1;background-color:var(--background-color-button)}#pwa-install-element .install-dialog.apple.dialog-body .about{display:grid;grid-template-rows:35px 60px;border-bottom:1px solid var(--border-bottom-color);grid-area:description}#pwa-install-element .install-dialog.apple.dialog-body .about .description,#pwa-install-element .install-dialog.apple.dialog-body .about .name{padding-right:15px;overflow:hidden}#pwa-install-element .install-dialog.apple.dialog-body .about .name{font-weight:600;padding-top:10px;padding-right:10px;line-height:22px;align-items:flex-start;display:flex}#pwa-install-element .install-dialog.apple.dialog-body .about .description{font-size:12px;line-height:15px;margin-bottom:15px;overflow-y:auto;color:var(--text-color-description)}#pwa-install-element .install-dialog.apple.dialog-body .welcome-to-install{font-size:15px;grid-area:welcome;text-align:left;font-weight:400;padding:15px;width:auto;border-bottom:1px solid var(--border-bottom-color)}#pwa-install-element .install-dialog.apple .action-buttons{grid-area:button;grid-column-start:1;grid-column-end:3;padding:15px}#pwa-install-element .install-dialog.apple .dialog-button{display:grid;height:50px;width:100%;line-height:50px;border-radius:8px;color:var(--text-color-normal)}#pwa-install-element .install-dialog.apple .dialog-button.button{border:none;outline:0;font-family:system-ui,-apple-system,HelveticaNeue,BlinkMacSystemFont;cursor:pointer;-webkit-user-select:none;user-select:none;font-weight:400;font-size:17px;padding:0;margin:0;background-color:var(--background-color-button)}#pwa-install-element .install-dialog.apple .dialog-button.button.install{padding:0 15px;text-align:left}#pwa-install-element .install-dialog.apple .dialog-button.button.install .button-text{opacity:0;display:flex;align-items:center;justify-content:space-between;transition:opacity .4s ease-in-out .1s;overflow:hidden}#pwa-install-element .install-dialog.apple .dialog-button.button.install .button-text>span{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}#pwa-install-element .install-dialog.apple .dialog-button.button.install .button-text>svg{flex-shrink:0;width:20px}#pwa-install-element .install-dialog.apple .dialog-button.button.install .button-text.show{opacity:1;visibility:visible;width:auto;height:auto}#pwa-install-element .install-dialog.apple .dialog-button.button.install .button-text.hide{opacity:0;position:absolute;width:0;height:0;visibility:hidden}#pwa-install-element .install-dialog.apple .dialog-button.button.gallery{display:flex;align-items:center;min-width:50px;width:auto;margin-right:15px}#pwa-install-element .install-dialog.apple .dialog-button.button.gallery #pwa-gallery{margin:0 auto;width:23px;fill:var(--text-color-normal)}#pwa-install-element .install-dialog.apple .dialog-button.button:active{background-color:var(--background-color-button-active)}#pwa-install-element .install-dialog.apple .how-to-body{opacity:0;max-height:0;overflow:hidden;transition:opacity ease-in-out .5s,max-height .5s ease-in-out;grid-area:how-to}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description{display:grid;-webkit-user-select:none;user-select:none;grid-auto-columns:1fr;grid-template-rows:1fr 1fr 1fr;gap:10px;padding:15px;padding-bottom:0}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step{display:inline-flex;flex-direction:row;gap:15px;align-items:center;font-size:14px}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap{position:relative;display:inline-flex;flex-shrink:0;color:var(--icon-how-to-color);width:50px;height:50px;align-items:center;border-radius:6px}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-add,#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-safari,#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-share{margin:0 auto}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-share{margin-bottom:4px;transform:scale(.9)}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-add{transform:scale(.8);fill:var(--text-color-normal)}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap #pwa-safari{transform:scale(.92)}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .svg-wrap .step-count{position:absolute;line-height:12px;top:3px;left:4px}#pwa-install-element .install-dialog.apple .how-to-body .how-to-description .description-step .step-text{font-weight:600;text-align:left}#pwa-install-element .install-dialog.apple pwa-gallery{grid-column:1/3;max-height:0;opacity:0;transition:opacity ease-in-out .5s,max-height .5s ease-in-out;overflow:hidden}#pwa-install-element .install-dialog.apple pwa-gallery+.action-buttons{display:flex}#pwa-install-element .install-dialog.apple.available{opacity:1;pointer-events:unset;transform:translateY(0);transition:transform .5s cubic-bezier(.33,1,.66,1),border .35s ease-in-out}#pwa-install-element .install-dialog.apple.gallery pwa-gallery{transition:opacity .3s ease-in-out .2s,max-height .5s ease-in-out;max-height:70vh;opacity:1}#pwa-install-element .install-dialog.apple.how-to .dialog-body{border-bottom:1px solid #e0e0e0}#pwa-install-element .install-dialog.apple.how-to .how-to-body{opacity:1;max-height:400px;overflow-y:auto;transition:opacity .3s ease-in-out .2s,max-height .5s ease-in-out}#pwa-install-element .install-dialog.apple.desktop{--text-color-normal:rgba(0, 0, 0, 0.85);--text-color-description:rgba(0, 0, 0, 0.85);--icon-how-to-color:rgba(0, 0, 0, 0.50);--background-color:rgb(246 246 246 / 85%);--background-color-button:#c6c1c6;--background-color-button-active:linear-gradient(0deg, rgba(64,121,250,1) 0%, rgba(84,144,251,1) 100%);--border-bottom-color:rgb(185 185 185);grid-template-columns:1fr;grid-template-rows:1fr auto;grid-template-areas:"icon" "description" "welcome" "how-to" "gallery" "button";gap:0;column-gap:0;padding:16px;max-width:260px;background:var(--background-color);border:1px solid var(--border-bottom-color)}#pwa-install-element .install-dialog.apple.desktop .icon{height:64px;padding-bottom:16px}#pwa-install-element .install-dialog.apple.desktop .icon .icon-image{border-radius:10px;width:52px;height:52px;filter:drop-shadow(0 1px 1px rgba(0, 0, 0, .15))}#pwa-install-element .install-dialog.apple.desktop .close{grid-area:icon;background:var(--background-color-button);opacity:1;height:20px;min-width:20px;margin-right:-5px;margin-top:-5px}#pwa-install-element .install-dialog.apple.desktop .close svg{width:14px}#pwa-install-element .install-dialog.apple.desktop .about{display:flex;flex-direction:column;align-items:center}#pwa-install-element .install-dialog.apple.desktop .about .name{font-size:13px;line-height:16px;font-weight:700;padding:0}#pwa-install-element .install-dialog.apple.desktop .about .description{padding:16px 0;margin:0;padding-top:10px;border-bottom:1px solid var(--border-bottom-color);min-width:100%}#pwa-install-element .install-dialog.apple.desktop .about .description,#pwa-install-element .install-dialog.apple.desktop .welcome-to-install{text-align:center;font-size:11px;line-height:14px}#pwa-install-element .install-dialog.apple.desktop .about,#pwa-install-element .install-dialog.apple.desktop .icon,#pwa-install-element .install-dialog.apple.desktop .welcome-to-install{border:none}#pwa-install-element .install-dialog.apple.desktop .welcome-to-install{padding:0;padding-top:16px}#pwa-install-element .install-dialog.apple.desktop .action-buttons{padding:0;padding-top:16px}#pwa-install-element .install-dialog.apple.desktop .action-buttons .dialog-button.button{font-size:13px;font-weight:400;padding:6px 8px;border-radius:6px;height:auto;line-height:18px}#pwa-install-element .install-dialog.apple.desktop .action-buttons .dialog-button.button.install{color:#fff;background:var(--background-color-button-active);transition:background .3s ease-in-out .1s,color .3s ease-in-out}#pwa-install-element .install-dialog.apple.desktop .action-buttons .dialog-button.button.install svg{transform:none;width:18px}#pwa-install-element .install-dialog.apple.desktop .action-buttons .dialog-button.button.gallery{width:30px;min-width:30px;margin-right:10px;background:var(--background-color-button)}#pwa-install-element .install-dialog.apple.desktop .action-buttons .dialog-button.button.gallery #pwa-gallery{width:14px;transition:transform .4s ease-in-out}#pwa-install-element .install-dialog.apple.desktop .close:active,#pwa-install-element .install-dialog.apple.desktop .dialog-button.button:active{filter:brightness(105%)}#pwa-install-element .install-dialog.apple.desktop .close:active .button-text,#pwa-install-element .install-dialog.apple.desktop .dialog-button.button:active .button-text{filter:brightness(90%)}#pwa-install-element .install-dialog.apple.desktop .how-to-body .how-to-description{padding:0;padding-top:16px;grid-template-rows:1fr 1fr}#pwa-install-element .install-dialog.apple.desktop .how-to-body .how-to-description .description-step{font-size:12px;gap:16px}#pwa-install-element .install-dialog.apple.desktop .how-to-body .how-to-description .description-step .svg-wrap{width:32px;height:32px;color:var(--icon-how-to-color)}#pwa-install-element .install-dialog.apple.desktop .how-to-body .how-to-description .description-step .svg-wrap #pwa-share{width:16px;margin-bottom:2px;transform:none}#pwa-install-element .install-dialog.apple.desktop .how-to-body .how-to-description .description-step .svg-wrap #pwa-add{width:18px;transform:none}#pwa-install-element .install-dialog.apple.desktop.gallery #pwa-gallery{transform:rotate(180deg)}#pwa-install-element .install-dialog.apple.desktop.how-to .action-buttons .dialog-button.button.install{color:var(--text-color-normal);background:var(--background-color-button)}@media(min-width:667px){#pwa-install-element .install-dialog.apple{top:0;bottom:unset;transform:translateY(calc(-100% - 40px));right:28px;left:auto}#pwa-install-element .install-dialog.apple.available{top:28px;bottom:auto;max-height:calc(95vh - 28px)}}@media(min-width:667px)and (max-width:1366px){#pwa-install-element .install-dialog.apple{right:max(28px,env(safe-area-inset-right,28px));left:auto}}@media(max-width:666px){#pwa-install-element .install-dialog.apple .description-step .step-text{font-size:13px}#pwa-install-element .install-dialog.apple.available{bottom:20px;max-height:calc(85vh - 20px)}#pwa-install-element .install-dialog.apple.dialog-body{filter:drop-shadow(rgba(0, 0, 0, .5) 0 0 15px)}}@media(max-width:428px){#pwa-install-element .install-dialog.apple.dialog-body{max-width:100vw;filter:drop-shadow(rgba(0, 0, 0, .5) 0 -5px 10px);border-bottom-left-radius:0;border-bottom-right-radius:0}#pwa-install-element .install-dialog.apple.dialog-body .action-buttons{padding-bottom:max(15px,env(safe-area-inset-bottom))}#pwa-install-element .install-dialog.apple.dialog-body.available{bottom:0;max-height:85vh}}@media(max-height:548px){#pwa-install-element .install-dialog.apple.dialog-body.available{overflow-y:auto;max-height:calc(90vh - 28px - env(safe-area-inset-bottom,0px))}}@media(max-height:600px){#pwa-install-element .install-dialog.apple pwa-gallery{overflow-y:auto}}@media(prefers-color-scheme:dark){#pwa-install-element .install-dialog.apple.dialog-body{--text-color-normal:#fff;--text-color-description:#9E9AA1;--background-color:rgb(25 25 25 / 90%);--background-color-button:#353535;--background-color-button-active:#454545;--border-bottom-color:#353535}#pwa-install-element .install-dialog.apple.dialog-body .close:active,#pwa-install-element .install-dialog.apple.dialog-body .dialog-button.button:active{filter:brightness(105%)}#pwa-install-element .install-dialog.apple.dialog-body .close:active .button-text,#pwa-install-element .install-dialog.apple.dialog-body .dialog-button.button:active .button-text{filter:brightness(90%)}#pwa-install-element .install-dialog.apple.dialog-body.desktop{--text-color-description:var(--text-color-normal);--icon-how-to-color:#bcb8b6;--background-color:rgb(45 45 45 / 90%);--border-bottom-color:#5b5b5b;--background-color-button:#6d6765;--background-color-button-active:linear-gradient(0deg, rgba(59,108,200,1) 0%, rgba(66,123,250,1) 100%);outline:1px solid #1c1c1c;color-scheme:dark}}`;
const $eed90f3bb627ac73$var$Oe = ((e)=>{
    var t = {};
    return $eed90f3bb627ac73$var$l.d(t, e), t;
})({
    classMap: ()=>$0e5c059fc79abe53$export$56cc687933817664
}), $eed90f3bb627ac73$var$Be = (e, t, a, l, i, o, s, n, r, d, p, c, b)=>{
    const g = ()=>({
            available: r,
            gallery: b
        }), h = !i && n.screenshots && n.screenshots.length;
    return $eed90f3bb627ac73$var$A.html`<div id="pwa-install-element"><div class="install-dialog chrome ${(0, $eed90f3bb627ac73$var$Oe.classMap)(g())}"><div class="dialog-body"><div class="icon"><img src="${s}" alt="icon" class="icon-image" draggable="false"></div><div class="about"><div class="name"><label>${e}</label>${o ? "" : $eed90f3bb627ac73$var$A.html`<button class="material-button secondary close" @click='${d}'><svg viewBox="0 0 24 24"><path d="M5.3 18.7c.2.2.4.3.7.3s.5-.1.7-.3l5.3-5.3 5.3 5.3a1.08 1.08 0 0 0 .7.3 1.08 1.08 0 0 0 .7-.3c.4-.4.4-1 0-1.4L13.4 12l5.3-5.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L12 10.6 6.7 5.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4z"/></svg></button>`}</div><div class="hostname">${location.hostname}</div></div>${t ? $eed90f3bb627ac73$var$A.html`<div class="description app-description">${t}</div>` : ""} ${l ? "" : $eed90f3bb627ac73$var$A.html`<hr><div class="description install-description">${a || `${$eed90f3bb627ac73$var$J("This site has app functionality.")} ${$eed90f3bb627ac73$var$J("Install it on your device for extensive experience and easy access.")}`}</div>`} ${h ? $eed90f3bb627ac73$var$A.html`<pwa-gallery .screenshots=${n.screenshots}></pwa-gallery>` : ""}<div class="action-buttons">${h ? $eed90f3bb627ac73$var$A.html`<button class="material-button secondary" @click='${c}'>${$eed90f3bb627ac73$var$J(b ? "Less" : "More")}</button>` : ""}<button class="material-button primary install" @click='${p}'>${$eed90f3bb627ac73$var$J("Install")}</button></div></div></div><div class="install-dialog chrome mobile ${(0, $eed90f3bb627ac73$var$Oe.classMap)(g())}"><div class="dialog-body"><pwa-bottom-sheet .props=${{
        name: e,
        icon: s,
        description: t
    }} .disableClose=${o} .install=${p} .hideDialog=${d}></pwa-bottom-sheet>${h ? $eed90f3bb627ac73$var$A.html`<pwa-gallery .screenshots=${n.screenshots}></pwa-gallery>` : ""}</div></div></div>`;
}, $eed90f3bb627ac73$var$qe = (e, t, a, l, i, o, s, n, r, d, p, c, b, g, h)=>{
    const m = !i && n.screenshots && n.screenshots.length;
    return $eed90f3bb627ac73$var$A.html`<aside id="pwa-install-element"><article class="install-dialog apple ${(0, $eed90f3bb627ac73$var$Oe.classMap)({
        available: r,
        "how-to": b,
        gallery: h,
        desktop: c
    })} dialog-body"><div class="icon"><img src="${s}" alt="icon" class="icon-image" draggable="false"></div>${o ? "" : $eed90f3bb627ac73$var$A.html`<button type="button" title="close" class="close" @click='${d}'><svg viewBox="0 0 24 24"><path d="M5.3 18.7c.2.2.4.3.7.3s.5-.1.7-.3l5.3-5.3 5.3 5.3a1.08 1.08 0 0 0 .7.3 1.08 1.08 0 0 0 .7-.3c.4-.4.4-1 0-1.4L13.4 12l5.3-5.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L12 10.6 6.7 5.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4z"/></svg></button>`}<div class="about"><div class="name">${e}</div><div class="description">${t || location.hostname}</div></div>${l ? "" : $eed90f3bb627ac73$var$A.html`<div class="welcome-to-install">${a || `${$eed90f3bb627ac73$var$J("This site has app functionality.")} ${$eed90f3bb627ac73$var$J(c ? "Add it to your Dock for extensive experience and easy access." : "Add it to your Home Screen for extensive experience and easy access.")}`}</div>`}<div class="how-to-body"><div class="how-to-description">${c ? "" : $eed90f3bb627ac73$var$A.html`<div class="description-step"><div class="svg-wrap"><svg id="pwa-safari" viewBox="0 0 20.283 19.932" width="24" height="24"><g fill="currentColor"><path d="M9.96 19.922c5.45 0 9.962-4.522 9.962-9.961C19.922 4.51 15.4 0 9.952 0 4.511 0 0 4.512 0 9.96c0 5.44 4.521 9.962 9.96 9.962Zm0-1.66A8.26 8.26 0 0 1 1.67 9.96c0-4.61 3.672-8.3 8.281-8.3 4.61 0 8.31 3.69 8.31 8.3 0 4.61-3.69 8.3-8.3 8.3Z"/><path d="m5.87 14.883 5.605-2.735a1.47 1.47 0 0 0 .683-.673l2.725-5.596c.312-.664-.166-1.182-.85-.84L8.447 7.764c-.302.136-.508.341-.674.673L5.03 14.043c-.312.645.196 1.152.84.84Zm4.09-3.72A1.19 1.19 0 0 1 8.77 9.97c0-.664.527-1.201 1.19-1.201a1.2 1.2 0 0 1 1.202 1.2c0 .655-.537 1.192-1.201 1.192Z"/></g></svg></div><div class="step-text">${$eed90f3bb627ac73$var$J("1) Open in Safari browser")}</div></div>`}<div class="description-step"><div class="svg-wrap"><svg id="pwa-share" width="25" height="32" viewBox="0 0 17.695 26.475"><g fill="currentColor"><path d="M17.334 10.762v9.746c0 2.012-1.025 3.027-3.066 3.027H3.066C1.026 23.535 0 22.52 0 20.508v-9.746C0 8.75 1.025 7.734 3.066 7.734h2.94v1.573h-2.92c-.977 0-1.514.527-1.514 1.543v9.57c0 1.015.537 1.543 1.514 1.543h11.152c.967 0 1.524-.527 1.524-1.543v-9.57c0-1.016-.557-1.543-1.524-1.543h-2.91V7.734h2.94c2.04 0 3.066 1.016 3.066 3.028Z"/><path d="M8.662 15.889c.42 0 .781-.352.781-.762V5.097l-.058-1.464.654.693 1.484 1.582a.698.698 0 0 0 .528.235c.4 0 .713-.293.713-.694 0-.205-.088-.361-.235-.508l-3.3-3.183c-.196-.196-.362-.264-.567-.264-.195 0-.361.069-.566.264L4.795 4.94a.681.681 0 0 0-.225.508c0 .4.293.694.703.694.186 0 .4-.079.538-.235l1.474-1.582.664-.693-.058 1.465v10.029c0 .41.351.762.771.762Z"/></g></svg></div><div class="step-text">${$eed90f3bb627ac73$var$J("2) Press Share in Navigation bar").replace(c ? "2)" : "0)", "1)")}</div></div><div class="description-step"><div class="svg-wrap">${c ? $eed90f3bb627ac73$var$A.html`<svg id="pwa-add" viewBox="0 0 23.389 17.979" width="25" height="25"><g fill="currentColor"><path d="M1.045 3.291v1.377h20.937V3.291Zm2.021 14.688h16.895c2.05 0 3.066-1.006 3.066-3.018V3.027C23.027 1.016 22.012 0 19.961 0H3.066C1.026 0 0 1.016 0 3.027v11.934c0 2.012 1.025 3.018 3.066 3.018Zm.02-1.573c-.977 0-1.514-.517-1.514-1.533V3.115c0-1.015.537-1.543 1.514-1.543H19.94c.967 0 1.514.528 1.514 1.543v11.758c0 1.016-.547 1.533-1.514 1.533Z"/><path d="M4.2 14.014c0 .508.35.85.868.85h12.92c.518 0 .87-.343.87-.85v-1.465c0-.508-.352-.85-.87-.85H5.068c-.517 0-.869.342-.869.85Z"/></g></svg>` : $eed90f3bb627ac73$var$A.html`<svg id="pwa-add" width="25" height="25"><g><path d="m23.40492,1.60784c-1.32504,-1.32504 -3.19052,-1.56912 -5.59644,-1.56912l-10.65243,0c-2.33622,0 -4.2017,0.24408 -5.5267,1.56912c-1.32504,1.34243 -1.56911,3.17306 -1.56911,5.50924l0,10.5827c0,2.40596 0.22665,4.254 1.55165,5.57902c1.34246,1.32501 3.19052,1.5691 5.59647,1.5691l10.60013,0c2.40592,0 4.2714,-0.24408 5.59644,-1.5691c1.325,-1.34245 1.55166,-3.17306 1.55166,-5.57902l0,-10.51293c0,-2.40596 -0.22666,-4.25401 -1.55166,-5.57901zm-0.38355,5.21289l0,11.24518c0,1.51681 -0.20924,2.94643 -1.02865,3.78327c-0.83683,0.83685 -2.30134,1.0635 -3.81815,1.0635l-11.33234,0c-1.51681,0 -2.96386,-0.22665 -3.80073,-1.0635c-0.83683,-0.83684 -1.04607,-2.26646 -1.04607,-3.78327l0,-11.19288c0,-1.5517 0.20924,-3.01617 1.02865,-3.85304c0.83687,-0.83683 2.31876,-1.04607 3.87042,-1.04607l11.28007,0c1.51681,0 2.98132,0.22666 3.81815,1.06353c0.81941,0.81941 1.02865,2.26645 1.02865,3.78327zm-10.53039,12.08205c0.64506,0 1.02861,-0.43586 1.02861,-1.13326l0,-4.34117l4.53294,0c0.66252,0 1.13326,-0.36613 1.13326,-0.99376c0,-0.64506 -0.43586,-1.02861 -1.13326,-1.02861l-4.53294,0l0,-4.53294c0,-0.6974 -0.38355,-1.13326 -1.02861,-1.13326c-0.62763,0 -0.99376,0.45332 -0.99376,1.13326l0,4.53294l-4.51552,0c-0.69737,0 -1.15069,0.38355 -1.15069,1.02861c0,0.62763 0.48817,0.99376 1.15069,0.99376l4.51552,0l0,4.34117c0,0.66252 0.36613,1.13326 0.99376,1.13326z"/></g></svg>`}</div><div class="step-text">${$eed90f3bb627ac73$var$J(c ? "2) Press Add to Dock" : "3) Press Add to Home Screen")}</div></div></div></div>${m ? $eed90f3bb627ac73$var$A.html`<pwa-gallery .screenshots=${n.screenshots} .theme="${c ? "apple_desktop" : "apple_mobile"}"></pwa-gallery>` : ""}<div class="action-buttons">${m ? $eed90f3bb627ac73$var$A.html`<button class="dialog-button button gallery" @click=${g}>${c ? $eed90f3bb627ac73$var$A.html`<svg id="pwa-gallery" viewBox="0 0 10 6"><path d="m1.102 2.21 3.169 3.24c.22.222.462.333.729.333a.94.94 0 0 0 .378-.083 1.19 1.19 0 0 0 .347-.25L8.89 2.21a.8.8 0 0 0 .246-.593.838.838 0 0 0-.118-.44.884.884 0 0 0-.312-.311.84.84 0 0 0-1.063.167L4.854 3.92h.299L2.359 1.033a.868.868 0 0 0-.642-.286.822.822 0 0 0-.43.119.935.935 0 0 0-.312.312.863.863 0 0 0-.115.44c0 .116.02.223.057.32a.898.898 0 0 0 .185.272Z"/></svg>` : $eed90f3bb627ac73$var$A.html`<svg id="pwa-gallery" width="26" height="26" viewBox="0 0 23.538 18.022"><path d="M2.79 18.022h17.958c1.834 0 2.79-.969 2.79-2.778V2.791C23.538.969 22.582 0 20.748 0H2.791C.956 0 0 .956 0 2.79v12.454c0 1.835.956 2.778 2.79 2.778zM.879 2.83C.878 1.55 1.55.88 2.816.88h17.906c1.228 0 1.938.671 1.938 1.95v12.067L16.756 9.47c-.517-.414-.995-.685-1.615-.685-.607 0-1.085.22-1.576.672L8.927 13.59l-1.938-1.796c-.426-.387-.853-.607-1.382-.607-.504 0-.879.207-1.305.594L.878 14.986zm6.46 6.356a2.39 2.39 0 002.377-2.39c0-1.304-1.072-2.39-2.377-2.39a2.401 2.401 0 00-2.39 2.39 2.393 2.393 0 002.39 2.39z"/></svg>`}</button>` : ""}<button class="dialog-button button install" @click=${p}><span class="button-text ${b ? "show" : "hide"}">${$eed90f3bb627ac73$var$J("Hide Instruction")}</span><span class="button-text ${b ? "hide" : "show"}"><span>${$eed90f3bb627ac73$var$J(c ? "Add to Dock" : "Add to Home Screen")}</span><svg viewBox="0 0 25 25"><use href="#pwa-add"></use></svg></span></button></div></article></aside>`;
};
var $eed90f3bb627ac73$var$Ue = function(e, t, a, l) {
    var i, o = arguments.length, s = o < 3 ? t : null === l ? l = Object.getOwnPropertyDescriptor(t, a) : l;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, a, l);
    else for(var n = e.length - 1; n >= 0; n--)(i = e[n]) && (s = (o < 3 ? i(s) : o > 3 ? i(t, a, s) : i(t, a)) || s);
    return o > 3 && s && Object.defineProperty(t, a, s), s;
}, $eed90f3bb627ac73$var$Ye = function(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
};
let $eed90f3bb627ac73$var$Ze = class extends $eed90f3bb627ac73$var$A.LitElement {
    constructor(){
        super(...arguments), this.manifestUrl = "/manifest.json", this.icon = "", this.name = "", this.description = "", this.installDescription = "", this.disableDescription = !1, this.disableScreenshots = !1, this.manualApple = !1, this.manualChrome = !1, this.disableChrome = !1, this.disableClose = !1, this.externalPromptEvent = null, this.platforms = [], this.userChoiceResult = "", this.isDialogHidden = JSON.parse(window.sessionStorage.getItem("pwa-hide-install") || "false"), this.isInstallAvailable = !1, this.isAppleMobilePlatform = !1, this.isAppleDesktopPlatform = !1, this.isUnderStandaloneMode = !1, this.isRelatedAppsInstalled = !1, this._manifest = new $eed90f3bb627ac73$var$De, this._howToRequested = !1, this._galleryRequested = !1, this._install = {
            handleEvent: ()=>{
                window.defferedPromptEvent && (this.hideDialog(), window.defferedPromptEvent.prompt(), window.defferedPromptEvent.userChoice.then((e)=>{
                    this.userChoiceResult = e.outcome, $eed90f3bb627ac73$var$$e.eventUserChoiceResult(this, this.userChoiceResult);
                }).catch((e)=>{
                    $eed90f3bb627ac73$var$$e.eventInstalledFail(this);
                }), window.defferedPromptEvent = null);
            },
            passive: !0
        }, this.install = ()=>{
            this.isAppleMobilePlatform || this.isAppleDesktopPlatform ? (this._howToRequested = !0, this.requestUpdate()) : this._install.handleEvent();
        }, this._hideDialog = {
            handleEvent: ()=>{
                this.isDialogHidden = !0, window.sessionStorage.setItem("pwa-hide-install", "true"), this.requestUpdate();
            },
            passive: !0
        }, this._hideDialogUser = ()=>{
            $eed90f3bb627ac73$var$$e.eventUserChoiceResult(this, "dismissed"), this.userChoiceResult = "dismissed", this.hideDialog();
        }, this.hideDialog = ()=>{
            this._hideDialog.handleEvent();
        }, this.showDialog = (e = !1)=>{
            this.isDialogHidden = !1, e && (this.isInstallAvailable = !0), window.sessionStorage.setItem("pwa-hide-install", "false"), this.requestUpdate();
        }, this.getInstalledRelatedApps = async ()=>await $eed90f3bb627ac73$var$$e.getInstalledRelatedApps(), this._howToForApple = {
            handleEvent: ()=>{
                this._howToRequested = !this._howToRequested, this._howToRequested && this._galleryRequested && (this._galleryRequested = !1), this.requestUpdate(), this._howToRequested && $eed90f3bb627ac73$var$$e.eventInstallHowTo(this);
            },
            passive: !0
        }, this._toggleGallery = {
            handleEvent: ()=>{
                this._galleryRequested = !this._galleryRequested, this._howToRequested && this._galleryRequested && (this._howToRequested = !1), this._galleryRequested && $eed90f3bb627ac73$var$$e.eventGallery(this), this.requestUpdate();
            },
            passive: !0
        }, this._init = async ()=>{
            if (window.defferedPromptEvent = null, this._checkInstalled(), !this.disableChrome) {
                const e = (e)=>{
                    window.defferedPromptEvent = e, e.preventDefault(), this.platforms = e.platforms, this.isRelatedAppsInstalled || this.isUnderStandaloneMode ? this.isInstallAvailable = !1 : (this.isInstallAvailable = !0, $eed90f3bb627ac73$var$$e.eventInstallAvailable(this)), "accepted" === this.userChoiceResult && (this.isDialogHidden = !0, $eed90f3bb627ac73$var$$e.eventInstalledSuccess(this)), this.requestUpdate();
                };
                null != this.externalPromptEvent ? setTimeout(()=>e(this.externalPromptEvent), 300) : window.addEventListener("beforeinstallprompt", e);
            }
            window.addEventListener("appinstalled", (e)=>{
                window.defferedPromptEvent = null, this.isInstallAvailable = !1, this.requestUpdate(), $eed90f3bb627ac73$var$$e.eventInstalledSuccess(this);
            });
            try {
                const e = await fetch(this.manifestUrl), t = await e.json();
                if (!e.ok || !t || !Object.keys(t)) throw Error("Manifest not found");
                this.icon = this.icon || t.icons?.length ? t.icons[0].src : "", this.name = this.name || t.short_name || t.name || "", this.description = this.description || t.description || "", this._manifest = t;
            } catch (e) {
                this.icon = this.icon || this._manifest.icons?.[0].src || "", this.name = this.name || this._manifest.short_name || "", this.description = this.description || this._manifest.description || "";
            }
        }, this._requestUpdate = ()=>{
            this.requestUpdate();
        };
    }
    static get styles() {
        return [
            $eed90f3bb627ac73$var$Te,
            $eed90f3bb627ac73$var$He
        ];
    }
    async _checkInstalled() {
        this.isUnderStandaloneMode = $eed90f3bb627ac73$var$$e.isStandalone(), this.isRelatedAppsInstalled = await $eed90f3bb627ac73$var$$e.isRelatedAppsInstalled(), this.isAppleMobilePlatform = $eed90f3bb627ac73$var$$e.isAppleMobile(), this.isAppleDesktopPlatform = $eed90f3bb627ac73$var$$e.isAppleDesktop(), this.isAppleMobilePlatform || this.isAppleDesktopPlatform ? this.isUnderStandaloneMode || (this.manualApple && this.hideDialog(), setTimeout(()=>{
            this.isInstallAvailable = !0, this.requestUpdate(), $eed90f3bb627ac73$var$$e.eventInstallAvailable(this);
        }, 1e3)) : this.manualChrome && this.hideDialog();
    }
    connectedCallback() {
        ((e)=>{
            try {
                $eed90f3bb627ac73$var$ve.get(e) ? $eed90f3bb627ac73$var$xe(e) : $eed90f3bb627ac73$var$xe(e.slice(0, 2));
            } catch  {}
        })(navigator.language), this._init(), $eed90f3bb627ac73$var$Se.finalized, $eed90f3bb627ac73$var$Me.finalized, super.connectedCallback();
    }
    willUpdate(e) {
        this.externalPromptEvent && e.has("externalPromptEvent") && "object" == typeof this.externalPromptEvent && this._init();
    }
    render() {
        return this.isAppleMobilePlatform || this.isAppleDesktopPlatform ? $eed90f3bb627ac73$var$A.html`${$eed90f3bb627ac73$var$qe(this.name, this.description, this.installDescription, this.disableDescription, this.disableScreenshots, this.disableClose, this.icon, this._manifest, this.isInstallAvailable && !this.isDialogHidden, this._hideDialogUser, this._howToForApple, this.isAppleDesktopPlatform, this._howToRequested, this._toggleGallery, this._galleryRequested)}` : $eed90f3bb627ac73$var$A.html`${$eed90f3bb627ac73$var$Be(this.name, this.description, this.installDescription, this.disableDescription, this.disableScreenshots, this.disableClose, this.icon, this._manifest, this.isInstallAvailable && !this.isDialogHidden, this._hideDialogUser, this._install, this._toggleGallery, this._galleryRequested)}`;
    }
};
$eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "manifest-url"
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "manifestUrl", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "icon", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "name", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)(),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "description", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "install-description"
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "installDescription", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "disable-install-description",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "disableDescription", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "disable-screenshots",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "disableScreenshots", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "manual-apple",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "manualApple", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "manual-chrome",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "manualChrome", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "disable-chrome",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "disableChrome", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.property)({
        attribute: "disable-close",
        type: Boolean
    }),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "disableClose", void 0), $eed90f3bb627ac73$var$Ue([
    (0, $eed90f3bb627ac73$var$Q.state)(),
    $eed90f3bb627ac73$var$Ye("design:type", Object)
], $eed90f3bb627ac73$var$Ze.prototype, "externalPromptEvent", void 0), $eed90f3bb627ac73$var$Ze = $eed90f3bb627ac73$var$Ue([
    (e, t)=>(e.addInitializer($eed90f3bb627ac73$var$S), e),
    (0, $eed90f3bb627ac73$var$Q.customElement)("pwa-install")
], $eed90f3bb627ac73$var$Ze);
var $eed90f3bb627ac73$export$16b3f68de76b3d7b = $eed90f3bb627ac73$var$i.k;



var $cm03h = parcelRequire("cm03h");
/**
 * Punto de entrada principal de la aplicación
 */ document.addEventListener('DOMContentLoaded', async ()=>{
    try {
        const App = new (0, $572f0c6bf2810aa6$export$2e2bcd8739ae039)();
        await App.init();
    } catch (error) {
        console.error('[App] Init Error', error);
        (0, $cm03h.Toast).show("Error al inicializar la aplicaci\xf3n. Por favor, recarga la p\xe1gina o contacta a soporte si el problema persiste.", 'danger', false, ()=>{
            window.location.reload();
        });
    }
});
window.addEventListener('error', (event)=>{
    console.error('[App] Unhandled error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
    });
});
window.addEventListener('unhandledrejection', (event)=>{
    console.error('[App] Unhandled promise rejection', {
        reason: event.reason,
        promise: event.promise
    });
});


//# sourceMappingURL=workspace.198ca50c.js.map
